export const DataCHN = [
  {
    ID: 0,
    BudgetSection: 1,
    Entity: "OSRSG-CAAC",
    EntityFullName: "负责儿童与武装冲突问题秘书长特别代表办公室",
    Programme: "通盘决策、领导和协调",
    Subprogramme: "负责儿童与武装冲突问题秘书长特别代表办公室",
    Title: "核实的被拘留儿童人数减少",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "促进人权",
    Beneficiary: "青年",
    BeneficiaryTwo: "难民、少数群体和其他弱势群体",
    SpecificResult: "减少性暴力，包括将性暴力作为战争和恐怖手段使用，减少暴力侵害儿童行为，包括武装冲突局势中侵害儿童的严重暴力行为",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CD,HT,NG,SO,YE",
    Image: "1POLICY1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=zh#page=55"
  },
  {
    ID: 1,
    BudgetSection: 1,
    Entity: "OSRSG-CAAC",
    EntityFullName: "负责儿童与武装冲突问题秘书长特别代表办公室",
    Programme: "通盘决策、领导和协调",
    Subprogramme: "负责儿童与武装冲突问题秘书长特别代表办公室",
    Title: "联合国与武装冲突各方为制止和预防严重侵害儿童行为而签署的行动计划、移交议定书和其他承诺增加",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "促进人权",
    Beneficiary: "青年",
    BeneficiaryTwo: "难民、少数群体和其他弱势群体",
    SpecificResult: "减少性暴力，包括将性暴力作为战争和恐怖手段使用，减少暴力侵害儿童行为，包括武装冲突局势中侵害儿童的严重暴力行为",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=zh#page=56"
  },
  {
    ID: 2,
    BudgetSection: 1,
    Entity: "OSRSG-CAAC",
    EntityFullName: "负责儿童与武装冲突问题秘书长特别代表办公室",
    Programme: "通盘决策、领导和协调",
    Subprogramme: "负责儿童与武装冲突问题秘书长特别代表办公室",
    Title: "在武装冲突局势中冲突各方招募和使用的儿童人数减少",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "促进人权",
    Beneficiary: "青年",
    BeneficiaryTwo: "难民、少数群体和其他弱势群体",
    SpecificResult: "减少性暴力，包括将性暴力作为战争和恐怖手段使用，减少暴力侵害儿童行为，包括武装冲突局势中侵害儿童的严重暴力行为",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=zh#page=57"
  },
  {
    ID: 3,
    BudgetSection: 1,
    Entity: "OSRSG-CAAC",
    EntityFullName: "负责儿童与武装冲突问题秘书长特别代表办公室",
    Programme: "通盘决策、领导和协调",
    Subprogramme: "负责儿童与武装冲突问题秘书长特别代表办公室",
    Title: "更多儿童从武装部队和武装团体中获释",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "促进人权",
    Beneficiary: "青年",
    BeneficiaryTwo: "难民、少数群体和其他弱势群体",
    SpecificResult: "减少性暴力，包括将性暴力作为战争和恐怖手段使用，减少暴力侵害儿童行为，包括武装冲突局势中侵害儿童的严重暴力行为",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=zh#page=57"
  },
  {
    ID: 4,
    BudgetSection: 1,
    Entity: "OSRSG-SVC",
    EntityFullName: "负责冲突中性暴力问题秘书长特别代表办公室",
    Programme: "通盘决策、领导和协调",
    Subprogramme: "负责冲突中性暴力问题秘书长特别代表办公室",
    Title: "加强国家自主权，防止与冲突有关的性暴力并为幸存者伸张正义：乌克兰的案例",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "促进人权",
    Beneficiary: "妇女和女童",
    BeneficiaryTwo: "难民、少数群体和其他弱势群体",
    SpecificResult: "减少性暴力，包括将性暴力作为战争和恐怖手段使用，减少暴力侵害儿童行为，包括武装冲突局势中侵害儿童的严重暴力行为",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "UA",
    Image: "1POLICY5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=zh#page=67"
  },
  {
    ID: 5,
    BudgetSection: 1,
    Entity: "OSRSG-SVC",
    EntityFullName: "负责冲突中性暴力问题秘书长特别代表办公室",
    Programme: "通盘决策、领导和协调",
    Subprogramme: "负责冲突中性暴力问题秘书长特别代表办公室",
    Title: "国家当局对与冲突有关的性暴力提供的服务和司法对策得到加强",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "促进人权",
    Beneficiary: "妇女和女童",
    BeneficiaryTwo: "难民、少数群体和其他弱势群体",
    SpecificResult: "减少性暴力，包括将性暴力作为战争和恐怖手段使用，减少暴力侵害儿童行为，包括武装冲突局势中侵害儿童的严重暴力行为",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DJ,ER,ET,SO,SD,QQ",
    Image: "1POLICY6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=zh#page=68"
  },
  {
    ID: 6,
    BudgetSection: 1,
    Entity: "OSRSG-SVC",
    EntityFullName: "负责冲突中性暴力问题秘书长特别代表办公室",
    Programme: "通盘决策、领导和协调",
    Subprogramme: "负责冲突中性暴力问题秘书长特别代表办公室",
    Title: "国家当局加强司法应对措施，促进以幸存者为中心的司法，并追究与冲突有关的性暴力的责任",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "促进人权",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "难民、少数群体和其他弱势群体",
    SpecificResult: "减少性暴力，包括将性暴力作为战争和恐怖手段使用，减少暴力侵害儿童行为，包括武装冲突局势中侵害儿童的严重暴力行为",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "CO,CF,CD,UA",
    Image: "1POLICY7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=zh#page=68"
  },
  {
    ID: 7,
    BudgetSection: 1,
    Entity: "OSRSG-SVC",
    EntityFullName: "负责冲突中性暴力问题秘书长特别代表办公室",
    Programme: "通盘决策、领导和协调",
    Subprogramme: "负责冲突中性暴力问题秘书长特别代表办公室",
    Title: "更好地遵守关于预防和处理与冲突有关性暴力的国际规范",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "促进人权",
    Beneficiary: "国际社会",
    BeneficiaryTwo: "难民、少数群体和其他弱势群体",
    SpecificResult: "减少性暴力，包括将性暴力作为战争和恐怖手段使用，减少暴力侵害儿童行为，包括武装冲突局势中侵害儿童的严重暴力行为",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=zh#page=69"
  },
  {
    ID: 8,
    BudgetSection: 1,
    Entity: "OSRSG-VAC",
    EntityFullName: "负责暴力侵害儿童问题秘书长特别代表办公室",
    Programme: "通盘决策、领导和协调",
    Subprogramme: "负责暴力侵害儿童问题秘书长特别代表办公室",
    Title: "私营部门加强对保护儿童在旅行和旅游业中免受暴力侵害的承诺",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "促进人权",
    Beneficiary: "青年",
    BeneficiaryTwo: "私营部门，包括中小微型企业",
    SpecificResult: "减少性暴力，包括将性暴力作为战争和恐怖手段使用，减少暴力侵害儿童行为，包括武装冲突局势中侵害儿童的严重暴力行为",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=zh#page=77"
  },
  {
    ID: 9,
    BudgetSection: 1,
    Entity: "OSRSG-VAC",
    EntityFullName: "负责暴力侵害儿童问题秘书长特别代表办公室",
    Programme: "通盘决策、领导和协调",
    Subprogramme: "负责暴力侵害儿童问题秘书长特别代表办公室",
    Title: "重振领航国家倡议(消除暴力侵害儿童行为全球领航联盟)，到 2030 年消除暴力侵害儿童行为",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "促进人权",
    Beneficiary: "青年",
    BeneficiaryTwo: "难民、少数群体和其他弱势群体",
    SpecificResult: "减少性暴力，包括将性暴力作为战争和恐怖手段使用，减少暴力侵害儿童行为，包括武装冲突局势中侵害儿童的严重暴力行为",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=zh#page=78"
  },
  {
    ID: 10,
    BudgetSection: 1,
    Entity: "OSRSG-VAC",
    EntityFullName: "负责暴力侵害儿童问题秘书长特别代表办公室",
    Programme: "通盘决策、领导和协调",
    Subprogramme: "负责暴力侵害儿童问题秘书长特别代表办公室",
    Title: "会员国通过到2030年消除暴力侵害儿童行为加快行动战略路线图",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "促进人权",
    Beneficiary: "青年",
    BeneficiaryTwo: "难民、少数群体和其他弱势群体",
    SpecificResult: "减少性暴力，包括将性暴力作为战争和恐怖手段使用，减少暴力侵害儿童行为，包括武装冲突局势中侵害儿童的严重暴力行为",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=zh#page=78"
  },
  {
    ID: 11,
    BudgetSection: 1,
    Entity: "OSRSG-VAC",
    EntityFullName: "负责暴力侵害儿童问题秘书长特别代表办公室",
    Programme: "通盘决策、领导和协调",
    Subprogramme: "负责暴力侵害儿童问题秘书长特别代表办公室",
    Title: "会员国之间的同行学习加速采取行动消除暴力侵害儿童行为",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "促进人权",
    Beneficiary: "青年",
    BeneficiaryTwo: "国际社会",
    SpecificResult: "减少性暴力，包括将性暴力作为战争和恐怖手段使用，减少暴力侵害儿童行为，包括武装冲突局势中侵害儿童的严重暴力行为",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=zh#page=79"
  },
  {
    ID: 12,
    BudgetSection: 1,
    Entity: "OSC-SEA",
    EntityFullName: "联合国改进联合国应对性剥削和性虐待措施特别协调员办公室",
    Programme: "通盘决策、领导和协调",
    Subprogramme: "联合国改进联合国应对性剥削和性虐待措施特别协调员办公室",
    Title: "扩大将保护措施纳入国家合作框架",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "促进司法和国际法",
    Beneficiary: "妇女和女童",
    BeneficiaryTwo: "难民、少数群体和其他弱势群体",
    SpecificResult: "加大应对力度，打击性剥削和性虐待、性骚扰以及欺诈和腐败；更好地将以受害者为中心的方法纳入主流",
    SpecificResultOrder: 22,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=zh#page=90"
  },
  {
    ID: 13,
    BudgetSection: 1,
    Entity: "OSC-SEA",
    EntityFullName: "联合国改进联合国应对性剥削和性虐待措施特别协调员办公室",
    Programme: "通盘决策、领导和协调",
    Subprogramme: "联合国改进联合国应对性剥削和性虐待措施特别协调员办公室",
    Title: "更有效地处理性剥削和性虐待问题的“全联合国”协调一致办法",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "促进司法和国际法",
    Beneficiary: "妇女和女童",
    BeneficiaryTwo: "难民、少数群体和其他弱势群体",
    SpecificResult: "加大应对力度，打击性剥削和性虐待、性骚扰以及欺诈和腐败；更好地将以受害者为中心的方法纳入主流",
    SpecificResultOrder: 22,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=zh#page=91"
  },
  {
    ID: 14,
    BudgetSection: 1,
    Entity: "OSC-SEA",
    EntityFullName: "联合国改进联合国应对性剥削和性虐待措施特别协调员办公室",
    Programme: "通盘决策、领导和协调",
    Subprogramme: "联合国改进联合国应对性剥削和性虐待措施特别协调员办公室",
    Title: "通过在整个联合国系统将防止性剥削和性虐待制度化，开展有效的预防和应对努力",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "促进司法和国际法",
    Beneficiary: "妇女和女童",
    BeneficiaryTwo: "难民、少数群体和其他弱势群体",
    SpecificResult: "加大应对力度，打击性剥削和性虐待、性骚扰以及欺诈和腐败；更好地将以受害者为中心的方法纳入主流",
    SpecificResultOrder: 22,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=zh#page=91"
  },
  {
    ID: 15,
    BudgetSection: 1,
    Entity: "OSC-SEA",
    EntityFullName: "联合国改进联合国应对性剥削和性虐待措施特别协调员办公室",
    Programme: "通盘决策、领导和协调",
    Subprogramme: "联合国改进联合国应对性剥削和性虐待措施特别协调员办公室",
    Title: "加强全系统应对性剥削和性虐待问题的战略方法",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "促进司法和国际法",
    Beneficiary: "妇女和女童",
    BeneficiaryTwo: "难民、少数群体和其他弱势群体",
    SpecificResult: "加大应对力度，打击性剥削和性虐待、性骚扰以及欺诈和腐败；更好地将以受害者为中心的方法纳入主流",
    SpecificResultOrder: 22,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=zh#page=92"
  },
  {
    ID: 16,
    BudgetSection: 1,
    Entity: "OMS",
    EntityFullName: "联合国监察员和调解事务办公室",
    Programme: "通盘决策、领导和协调",
    Subprogramme: "联合国监察员和调解事务办公室",
    Title: "通过能力和技能建设活动更好地管理工作场所冲突",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "加强内部司法和调解机制，在联合国内部倡导道德行为、增进和谐和改善诉诸司法机会",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=zh#page=101"
  },
  {
    ID: 17,
    BudgetSection: 1,
    Entity: "OMS",
    EntityFullName: "联合国监察员和调解事务办公室",
    Programme: "通盘决策、领导和协调",
    Subprogramme: "联合国监察员和调解事务办公室",
    Title: "联合国编外人员可获得非正式解决冲突服务",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "加强内部司法和调解机制，在联合国内部倡导道德行为、增进和谐和改善诉诸司法机会",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=zh#page=101"
  },
  {
    ID: 18,
    BudgetSection: 1,
    Entity: "OMS",
    EntityFullName: "联合国监察员和调解事务办公室",
    Programme: "通盘决策、领导和协调",
    Subprogramme: "联合国监察员和调解事务办公室",
    Title: "外地工作人员获得服务的机会增加",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "加强内部司法和调解机制，在联合国内部倡导道德行为、增进和谐和改善诉诸司法机会",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=zh#page=102"
  },
  {
    ID: 19,
    BudgetSection: 1,
    Entity: "OMS",
    EntityFullName: "联合国监察员和调解事务办公室",
    Programme: "通盘决策、领导和协调",
    Subprogramme: "联合国监察员和调解事务办公室",
    Title: "提高对调解服务的认识",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "加强内部司法和调解机制，在联合国内部倡导道德行为、增进和谐和改善诉诸司法机会",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=zh#page=103"
  },
  {
    ID: 20,
    BudgetSection: 1,
    Entity: "OAJ",
    EntityFullName: "内部司法办公室",
    Programme: "通盘决策、领导和协调",
    Subprogramme: "内部司法办公室",
    Title: "提高跟踪向联合国争议法庭所提交案件的能力",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "加强内部司法和调解机制，在联合国内部倡导道德行为、增进和谐和改善诉诸司法机会",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=zh#page=110"
  },
  {
    ID: 21,
    BudgetSection: 1,
    Entity: "OAJ",
    EntityFullName: "内部司法办公室",
    Programme: "通盘决策、领导和协调",
    Subprogramme: "内部司法办公室",
    Title: "通过使用业务情报以及就趋势分析进行报告，内部司法系统的透明度得到提高",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "加强内部司法和调解机制，在联合国内部倡导道德行为、增进和谐和改善诉诸司法机会",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=zh#page=111"
  },
  {
    ID: 22,
    BudgetSection: 1,
    Entity: "OAJ",
    EntityFullName: "内部司法办公室",
    Programme: "通盘决策、领导和协调",
    Subprogramme: "内部司法办公室",
    Title: "工作人员法律援助办公室的法律意见得到更多利用",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "加强内部司法和调解机制，在联合国内部倡导道德行为、增进和谐和改善诉诸司法机会",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=zh#page=111"
  },
  {
    ID: 23,
    BudgetSection: 1,
    Entity: "OAJ",
    EntityFullName: "内部司法办公室",
    Programme: "通盘决策、领导和协调",
    Subprogramme: "内部司法办公室",
    Title: "更及时地解决提交联合国争议法庭的案件",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "加强内部司法和调解机制，在联合国内部倡导道德行为、增进和谐和改善诉诸司法机会",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=zh#page=112"
  },
  {
    ID: 24,
    BudgetSection: 1,
    Entity: "EO",
    EntityFullName: "道德操守办公室",
    Programme: "通盘决策、领导和协调",
    Subprogramme: "道德操守办公室",
    Title: "工作人员对寻求有关防范报复咨询的信心增强",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "加强内部司法和调解机制，在联合国内部倡导道德行为、增进和谐和改善诉诸司法机会",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=zh#page=120"
  },
  {
    ID: 25,
    BudgetSection: 1,
    Entity: "EO",
    EntityFullName: "道德操守办公室",
    Programme: "通盘决策、领导和协调",
    Subprogramme: "道德操守办公室",
    Title: "外地人员的道德操守意识和获得道德操守服务的机会得到提高",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "加强内部司法和调解机制，在联合国内部倡导道德行为、增进和谐和改善诉诸司法机会",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=zh#page=121"
  },
  {
    ID: 26,
    BudgetSection: 1,
    Entity: "EO",
    EntityFullName: "道德操守办公室",
    Programme: "通盘决策、领导和协调",
    Subprogramme: "道德操守办公室",
    Title: "通过财务披露方案提供更好的咨询和指导，加强透明度和问责制",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "加强内部司法和调解机制，在联合国内部倡导道德行为、增进和谐和改善诉诸司法机会",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY27.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=zh#page=122"
  },
  {
    ID: 27,
    BudgetSection: 1,
    Entity: "EO",
    EntityFullName: "道德操守办公室",
    Programme: "通盘决策、领导和协调",
    Subprogramme: "道德操守办公室",
    Title: "工作人员对防止报复程序的了解加深并且程序的及时性提高",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "加强内部司法和调解机制，在联合国内部倡导道德行为、增进和谐和改善诉诸司法机会",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY28.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=zh#page=122"
  },
  {
    ID: 28,
    BudgetSection: 1,
    Entity: "RCS",
    EntityFullName: "驻地协调员系统",
    Programme: "通盘决策、领导和协调",
    Subprogramme: "驻地协调员系统",
    Title: "各国政府推进加速实现可持续发展目标的综合政策方法",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: "国际社会",
    SpecificResult: "通过稳健协调结构等途径，利用可持续发展目标之间的相互关联性，加快推进可持续发展目标",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY29.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=zh#page=131"
  },
  {
    ID: 29,
    BudgetSection: 1,
    Entity: "RCS",
    EntityFullName: "驻地协调员系统",
    Programme: "通盘决策、领导和协调",
    Subprogramme: "驻地协调员系统",
    Title: "通过标准的联合国可持续发展合作框架指标，提高联合国成果以及联合国对可持续发展目标贡献的透明度和问责力度",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "提高报告可持续发展目标进展情况的能力；提高自愿国别评估数目和质量",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY30.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=zh#page=132"
  },
  {
    ID: 30,
    BudgetSection: 1,
    Entity: "RCS",
    EntityFullName: "驻地协调员系统",
    Programme: "通盘决策、领导和协调",
    Subprogramme: "驻地协调员系统",
    Title: "通过数据驱动的解决方案和数字创新，提高联合国在实现可持续发展目标方面的支助效力",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "在科学、技术和创新促进可持续发展(包括人工智能)方面取得进展",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY31.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=zh#page=133"
  },
  {
    ID: 31,
    BudgetSection: 1,
    Entity: "RCS",
    EntityFullName: "驻地协调员系统",
    Programme: "通盘决策、领导和协调",
    Subprogramme: "驻地协调员系统",
    Title: "在危机的长期社会经济影响下保障生命和生计",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "难民、少数群体和其他弱势群体",
    BeneficiaryTwo: "公共行政",
    SpecificResult: "实现更具有包容性的发展，不让任何一个人掉队；消除贫困和减少不平等；减少对妇女和女童的歧视，加强性别平等。",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY32.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=zh#page=134"
  },
  {
    ID: 32,
    BudgetSection: 1,
    Entity: "UNYO",
    EntityFullName: "联合国青年办公室",
    Programme: "通盘决策、领导和协调",
    Subprogramme: "联合国青年办公室",
    Title: "在推进青年优先事项和青年的切实参与方面取得进展",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "青年",
    BeneficiaryTwo: "国际社会",
    SpecificResult: "多边主义得到加强",
    SpecificResultOrder: 2,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY33.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=zh#page=148"
  },
  {
    ID: 33,
    BudgetSection: 1,
    Entity: "UNYO",
    EntityFullName: "联合国青年办公室",
    Programme: "通盘决策、领导和协调",
    Subprogramme: "联合国青年办公室",
    Title: "青年在各级的参与：从数量转向质量",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "青年",
    BeneficiaryTwo: "国际社会",
    SpecificResult: "加强合作、增进信息和最佳做法共享，推动在实现可持续发展目标方面取得进展",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY34.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=zh#page=149"
  },
  {
    ID: 34,
    BudgetSection: 1,
    Entity: "UNYO",
    EntityFullName: "联合国青年办公室",
    Programme: "通盘决策、领导和协调",
    Subprogramme: "联合国青年办公室",
    Title: "建立一个全球青年投资平台，扩大与青年有关的方案拟订工作",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "青年",
    BeneficiaryTwo: "国际社会",
    SpecificResult: "提高报告可持续发展目标进展情况的能力；提高自愿国别评估数目和质量",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY35.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=zh#page=149"
  },
  {
    ID: 35,
    BudgetSection: 1,
    Entity: "UNYO",
    EntityFullName: "联合国青年办公室",
    Programme: "通盘决策、领导和协调",
    Subprogramme: "联合国青年办公室",
    Title: "加强青年对和平与安全进程的参与",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "维护国际和平与安全",
    Beneficiary: "青年",
    BeneficiaryTwo: "国际社会",
    SpecificResult: "多边主义得到加强",
    SpecificResultOrder: 2,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY36.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=zh#page=150"
  },
  {
    ID: 36,
    BudgetSection: 1,
    Entity: "ODPP",
    EntityFullName: "数据保护和隐私办公室",
    Programme: "通盘决策、领导和协调",
    Subprogramme: "数据保护和隐私办公室",
    Title: "提高数据保护和隐私管理方面的业务就绪水平",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "加强组织能力、问责制和响应能力，更有效地执行任务",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY37.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=zh#page=158"
  },
  {
    ID: 37,
    BudgetSection: 1,
    Entity: "ODPP",
    EntityFullName: "数据保护和隐私办公室",
    Programme: "通盘决策、领导和协调",
    Subprogramme: "数据保护和隐私办公室",
    Title: "整个秘书处的数据保护和隐私得到加强",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "改善信息传播和使用",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY38.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=zh#page=158"
  },
  {
    ID: 38,
    BudgetSection: 1,
    Entity: "ODPP",
    EntityFullName: "数据保护和隐私办公室",
    Programme: "通盘决策、领导和协调",
    Subprogramme: "数据保护和隐私办公室",
    Title: "优化业务流程，在整个组织融入数据保护和隐私政策并确保政策得到遵守",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "建立有利的法律和法规框架；减少法律责任风险",
    SpecificResultOrder: 39,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY39.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=zh#page=159"
  },
  {
    ID: 39,
    BudgetSection: 1,
    Entity: "ODPP",
    EntityFullName: "数据保护和隐私办公室",
    Programme: "通盘决策、领导和协调",
    Subprogramme: "数据保护和隐私办公室",
    Title: "在人工智能时代，提升组织复原力并更成熟地在设计阶段即纳入数据保护和隐私因素",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "推进技术进步，改善信息质量、可用性、可及性和安全性",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY40.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=zh#page=160"
  },
  {
    ID: 40,
    BudgetSection: 1,
    Entity: "ODET",
    EntityFullName: "数字和新兴技术办公室",
    Programme: "通盘决策、领导和协调",
    Subprogramme: "数字和新兴技术办公室",
    Title: "所有利益攸关方目睹《全球数字契约》取得的进展",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "改善信息传播和使用",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY41.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=zh#page=166"
  },
  {
    ID: 41,
    BudgetSection: 1,
    Entity: "ODET",
    EntityFullName: "数字和新兴技术办公室",
    Programme: "通盘决策、领导和协调",
    Subprogramme: "数字和新兴技术办公室",
    Title: "多方利益攸关方对《全球数字契约》的承诺得到加强",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "在科学、技术和创新促进可持续发展(包括人工智能)方面取得进展",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY42.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=zh#page=167"
  },
  {
    ID: 42,
    BudgetSection: 1,
    Entity: "ODET",
    EntityFullName: "数字和新兴技术办公室",
    Programme: "通盘决策、领导和协调",
    Subprogramme: "数字和新兴技术办公室",
    Title: "推进人工智能国际治理合作",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "在科学、技术和创新促进可持续发展(包括人工智能)方面取得进展",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY43.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=zh#page=167"
  },
  {
    ID: 43,
    BudgetSection: 1,
    Entity: "UNAOC",
    EntityFullName: "联合国文明联盟",
    Programme: "通盘决策、领导和协调",
    Subprogramme: "联合国文明联盟",
    Title: "会员国在培育和平文化、促进宗教间和文化间对话、推动相互了解及应对各种宗教不容忍方面的主人翁意识得到增强",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "促进人权",
    Beneficiary: "国际社会",
    BeneficiaryTwo: "难民、少数群体和其他弱势群体",
    SpecificResult: "在人权的保护和享受方面取得进展，减少不平等和歧视；进一步融合发展权",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY44.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=zh#page=178"
  },
  {
    ID: 44,
    BudgetSection: 1,
    Entity: "UNAOC",
    EntityFullName: "联合国文明联盟",
    Programme: "通盘决策、领导和协调",
    Subprogramme: "联合国文明联盟",
    Title: "国家和非国家行为体对当代伊斯兰恐惧症趋势的认识得到提高",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "维护国际和平与安全",
    Beneficiary: "国际社会",
    BeneficiaryTwo: "难民、少数群体和其他弱势群体",
    SpecificResult: "在人权的保护和享受方面取得进展，减少不平等和歧视；进一步融合发展权",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY45.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=zh#page=178"
  },
  {
    ID: 45,
    BudgetSection: 1,
    Entity: "UNAOC",
    EntityFullName: "联合国文明联盟",
    Programme: "通盘决策、领导和协调",
    Subprogramme: "联合国文明联盟",
    Title: "加强联合国全系统协调和利益攸关方参与以应对反犹太主义",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "维护国际和平与安全",
    Beneficiary: "国际社会",
    BeneficiaryTwo: "难民、少数群体和其他弱势群体",
    SpecificResult: "在人权的保护和享受方面取得进展，减少不平等和歧视；进一步融合发展权",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY46.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=zh#page=179"
  },
  {
    ID: 46,
    BudgetSection: 1,
    Entity: "UNSWE",
    EntityFullName: "联合国可持续发展集团全系统评价办公室",
    Programme: "通盘决策、领导和协调",
    Subprogramme: "联合国可持续发展集团全系统评价办公室",
    Title: "全系统评价证据为联合国80周年倡议决策提供信息",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "加强组织能力、问责制和响应能力，更有效地执行任务",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY47.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=zh#page=187"
  },
  {
    ID: 47,
    BudgetSection: 1,
    Entity: "UNSWE",
    EntityFullName: "联合国可持续发展集团全系统评价办公室",
    Programme: "通盘决策、领导和协调",
    Subprogramme: "联合国可持续发展集团全系统评价办公室",
    Title: "全系统评价结果的提供和使用增加",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "加强组织能力、问责制和响应能力，更有效地执行任务",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY48.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=zh#page=187"
  },
  {
    ID: 48,
    BudgetSection: 1,
    Entity: "UNSWE",
    EntityFullName: "联合国可持续发展集团全系统评价办公室",
    Programme: "通盘决策、领导和协调",
    Subprogramme: "联合国可持续发展集团全系统评价办公室",
    Title: "会员国和政府间机构在决策过程中更好地利用联合国系统评价证据",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "加强组织能力、问责制和响应能力，更有效地执行任务",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY49.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=zh#page=188"
  },
  {
    ID: 49,
    BudgetSection: 2,
    Entity: "DGACM",
    EntityFullName: "大会和会议管理部",
    Programme: "大会和经济及社会理事会事务和会议管理",
    Subprogramme: "大会和经济及社会理事会事务和会议管理",
    Title: "大会主席任命的共同协调人开展的非正式进程数目不断增加",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "通过科学、技术和创新提高流程效率",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.2)&l=zh#page=8"
  },
  {
    ID: 50,
    BudgetSection: 2,
    Entity: "DGACM",
    EntityFullName: "大会和会议管理部",
    Programme: "大会和经济及社会理事会事务和会议管理",
    Subprogramme: "大会和经济及社会理事会事务和会议管理",
    Title: "向代表提供关于各政府间机构会议记录的标准化信息",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "推进技术进步，改善信息质量、可用性、可及性和安全性",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.2)&l=zh#page=9"
  },
  {
    ID: 51,
    BudgetSection: 2,
    Entity: "DGACM",
    EntityFullName: "大会和会议管理部",
    Programme: "大会和经济及社会理事会事务和会议管理",
    Subprogramme: "大会和经济及社会理事会事务和会议管理",
    Title: "各代表团与秘书处之间使用e-deleGATE平台进行更简单、更直观的互动",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "通过科学、技术和创新提高流程效率",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.2)&l=zh#page=10"
  },
  {
    ID: 52,
    BudgetSection: 2,
    Entity: "DGACM",
    EntityFullName: "大会和会议管理部",
    Programme: "大会和经济及社会理事会事务和会议管理",
    Subprogramme: "大会和经济及社会理事会事务和会议管理",
    Title: "改善e-delGATE模块对附属机构的可用性",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "通过科学、技术和创新提高流程效率",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.2)&l=zh#page=10"
  },
  {
    ID: 53,
    BudgetSection: 2,
    Entity: "DGACM",
    EntityFullName: "大会和会议管理部",
    Programme: "大会和经济及社会理事会事务和会议管理",
    Subprogramme: "会议事务的规划和协调",
    Title: "在总部以外举行、并获得服务的会议次数增加",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "加强组织能力、问责制和响应能力，更有效地执行任务",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BR,CA,CR,ET,FR,DE,MA,PA,QA,SA,ES,EI,TH,TM,UY",
    Image: "2DGACM5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.2)&l=zh#page=12"
  },
  {
    ID: 54,
    BudgetSection: 2,
    Entity: "DGACM",
    EntityFullName: "大会和会议管理部",
    Programme: "大会和经济及社会理事会事务和会议管理",
    Subprogramme: "会议事务的规划和协调",
    Title: "全球会议服务网关",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "通过科学、技术和创新提高流程效率",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.2)&l=zh#page=13"
  },
  {
    ID: 55,
    BudgetSection: 2,
    Entity: "DGACM",
    EntityFullName: "大会和会议管理部",
    Programme: "大会和经济及社会理事会事务和会议管理",
    Subprogramme: "会议事务的规划和协调",
    Title: "会员国通过全球调查提供的反馈增加",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "加强组织能力、问责制和响应能力，更有效地执行任务",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.2)&l=zh#page=14"
  },
  {
    ID: 56,
    BudgetSection: 2,
    Entity: "DGACM",
    EntityFullName: "大会和会议管理部",
    Programme: "大会和经济及社会理事会事务和会议管理",
    Subprogramme: "会议事务的规划和协调",
    Title: "通过会议服务交叉培训确保业务具有韧性",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "加强组织能力、问责制和响应能力，更有效地执行任务",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.2)&l=zh#page=14"
  },
  {
    ID: 57,
    BudgetSection: 2,
    Entity: "DGACM",
    EntityFullName: "大会和会议管理部",
    Programme: "大会和经济及社会理事会事务和会议管理",
    Subprogramme: "文件服务",
    Title: "尽管面临制约，但仍保持及时发布文件",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "通过科学、技术和创新提高流程效率",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.2)&l=zh#page=18"
  },
  {
    ID: 58,
    BudgetSection: 2,
    Entity: "DGACM",
    EntityFullName: "大会和会议管理部",
    Programme: "大会和经济及社会理事会事务和会议管理",
    Subprogramme: "文件服务",
    Title: "通过笔译质量管理框架提供高质量的多语种文件",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "加强组织能力、问责制和响应能力，更有效地执行任务",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.2)&l=zh#page=19"
  },
  {
    ID: 59,
    BudgetSection: 2,
    Entity: "DGACM",
    EntityFullName: "大会和会议管理部",
    Programme: "大会和经济及社会理事会事务和会议管理",
    Subprogramme: "文件服务",
    Title: "及时提供会议文件",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "通过科学、技术和创新提高流程效率",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.2)&l=zh#page=20"
  },
  {
    ID: 60,
    BudgetSection: 2,
    Entity: "DGACM",
    EntityFullName: "大会和会议管理部",
    Programme: "大会和经济及社会理事会事务和会议管理",
    Subprogramme: "文件服务",
    Title: "坚持各正式语文享有平等待遇",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "通过科学、技术和创新提高流程效率",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.2)&l=zh#page=20"
  },
  {
    ID: 61,
    BudgetSection: 2,
    Entity: "DGACM",
    EntityFullName: "大会和会议管理部",
    Programme: "大会和经济及社会理事会事务和会议管理",
    Subprogramme: "会议和出版事务",
    Title: "通过口译资源的全球统筹管理，保持质量并为会议组织者实现增效",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "加强组织能力、问责制和响应能力，更有效地执行任务",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.2)&l=zh#page=24"
  },
  {
    ID: 62,
    BudgetSection: 2,
    Entity: "DGACM",
    EntityFullName: "大会和会议管理部",
    Programme: "大会和经济及社会理事会事务和会议管理",
    Subprogramme: "会议和出版事务",
    Title: "提供更多口译服务，以满足会员国对配备口译服务的会议日益增长的需求",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "加强组织能力、问责制和响应能力，更有效地执行任务",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.2)&l=zh#page=25"
  },
  {
    ID: 63,
    BudgetSection: 2,
    Entity: "DGACM",
    EntityFullName: "大会和会议管理部",
    Programme: "大会和经济及社会理事会事务和会议管理",
    Subprogramme: "会议和出版事务",
    Title: "加强面向会员国和公众的出版产品",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "推进技术进步，改善信息质量、可用性、可及性和安全性",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.2)&l=zh#page=25"
  },
  {
    ID: 64,
    BudgetSection: 2,
    Entity: "DGACM",
    EntityFullName: "大会和会议管理部",
    Programme: "大会和经济及社会理事会事务和会议管理",
    Subprogramme: "会议和出版事务",
    Title: "利用内部口译规划技术保持会议覆盖率",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "推进技术进步，改善信息质量、可用性、可及性和安全性",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.2)&l=zh#page=26"
  },
  {
    ID: 65,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "政治与建设和平事务部",
    Programme: "政治事务",
    Subprogramme: "预防、管理和解决冲突",
    Title: "会员国和其他利益攸关方促进对所有形式联合国和平行动的前景进行审查",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "维护国际和平与安全",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "加强体制、法治和预防冲突",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=zh#page=13"
  },
  {
    ID: 66,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "政治与建设和平事务部",
    Programme: "政治事务",
    Subprogramme: "预防、管理和解决冲突",
    Title: "减少对国际和平与安全的威胁",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "维护国际和平与安全",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "加强体制、法治和预防冲突",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CO,LY,MZ,SD,QQ",
    Image: "3DPPA2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=zh#page=13"
  },
  {
    ID: 67,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "政治与建设和平事务部",
    Programme: "政治事务",
    Subprogramme: "预防、管理和解决冲突",
    Title: "区域和次区域组织在调解、预防外交和斡旋方面得到支持",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "维护国际和平与安全",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "加强体制、法治和预防冲突",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=zh#page=14"
  },
  {
    ID: 68,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "政治与建设和平事务部",
    Programme: "政治事务",
    Subprogramme: "预防、管理和解决冲突",
    Title: "会员国获得快速调解支持的机会有所增加",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "维护国际和平与安全",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "加强体制、法治和预防冲突",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=zh#page=14"
  },
  {
    ID: 69,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "政治与建设和平事务部",
    Programme: "政治事务",
    Subprogramme: "选举援助",
    Title: "加强妇女在选举和政治进程中的领导力和参与",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "维护国际和平与安全",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "妇女和女童",
    SpecificResult: "加强体制、法治和预防冲突",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=zh#page=17"
  },
  {
    ID: 70,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "政治与建设和平事务部",
    Programme: "政治事务",
    Subprogramme: "选举援助",
    Title: "妇女在选举和政治进程中的代表性增强",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "维护国际和平与安全",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "妇女和女童",
    SpecificResult: "加强体制、法治和预防冲突",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=zh#page=18"
  },
  {
    ID: 71,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "政治与建设和平事务部",
    Programme: "政治事务",
    Subprogramme: "选举援助",
    Title: "通过与区域和次区域组织的联合举措，接受联合国选举援助的会员国的能力得到加强",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "维护国际和平与安全",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "国际社会",
    SpecificResult: "加强体制、法治和预防冲突",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=zh#page=18"
  },
  {
    ID: 72,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "政治与建设和平事务部",
    Programme: "政治事务",
    Subprogramme: "选举援助",
    Title: "会员国要求联合国提供选举援助的请求得到及时有效的回应",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "维护国际和平与安全",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "国际社会",
    SpecificResult: "加强体制、法治和预防冲突",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=zh#page=19"
  },
  {
    ID: 73,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "政治与建设和平事务部",
    Programme: "政治事务",
    Subprogramme: "安全理事会事务",
    Title: "通过更及时地考虑成员的反馈来改进安全理事会的工作方法",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "维护国际和平与安全",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "通过科学、技术和创新提高流程效率",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=zh#page=21"
  },
  {
    ID: 74,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "政治与建设和平事务部",
    Programme: "政治事务",
    Subprogramme: "安全理事会事务",
    Title: "就安全理事会的工作加强与会员国的接触",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "维护国际和平与安全",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "改善信息传播和使用",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=zh#page=22"
  },
  {
    ID: 75,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "政治与建设和平事务部",
    Programme: "政治事务",
    Subprogramme: "安全理事会事务",
    Title: "会员国和公众更容易获得关于安全理事会惯例和工作的最新即时分析资料",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "维护国际和平与安全",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "改善信息传播和使用",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=zh#page=22"
  },
  {
    ID: 76,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "政治与建设和平事务部",
    Programme: "政治事务",
    Subprogramme: "安全理事会事务",
    Title: "安全理事会成员及时收到关于制裁措施执行情况的信息",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "维护国际和平与安全",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "改善信息传播和使用",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=zh#page=23"
  },
  {
    ID: 77,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "政治与建设和平事务部",
    Programme: "政治事务",
    Subprogramme: "非殖民化",
    Title: "加强公众的非殖民化意识",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "维护国际和平与安全",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "改善信息传播和使用",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=zh#page=25"
  },
  {
    ID: 78,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "政治与建设和平事务部",
    Programme: "政治事务",
    Subprogramme: "非殖民化",
    Title: "特别委员会可获得非殖民化问题合格专家的最新名单",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "维护国际和平与安全",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "改善信息传播和使用",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=zh#page=26"
  },
  {
    ID: 79,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "政治与建设和平事务部",
    Programme: "政治事务",
    Subprogramme: "非殖民化",
    Title: "非殖民化信息得到更多传播",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "维护国际和平与安全",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "改善信息传播和使用",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=zh#page=26"
  },
  {
    ID: 80,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "政治与建设和平事务部",
    Programme: "政治事务",
    Subprogramme: "非殖民化",
    Title: "特别委员会可获得关于向非自治领土提供的援助的增强型报告",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "维护国际和平与安全",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "提高报告可持续发展目标进展情况的能力；提高自愿国别评估数目和质量",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=zh#page=27"
  },
  {
    ID: 81,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "政治与建设和平事务部",
    Programme: "政治事务",
    Subprogramme: "巴勒斯坦问题",
    Title: "会员国更多参与和并为委员会提供更多支持",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "维护国际和平与安全",
    Beneficiary: "国际社会",
    BeneficiaryTwo: "难民、少数群体和其他弱势群体",
    SpecificResult: "多边主义得到加强",
    SpecificResultOrder: 2,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=zh#page=29"
  },
  {
    ID: 82,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "政治与建设和平事务部",
    Programme: "政治事务",
    Subprogramme: "巴勒斯坦问题",
    Title: "委员会就巴勒斯坦问题开展的公共外联活动得到加强",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "维护国际和平与安全",
    Beneficiary: "国际社会",
    BeneficiaryTwo: "难民、少数群体和其他弱势群体",
    SpecificResult: "改善信息传播和使用",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=zh#page=29"
  },
  {
    ID: 83,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "政治与建设和平事务部",
    Programme: "政治事务",
    Subprogramme: "巴勒斯坦问题",
    Title: "委员会的情况通报和与安全理事会的接触得到加强",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "维护国际和平与安全",
    Beneficiary: "国际社会",
    BeneficiaryTwo: "难民、少数群体和其他弱势群体",
    SpecificResult: "多边主义得到加强",
    SpecificResultOrder: 2,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=zh#page=30"
  },
  {
    ID: 84,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "政治与建设和平事务部",
    Programme: "政治事务",
    Subprogramme: "巴勒斯坦问题",
    Title: "委员会就巴勒斯坦问题开展更多宣传并使更多公众参与",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "维护国际和平与安全",
    Beneficiary: "国际社会",
    BeneficiaryTwo: "难民、少数群体和其他弱势群体",
    SpecificResult: "改善信息传播和使用",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=zh#page=31"
  },
  {
    ID: 85,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "政治与建设和平事务部",
    Programme: "政治事务",
    Subprogramme: "建设和平支助办公室",
    Title: "会员国加强国家预防和建设和平战略和办法",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "维护国际和平与安全",
    Beneficiary: "亚洲及太平洋地区会员国",
    BeneficiaryTwo: "非洲会员国",
    SpecificResult: "加强体制、法治和预防冲突",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "TD,MR,PG",
    Image: "3DPPA21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=zh#page=33"
  },
  {
    ID: 86,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "政治与建设和平事务部",
    Programme: "政治事务",
    Subprogramme: "建设和平支助办公室",
    Title: "更加注重特派任务的过渡",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "维护国际和平与安全",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "加强体制、法治和预防冲突",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=zh#page=34"
  },
  {
    ID: 87,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "政治与建设和平事务部",
    Programme: "政治事务",
    Subprogramme: "建设和平支助办公室",
    Title: "加强与国际金融机构的伙伴关系，以促进国家自主的建设和平和预防战略",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "维护国际和平与安全",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "加强体制、法治和预防冲突",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=zh#page=35"
  },
  {
    ID: 88,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "政治与建设和平事务部",
    Programme: "政治事务",
    Subprogramme: "建设和平支助办公室",
    Title: "对建设和平基金报告催化效应的举措提供更多投资",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "维护国际和平与安全",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "加强体制、法治和预防冲突",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=zh#page=35"
  },
  {
    ID: 89,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "政治与建设和平事务部",
    Programme: "政治事务",
    Subprogramme: "联合国同阿拉伯国家联盟的合作",
    Title: "阿拉伯国家联盟与联合国在妇女权利和武装冲突中保护儿童方面开展的合作得到加强",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "维护国际和平与安全",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "加强体制、法治和预防冲突",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "EG,QG,LB,IQ,JO,SA,LY,TN,MA,KW,DZ,BH,OM,QA,AE,MR,SO,PS,DJ,KM,YE,SD,QQ,SY",
    Image: "3DPPA25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=zh#page=38"
  },
  {
    ID: 90,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "政治与建设和平事务部",
    Programme: "政治事务",
    Subprogramme: "联合国同阿拉伯国家联盟的合作",
    Title: "阿拉伯国家联盟在预防外交、调解和分析方面取得进展",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "维护国际和平与安全",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "加强体制、法治和预防冲突",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "EG,QG,LB,IQ,JO,SA,LY,TN,MA,KW,DZ,BH,OM,QA,AE,MR,SO,PS,DJ,KM,YE,SD,QQ,SY",
    Image: "3DPPA26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=zh#page=38"
  },
  {
    ID: 91,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "政治与建设和平事务部",
    Programme: "政治事务",
    Subprogramme: "联合国同阿拉伯国家联盟的合作",
    Title: "与阿拉伯国家联盟总秘书处和阿盟成员国的互动协作得到加强",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "维护国际和平与安全",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "加强体制、法治和预防冲突",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "EG,QG,LB,IQ,JO,SA,LY,TN,MA,KW,DZ,BH,OM,QA,AE,MR,SO,PS,DJ,KM,YE,SD,QQ,SY",
    Image: "3DPPA27.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=zh#page=39"
  },
  {
    ID: 92,
    BudgetSection: 3,
    Entity: "DPPA",
    EntityFullName: "政治与建设和平事务部",
    Programme: "政治事务",
    Subprogramme: "联合国同阿拉伯国家联盟的合作",
    Title: "联合国和阿拉伯国家联盟在阿拉伯区域推动预防冲突与保持和平方面的伙伴关系得到加强",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "维护国际和平与安全",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "加强体制、法治和预防冲突",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "EG,QG,LB,IQ,JO,SA,LY,TN,MA,KW,DZ,BH,OM,QA,AE,MR,SO,PS,DJ,KM,YE,SD,QQ,SY",
    Image: "3DPPA28.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=zh#page=39"
  },
  {
    ID: 93,
    BudgetSection: 3,
    Entity: "UNSCO",
    EntityFullName: "联合国中东和平进程特别协调员办事处",
    Programme: "政治事务",
    Subprogramme: "联合国中东和平进程特别协调员办事处",
    Title: "循证的加沙恢复规划",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "维护国际和平与安全",
    Beneficiary: "难民、少数群体和其他弱势群体",
    BeneficiaryTwo: " ",
    SpecificResult: "加强体制、法治和预防冲突",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "PS",
    Image: "3DPPA29.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=zh#page=63"
  },
  {
    ID: 94,
    BudgetSection: 3,
    Entity: "UNSCO",
    EntityFullName: "联合国中东和平进程特别协调员办事处",
    Programme: "政治事务",
    Subprogramme: "联合国中东和平进程特别协调员办事处",
    Title: "在通过谈判达成的两国解决方案框架内建立一个管理整个巴勒斯坦被占领土的单一的巴勒斯坦政府方面取得进展",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "维护国际和平与安全",
    Beneficiary: "难民、少数群体和其他弱势群体",
    BeneficiaryTwo: " ",
    SpecificResult: "加强体制、法治和预防冲突",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "PS",
    Image: "3DPPA30.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=zh#page=63"
  },
  {
    ID: 95,
    BudgetSection: 3,
    Entity: "UNSCO",
    EntityFullName: "联合国中东和平进程特别协调员办事处",
    Programme: "政治事务",
    Subprogramme: "联合国中东和平进程特别协调员办事处",
    Title: "努力建立解决以色列-巴勒斯坦冲突的政治框架",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "维护国际和平与安全",
    Beneficiary: "难民、少数群体和其他弱势群体",
    BeneficiaryTwo: " ",
    SpecificResult: "加强体制、法治和预防冲突",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "PS",
    Image: "3DPPA31.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=zh#page=64"
  },
  {
    ID: 96,
    BudgetSection: 3,
    Entity: "UNSCO",
    EntityFullName: "联合国中东和平进程特别协调员办事处",
    Programme: "政治事务",
    Subprogramme: "联合国中东和平进程特别协调员办事处",
    Title: "在执行安全理事会第2803(2025)号决议核可的《全面解决加沙冲突计划》方面取得的进展",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "维护国际和平与安全",
    Beneficiary: "难民、少数群体和其他弱势群体",
    BeneficiaryTwo: " ",
    SpecificResult: "加强体制、法治和预防冲突",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "PS",
    Image: "3DPPA32.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=zh#page=65"
  },
  {
    ID: 97,
    BudgetSection: 3,
    Entity: "UNRoD",
    EntityFullName: "联合国关于在巴勒斯坦被占领土修建隔离墙造成的损失登记册",
    Programme: "政治事务",
    Subprogramme: "联合国关于在巴勒斯坦被占领土修建隔离墙造成的损失登记册",
    Title: "优化损失索赔审查程序，更快地为索赔人提供服务",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "维护国际和平与安全",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "难民、少数群体和其他弱势群体",
    SpecificResult: "通过科学、技术和创新提高流程效率",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "PS",
    Image: "3DPPA33.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=zh#page=72"
  },
  {
    ID: 98,
    BudgetSection: 3,
    Entity: "UNRoD",
    EntityFullName: "联合国关于在巴勒斯坦被占领土修建隔离墙造成的损失登记册",
    Programme: "政治事务",
    Subprogramme: "联合国关于在巴勒斯坦被占领土修建隔离墙造成的损失登记册",
    Title: "未处理索赔数目减少",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "维护国际和平与安全",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "难民、少数群体和其他弱势群体",
    SpecificResult: "通过科学、技术和创新提高流程效率",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "PS",
    Image: "3DPPA34.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=zh#page=73"
  },
  {
    ID: 99,
    BudgetSection: 3,
    Entity: "UNRoD",
    EntityFullName: "联合国关于在巴勒斯坦被占领土修建隔离墙造成的损失登记册",
    Programme: "政治事务",
    Subprogramme: "联合国关于在巴勒斯坦被占领土修建隔离墙造成的损失登记册",
    Title: "补正流程得到加强，以完成已收集但资料缺失的索赔案件的处理",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "维护国际和平与安全",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "难民、少数群体和其他弱势群体",
    SpecificResult: "改善信息传播和使用",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "PS",
    Image: "3DPPA35.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=zh#page=73"
  },
  {
    ID: 100,
    BudgetSection: 3,
    Entity: "UNRoD",
    EntityFullName: "联合国关于在巴勒斯坦被占领土修建隔离墙造成的损失登记册",
    Programme: "政治事务",
    Subprogramme: "联合国关于在巴勒斯坦被占领土修建隔离墙造成的损失登记册",
    Title: "通过统一提交程序改善委员会裁定工作",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "维护国际和平与安全",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "难民、少数群体和其他弱势群体",
    SpecificResult: "通过科学、技术和创新提高流程效率",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "PS",
    Image: "3DPPA36.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=zh#page=74"
  },
  {
    ID: 101,
    BudgetSection: 3,
    Entity: "UNOAU",
    EntityFullName: "联合国驻非洲联盟办事处",
    Programme: "政治事务",
    Subprogramme: "联合国驻非洲联盟办事处",
    Title: "索马里安全过渡已经完成，非洲联盟和平支助能力得到加强",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "维护国际和平与安全",
    Beneficiary: "国际社会",
    BeneficiaryTwo: "非洲会员国",
    SpecificResult: "加强体制、法治和预防冲突",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "SO",
    Image: "3DPPA37.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=zh#page=83"
  },
  {
    ID: 102,
    BudgetSection: 3,
    Entity: "UNOAU",
    EntityFullName: "联合国驻非洲联盟办事处",
    Programme: "政治事务",
    Subprogramme: "联合国驻非洲联盟办事处",
    Title: "推动青年参与非洲和平与安全倡议",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "维护国际和平与安全",
    Beneficiary: "青年",
    BeneficiaryTwo: "非洲会员国",
    SpecificResult: "加强体制、法治和预防冲突",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "3DPPA38.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=zh#page=84"
  },
  {
    ID: 103,
    BudgetSection: 3,
    Entity: "UNOAU",
    EntityFullName: "联合国驻非洲联盟办事处",
    Programme: "政治事务",
    Subprogramme: "联合国驻非洲联盟办事处",
    Title: "联合国-非洲联盟在预防和调解冲突、保持和平、消除冲突根源方面的联合努力得到加强",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "维护国际和平与安全",
    Beneficiary: "国际社会",
    BeneficiaryTwo: "非洲会员国",
    SpecificResult: "加强体制、法治和预防冲突",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "3DPPA39.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=zh#page=84"
  },
  {
    ID: 104,
    BudgetSection: 3,
    Entity: "UNOAU",
    EntityFullName: "联合国驻非洲联盟办事处",
    Programme: "政治事务",
    Subprogramme: "联合国驻非洲联盟办事处",
    Title: "加强非洲妇女在和平与安全进程中的切实参与、领导作用和影响力",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "维护国际和平与安全",
    Beneficiary: "妇女和女童",
    BeneficiaryTwo: "非洲会员国",
    SpecificResult: "加强体制、法治和预防冲突",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "3DPPA40.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=zh#page=85"
  },
  {
    ID: 105,
    BudgetSection: 3,
    Entity: "OCT",
    EntityFullName: "反恐怖主义办公室",
    Programme: "政治事务",
    Subprogramme: "反恐怖主义办公室",
    Title: "为恐怖主义受害者倡导权益、影响政策制定、获取支持的全球网络",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "药物管制、预防犯罪和打击一切形式和表现的有组织犯罪和国际恐怖主义",
    Beneficiary: "难民、少数群体和其他弱势群体",
    BeneficiaryTwo: "国际社会",
    SpecificResult: "加强对法治的遵守；加强预防犯罪和刑事司法；减少腐败；预防和打击恐怖主义",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA41.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=zh#page=98"
  },
  {
    ID: 106,
    BudgetSection: 3,
    Entity: "OCT",
    EntityFullName: "反恐怖主义办公室",
    Programme: "政治事务",
    Subprogramme: "反恐怖主义办公室",
    Title: "会员国进一步努力打击恐怖分子使用武器的行为",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "药物管制、预防犯罪和打击一切形式和表现的有组织犯罪和国际恐怖主义",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "加强对法治的遵守；加强预防犯罪和刑事司法；减少腐败；预防和打击恐怖主义",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA42.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=zh#page=99"
  },
  {
    ID: 107,
    BudgetSection: 3,
    Entity: "OCT",
    EntityFullName: "反恐怖主义办公室",
    Programme: "政治事务",
    Subprogramme: "反恐怖主义办公室",
    Title: "通过加强机构间协调和情报分析技能，提高国家反恐能力，以防止和打击恐怖主义",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "药物管制、预防犯罪和打击一切形式和表现的有组织犯罪和国际恐怖主义",
    Beneficiary: "国际社会",
    BeneficiaryTwo: "非洲会员国",
    SpecificResult: "加强对法治的遵守；加强预防犯罪和刑事司法；减少腐败；预防和打击恐怖主义",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA43.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=zh#page=100"
  },
  {
    ID: 108,
    BudgetSection: 3,
    Entity: "OCT",
    EntityFullName: "反恐怖主义办公室",
    Programme: "政治事务",
    Subprogramme: "反恐怖主义办公室",
    Title: "增强国家能力，以打击为恐怖主义目的使用无人航空器系统",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "药物管制、预防犯罪和打击一切形式和表现的有组织犯罪和国际恐怖主义",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "加强对法治的遵守；加强预防犯罪和刑事司法；减少腐败；预防和打击恐怖主义",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA44.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=zh#page=100"
  },
  {
    ID: 109,
    BudgetSection: 4,
    Entity: "ODA",
    EntityFullName: "裁军事务厅",
    Programme: "裁军",
    Subprogramme: "裁军和军备限制问题多边谈判和审议",
    Title: "《禁止或限制使用某些可被认为具有过分伤害力或滥杀滥伤作用的常规武器公约》缔约国提交的年度报告增加",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "裁军",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "裁军、不扩散和军备控制努力与举措取得进展",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.4)&l=zh#page=8"
  },
  {
    ID: 110,
    BudgetSection: 4,
    Entity: "ODA",
    EntityFullName: "裁军事务厅",
    Programme: "裁军",
    Subprogramme: "裁军和军备限制问题多边谈判和审议",
    Title: "裁军谈判会议的审议和最终谈判增加",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "裁军",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "裁军、不扩散和军备控制努力与举措取得进展",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.4)&l=zh#page=9"
  },
  {
    ID: 111,
    BudgetSection: 4,
    Entity: "ODA",
    EntityFullName: "裁军事务厅",
    Programme: "裁军",
    Subprogramme: "裁军和军备限制问题多边谈判和审议",
    Title: "防止外层空间的军备竞赛",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "裁军",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "裁军、不扩散和军备控制努力与举措取得进展",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.4)&l=zh#page=9"
  },
  {
    ID: 112,
    BudgetSection: 4,
    Entity: "ODA",
    EntityFullName: "裁军事务厅",
    Programme: "裁军",
    Subprogramme: "裁军和军备限制问题多边谈判和审议",
    Title: "应对致命自主武器系统领域的新兴技术",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "裁军",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "裁军、不扩散和军备控制努力与举措取得进展",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.4)&l=zh#page=10"
  },
  {
    ID: 113,
    BudgetSection: 4,
    Entity: "ODA",
    EntityFullName: "裁军事务厅",
    Programme: "裁军",
    Subprogramme: "大规模毁灭性武器",
    Title: "亚太区域会员国确定在参与应对生物武器扩散或使用所构成威胁的文书方面的潜在协同增效作用",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "裁军",
    Beneficiary: "拉丁美洲和加勒比地区会员国",
    BeneficiaryTwo: "亚洲及太平洋地区会员国",
    SpecificResult: "裁军、不扩散和军备控制努力与举措取得进展",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CL,CO,CR,CU,DM,DO,EC,SV,GD,GT,GY,HT,HN,JM,MX,NI,PA,PY,PE,KN,LC,VC,SR,TT,UY,VE,AF,BH,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,IN,AP,ID,IR,IQ,JP,JO,KZ,KW,KG,LA,LB,MY,MV,MH,FM,MN,MM,NR,NP,OM,PK,PW,PG,PH,QA,KR,WS,SA,SG,SB,LK,SY,TJ,TH,TL,TO,TR,TM,TV,AE,UZ,VU,VN,YE",
    Image: "4ODA5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.4)&l=zh#page=13"
  },
  {
    ID: 114,
    BudgetSection: 4,
    Entity: "ODA",
    EntityFullName: "裁军事务厅",
    Programme: "裁军",
    Subprogramme: "大规模毁灭性武器",
    Title: "建立中东无核武器和其他大规模毁灭性武器区的进程",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "裁军",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "裁军、不扩散和军备控制努力与举措取得进展",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,BH,DJ,EG,QG,IR,IQ,JO,KW,LB,LY,MA,OM,QA,SA,SY,TN,AE,PS,YE",
    Image: "4ODA6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.4)&l=zh#page=14"
  },
  {
    ID: 115,
    BudgetSection: 4,
    Entity: "ODA",
    EntityFullName: "裁军事务厅",
    Programme: "裁军",
    Subprogramme: "大规模毁灭性武器",
    Title: "改进秘书长调查指称使用化学和生物武器机制的准备状态",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "裁军",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "裁军、不扩散和军备控制努力与举措取得进展",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.4)&l=zh#page=14"
  },
  {
    ID: 116,
    BudgetSection: 4,
    Entity: "ODA",
    EntityFullName: "裁军事务厅",
    Programme: "裁军",
    Subprogramme: "大规模毁灭性武器",
    Title: "核裁军核查问题科学和技术专家组推进对核裁军核查方面技术挑战和可行办法的理解",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "裁军",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "裁军、不扩散和军备控制努力与举措取得进展",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.4)&l=zh#page=15"
  },
  {
    ID: 117,
    BudgetSection: 4,
    Entity: "ODA",
    EntityFullName: "裁军事务厅",
    Programme: "裁军",
    Subprogramme: "常规武器",
    Title: "对全球军事开支增加对实现可持续发展目标进展的影响的理解提高，减轻影响的建议增多",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "裁军",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "改善信息传播和使用",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.4)&l=zh#page=19"
  },
  {
    ID: 118,
    BudgetSection: 4,
    Entity: "ODA",
    EntityFullName: "裁军事务厅",
    Programme: "裁军",
    Subprogramme: "常规武器",
    Title: "对弹药全周期管理全球援助机制的利用增加",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "裁军",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "裁军、不扩散和军备控制努力与举措取得进展",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.4)&l=zh#page=20"
  },
  {
    ID: 119,
    BudgetSection: 4,
    Entity: "ODA",
    EntityFullName: "裁军事务厅",
    Programme: "裁军",
    Subprogramme: "常规武器",
    Title: "应对小武器和轻武器制造、技术和设计方面的发展情况，以防止、打击和消除其非法贸易和滥用",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "裁军",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "裁军、不扩散和军备控制努力与举措取得进展",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.4)&l=zh#page=21"
  },
  {
    ID: 120,
    BudgetSection: 4,
    Entity: "ODA",
    EntityFullName: "裁军事务厅",
    Programme: "裁军",
    Subprogramme: "常规武器",
    Title: "增强专门知识，以推进《小武器和轻武器行动纲领》及其《国际追查文书》的执行",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "裁军",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "裁军、不扩散和军备控制努力与举措取得进展",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.4)&l=zh#page=21"
  },
  {
    ID: 121,
    BudgetSection: 4,
    Entity: "ODA",
    EntityFullName: "裁军事务厅",
    Programme: "裁军",
    Subprogramme: "区域裁军、能力建设和外联",
    Title: "国家裁军专门知识得到加强，以推进裁军努力",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "裁军",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "裁军、不扩散和军备控制努力与举措取得进展",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "SR,ZM",
    Image: "4ODA13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.4)&l=zh#page=25"
  },
  {
    ID: 122,
    BudgetSection: 4,
    Entity: "ODA",
    EntityFullName: "裁军事务厅",
    Programme: "裁军",
    Subprogramme: "区域裁军、能力建设和外联",
    Title: "关于从国际安全角度看信息和通信技术领域发展以及推进信息和通信技术使用方面负责任国家行为的全球机制",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "裁军",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "裁军、不扩散和军备控制努力与举措取得进展",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.4)&l=zh#page=25"
  },
  {
    ID: 123,
    BudgetSection: 4,
    Entity: "ODA",
    EntityFullName: "裁军事务厅",
    Programme: "裁军",
    Subprogramme: "裁军和军备限制问题多边谈判和审议",
    Title: "通过联合国裁军研究金、培训和咨询服务方案加强裁军专门知识",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "裁军",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "裁军、不扩散和军备控制努力与举措取得进展",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.4)&l=zh#page=28"
  },
  {
    ID: 124,
    BudgetSection: 4,
    Entity: "ODA",
    EntityFullName: "裁军事务厅",
    Programme: "裁军",
    Subprogramme: "信息和外联",
    Title: "增强青年在裁军和不扩散领域的权能",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "裁军",
    Beneficiary: "青年",
    BeneficiaryTwo: "国际社会",
    SpecificResult: "裁军、不扩散和军备控制努力与举措取得进展",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.4)&l=zh#page=28"
  },
  {
    ID: 125,
    BudgetSection: 4,
    Entity: "ODA",
    EntityFullName: "裁军事务厅",
    Programme: "裁军",
    Subprogramme: "信息和外联",
    Title: "提高对裁军和不扩散问题的认识",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "裁军",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "裁军、不扩散和军备控制努力与举措取得进展",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.4)&l=zh#page=29"
  },
  {
    ID: 126,
    BudgetSection: 4,
    Entity: "ODA",
    EntityFullName: "裁军事务厅",
    Programme: "裁军",
    Subprogramme: "区域裁军",
    Title: "在区域、次区域和国家层面宣传和支持执行《常规弹药全周期管理全球框架》",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "裁军",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "裁军、不扩散和军备控制努力与举措取得进展",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.4)&l=zh#page=30"
  },
  {
    ID: 127,
    BudgetSection: 4,
    Entity: "ODA",
    EntityFullName: "裁军事务厅",
    Programme: "裁军",
    Subprogramme: "区域裁军",
    Title: "更多地将裁军纳入国家发展框架",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "裁军",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "裁军、不扩散和军备控制努力与举措取得进展",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.4)&l=zh#page=30"
  },
  {
    ID: 128,
    BudgetSection: 5,
    Entity: "DPO",
    EntityFullName: "和平行动部",
    Programme: "维持和平行动",
    Subprogramme: "业务活动",
    Title: "2019年《中非共和国和平与和解政治协议》的执行进展",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "维护国际和平与安全",
    Beneficiary: "非洲会员国",
    BeneficiaryTwo: "难民、少数群体和其他弱势群体",
    SpecificResult: "加强体制、法治和预防冲突",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CF",
    Image: "5DPO1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.5)&l=zh#page=7"
  },
  {
    ID: 129,
    BudgetSection: 5,
    Entity: "DPO",
    EntityFullName: "和平行动部",
    Programme: "维持和平行动",
    Subprogramme: "业务活动",
    Title: "2018年《解决南苏丹共和国冲突重振协议》的执行进展",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "维护国际和平与安全",
    Beneficiary: "非洲会员国",
    BeneficiaryTwo: "难民、少数群体和其他弱势群体",
    SpecificResult: "加强体制、法治和预防冲突",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "SS,II",
    Image: "5DPO2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.5)&l=zh#page=8"
  },
  {
    ID: 130,
    BudgetSection: 5,
    Entity: "DPO",
    EntityFullName: "和平行动部",
    Programme: "维持和平行动",
    Subprogramme: "业务活动",
    Title: "通过驻苏丹和南苏丹驻地协调员阿卜耶伊联合方案使阿卜耶伊的建设和平工作得到了加强",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "维护国际和平与安全",
    Beneficiary: "非洲会员国",
    BeneficiaryTwo: "难民、少数群体和其他弱势群体",
    SpecificResult: "加强体制、法治和预防冲突",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "SS,II,SD,QQ",
    Image: "5DPO3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.5)&l=zh#page=9"
  },
  {
    ID: 131,
    BudgetSection: 5,
    Entity: "DPO",
    EntityFullName: "和平行动部",
    Programme: "维持和平行动",
    Subprogramme: "业务活动",
    Title: "刚果民主共和国东部外国战斗人员解除武装、复员、遣返、重新安置或重返社会工作得到加强",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "维护国际和平与安全",
    Beneficiary: "非洲会员国",
    BeneficiaryTwo: "难民、少数群体和其他弱势群体",
    SpecificResult: "加强体制、法治和预防冲突",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CD",
    Image: "5DPO4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.5)&l=zh#page=10"
  },
  {
    ID: 132,
    BudgetSection: 5,
    Entity: "DPO",
    EntityFullName: "和平行动部",
    Programme: "维持和平行动",
    Subprogramme: "军事",
    Title: "为联合国维和特派团的过渡和撤离所做的准备工作得到了加强",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "维护国际和平与安全",
    Beneficiary: "国际社会",
    BeneficiaryTwo: "难民、少数群体和其他弱势群体",
    SpecificResult: "改善维和特派团的业绩、安全和安保，包括根据安全理事会决议进行平稳过渡",
    SpecificResultOrder: 37,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CY,LB,SS,II,SD,QQ",
    Image: "5DPO5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.5)&l=zh#page=12"
  },
  {
    ID: 133,
    BudgetSection: 5,
    Entity: "DPO",
    EntityFullName: "和平行动部",
    Programme: "维持和平行动",
    Subprogramme: "军事",
    Title: "特派团建立爆炸物处理能力，以应对简易爆炸装置构成的威胁",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "维护国际和平与安全",
    Beneficiary: "国际社会",
    BeneficiaryTwo: "难民、少数群体和其他弱势群体",
    SpecificResult: "改善维和特派团的业绩、安全和安保，包括根据安全理事会决议进行平稳过渡",
    SpecificResultOrder: 37,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "LB",
    Image: "5DPO6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.5)&l=zh#page=13"
  },
  {
    ID: 134,
    BudgetSection: 5,
    Entity: "DPO",
    EntityFullName: "和平行动部",
    Programme: "维持和平行动",
    Subprogramme: "军事",
    Title: "和平行动采取应对行动，抵御敌对无人机系统的威胁",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "维护国际和平与安全",
    Beneficiary: "国际社会",
    BeneficiaryTwo: "难民、少数群体和其他弱势群体",
    SpecificResult: "改善维和特派团的业绩、安全和安保，包括根据安全理事会决议进行平稳过渡",
    SpecificResultOrder: 37,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "CD,ML",
    Image: "5DPO7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.5)&l=zh#page=13"
  },
  {
    ID: 135,
    BudgetSection: 5,
    Entity: "DPO",
    EntityFullName: "和平行动部",
    Programme: "维持和平行动",
    Subprogramme: "军事",
    Title: "维和行动加强对虚假信息、错误信息和仇恨言论的监测、分析和应对",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "维护国际和平与安全",
    Beneficiary: "国际社会",
    BeneficiaryTwo: "难民、少数群体和其他弱势群体",
    SpecificResult: "改善维和特派团的业绩、安全和安保，包括根据安全理事会决议进行平稳过渡",
    SpecificResultOrder: 37,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CD,LB,ML,SS,II",
    Image: "5DPO8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.5)&l=zh#page=14"
  },
  {
    ID: 136,
    BudgetSection: 5,
    Entity: "DPO",
    EntityFullName: "和平行动部",
    Programme: "维持和平行动",
    Subprogramme: "法治和安全机构",
    Title: "国家和区域应对简易爆炸装置威胁的能力得到加强",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "维护国际和平与安全",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "加强体制、法治和预防冲突",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "5DPO9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.5)&l=zh#page=17"
  },
  {
    ID: 137,
    BudgetSection: 5,
    Entity: "DPO",
    EntityFullName: "和平行动部",
    Programme: "维持和平行动",
    Subprogramme: "法治和安全机构",
    Title: "联合国警察的绩效得到改善，以加强任务的执行",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "维护国际和平与安全",
    Beneficiary: "国际社会",
    BeneficiaryTwo: "难民、少数群体和其他弱势群体",
    SpecificResult: "加强体制、法治和预防冲突",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "5DPO10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.5)&l=zh#page=17"
  },
  {
    ID: 138,
    BudgetSection: 5,
    Entity: "DPO",
    EntityFullName: "和平行动部",
    Programme: "维持和平行动",
    Subprogramme: "法治和安全机构",
    Title: "使东道国能够在特派团过渡期间和之后继续开展法治和安全机构改革并保持改革进展",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "维护国际和平与安全",
    Beneficiary: "国际社会",
    BeneficiaryTwo: "难民、少数群体和其他弱势群体",
    SpecificResult: "加强体制、法治和预防冲突",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CF,CD,ML,SO",
    Image: "5DPO11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.5)&l=zh#page=18"
  },
  {
    ID: 139,
    BudgetSection: 5,
    Entity: "DPO",
    EntityFullName: "和平行动部",
    Programme: "维持和平行动",
    Subprogramme: "法治和安全机构",
    Title: "对联合国维持和平行动人员所犯罪行的追责工作加强",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "维护国际和平与安全",
    Beneficiary: "国际社会",
    BeneficiaryTwo: "难民、少数群体和其他弱势群体",
    SpecificResult: "加强体制、法治和预防冲突",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CF,CD,LB,ML",
    Image: "5DPO12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.5)&l=zh#page=19"
  },
  {
    ID: 140,
    BudgetSection: 5,
    Entity: "DPO",
    EntityFullName: "和平行动部",
    Programme: "维持和平行动",
    Subprogramme: "政策、评价和培训",
    Title: "非洲联盟领导的和平行动中保护平民的政策和指导方针得到加强",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "维护国际和平与安全",
    Beneficiary: "非洲会员国",
    BeneficiaryTwo: "国际社会",
    SpecificResult: "加强体制、法治和预防冲突",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "5DPO13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.5)&l=zh#page=23"
  },
  {
    ID: 141,
    BudgetSection: 5,
    Entity: "DPO",
    EntityFullName: "和平行动部",
    Programme: "维持和平行动",
    Subprogramme: "政策、评价和培训",
    Title: "建立一个在线平台，促进会员国就维和人员的准备工作进行直接协作",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "维护国际和平与安全",
    Beneficiary: "国际社会",
    BeneficiaryTwo: "难民、少数群体和其他弱势群体",
    SpecificResult: "改善信息传播和使用",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "5DPO14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.5)&l=zh#page=23"
  },
  {
    ID: 142,
    BudgetSection: 5,
    Entity: "DPO",
    EntityFullName: "和平行动部",
    Programme: "维持和平行动",
    Subprogramme: "政策、评价和培训",
    Title: "外地办事处一级应对当地冲突动态，促进政治解决方案的分析和规划工作得到改进",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "维护国际和平与安全",
    Beneficiary: "国际社会",
    BeneficiaryTwo: "难民、少数群体和其他弱势群体",
    SpecificResult: "加强体制、法治和预防冲突",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "5DPO15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.5)&l=zh#page=24"
  },
  {
    ID: 143,
    BudgetSection: 5,
    Entity: "DPO",
    EntityFullName: "和平行动部",
    Programme: "维持和平行动",
    Subprogramme: "政策、评价和培训",
    Title: "维和行动中针对与冲突有关的性暴力的预防和应对工作得到加强",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "维护国际和平与安全",
    Beneficiary: "妇女和女童",
    BeneficiaryTwo: "难民、少数群体和其他弱势群体",
    SpecificResult: "减少性暴力，包括将性暴力作为战争和恐怖手段使用，减少暴力侵害儿童行为，包括武装冲突局势中侵害儿童的严重暴力行为",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "5DPO16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.5)&l=zh#page=25"
  },
  {
    ID: 144,
    BudgetSection: 5,
    Entity: "UNTSO",
    EntityFullName: "联合国停战监督组织",
    Programme: "维持和平行动",
    Subprogramme: "联合国停战监督组织",
    Title: "停火线沿线及隔离区内的观察工作加强",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "维护国际和平与安全",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "加强体制、法治和预防冲突",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "EG,QG,IL,JO,LB,SY",
    Image: "5DPO17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.5)&l=zh#page=42"
  },
  {
    ID: 145,
    BudgetSection: 5,
    Entity: "UNTSO",
    EntityFullName: "联合国停战监督组织",
    Programme: "维持和平行动",
    Subprogramme: "联合国停战监督组织",
    Title: "更多地参与联合国停战监督组织的任务和工作",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "维护国际和平与安全",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "改善信息传播和使用",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "EG,QG,IL,JO,LB,SY",
    Image: "5DPO18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.5)&l=zh#page=42"
  },
  {
    ID: 146,
    BudgetSection: 5,
    Entity: "UNTSO",
    EntityFullName: "联合国停战监督组织",
    Programme: "维持和平行动",
    Subprogramme: "联合国停战监督组织",
    Title: "适应不断变化的业务环境的组织能力得到加强",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "维护国际和平与安全",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "改善维和特派团的业绩、安全和安保，包括根据安全理事会决议进行平稳过渡",
    SpecificResultOrder: 37,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "EG,QG,IL,JO,LB,SY",
    Image: "5DPO19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.5)&l=zh#page=43"
  },
  {
    ID: 147,
    BudgetSection: 5,
    Entity: "UNTSO",
    EntityFullName: "联合国停战监督组织",
    Programme: "维持和平行动",
    Subprogramme: "联合国停战监督组织",
    Title: "黎巴嫩南部的规划与协调机制得到加强",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "维护国际和平与安全",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "改善维和特派团的业绩、安全和安保，包括根据安全理事会决议进行平稳过渡",
    SpecificResultOrder: 37,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "EG,QG,IL,JO,LB,SY",
    Image: "5DPO20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.5)&l=zh#page=44"
  },
  {
    ID: 148,
    BudgetSection: 5,
    Entity: "UNMOGIP",
    EntityFullName: "联合国驻印度和巴基斯坦军事观察组",
    Programme: "维持和平行动",
    Subprogramme: "联合国驻印度和巴基斯坦军事观察组",
    Title: "关于违反停火指控的投诉数量有限",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "维护国际和平与安全",
    Beneficiary: "国际社会",
    BeneficiaryTwo: "亚洲及太平洋地区会员国",
    SpecificResult: "加强体制、法治和预防冲突",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "IN,AP,PK",
    Image: "5DPO21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.5)&l=zh#page=51"
  },
  {
    ID: 149,
    BudgetSection: 5,
    Entity: "UNMOGIP",
    EntityFullName: "联合国驻印度和巴基斯坦军事观察组",
    Programme: "维持和平行动",
    Subprogramme: "联合国驻印度和巴基斯坦军事观察组",
    Title: "利用地理空间信息系统改进态势感知",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "维护国际和平与安全",
    Beneficiary: "国际社会",
    BeneficiaryTwo: "亚洲及太平洋地区会员国",
    SpecificResult: "加强体制、法治和预防冲突",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "IN,AP,PK",
    Image: "5DPO22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.5)&l=zh#page=52"
  },
  {
    ID: 150,
    BudgetSection: 5,
    Entity: "UNMOGIP",
    EntityFullName: "联合国驻印度和巴基斯坦军事观察组",
    Programme: "维持和平行动",
    Subprogramme: "联合国驻印度和巴基斯坦军事观察组",
    Title: "在控制线上继续派驻人员",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "维护国际和平与安全",
    Beneficiary: "国际社会",
    BeneficiaryTwo: "亚洲及太平洋地区会员国",
    SpecificResult: "加强体制、法治和预防冲突",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "IN,AP,PK",
    Image: "5DPO23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.5)&l=zh#page=52"
  },
  {
    ID: 151,
    BudgetSection: 5,
    Entity: "UNMOGIP",
    EntityFullName: "联合国驻印度和巴基斯坦军事观察组",
    Programme: "维持和平行动",
    Subprogramme: "联合国驻印度和巴基斯坦军事观察组",
    Title: "通过加强联络与接触，增进了相互了解",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "维护国际和平与安全",
    Beneficiary: "国际社会",
    BeneficiaryTwo: "亚洲及太平洋地区会员国",
    SpecificResult: "改善信息传播和使用",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "IN,AP,PK",
    Image: "5DPO24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.5)&l=zh#page=53"
  },
  {
    ID: 152,
    BudgetSection: 6,
    Entity: "OOSA",
    EntityFullName: "外层空间事务厅",
    Programme: "和平利用外层空间",
    Subprogramme: "和平利用外层空间",
    Title: "对潜在危险近地天体的规划和防备得到加强",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "维护国际和平与安全",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "改善信息传播和使用",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AO,BW,KM,SZ,LS,MG,MW,MU,MZ,NA,SC,ZA,ZM,ZW",
    Image: "6COPUOS1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.6)&l=zh#page=4"
  },
  {
    ID: 153,
    BudgetSection: 6,
    Entity: "OOSA",
    EntityFullName: "外层空间事务厅",
    Programme: "和平利用外层空间",
    Subprogramme: "和平利用外层空间",
    Title: "增加进入空间的机会",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "维护国际和平与安全",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "通过稳健协调结构等途径，利用可持续发展目标之间的相互关联性，加快推进可持续发展目标",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "6COPUOS2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.6)&l=zh#page=5"
  },
  {
    ID: 154,
    BudgetSection: 6,
    Entity: "OOSA",
    EntityFullName: "外层空间事务厅",
    Programme: "和平利用外层空间",
    Subprogramme: "和平利用外层空间",
    Title: "更多地利用空间解决办法、伙伴关系、能力建设和参与外层空间活动的治理",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "维护国际和平与安全",
    Beneficiary: "国际社会",
    BeneficiaryTwo: "最不发达国家、内陆发展中国家、小岛屿发展中国家和其他发展中国家",
    SpecificResult: "多边主义得到加强",
    SpecificResultOrder: 2,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "6COPUOS3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.6)&l=zh#page=5"
  },
  {
    ID: 155,
    BudgetSection: 6,
    Entity: "OOSA",
    EntityFullName: "外层空间事务厅",
    Programme: "和平利用外层空间",
    Subprogramme: "和平利用外层空间",
    Title: "更多利用天基技术和数据开展灾害管理和紧急反应",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "维护国际和平与安全",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "推进技术进步，改善信息质量、可用性、可及性和安全性",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "6COPUOS4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.6)&l=zh#page=6"
  },
  {
    ID: 156,
    BudgetSection: 7,
    Entity: "ICJ",
    EntityFullName: "国际法院",
    Programme: "国际法院",
    Subprogramme: "书记官处",
    Title: "增强公众对法院活动的了解",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "促进司法和国际法",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "改善信息传播和使用",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "7ICJ1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.7)&l=zh#page=3"
  },
  {
    ID: 157,
    BudgetSection: 7,
    Entity: "ICJ",
    EntityFullName: "国际法院",
    Programme: "国际法院",
    Subprogramme: "书记官处",
    Title: "与司法程序有关的文件的传送和接收程序得到加强",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "促进司法和国际法",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "促进国际法和加强国际争端解决机制",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "7ICJ2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.7)&l=zh#page=4"
  },
  {
    ID: 158,
    BudgetSection: 7,
    Entity: "ICJ",
    EntityFullName: "国际法院",
    Programme: "国际法院",
    Subprogramme: "书记官处",
    Title: "在社交媒体平台上提供更多关于法院的信息",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "促进司法和国际法",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "促进国际法和加强国际争端解决机制",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "7ICJ3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.7)&l=zh#page=5"
  },
  {
    ID: 159,
    BudgetSection: 7,
    Entity: "ICJ",
    EntityFullName: "国际法院",
    Programme: "国际法院",
    Subprogramme: "书记官处",
    Title: "在年轻人中提高法院活动的可见度、增强对法院活动的了解",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "促进司法和国际法",
    Beneficiary: "国际社会",
    BeneficiaryTwo: "青年",
    SpecificResult: "改善信息传播和使用",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "7ICJ4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.7)&l=zh#page=5"
  },
  {
    ID: 160,
    BudgetSection: 8,
    Entity: "OLA",
    EntityFullName: "法律事务厅",
    Programme: "法律事务",
    Subprogramme: "向全联合国系统提供法律服务",
    Title: "在海地建立新的联合国外地业务和支持驻海地多国镇压黑帮部队的法律框架",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "建立有利的法律和法规框架；减少法律责任风险",
    SpecificResultOrder: 39,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "HT",
    Image: "8OLA1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.8)&l=zh#page=9"
  },
  {
    ID: 161,
    BudgetSection: 8,
    Entity: "OLA",
    EntityFullName: "法律事务厅",
    Programme: "法律事务",
    Subprogramme: "向全联合国系统提供法律服务",
    Title: "缔结关于柬埔寨法院特别法庭继续履行余留职能的协定",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "建立有利的法律和法规框架；减少法律责任风险",
    SpecificResultOrder: 39,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "KH",
    Image: "8OLA2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.8)&l=zh#page=10"
  },
  {
    ID: 162,
    BudgetSection: 8,
    Entity: "OLA",
    EntityFullName: "法律事务厅",
    Programme: "法律事务",
    Subprogramme: "向全联合国系统提供法律服务",
    Title: "包括 2026 年加快实现可持续发展目标 6 即为所有人提供水和环境卫生并对其进行可持续管理的联合国水事会议在内的联合国会议的法律和程序框架",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "建立有利的法律和法规框架；减少法律责任风险",
    SpecificResultOrder: 39,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "SN,AE",
    Image: "8OLA3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.8)&l=zh#page=10"
  },
  {
    ID: 163,
    BudgetSection: 8,
    Entity: "OLA",
    EntityFullName: "法律事务厅",
    Programme: "法律事务",
    Subprogramme: "向全联合国系统提供法律服务",
    Title: "推进组织改革和机构过渡",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "建立有利的法律和法规框架；减少法律责任风险",
    SpecificResultOrder: 39,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.8)&l=zh#page=11"
  },
  {
    ID: 164,
    BudgetSection: 8,
    Entity: "OLA",
    EntityFullName: "法律事务厅",
    Programme: "法律事务",
    Subprogramme: "向联合国各机关和方案提供一般法律服务",
    Title: "客户单位可查阅标准合同模板",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "建立有利的法律和法规框架；减少法律责任风险",
    SpecificResultOrder: 39,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.8)&l=zh#page=13"
  },
  {
    ID: 165,
    BudgetSection: 8,
    Entity: "OLA",
    EntityFullName: "法律事务厅",
    Programme: "法律事务",
    Subprogramme: "向联合国各机关和方案提供一般法律服务",
    Title: "更新的事项管理系统为客户单位查询法律咨询意见提供便利",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "建立有利的法律和法规框架；减少法律责任风险",
    SpecificResultOrder: 39,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.8)&l=zh#page=14"
  },
  {
    ID: 166,
    BudgetSection: 8,
    Entity: "OLA",
    EntityFullName: "法律事务厅",
    Programme: "法律事务",
    Subprogramme: "向联合国各机关和方案提供一般法律服务",
    Title: "客户单位可查阅最新的《联合国合同总则》",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "建立有利的法律和法规框架；减少法律责任风险",
    SpecificResultOrder: 39,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.8)&l=zh#page=14"
  },
  {
    ID: 167,
    BudgetSection: 8,
    Entity: "OLA",
    EntityFullName: "法律事务厅",
    Programme: "法律事务",
    Subprogramme: "向联合国各机关和方案提供一般法律服务",
    Title: "客户单位可查阅最新版提供航空货运服务的合同范本",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "建立有利的法律和法规框架；减少法律责任风险",
    SpecificResultOrder: 39,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.8)&l=zh#page=14"
  },
  {
    ID: 168,
    BudgetSection: 8,
    Entity: "OLA",
    EntityFullName: "法律事务厅",
    Programme: "法律事务",
    Subprogramme: "国际法规则的逐渐发展和编纂",
    Title: "联合国宪章和加强联合国作用特别委员会通过实质性报告",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "促进司法和国际法",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "促进国际法和加强国际争端解决机制",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.8)&l=zh#page=16"
  },
  {
    ID: 169,
    BudgetSection: 8,
    Entity: "OLA",
    EntityFullName: "法律事务厅",
    Programme: "法律事务",
    Subprogramme: "国际法规则的逐渐发展和编纂",
    Title: "更多国家在协助方案下申请参加国际法培训方案",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "促进司法和国际法",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "促进国际法和加强国际争端解决机制",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.8)&l=zh#page=16"
  },
  {
    ID: 170,
    BudgetSection: 8,
    Entity: "OLA",
    EntityFullName: "法律事务厅",
    Programme: "法律事务",
    Subprogramme: "国际法规则的逐渐发展和编纂",
    Title: "国际法律界有更多机会查阅《联合国法律年鉴》中关于联合国和有关政府间组织的具有法律性质的文件材料",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "促进司法和国际法",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "改善信息传播和使用",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.8)&l=zh#page=17"
  },
  {
    ID: 171,
    BudgetSection: 8,
    Entity: "OLA",
    EntityFullName: "法律事务厅",
    Programme: "法律事务",
    Subprogramme: "国际法规则的逐渐发展和编纂",
    Title: "更好地了解有关国际组织作为当事方的争端的解决的法律问题",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "促进司法和国际法",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "促进国际法和加强国际争端解决机制",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.8)&l=zh#page=18"
  },
  {
    ID: 172,
    BudgetSection: 8,
    Entity: "OLA",
    EntityFullName: "法律事务厅",
    Programme: "法律事务",
    Subprogramme: "海洋法和海洋事务",
    Title: "《国家管辖范围以外区域海洋生物多样性协定》生效所需条件得到满足",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "促进司法和国际法",
    Beneficiary: "国际社会",
    BeneficiaryTwo: "气候和环境",
    SpecificResult: "促进国际法和加强国际争端解决机制",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.8)&l=zh#page=20"
  },
  {
    ID: 173,
    BudgetSection: 8,
    Entity: "OLA",
    EntityFullName: "法律事务厅",
    Programme: "法律事务",
    Subprogramme: "海洋法和海洋事务",
    Title: "通过实施国际法，会员国对养护和可持续利用海洋及其资源的承诺得到加强",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "促进司法和国际法",
    Beneficiary: "国际社会",
    BeneficiaryTwo: "气候和环境",
    SpecificResult: "促进国际法和加强国际争端解决机制",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.8)&l=zh#page=21"
  },
  {
    ID: 174,
    BudgetSection: 8,
    Entity: "OLA",
    EntityFullName: "法律事务厅",
    Programme: "法律事务",
    Subprogramme: "海洋法和海洋事务",
    Title: "加强保护海洋环境及养护和可持续利用海洋资源的科学与政策衔接",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "促进司法和国际法",
    Beneficiary: "国际社会",
    BeneficiaryTwo: "气候和环境",
    SpecificResult: "可持续资源管理；在可再生能源方面取得进展",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.8)&l=zh#page=22"
  },
  {
    ID: 175,
    BudgetSection: 8,
    Entity: "OLA",
    EntityFullName: "法律事务厅",
    Programme: "法律事务",
    Subprogramme: "海洋法和海洋事务",
    Title: "根据《联合国海洋法公约》加强大陆架界限委员会及其小组委员会的作用",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "促进司法和国际法",
    Beneficiary: "国际社会",
    BeneficiaryTwo: "气候和环境",
    SpecificResult: "促进国际法和加强国际争端解决机制",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.8)&l=zh#page=22"
  },
  {
    ID: 176,
    BudgetSection: 8,
    Entity: "OLA",
    EntityFullName: "法律事务厅",
    Programme: "法律事务",
    Subprogramme: "国际贸易法的逐步协调、现代化与统一 ",
    Title: "司法机关在适用联合国国际贸易法委员会破产法法规所提供指导方面的能力得到加强",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "促进司法和国际法",
    Beneficiary: "国际社会",
    BeneficiaryTwo: "私营部门，包括中小微型企业",
    SpecificResult: "促进国际法和加强国际争端解决机制",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.8)&l=zh#page=25"
  },
  {
    ID: 177,
    BudgetSection: 8,
    Entity: "OLA",
    EntityFullName: "法律事务厅",
    Programme: "法律事务",
    Subprogramme: "国际贸易法的逐步协调、现代化与统一 ",
    Title: "商业数据交易的法律确定性提高",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "促进司法和国际法",
    Beneficiary: "国际社会",
    BeneficiaryTwo: "私营部门，包括中小微型企业",
    SpecificResult: "促进国际法和加强国际争端解决机制",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.8)&l=zh#page=26"
  },
  {
    ID: 178,
    BudgetSection: 8,
    Entity: "OLA",
    EntityFullName: "法律事务厅",
    Programme: "法律事务",
    Subprogramme: "国际贸易法的逐步协调、现代化与统一 ",
    Title: "联合国国际贸易法委员会审议其关于公共采购框架文书的相关性1",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "促进司法和国际法",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "促进国际法和加强国际争端解决机制",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.8)&l=zh#page=27"
  },
  {
    ID: 179,
    BudgetSection: 8,
    Entity: "OLA",
    EntityFullName: "法律事务厅",
    Programme: "法律事务",
    Subprogramme: "国际贸易法的逐步协调、现代化与统一 ",
    Title: "通过多边框架公约机制实施投资人与国家间争端解决改革",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "促进司法和国际法",
    Beneficiary: "国际社会",
    BeneficiaryTwo: "私营部门，包括中小微型企业",
    SpecificResult: "促进国际法和加强国际争端解决机制",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.8)&l=zh#page=27"
  },
  {
    ID: 180,
    BudgetSection: 8,
    Entity: "OLA",
    EntityFullName: "法律事务厅",
    Programme: "法律事务",
    Subprogramme: "条约保管、登记和公布",
    Title: "《联合国打击网络犯罪以及为打击使用信息通信技术系统实施的某些犯罪并共享严重犯罪电子证据而加强国际合作公约》开放供签署",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "促进司法和国际法",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "促进国际法和加强国际争端解决机制",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.8)&l=zh#page=30"
  },
  {
    ID: 181,
    BudgetSection: 8,
    Entity: "OLA",
    EntityFullName: "法律事务厅",
    Programme: "法律事务",
    Subprogramme: "条约保管、登记和公布",
    Title: "会员国推进关于条约实践的讨论",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "促进司法和国际法",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "促进国际法和加强国际争端解决机制",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.8)&l=zh#page=31"
  },
  {
    ID: 182,
    BudgetSection: 8,
    Entity: "OLA",
    EntityFullName: "法律事务厅",
    Programme: "法律事务",
    Subprogramme: "条约保管、登记和公布",
    Title: "在联合国《条约汇编》中公布条约和条约行动",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "促进司法和国际法",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "改善信息传播和使用",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.8)&l=zh#page=31"
  },
  {
    ID: 183,
    BudgetSection: 8,
    Entity: "OLA",
    EntityFullName: "法律事务厅",
    Programme: "法律事务",
    Subprogramme: "条约保管、登记和公布",
    Title: "各会员国探讨国际合作(包括技术使用和能力建设)在加强国际条约框架方面的作用",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "促进司法和国际法",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "促进国际法和加强国际争端解决机制",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.8)&l=zh#page=31"
  },
  {
    ID: 184,
    BudgetSection: 8,
    Entity: "IIMM",
    EntityFullName: "缅甸问题独立调查机制",
    Programme: "法律事务",
    Subprogramme: "缅甸问题独立调查机制",
    Title: "主管机构拥有对开源信息进行法证分析的途径",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "促进司法和国际法",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "促进国际法和加强国际争端解决机制",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "MM",
    Image: "8OLA25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.8)&l=zh#page=56"
  },
  {
    ID: 185,
    BudgetSection: 8,
    Entity: "IIMM",
    EntityFullName: "缅甸问题独立调查机制",
    Programme: "法律事务",
    Subprogramme: "缅甸问题独立调查机制",
    Title: "受害者、幸存者、民间社会和信息提供者参与追责进程",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "促进司法和国际法",
    Beneficiary: "国际社会",
    BeneficiaryTwo: "难民、少数群体和其他弱势群体",
    SpecificResult: "促进国际法和加强国际争端解决机制",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "MM",
    Image: "8OLA26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.8)&l=zh#page=57"
  },
  {
    ID: 186,
    BudgetSection: 8,
    Entity: "IIMM",
    EntityFullName: "缅甸问题独立调查机制",
    Programme: "法律事务",
    Subprogramme: "缅甸问题独立调查机制",
    Title: "取得证据的途径增多且证据尽可能广泛地得到国家、区域和国际性法院的采信",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "促进司法和国际法",
    Beneficiary: "国际社会",
    BeneficiaryTwo: "难民、少数群体和其他弱势群体",
    SpecificResult: "促进国际法和加强国际争端解决机制",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "MM",
    Image: "8OLA27.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.8)&l=zh#page=57"
  },
  {
    ID: 187,
    BudgetSection: 8,
    Entity: "IIMM",
    EntityFullName: "缅甸问题独立调查机制",
    Programme: "法律事务",
    Subprogramme: "缅甸问题独立调查机制",
    Title: "证人和消息来源安全地为追责工作提供协助并获得了必要的社会心理支持",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "促进司法和国际法",
    Beneficiary: "国际社会",
    BeneficiaryTwo: "难民、少数群体和其他弱势群体",
    SpecificResult: "促进国际法和加强国际争端解决机制",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "MM",
    Image: "8OLA28.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.8)&l=zh#page=58"
  },
  {
    ID: 188,
    BudgetSection: 8,
    Entity: "IIIM",
    EntityFullName: "协助调查和起诉自 2011 年 3 月以来在阿拉伯叙利亚共和国境内犯下国际法所规定最严重罪行者的国际公正独立机制",
    Programme: "法律事务",
    Subprogramme: "协助调查和起诉自 2011 年 3 月以来在阿拉伯叙利亚共和国境内犯下国际法所规定最严重罪行者的国际公正独立机制",
    Title: "迈向叙利亚主导的过渡期正义的各项步骤",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "促进司法和国际法",
    Beneficiary: "国际社会",
    BeneficiaryTwo: "难民、少数群体和其他弱势群体",
    SpecificResult: "促进国际法和加强国际争端解决机制",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "SY",
    Image: "8OLA29.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.8)&l=zh#page=68"
  },
  {
    ID: 189,
    BudgetSection: 8,
    Entity: "IIIM",
    EntityFullName: "协助调查和起诉自 2011 年 3 月以来在阿拉伯叙利亚共和国境内犯下国际法所规定最严重罪行者的国际公正独立机制",
    Programme: "法律事务",
    Subprogramme: "协助调查和起诉自 2011 年 3 月以来在阿拉伯叙利亚共和国境内犯下国际法所规定最严重罪行者的国际公正独立机制",
    Title: "对受害人、证人或与公正独立机制合作的其他消息来源的保护和支持力度加大",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "促进司法和国际法",
    Beneficiary: "国际社会",
    BeneficiaryTwo: "难民、少数群体和其他弱势群体",
    SpecificResult: "促进国际法和加强国际争端解决机制",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "SY",
    Image: "8OLA30.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.8)&l=zh#page=68"
  },
  {
    ID: 190,
    BudgetSection: 8,
    Entity: "IIIM",
    EntityFullName: "协助调查和起诉自 2011 年 3 月以来在阿拉伯叙利亚共和国境内犯下国际法所规定最严重罪行者的国际公正独立机制",
    Programme: "法律事务",
    Subprogramme: "协助调查和起诉自 2011 年 3 月以来在阿拉伯叙利亚共和国境内犯下国际法所规定最严重罪行者的国际公正独立机制",
    Title: "采用综合方法促进包容性司法",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "促进司法和国际法",
    Beneficiary: "国际社会",
    BeneficiaryTwo: "难民、少数群体和其他弱势群体",
    SpecificResult: "促进国际法和加强国际争端解决机制",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "SY",
    Image: "8OLA31.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.8)&l=zh#page=69"
  },
  {
    ID: 191,
    BudgetSection: 8,
    Entity: "IIIM",
    EntityFullName: "协助调查和起诉自 2011 年 3 月以来在阿拉伯叙利亚共和国境内犯下国际法所规定最严重罪行者的国际公正独立机制",
    Programme: "法律事务",
    Subprogramme: "协助调查和起诉自 2011 年 3 月以来在阿拉伯叙利亚共和国境内犯下国际法所规定最严重罪行者的国际公正独立机制",
    Title: "叙人主导、叙人所有的、2011年以来在阿拉伯叙利亚共和国境内犯下国际法所规定最",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "促进司法和国际法",
    Beneficiary: "国际社会",
    BeneficiaryTwo: "难民、少数群体和其他弱势群体",
    SpecificResult: "促进国际法和加强国际争端解决机制",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "SY",
    Image: "8OLA32.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.8)&l=zh#page=69"
  },
  {
    ID: 192,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "经济和社会事务部",
    Programme: "经济和社会事务",
    Subprogramme: "可持续发展事务政府间支助和协调",
    Title: "在《2030年可持续发展议程》十周年之际重申对《议程》所作的政治承诺",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "通过稳健协调结构等途径，利用可持续发展目标之间的相互关联性，加快推进可持续发展目标",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.9)&l=zh#page=15"
  },
  {
    ID: 193,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "经济和社会事务部",
    Programme: "经济和社会事务",
    Subprogramme: "可持续发展事务政府间支助和协调",
    Title: "经济及社会理事会更大力发挥作用，支持会员国将可持续发展目标峰会的承诺转化为行动和国家政策",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "提高报告可持续发展目标进展情况的能力；提高自愿国别评估数目和质量",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.9)&l=zh#page=15"
  },
  {
    ID: 194,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "经济和社会事务部",
    Programme: "经济和社会事务",
    Subprogramme: "可持续发展事务政府间支助和协调",
    Title: "通过有效的自愿国别评估准备进程，加速落实可持续发展目标",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "提高报告可持续发展目标进展情况的能力；提高自愿国别评估数目和质量",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.9)&l=zh#page=16"
  },
  {
    ID: 195,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "经济和社会事务部",
    Programme: "经济和社会事务",
    Subprogramme: "可持续发展事务政府间支助和协调",
    Title: "加强经济及社会理事会对联合国发展系统的指导，以更好地开展发展方面的业务活动",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "加强合作、增进信息和最佳做法共享，推动在实现可持续发展目标方面取得进展",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.9)&l=zh#page=17"
  },
  {
    ID: 196,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "经济和社会事务部",
    Programme: "经济和社会事务",
    Subprogramme: "包容性社会发展",
    Title: "2025年《世界社会报告》为政府间机构的社会政策对话提供了参考",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "改善信息传播和使用",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.9)&l=zh#page=19"
  },
  {
    ID: 197,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "经济和社会事务部",
    Programme: "经济和社会事务",
    Subprogramme: "包容性社会发展",
    Title: "联合国系统在努力满足土著人民需求方面更加协调一致",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "国际社会",
    SpecificResult: "实现更具有包容性的发展，不让任何一个人掉队；消除贫困和减少不平等；减少对妇女和女童的歧视，加强性别平等。",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.9)&l=zh#page=20"
  },
  {
    ID: 198,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "经济和社会事务部",
    Programme: "经济和社会事务",
    Subprogramme: "包容性社会发展",
    Title: "通过第二次社会发展问题世界首脑会议加速社会发展",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "实现更具有包容性的发展，不让任何一个人掉队；消除贫困和减少不平等；减少对妇女和女童的歧视，加强性别平等。",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.9)&l=zh#page=20"
  },
  {
    ID: 199,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "经济和社会事务部",
    Programme: "经济和社会事务",
    Subprogramme: "包容性社会发展",
    Title: "对《马德里老龄问题国际行动计划》执行情况进行第五次审查和评价，从而提高老年人的生活质量",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "国际社会",
    BeneficiaryTwo: "难民、少数群体和其他弱势群体",
    SpecificResult: "实现更具有包容性的发展，不让任何一个人掉队；消除贫困和减少不平等；减少对妇女和女童的歧视，加强性别平等。",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.9)&l=zh#page=21"
  },
  {
    ID: 200,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "经济和社会事务部",
    Programme: "经济和社会事务",
    Subprogramme: "可持续发展",
    Title: "联合国可持续交通运输十年（2026-2035年）实施计划启动",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: "国际社会",
    SpecificResult: "加强监管框架和环境治理；加大气候行动力度促进可持续发展",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.9)&l=zh#page=24"
  },
  {
    ID: 201,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "经济和社会事务部",
    Programme: "经济和社会事务",
    Subprogramme: "可持续发展",
    Title: "通过第三次联合国海洋大会加快推进可持续发展目标14",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: " ",
    SpecificResult: "通过稳健协调结构等途径，利用可持续发展目标之间的相互关联性，加快推进可持续发展目标",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.9)&l=zh#page=24"
  },
  {
    ID: 202,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "经济和社会事务部",
    Programme: "经济和社会事务",
    Subprogramme: "可持续发展",
    Title: "通过2026年联合国水事会议加快实现可持续发展目标6",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: " ",
    SpecificResult: "通过稳健协调结构等途径，利用可持续发展目标之间的相互关联性，加快推进可持续发展目标",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.9)&l=zh#page=25"
  },
  {
    ID: 203,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "经济和社会事务部",
    Programme: "经济和社会事务",
    Subprogramme: "可持续发展",
    Title: "《2027年全球可持续发展报告》指导《2030年议程》的实施",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "加强合作、增进信息和最佳做法共享，推动在实现可持续发展目标方面取得进展",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.9)&l=zh#page=25"
  },
  {
    ID: 204,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "经济和社会事务部",
    Programme: "经济和社会事务",
    Subprogramme: "统计",
    Title: "用户对移民统计数据的理解有所提高",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: " ",
    SpecificResult: "改善用于循证决策的计量与统计促进可持续发展",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.9)&l=zh#page=28"
  },
  {
    ID: 205,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "经济和社会事务部",
    Programme: "经济和社会事务",
    Subprogramme: "统计",
    Title: "UNdata现代化：获取联合国系统权威统计数据的单一入口",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "国际社会",
    SpecificResult: "改善用于循证决策的计量与统计促进可持续发展",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.9)&l=zh#page=29"
  },
  {
    ID: 206,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "经济和社会事务部",
    Programme: "经济和社会事务",
    Subprogramme: "统计",
    Title: "提高全球循证监测可持续发展目标进展情况的能力",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "国际社会",
    SpecificResult: "改善用于循证决策的计量与统计促进可持续发展",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.9)&l=zh#page=29"
  },
  {
    ID: 207,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "经济和社会事务部",
    Programme: "经济和社会事务",
    Subprogramme: "统计",
    Title: "各会员国实施《2025年国民账户体系》",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "国际社会",
    SpecificResult: "改善用于循证决策的计量与统计促进可持续发展",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.9)&l=zh#page=30"
  },
  {
    ID: 208,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "经济和社会事务部",
    Programme: "经济和社会事务",
    Subprogramme: "人口",
    Title: "采用国际公认的概率方法编制的国家及地区人口预测",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "国际社会",
    SpecificResult: "改善人口、移民、民事登记和人口统计(包括按性别分列的统计)信息",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "UG",
    Image: "9DESA17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.9)&l=zh#page=34"
  },
  {
    ID: 209,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "经济和社会事务部",
    Programme: "经济和社会事务",
    Subprogramme: "人口",
    Title: "旨在促进可持续发展目标的城市化和空间分布估计和预测的可比性得到加强",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "国际社会",
    SpecificResult: "改善用于循证决策的计量与统计促进可持续发展",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.9)&l=zh#page=34"
  },
  {
    ID: 210,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "经济和社会事务部",
    Programme: "经济和社会事务",
    Subprogramme: "人口",
    Title: "人口分析、预测和可视化在线工具得到加强",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "国际社会",
    SpecificResult: "改善人口、移民、民事登记和人口统计(包括按性别分列的统计)信息",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.9)&l=zh#page=35"
  },
  {
    ID: 211,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "经济和社会事务部",
    Programme: "经济和社会事务",
    Subprogramme: "人口",
    Title: "加强国际移民的证据基础，以支持政策制定并促进充分知情的公共讨论",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "难民、少数群体和其他弱势群体",
    SpecificResult: "改善人口、移民、民事登记和人口统计(包括按性别分列的统计)信息",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.9)&l=zh#page=35"
  },
  {
    ID: 212,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "经济和社会事务部",
    Programme: "经济和社会事务",
    Subprogramme: "经济分析与政策",
    Title: "改进数字工具，以增强政府官员在宏观经济和贸易领域的知识",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: " ",
    SpecificResult: "在科学、技术和创新促进可持续发展(包括人工智能)方面取得进展",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.9)&l=zh#page=38"
  },
  {
    ID: 213,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "经济和社会事务部",
    Programme: "经济和社会事务",
    Subprogramme: "经济分析与政策",
    Title: "利用先进的政策模拟工具促进数据驱动的循证决策",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: "国际社会",
    SpecificResult: "提高报告可持续发展目标进展情况的能力；提高自愿国别评估数目和质量",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.9)&l=zh#page=39"
  },
  {
    ID: 214,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "经济和社会事务部",
    Programme: "经济和社会事务",
    Subprogramme: "经济分析与政策",
    Title: "更多地参与和使用分析产品进行循证决策",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "国际社会",
    SpecificResult: "加强合作、增进信息和最佳做法共享，推动在实现可持续发展目标方面取得进展",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.9)&l=zh#page=40"
  },
  {
    ID: 215,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "经济和社会事务部",
    Programme: "经济和社会事务",
    Subprogramme: "经济分析与政策",
    Title: "最不发达国家已为应对毕业进程及毕业后形势作好准备",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "最不发达国家、内陆发展中国家、小岛屿发展中国家和其他发展中国家",
    BeneficiaryTwo: " ",
    SpecificResult: "加强合作、增进信息和最佳做法共享，推动在实现可持续发展目标方面取得进展",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AO,SD,QQ,BJ,BF,BI,KH,CF,TD,KM,CD,DJ,ER,ET,GM,GN,GW,HT,KI,LA,LS,LR,MG,MW,ML,MR,MZ,MM,NP,NE,RW,SN,SL,SB,SO,SS,II,SD,QQ,TL,TG,TV,UG,TZ,YE,ZM",
    Image: "9DESA24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.9)&l=zh#page=40"
  },
  {
    ID: 216,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "经济和社会事务部",
    Programme: "经济和社会事务",
    Subprogramme: "机构与数字化转型",
    Title: "最高审计机关对可持续发展目标13（气候行动）的落实情况进行了评估",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "气候和环境",
    SpecificResult: "加强监管框架和环境治理；加大气候行动力度促进可持续发展",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.9)&l=zh#page=44"
  },
  {
    ID: 217,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "经济和社会事务部",
    Programme: "经济和社会事务",
    Subprogramme: "机构与数字化转型",
    Title: "国家执行有效治理促进可持续发展原则，以增强对公共机构的信任",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "国际社会",
    SpecificResult: "通过稳健协调结构等途径，利用可持续发展目标之间的相互关联性，加快推进可持续发展目标",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.9)&l=zh#page=44"
  },
  {
    ID: 218,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "经济和社会事务部",
    Programme: "经济和社会事务",
    Subprogramme: "机构与数字化转型",
    Title: "高效且具有韧性地应对未来的挑战与机遇，以加快可持续发展",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: " ",
    SpecificResult: "实现更具有包容性的发展，不让任何一个人掉队；消除贫困和减少不平等；减少对妇女和女童的歧视，加强性别平等。",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA27.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.9)&l=zh#page=45"
  },
  {
    ID: 219,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "经济和社会事务部",
    Programme: "经济和社会事务",
    Subprogramme: "机构与数字化转型",
    Title: "公职人员运用行为洞见并借鉴良好做法，以推动创新和数字化转型",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: " ",
    SpecificResult: "在科学、技术和创新促进可持续发展(包括人工智能)方面取得进展",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA28.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.9)&l=zh#page=45"
  },
  {
    ID: 220,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "经济和社会事务部",
    Programme: "经济和社会事务",
    Subprogramme: "可持续森林管理",
    Title: "会员国开始实施新的四年期工作方案(2025-2028年)，以加快落实《联合国森林战略计划》",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "国际社会",
    BeneficiaryTwo: "气候和环境",
    SpecificResult: "加强监管框架和环境治理；加大气候行动力度促进可持续发展",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA29.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.9)&l=zh#page=48"
  },
  {
    ID: 221,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "经济和社会事务部",
    Programme: "经济和社会事务",
    Subprogramme: "可持续森林管理",
    Title: "联合国森林论坛的接触面扩大，森林对《2030年议程》的贡献增加",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "国际社会",
    BeneficiaryTwo: "气候和环境",
    SpecificResult: "提高报告可持续发展目标进展情况的能力；提高自愿国别评估数目和质量",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA30.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.9)&l=zh#page=49"
  },
  {
    ID: 222,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "经济和社会事务部",
    Programme: "经济和社会事务",
    Subprogramme: "可持续森林管理",
    Title: "通过2017-2030年联合国森林战略计划推进可持续发展目标",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "国际社会",
    BeneficiaryTwo: "气候和环境",
    SpecificResult: "加强监管框架和环境治理；加大气候行动力度促进可持续发展",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA31.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.9)&l=zh#page=50"
  },
  {
    ID: 223,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "经济和社会事务部",
    Programme: "经济和社会事务",
    Subprogramme: "可持续森林管理",
    Title: "国际森林安排加强实现全球森林目标的承诺和行动",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "国际社会",
    BeneficiaryTwo: "气候和环境",
    SpecificResult: "改善用于循证决策的计量与统计促进可持续发展",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA32.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.9)&l=zh#page=50"
  },
  {
    ID: 224,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "经济和社会事务部",
    Programme: "经济和社会事务",
    Subprogramme: "可持续发展筹资",
    Title: "通过新的筹资框架《塞维利亚承诺》，作为《亚的斯亚贝巴行动议程》的后续行动",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "增进对筹资需求的了解，改进为可持续资本投资筹措资金的政策备选方案，加大可持续项目供资承诺和参与力度",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA33.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.9)&l=zh#page=53"
  },
  {
    ID: 225,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "经济和社会事务部",
    Programme: "经济和社会事务",
    Subprogramme: "可持续发展筹资",
    Title: "会员国更大力参与发展筹资后续进程，以改进商定成果的一致性和执行工作",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "增进对筹资需求的了解，改进为可持续资本投资筹措资金的政策备选方案，加大可持续项目供资承诺和参与力度",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA34.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.9)&l=zh#page=54"
  },
  {
    ID: 226,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "经济和社会事务部",
    Programme: "经济和社会事务",
    Subprogramme: "可持续发展筹资",
    Title: "发展中国家在制定国际税务规范方面的参与度得到增强",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "增进对筹资需求的了解，改进为可持续资本投资筹措资金的政策备选方案，加大可持续项目供资承诺和参与力度",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA35.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.9)&l=zh#page=54"
  },
  {
    ID: 227,
    BudgetSection: 9,
    Entity: "DESA",
    EntityFullName: "经济和社会事务部",
    Programme: "经济和社会事务",
    Subprogramme: "可持续发展筹资",
    Title: "国际债务架构得到落实",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "增进对筹资需求的了解，改进为可持续资本投资筹措资金的政策备选方案，加大可持续项目供资承诺和参与力度",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA36.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.9)&l=zh#page=55"
  },
  {
    ID: 228,
    BudgetSection: 10,
    Entity: "UN-OHRLLS",
    EntityFullName: "联合国最不发达国家、内陆发展中国家和小岛屿发展中国家高级代表办公室",
    Programme: "最不发达国家、内陆发展中国家和小岛屿发展中国家",
    Subprogramme: "最不发达国家",
    Title: "加快落实《支援最不发达国家多哈行动纲领》并加强对落实工作的监测",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "最不发达国家、内陆发展中国家、小岛屿发展中国家和其他发展中国家",
    BeneficiaryTwo: " ",
    SpecificResult: "提高报告可持续发展目标进展情况的能力；提高自愿国别评估数目和质量",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AO,SD,QQ,BJ,BF,BI,KH,CF,TD,KM,CD,DJ,ER,ET,GM,GN,GW,HT,KI,LA,LS,LR,MG,MW,ML,MR,MZ,MM,NP,NE,RW,SN,SL,SB,SO,SS,II,SD,QQ,TL,TG,TV,UG,TZ,YE,ZM",
    Image: "10UNOHRLLS1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.10)&l=zh#page=8"
  },
  {
    ID: 229,
    BudgetSection: 10,
    Entity: "UN-OHRLLS",
    EntityFullName: "联合国最不发达国家、内陆发展中国家和小岛屿发展中国家高级代表办公室",
    Programme: "最不发达国家、内陆发展中国家和小岛屿发展中国家",
    Subprogramme: "最不发达国家",
    Title: "减少最不发达国家粮食不安全情形的新粮食储备机制",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "最不发达国家、内陆发展中国家、小岛屿发展中国家和其他发展中国家",
    BeneficiaryTwo: " ",
    SpecificResult: "在科学、技术和创新促进可持续发展(包括人工智能)方面取得进展",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AO,SD,QQ,BJ,BF,BI,KH,CF,TD,KM,CD,DJ,ER,ET,GM,GN,GW,HT,KI,LA,LS,LR,MG,MW,ML,MR,MZ,MM,NP,NE,RW,SN,SL,SB,SO,SS,II,SD,QQ,TL,TG,TV,UG,TZ,YE,ZM",
    Image: "10UNOHRLLS2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.10)&l=zh#page=8"
  },
  {
    ID: 230,
    BudgetSection: 10,
    Entity: "UN-OHRLLS",
    EntityFullName: "联合国最不发达国家、内陆发展中国家和小岛屿发展中国家高级代表办公室",
    Programme: "最不发达国家、内陆发展中国家和小岛屿发展中国家",
    Subprogramme: "最不发达国家",
    Title: "加强最不发达国家抵御外部冲击的能力",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "最不发达国家、内陆发展中国家、小岛屿发展中国家和其他发展中国家",
    BeneficiaryTwo: " ",
    SpecificResult: "包容型、可持续灾后恢复；建设抵御未来灾害的能力",
    SpecificResultOrder: 12,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AO,SD,QQ,BJ,BF,BI,KH,CF,TD,KM,CD,DJ,ER,ET,GM,GN,GW,HT,KI,LA,LS,LR,MG,MW,ML,MR,MZ,MM,NP,NE,RW,SN,SL,SB,SO,SS,II,SD,QQ,TL,TG,TV,UG,TZ,YE,ZM",
    Image: "10UNOHRLLS3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.10)&l=zh#page=9"
  },
  {
    ID: 231,
    BudgetSection: 10,
    Entity: "UN-OHRLLS",
    EntityFullName: "联合国最不发达国家、内陆发展中国家和小岛屿发展中国家高级代表办公室",
    Programme: "最不发达国家、内陆发展中国家和小岛屿发展中国家",
    Subprogramme: "最不发达国家",
    Title: "最不发达国家加强可持续且不可逆转地从最不发达国家类别毕业的途径",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "最不发达国家、内陆发展中国家、小岛屿发展中国家和其他发展中国家",
    BeneficiaryTwo: " ",
    SpecificResult: "实现更具有包容性的发展，不让任何一个人掉队；消除贫困和减少不平等；减少对妇女和女童的歧视，加强性别平等。",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AO,SD,QQ,BJ,BF,BI,KH,CF,TD,KM,CD,DJ,ER,ET,GM,GN,GW,HT,KI,LA,LS,LR,MG,MW,ML,MR,MZ,MM,NP,NE,RW,SN,SL,SB,SO,SS,II,SD,QQ,TL,TG,TV,UG,TZ,YE,ZM",
    Image: "10UNOHRLLS4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.10)&l=zh#page=9"
  },
  {
    ID: 232,
    BudgetSection: 10,
    Entity: "UN-OHRLLS",
    EntityFullName: "联合国最不发达国家、内陆发展中国家和小岛屿发展中国家高级代表办公室",
    Programme: "最不发达国家、内陆发展中国家和小岛屿发展中国家",
    Subprogramme: "内陆发展中国家",
    Title: "在第三次联合国内陆发展中国家问题会议上通过《阿瓦扎政治宣言》",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "最不发达国家、内陆发展中国家、小岛屿发展中国家和其他发展中国家",
    BeneficiaryTwo: " ",
    SpecificResult: "加强合作、增进信息和最佳做法共享，推动在实现可持续发展目标方面取得进展",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AZ,BT,BO,BW,BF,BI,CF,TD,SZ,ET,KZ,KG,LA,LS,MK,MW,ML,MN,NP,NE,PY,MD,RW,SS,II,TJ,TM,UG,UZ,ZM,ZW",
    Image: "10UNOHRLLS5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.10)&l=zh#page=12"
  },
  {
    ID: 233,
    BudgetSection: 10,
    Entity: "UN-OHRLLS",
    EntityFullName: "联合国最不发达国家、内陆发展中国家和小岛屿发展中国家高级代表办公室",
    Programme: "最不发达国家、内陆发展中国家和小岛屿发展中国家",
    Subprogramme: "内陆发展中国家",
    Title: "增强内陆发展中国家经济复原力的发展筹资战略举措",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "最不发达国家、内陆发展中国家、小岛屿发展中国家和其他发展中国家",
    BeneficiaryTwo: " ",
    SpecificResult: "增进对筹资需求的了解，改进为可持续资本投资筹措资金的政策备选方案，加大可持续项目供资承诺和参与力度",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AM,AZ,BT,BO,BW,BF,BI,CF,TD,SZ,ET,KZ,KG,LA,LS,MK,MW,ML,MN,NP,NE,PY,MD,RW,SS,II,TJ,TM,UG,UZ,ZM,ZW",
    Image: "10UNOHRLLS6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.10)&l=zh#page=13"
  },
  {
    ID: 234,
    BudgetSection: 10,
    Entity: "UN-OHRLLS",
    EntityFullName: "联合国最不发达国家、内陆发展中国家和小岛屿发展中国家高级代表办公室",
    Programme: "最不发达国家、内陆发展中国家和小岛屿发展中国家",
    Subprogramme: "内陆发展中国家",
    Title: "推进内陆发展中国家的过境自由",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "最不发达国家、内陆发展中国家、小岛屿发展中国家和其他发展中国家",
    BeneficiaryTwo: " ",
    SpecificResult: "利用电子商务和数字经济等方式增强能力和减少壁垒，改善贸易和竞争力",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AM,AZ,BT,BO,BW,BF,BI,CF,TD,SZ,ET,KZ,KG,LA,LS,MK,MW,ML,MN,NP,NE,PY,MD,RW,SS,II,TJ,TM,UG,UZ,ZM,ZW",
    Image: "10UNOHRLLS7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.10)&l=zh#page=14"
  },
  {
    ID: 235,
    BudgetSection: 10,
    Entity: "UN-OHRLLS",
    EntityFullName: "联合国最不发达国家、内陆发展中国家和小岛屿发展中国家高级代表办公室",
    Programme: "最不发达国家、内陆发展中国家和小岛屿发展中国家",
    Subprogramme: "内陆发展中国家",
    Title: "将《内陆发展中国家阿瓦扎行动纲领》纳入国家和部门发展战略、发展合作框架和战",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "最不发达国家、内陆发展中国家、小岛屿发展中国家和其他发展中国家",
    BeneficiaryTwo: " ",
    SpecificResult: "通过稳健协调结构等途径，利用可持续发展目标之间的相互关联性，加快推进可持续发展目标",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AZ,BT,BO,BW,BF,BI,CF,TD,SZ,ET,KZ,KG,LA,LS,MK,MW,ML,MN,NP,NE,PY,MD,RW,SS,II,TJ,TM,UG,UZ,ZM,ZW",
    Image: "10UNOHRLLS8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.10)&l=zh#page=14"
  },
  {
    ID: 236,
    BudgetSection: 10,
    Entity: "UN-OHRLLS",
    EntityFullName: "联合国最不发达国家、内陆发展中国家和小岛屿发展中国家高级代表办公室",
    Programme: "最不发达国家、内陆发展中国家和小岛屿发展中国家",
    Subprogramme: "小岛屿发展中国家",
    Title: "促进小岛屿发展中国家的债务可持续性",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "最不发达国家、内陆发展中国家、小岛屿发展中国家和其他发展中国家",
    BeneficiaryTwo: " ",
    SpecificResult: "增进对筹资需求的了解，改进为可持续资本投资筹措资金的政策备选方案，加大可持续项目供资承诺和参与力度",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CV,KM,CK,MV,MU,SC,AG,BS,BD,BZ,CU,DM,DO,GD,HT,JM,KN,LC,VC,SR,TT,FJ,KI,MH,FM,NR,NU,PW,PG,WS,SB,TL,TO,TV,VU",
    Image: "10UNOHRLLS9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.10)&l=zh#page=17"
  },
  {
    ID: 237,
    BudgetSection: 10,
    Entity: "UN-OHRLLS",
    EntityFullName: "联合国最不发达国家、内陆发展中国家和小岛屿发展中国家高级代表办公室",
    Programme: "最不发达国家、内陆发展中国家和小岛屿发展中国家",
    Subprogramme: "小岛屿发展中国家",
    Title: "以数据为依据作出决定，解决小岛屿发展中国家的结构脆弱性和复原力问题",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "最不发达国家、内陆发展中国家、小岛屿发展中国家和其他发展中国家",
    BeneficiaryTwo: " ",
    SpecificResult: "实现更具有包容性的发展，不让任何一个人掉队；消除贫困和减少不平等；减少对妇女和女童的歧视，加强性别平等。",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "CV,KM,CK,MV,MU,SC,AG,BS,BD,BZ,CU,DM,DO,GD,HT,JM,KN,LC,VC,SR,TT,FJ,KI,MH,FM,NR,NU,PW,PG,WS,SB,TL,TO,TV,VU",
    Image: "10UNOHRLLS10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.10)&l=zh#page=17"
  },
  {
    ID: 238,
    BudgetSection: 10,
    Entity: "UN-OHRLLS",
    EntityFullName: "联合国最不发达国家、内陆发展中国家和小岛屿发展中国家高级代表办公室",
    Programme: "最不发达国家、内陆发展中国家和小岛屿发展中国家",
    Subprogramme: "小岛屿发展中国家",
    Title: "小岛屿发展中国家利用《安提瓜和巴布达小岛屿发展中国家议程》的监测和报告框架",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "最不发达国家、内陆发展中国家、小岛屿发展中国家和其他发展中国家",
    BeneficiaryTwo: " ",
    SpecificResult: "提高报告可持续发展目标进展情况的能力；提高自愿国别评估数目和质量",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CV,KM,CK,MV,MU,SC,AG,BS,BD,BZ,CU,DM,DO,GD,HT,JM,KN,LC,VC,SR,TT,FJ,KI,MH,FM,NR,NU,PW,PG,WS,SB,TL,TO,TV,VU",
    Image: "10UNOHRLLS11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.10)&l=zh#page=18"
  },
  {
    ID: 239,
    BudgetSection: 10,
    Entity: "UN-OHRLLS",
    EntityFullName: "联合国最不发达国家、内陆发展中国家和小岛屿发展中国家高级代表办公室",
    Programme: "最不发达国家、内陆发展中国家和小岛屿发展中国家",
    Subprogramme: "小岛屿发展中国家",
    Title: "建立战略伙伴关系，加速落实《安提瓜和巴布达小岛屿发展中国家议程》",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "最不发达国家、内陆发展中国家、小岛屿发展中国家和其他发展中国家",
    BeneficiaryTwo: " ",
    SpecificResult: "通过持续沟通，改善合作和伙伴关系，提高一致性、增强合力和减少重叠",
    SpecificResultOrder: 29,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CV,KM,CK,MV,MU,SC,AG,BS,BD,BZ,CU,DM,DO,GD,HT,JM,KN,LC,VC,SR,TT,FJ,KI,MH,FM,NR,NU,PW,PG,WS,SB,TL,TO,TV,VU",
    Image: "10UNOHRLLS12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.10)&l=zh#page=18"
  },
  {
    ID: 240,
    BudgetSection: 10,
    Entity: "UN-OHRLLS",
    EntityFullName: "联合国最不发达国家、内陆发展中国家和小岛屿发展中国家高级代表办公室",
    Programme: "最不发达国家、内陆发展中国家和小岛屿发展中国家",
    Subprogramme: "宣传、外联和分析",
    Title: "以更大力度将三个行动纲领纳入相关政府间进程",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "最不发达国家、内陆发展中国家、小岛屿发展中国家和其他发展中国家",
    BeneficiaryTwo: " ",
    SpecificResult: "提高报告可持续发展目标进展情况的能力；提高自愿国别评估数目和质量",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AO,AG,AM,AZ,BS,SD,QQ,BD,BZ,BJ,BT,BO,BW,BF,BI,CV,KH,CF,TD,KM,CK,CU,CD,DJ,DM,DO,ER,SZ,ET,FJ,GM,GD,GN,GW,HT,JM,KZ,KG,KI,LA,LS,LR,MK,MG,MW,MV,ML,MH,MR,MU,FM,MN,MZ,MM,NR,NP,NE,NU,PW,PG,PY,MD,RW,KN,LC,VC,WS,SN,SC,SL,SB,SO,SS,II,SD,QQ,SR,TJ,TL,TG,TO,TT,TM,TV,UG,TZ,UZ,VU,YE,ZM,ZW",
    Image: "10UNOHRLLS13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.10)&l=zh#page=21"
  },
  {
    ID: 241,
    BudgetSection: 10,
    Entity: "UN-OHRLLS",
    EntityFullName: "联合国最不发达国家、内陆发展中国家和小岛屿发展中国家高级代表办公室",
    Programme: "最不发达国家、内陆发展中国家和小岛屿发展中国家",
    Subprogramme: "宣传、外联和分析",
    Title: "实时分析和监测三个行动纲领，为政策制定、规划和决策提供参考",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "最不发达国家、内陆发展中国家、小岛屿发展中国家和其他发展中国家",
    BeneficiaryTwo: " ",
    SpecificResult: "改善信息传播和使用",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AO,AG,AM,AZ,BS,SD,QQ,BD,BZ,BJ,BT,BO,BW,BF,BI,CV,KH,CF,TD,KM,CK,CU,CD,DJ,DM,DO,ER,SZ,ET,FJ,GM,GD,GN,GW,HT,JM,KZ,KG,KI,LA,LS,LR,MK,MG,MW,MV,ML,MH,MR,MU,FM,MN,MZ,MM,NR,NP,NE,NU,PW,PG,PY,MD,RW,KN,LC,VC,WS,SN,SC,SL,SB,SO,SS,II,SD,QQ,SR,TJ,TL,TG,TO,TT,TM,TV,UG,TZ,UZ,VU,YE,ZM,ZW",
    Image: "10UNOHRLLS14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.10)&l=zh#page=22"
  },
  {
    ID: 242,
    BudgetSection: 11,
    Entity: "OSAA",
    EntityFullName: "非洲特别顾问办公室",
    Programme: "联合国系统支助非洲联盟《2063年议程：我们希望的非洲》",
    Subprogramme: "开展数据和知识管理促进循证政策和宣传以支持《2063年议程》",
    Title: "非洲政策制定者采用综合分析方法促进长期和平与发展成果",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "非洲的发展",
    Beneficiary: "非洲会员国",
    BeneficiaryTwo: " ",
    SpecificResult: "通过稳健协调结构等途径，利用可持续发展目标之间的相互关联性，加快推进可持续发展目标",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "11NEPAD1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.11)&l=zh#page=8"
  },
  {
    ID: 243,
    BudgetSection: 11,
    Entity: "OSAA",
    EntityFullName: "非洲特别顾问办公室",
    Programme: "联合国系统支助非洲联盟《2063年议程：我们希望的非洲》",
    Subprogramme: "开展数据和知识管理促进循证政策和宣传以支持《2063年议程》",
    Title: "非洲金融体系转型和债务管理的数字解决方案",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "非洲的发展",
    Beneficiary: "非洲会员国",
    BeneficiaryTwo: " ",
    SpecificResult: "增进对筹资需求的了解，改进为可持续资本投资筹措资金的政策备选方案，加大可持续项目供资承诺和参与力度",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "11NEPAD2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.11)&l=zh#page=8"
  },
  {
    ID: 244,
    BudgetSection: 11,
    Entity: "OSAA",
    EntityFullName: "非洲特别顾问办公室",
    Programme: "联合国系统支助非洲联盟《2063年议程：我们希望的非洲》",
    Subprogramme: "开展数据和知识管理促进循证政策和宣传以支持《2063年议程》",
    Title: "使非洲劳动力具备全球数字经济所需能力的政策生态系统",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "非洲的发展",
    Beneficiary: "非洲会员国",
    BeneficiaryTwo: "私营部门，包括中小微型企业",
    SpecificResult: "在科学、技术和创新促进可持续发展(包括人工智能)方面取得进展",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "11NEPAD3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.11)&l=zh#page=9"
  },
  {
    ID: 245,
    BudgetSection: 11,
    Entity: "OSAA",
    EntityFullName: "非洲特别顾问办公室",
    Programme: "联合国系统支助非洲联盟《2063年议程：我们希望的非洲》",
    Subprogramme: "开展数据和知识管理促进循证政策和宣传以支持《2063年议程》",
    Title: "加强青年教育和技能发展政策，以解决非洲的粮食不安全问题并促进气候适应能力",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "非洲的发展",
    Beneficiary: "非洲会员国",
    BeneficiaryTwo: "青年",
    SpecificResult: "实现更具有包容性的发展，不让任何一个人掉队；消除贫困和减少不平等；减少对妇女和女童的歧视，加强性别平等。",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "11NEPAD4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.11)&l=zh#page=9"
  },
  {
    ID: 246,
    BudgetSection: 11,
    Entity: "OSAA",
    EntityFullName: "非洲特别顾问办公室",
    Programme: "联合国系统支助非洲联盟《2063年议程：我们希望的非洲》",
    Subprogramme: "为联合国支持统筹落实《2030年可持续发展议程》和《2063年议程》开展区域协调",
    Title: "通过国内资源调动战略，为《2063年议程》第二个十年执行计划提供资金",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "非洲的发展",
    Beneficiary: "非洲会员国",
    BeneficiaryTwo: " ",
    SpecificResult: "增进对筹资需求的了解，改进为可持续资本投资筹措资金的政策备选方案，加大可持续项目供资承诺和参与力度",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "11NEPAD5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.11)&l=zh#page=12"
  },
  {
    ID: 247,
    BudgetSection: 11,
    Entity: "OSAA",
    EntityFullName: "非洲特别顾问办公室",
    Programme: "联合国系统支助非洲联盟《2063年议程：我们希望的非洲》",
    Subprogramme: "为联合国支持统筹落实《2030年可持续发展议程》和《2063年议程》开展区域协调",
    Title: "非洲债务管理长期战略",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "非洲的发展",
    Beneficiary: "非洲会员国",
    BeneficiaryTwo: " ",
    SpecificResult: "增进对筹资需求的了解，改进为可持续资本投资筹措资金的政策备选方案，加大可持续项目供资承诺和参与力度",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "11NEPAD6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.11)&l=zh#page=13"
  },
  {
    ID: 248,
    BudgetSection: 11,
    Entity: "OSAA",
    EntityFullName: "非洲特别顾问办公室",
    Programme: "联合国系统支助非洲联盟《2063年议程：我们希望的非洲》",
    Subprogramme: "为联合国支持统筹落实《2030年可持续发展议程》和《2063年议程》开展区域协调",
    Title: "加强公共机构的反应能力和问责制",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "非洲的发展",
    Beneficiary: "非洲会员国",
    BeneficiaryTwo: "公共行政",
    SpecificResult: "加强体制、法治和预防冲突",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "11NEPAD7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.11)&l=zh#page=13"
  },
  {
    ID: 249,
    BudgetSection: 11,
    Entity: "OSAA",
    EntityFullName: "非洲特别顾问办公室",
    Programme: "联合国系统支助非洲联盟《2063年议程：我们希望的非洲》",
    Subprogramme: "为联合国支持统筹落实《2030年可持续发展议程》和《2063年议程》开展区域协调",
    Title: "非洲会员国制定应对气候变化影响的政策",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "非洲的发展",
    Beneficiary: "非洲会员国",
    BeneficiaryTwo: "气候和环境",
    SpecificResult: "加强监管框架和环境治理；加大气候行动力度促进可持续发展",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "11NEPAD8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.11)&l=zh#page=14"
  },
  {
    ID: 250,
    BudgetSection: 11,
    Entity: "OSAA",
    EntityFullName: "非洲特别顾问办公室",
    Programme: "联合国系统支助非洲联盟《2063年议程：我们希望的非洲》",
    Subprogramme: "为支持《2063年议程》开展公共信息和提高认识活动",
    Title: "覆盖1.3亿受众的媒体合作，聚焦非洲视角下的人工智能与数字就业议题",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "非洲的发展",
    Beneficiary: "非洲会员国",
    BeneficiaryTwo: " ",
    SpecificResult: "改善信息传播和使用",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "11NEPAD9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.11)&l=zh#page=16"
  },
  {
    ID: 251,
    BudgetSection: 11,
    Entity: "OSAA",
    EntityFullName: "非洲特别顾问办公室",
    Programme: "联合国系统支助非洲联盟《2063年议程：我们希望的非洲》",
    Subprogramme: "为支持《2063年议程》开展公共信息和提高认识活动",
    Title: "公众关注非洲债务负担和可能的解决办法",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "非洲的发展",
    Beneficiary: "非洲会员国",
    BeneficiaryTwo: " ",
    SpecificResult: "改善信息传播和使用",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "11NEPAD10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.11)&l=zh#page=17"
  },
  {
    ID: 252,
    BudgetSection: 11,
    Entity: "OSAA",
    EntityFullName: "非洲特别顾问办公室",
    Programme: "联合国系统支助非洲联盟《2063年议程：我们希望的非洲》",
    Subprogramme: "为支持《2063年议程》开展公共信息和提高认识活动",
    Title: "媒体伙伴加强在非洲教育、体面工作和社会保护方面的外联工作",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "非洲的发展",
    Beneficiary: "非洲会员国",
    BeneficiaryTwo: "国际社会",
    SpecificResult: "通过持续沟通，改善合作和伙伴关系，提高一致性、增强合力和减少重叠",
    SpecificResultOrder: 29,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "11NEPAD11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.11)&l=zh#page=17"
  },
  {
    ID: 253,
    BudgetSection: 11,
    Entity: "OSAA",
    EntityFullName: "非洲特别顾问办公室",
    Programme: "联合国系统支助非洲联盟《2063年议程：我们希望的非洲》",
    Subprogramme: "为支持《2063年议程》开展公共信息和提高认识活动",
    Title: "青年主导的气候适应能力解决方案的可见度提高",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "非洲的发展",
    Beneficiary: "非洲会员国",
    BeneficiaryTwo: "青年",
    SpecificResult: "通过持续沟通，改善合作和伙伴关系，提高一致性、增强合力和减少重叠",
    SpecificResultOrder: 29,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "11NEPAD12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.11)&l=zh#page=18"
  },
  {
    ID: 254,
    BudgetSection: 12,
    Entity: "UNCTAD",
    EntityFullName: "联合国贸易和发展会议",
    Programme: "贸易与发展",
    Subprogramme: "全球化、相互依存和发展",
    Title: "贸易和发展展望为全球政策讨论和对策提供信息支持",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "国际社会",
    BeneficiaryTwo: "最不发达国家、内陆发展中国家、小岛屿发展中国家和其他发展中国家",
    SpecificResult: "加强合作、增进信息和最佳做法共享，推动在实现可持续发展目标方面取得进展",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "12UNCTAD1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.12)&l=zh#page=12"
  },
  {
    ID: 255,
    BudgetSection: 12,
    Entity: "UNCTAD",
    EntityFullName: "联合国贸易和发展会议",
    Programme: "贸易与发展",
    Subprogramme: "全球化、相互依存和发展",
    Title: "提高发展中国家的债务数据透明度",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "增进对筹资需求的了解，改进为可持续资本投资筹措资金的政策备选方案，加大可持续项目供资承诺和参与力度",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "EC,EG,QG,JO",
    Image: "12UNCTAD2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.12)&l=zh#page=12"
  },
  {
    ID: 256,
    BudgetSection: 12,
    Entity: "UNCTAD",
    EntityFullName: "联合国贸易和发展会议",
    Programme: "贸易与发展",
    Subprogramme: "全球化、相互依存和发展",
    Title: "发展中经济体通过南南和三方合作制定可持续的工业和结构转型政策",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "最不发达国家、内陆发展中国家、小岛屿发展中国家和其他发展中国家",
    BeneficiaryTwo: "私营部门，包括中小微型企业",
    SpecificResult: "利用电子商务和数字经济等方式增强能力和减少壁垒，改善贸易和竞争力",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "KZ,MY,PK,TR",
    Image: "12UNCTAD3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.12)&l=zh#page=13"
  },
  {
    ID: 257,
    BudgetSection: 12,
    Entity: "UNCTAD",
    EntityFullName: "联合国贸易和发展会议",
    Programme: "贸易与发展",
    Subprogramme: "全球化、相互依存和发展",
    Title: "资金借入国以更有效、更可持续的方式管理债务",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "增进对筹资需求的了解，改进为可持续资本投资筹措资金的政策备选方案，加大可持续项目供资承诺和参与力度",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "12UNCTAD4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.12)&l=zh#page=13"
  },
  {
    ID: 258,
    BudgetSection: 12,
    Entity: "UNCTAD",
    EntityFullName: "联合国贸易和发展会议",
    Programme: "贸易与发展",
    Subprogramme: "投资和企业",
    Title: "加强创业生态系统，促进包容性创新企业发展",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "私营部门，包括中小微型企业",
    BeneficiaryTwo: " ",
    SpecificResult: "创业和提高中小微型企业竞争力",
    SpecificResultOrder: 11,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "12UNCTAD5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.12)&l=zh#page=17"
  },
  {
    ID: 259,
    BudgetSection: 12,
    Entity: "UNCTAD",
    EntityFullName: "联合国贸易和发展会议",
    Programme: "贸易与发展",
    Subprogramme: "投资和企业",
    Title: "加快可持续发展目标投资",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "通过稳健协调结构等途径，利用可持续发展目标之间的相互关联性，加快推进可持续发展目标",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "12UNCTAD6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.12)&l=zh#page=17"
  },
  {
    ID: 260,
    BudgetSection: 12,
    Entity: "UNCTAD",
    EntityFullName: "联合国贸易和发展会议",
    Programme: "贸易与发展",
    Subprogramme: "投资和企业",
    Title: "成员国促进有利的商业和投资环境",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "私营部门，包括中小微型企业",
    BeneficiaryTwo: " ",
    SpecificResult: "利用电子商务和数字经济等方式增强能力和减少壁垒，改善贸易和竞争力",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "12UNCTAD7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.12)&l=zh#page=18"
  },
  {
    ID: 261,
    BudgetSection: 12,
    Entity: "UNCTAD",
    EntityFullName: "联合国贸易和发展会议",
    Programme: "贸易与发展",
    Subprogramme: "投资和企业",
    Title: "可持续投资实践采纳程度提高",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "私营部门，包括中小微型企业",
    BeneficiaryTwo: "国际社会",
    SpecificResult: "利用电子商务和数字经济等方式增强能力和减少壁垒，改善贸易和竞争力",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "12UNCTAD8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.12)&l=zh#page=18"
  },
  {
    ID: 262,
    BudgetSection: 12,
    Entity: "UNCTAD",
    EntityFullName: "联合国贸易和发展会议",
    Programme: "贸易与发展",
    Subprogramme: "国际贸易及初级商品",
    Title: "增强消费品安全",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "私营部门，包括中小微型企业",
    BeneficiaryTwo: "国际社会",
    SpecificResult: "多边主义得到加强",
    SpecificResultOrder: 2,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "12UNCTAD9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.12)&l=zh#page=23"
  },
  {
    ID: 263,
    BudgetSection: 12,
    Entity: "UNCTAD",
    EntityFullName: "联合国贸易和发展会议",
    Programme: "贸易与发展",
    Subprogramme: "国际贸易及初级商品",
    Title: "发展中国家通过贸易政策加强落实国家自主贡献",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: " ",
    SpecificResult: "可持续资源管理；在可再生能源方面取得进展",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "GM",
    Image: "12UNCTAD10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.12)&l=zh#page=24"
  },
  {
    ID: 264,
    BudgetSection: 12,
    Entity: "UNCTAD",
    EntityFullName: "联合国贸易和发展会议",
    Programme: "贸易与发展",
    Subprogramme: "国际贸易及初级商品",
    Title: "成员国利用关键的能源转型矿物促进可持续发展",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: "国际社会",
    SpecificResult: "可持续资源管理；在可再生能源方面取得进展",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "NA,ZM",
    Image: "12UNCTAD11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.12)&l=zh#page=24"
  },
  {
    ID: 265,
    BudgetSection: 12,
    Entity: "UNCTAD",
    EntityFullName: "联合国贸易和发展会议",
    Programme: "贸易与发展",
    Subprogramme: "国际贸易及初级商品",
    Title: "提供及时非关税措施数据，促进监管实践优化和经济发展",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "私营部门，包括中小微型企业",
    BeneficiaryTwo: " ",
    SpecificResult: "改善用于循证决策的计量与统计促进可持续发展",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "12UNCTAD12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.12)&l=zh#page=25"
  },
  {
    ID: 266,
    BudgetSection: 12,
    Entity: "UNCTAD",
    EntityFullName: "联合国贸易和发展会议",
    Programme: "贸易与发展",
    Subprogramme: "技术和物流",
    Title: "发展中国家推进可持续发展科学、技术和创新园区的概念化与发展",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "私营部门，包括中小微型企业",
    BeneficiaryTwo: "最不发达国家、内陆发展中国家、小岛屿发展中国家和其他发展中国家",
    SpecificResult: "在科学、技术和创新促进可持续发展(包括人工智能)方面取得进展",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "GH,MN,MZ,UZ",
    Image: "12UNCTAD13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.12)&l=zh#page=30"
  },
  {
    ID: 267,
    BudgetSection: 12,
    Entity: "UNCTAD",
    EntityFullName: "联合国贸易和发展会议",
    Programme: "贸易与发展",
    Subprogramme: "技术和物流",
    Title: "改善发展中国家数字经济统计数据的提供情况",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "国际社会",
    BeneficiaryTwo: "私营部门，包括中小微型企业",
    SpecificResult: "改善用于循证决策的计量与统计促进可持续发展",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "12UNCTAD14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.12)&l=zh#page=30"
  },
  {
    ID: 268,
    BudgetSection: 12,
    Entity: "UNCTAD",
    EntityFullName: "联合国贸易和发展会议",
    Programme: "贸易与发展",
    Subprogramme: "技术和物流",
    Title: "提高贸易程序的效率和可持续性",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "私营部门，包括中小微型企业",
    BeneficiaryTwo: "最不发达国家、内陆发展中国家、小岛屿发展中国家和其他发展中国家",
    SpecificResult: "通过科学、技术和创新提高流程效率",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "JM,VC,TJ,TL,VU,ZW",
    Image: "12UNCTAD15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.12)&l=zh#page=31"
  },
  {
    ID: 269,
    BudgetSection: 12,
    Entity: "UNCTAD",
    EntityFullName: "联合国贸易和发展会议",
    Programme: "贸易与发展",
    Subprogramme: "技术和物流",
    Title: "加强贸易便利化领域的包容性",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "难民、少数群体和其他弱势群体",
    BeneficiaryTwo: "妇女和女童",
    SpecificResult: "实现更具有包容性的发展，不让任何一个人掉队；消除贫困和减少不平等；减少对妇女和女童的歧视，加强性别平等。",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "12UNCTAD16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.12)&l=zh#page=31"
  },
  {
    ID: 270,
    BudgetSection: 12,
    Entity: "UNCTAD",
    EntityFullName: "联合国贸易和发展会议",
    Programme: "贸易与发展",
    Subprogramme: "非洲、最不发达国家和特别方案",
    Title: "最不发达国家就原产地规则和世界贸易组织第十四届部长级会议议程确定了共同立场",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "最不发达国家、内陆发展中国家、小岛屿发展中国家和其他发展中国家",
    BeneficiaryTwo: " ",
    SpecificResult: "多边主义得到加强",
    SpecificResultOrder: 2,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AO,AG,AM,AZ,BS,SD,QQ,BD,BZ,BJ,BT,BO,BW,BF,BI,CV,KH,CF,TD,KM,CK,CU,CD,DJ,DM,DO,ER,SZ,ET,FJ,GM,GD,GN,GW,HT,JM,KZ,KG,KI,LA,LS,LR,MK,MG,MW,MV,ML,MH,MR,MU,FM,MN,MZ,MM,NR,NP,NE,NU,PW,PG,PY,MD,RW,KN,LC,VC,WS,SN,SC,SL,SB,SO,SS,II,SD,QQ,SR,TJ,TL,TG,TO,TT,TM,TV,UG,TZ,UZ,VU,YE,ZM,ZW",
    Image: "12UNCTAD17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.12)&l=zh#page=36"
  },
  {
    ID: 271,
    BudgetSection: 12,
    Entity: "UNCTAD",
    EntityFullName: "联合国贸易和发展会议",
    Programme: "贸易与发展",
    Subprogramme: "非洲、最不发达国家和特别方案",
    Title: "提高最不发达国家和其他发展中国家的统计能力，帮助在制定整体经济多样化政策方",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "最不发达国家、内陆发展中国家、小岛屿发展中国家和其他发展中国家",
    BeneficiaryTwo: " ",
    SpecificResult: "改善用于循证决策的计量与统计促进可持续发展",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AO,ET,KE,NG",
    Image: "12UNCTAD18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.12)&l=zh#page=37"
  },
  {
    ID: 272,
    BudgetSection: 12,
    Entity: "UNCTAD",
    EntityFullName: "联合国贸易和发展会议",
    Programme: "贸易与发展",
    Subprogramme: "非洲、最不发达国家和特别方案",
    Title: "加强小岛屿发展中国家建设生产能力的能力",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "最不发达国家、内陆发展中国家、小岛屿发展中国家和其他发展中国家",
    BeneficiaryTwo: " ",
    SpecificResult: "利用电子商务和数字经济等方式增强能力和减少壁垒，改善贸易和竞争力",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AG,KM,DO,MV,JM,VC,TT",
    Image: "12UNCTAD19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.12)&l=zh#page=37"
  },
  {
    ID: 273,
    BudgetSection: 12,
    Entity: "UNCTAD",
    EntityFullName: "联合国贸易和发展会议",
    Programme: "贸易与发展",
    Subprogramme: "非洲、最不发达国家和特别方案",
    Title: "最不发达国家能够制定实施包容且协调一致的贸易政策",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "最不发达国家、内陆发展中国家、小岛屿发展中国家和其他发展中国家",
    BeneficiaryTwo: " ",
    SpecificResult: "利用电子商务和数字经济等方式增强能力和减少壁垒，改善贸易和竞争力",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BF,TD,TZ",
    Image: "12UNCTAD20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.12)&l=zh#page=38"
  },
  {
    ID: 274,
    BudgetSection: 13,
    Entity: "ITC",
    EntityFullName: "国际贸易中心",
    Programme: "国际贸易中心",
    Subprogramme: "贸易促进和出口发展的业务方面",
    Title: "非洲和拉丁美洲青年初创企业和企业家的创新、创办工商企业和就业机会得到改善",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "私营部门，包括中小微型企业",
    BeneficiaryTwo: "青年",
    SpecificResult: "创业和提高中小微型企业竞争力",
    SpecificResultOrder: 11,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CO,UG",
    Image: "13ITC1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.13)&l=zh#page=6"
  },
  {
    ID: 275,
    BudgetSection: 13,
    Entity: "ITC",
    EntityFullName: "国际贸易中心",
    Programme: "国际贸易中心",
    Subprogramme: "贸易促进和出口发展的业务方面",
    Title: "当地企业扶持组织向小企业提供的旨在让其利用非洲大陆自由贸易区的服务得到加强",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "私营部门，包括中小微型企业",
    BeneficiaryTwo: "最不发达国家、内陆发展中国家、小岛屿发展中国家和其他发展中国家",
    SpecificResult: "创业和提高中小微型企业竞争力",
    SpecificResultOrder: 11,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "13ITC2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.13)&l=zh#page=6"
  },
  {
    ID: 276,
    BudgetSection: 13,
    Entity: "ITC",
    EntityFullName: "国际贸易中心",
    Programme: "国际贸易中心",
    Subprogramme: "贸易促进和出口发展的业务方面",
    Title: "非洲和亚太区域纺织和服装业中小企业向可持续经营转型",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "私营部门，包括中小微型企业",
    BeneficiaryTwo: "最不发达国家、内陆发展中国家、小岛屿发展中国家和其他发展中国家",
    SpecificResult: "创业和提高中小微型企业竞争力",
    SpecificResultOrder: 11,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW,AF,BH,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,IN,AP,ID,IR,IQ,JP,JO,KZ,KW,KG,LA,LB,MY,MV,MH,FM,MN,MM,NR,NP,OM,PK,PW,PG,PH,QA,KR,WS,SA,SG,SB,LK,SY,TJ,TH,TL,TO,TR,TM,TV,AE,UZ,VU,VN,YE",
    Image: "13ITC3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.13)&l=zh#page=7"
  },
  {
    ID: 277,
    BudgetSection: 13,
    Entity: "ITC",
    EntityFullName: "国际贸易中心",
    Programme: "国际贸易中心",
    Subprogramme: "贸易促进和出口发展的业务方面",
    Title: "东欧和中亚中小企业的出口竞争力得到增强",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "私营部门，包括中小微型企业",
    BeneficiaryTwo: " ",
    SpecificResult: "创业和提高中小微型企业竞争力",
    SpecificResultOrder: 11,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AM,KZ,KG,TJ,UZ",
    Image: "13ITC4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.13)&l=zh#page=8"
  },
  {
    ID: 278,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "联合国环境规划署",
    Programme: "环境",
    Subprogramme: "气候行动",
    Title: "城市承诺实现可持续制冷目标",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: " ",
    SpecificResult: "加强监管框架和环境治理；加大气候行动力度促进可持续发展",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.14)&l=zh#page=10"
  },
  {
    ID: 279,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "联合国环境规划署",
    Programme: "环境",
    Subprogramme: "气候行动",
    Title: "会员国制定国家甲烷路线图和行动计划",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: " ",
    SpecificResult: "加强监管框架和环境治理；加大气候行动力度促进可持续发展",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.14)&l=zh#page=11"
  },
  {
    ID: 280,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "联合国环境规划署",
    Programme: "环境",
    Subprogramme: "气候行动",
    Title: "会员国采用无害环境技术减缓和适应气候变化",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: " ",
    SpecificResult: "加强监管框架和环境治理；加大气候行动力度促进可持续发展",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.14)&l=zh#page=11"
  },
  {
    ID: 281,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "联合国环境规划署",
    Programme: "环境",
    Subprogramme: "气候行动",
    Title: "国家和国家以下各级政府采取气候适应战略和政策，包括国家适应计划",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: " ",
    SpecificResult: "加强监管框架和环境治理；加大气候行动力度促进可持续发展",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.14)&l=zh#page=12"
  },
  {
    ID: 282,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "联合国环境规划署",
    Programme: "环境",
    Subprogramme: "以数字化转型支持环境行动",
    Title: "政府和政策制定者获准访问人工智能驱动的环境门户网站",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: " ",
    SpecificResult: "在科学、技术和创新促进可持续发展(包括人工智能)方面取得进展",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.14)&l=zh#page=14"
  },
  {
    ID: 283,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "联合国环境规划署",
    Programme: "环境",
    Subprogramme: "以数字化转型支持环境行动",
    Title: "提高全球环境数据的互操作性",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: " ",
    SpecificResult: "加强监管框架和环境治理；加大气候行动力度促进可持续发展",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.14)&l=zh#page=15"
  },
  {
    ID: 284,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "联合国环境规划署",
    Programme: "环境",
    Subprogramme: "以数字化转型支持环境行动",
    Title: "加强推动环境可持续性的数字能力",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: " ",
    SpecificResult: "推进技术进步，改善信息质量、可用性、可及性和安全性",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.14)&l=zh#page=16"
  },
  {
    ID: 285,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "联合国环境规划署",
    Programme: "环境",
    Subprogramme: "以数字化转型支持环境行动",
    Title: "世界环境情况室为政策决策提供信息",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: " ",
    SpecificResult: "改善信息传播和使用",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.14)&l=zh#page=16"
  },
  {
    ID: 286,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "联合国环境规划署",
    Programme: "环境",
    Subprogramme: "自然行动",
    Title: "会员国承诺保护国界以外的海洋生物多样性",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: " ",
    SpecificResult: "加强监管框架和环境治理；加大气候行动力度促进可持续发展",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.14)&l=zh#page=18"
  },
  {
    ID: 287,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "联合国环境规划署",
    Programme: "环境",
    Subprogramme: "自然行动",
    Title: "公共部门机构在决策中体现生物多样性和生态系统服务的经济贡献",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: " ",
    SpecificResult: "加强监管框架和环境治理；加大气候行动力度促进可持续发展",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.14)&l=zh#page=19"
  },
  {
    ID: 288,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "联合国环境规划署",
    Programme: "环境",
    Subprogramme: "自然行动",
    Title: "沿海珊瑚礁生态系统和当地社区的复原力得到加强",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: " ",
    SpecificResult: "包容型、可持续灾后恢复；建设抵御未来灾害的能力",
    SpecificResultOrder: 12,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.14)&l=zh#page=20"
  },
  {
    ID: 289,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "联合国环境规划署",
    Programme: "环境",
    Subprogramme: "自然行动",
    Title: "扩大得到可持续管理和恢复的生态系统",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: " ",
    SpecificResult: "可持续资源管理；在可再生能源方面取得进展",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.14)&l=zh#page=20"
  },
  {
    ID: 290,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "联合国环境规划署",
    Programme: "环境",
    Subprogramme: "环境治理",
    Title: "会员国推进应对非法废物贩运问题的法律框架和国家战略",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: " ",
    SpecificResult: "加强监管框架和环境治理；加大气候行动力度促进可持续发展",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.14)&l=zh#page=23"
  },
  {
    ID: 291,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "联合国环境规划署",
    Programme: "环境",
    Subprogramme: "环境治理",
    Title: "通过执行《<关于消耗臭氧层物质的蒙特利尔议定书>基加利修正案》，减少氢氟碳化",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: " ",
    SpecificResult: "加强监管框架和环境治理；加大气候行动力度促进可持续发展",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.14)&l=zh#page=23"
  },
  {
    ID: 292,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "联合国环境规划署",
    Programme: "环境",
    Subprogramme: "环境治理",
    Title: "法律利益攸关方加强环境法的实施和执行",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: " ",
    SpecificResult: "促进国际法和加强国际争端解决机制",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.14)&l=zh#page=24"
  },
  {
    ID: 293,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "联合国环境规划署",
    Programme: "环境",
    Subprogramme: "环境治理",
    Title: "环境目标被纳入国家政策和法律框架",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: " ",
    SpecificResult: "加强监管框架和环境治理；加大气候行动力度促进可持续发展",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.14)&l=zh#page=25"
  },
  {
    ID: 294,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "联合国环境规划署",
    Programme: "环境",
    Subprogramme: "化学品和污染行动",
    Title: "全球关切的化学品及其废物减少",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: " ",
    SpecificResult: "加强监管框架和环境治理；加大气候行动力度促进可持续发展",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.14)&l=zh#page=27"
  },
  {
    ID: 295,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "联合国环境规划署",
    Programme: "环境",
    Subprogramme: "化学品和污染行动",
    Title: "采取政策和做法支持高影响力部门的循环经济方法，以减少污染",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: " ",
    SpecificResult: "加强监管框架和环境治理；加大气候行动力度促进可持续发展",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.14)&l=zh#page=27"
  },
  {
    ID: 296,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "联合国环境规划署",
    Programme: "环境",
    Subprogramme: "化学品和污染行动",
    Title: "采取政策和战略，解决抗微生物药物耐药性的环境层面问题",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: " ",
    SpecificResult: "加强监管框架和环境治理；加大气候行动力度促进可持续发展",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.14)&l=zh#page=28"
  },
  {
    ID: 297,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "联合国环境规划署",
    Programme: "环境",
    Subprogramme: "化学品和污染行动",
    Title: "会员国通过有关关键部门化学品和废物管理的政策、法律或法规",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: " ",
    SpecificResult: "加强监管框架和环境治理；加大气候行动力度促进可持续发展",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.14)&l=zh#page=29"
  },
  {
    ID: 298,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "联合国环境规划署",
    Programme: "环境",
    Subprogramme: "金融和经济转型",
    Title: "保险公司承诺在其业务做法中采用可持续性方法",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: " ",
    SpecificResult: "通过持续沟通，改善合作和伙伴关系，提高一致性、增强合力和减少重叠",
    SpecificResultOrder: 29,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.14)&l=zh#page=31"
  },
  {
    ID: 299,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "联合国环境规划署",
    Programme: "环境",
    Subprogramme: "金融和经济转型",
    Title: "推出更多工具和措施，用来转变政府、企业和个人消费者的选择和行为，从而提升环",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: " ",
    SpecificResult: "加强监管框架和环境治理；加大气候行动力度促进可持续发展",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.14)&l=zh#page=32"
  },
  {
    ID: 300,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "联合国环境规划署",
    Programme: "环境",
    Subprogramme: "金融和经济转型",
    Title: "加快在实现可持续消费和生产模式方面的进展",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: " ",
    SpecificResult: "可持续资源管理；在可再生能源方面取得进展",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.14)&l=zh#page=32"
  },
  {
    ID: 301,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "联合国环境规划署",
    Programme: "环境",
    Subprogramme: "金融和经济转型",
    Title: "会员国采取政策增加可持续融资",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: " ",
    SpecificResult: "增进对筹资需求的了解，改进为可持续资本投资筹措资金的政策备选方案，加大可持续项目供资承诺和参与力度",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.14)&l=zh#page=33"
  },
  {
    ID: 302,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "联合国环境规划署",
    Programme: "环境",
    Subprogramme: "科学政策",
    Title: "各国实施环境经济核算体系",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: " ",
    SpecificResult: "改善用于循证决策的计量与统计促进可持续发展",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.14)&l=zh#page=36"
  },
  {
    ID: 303,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "联合国环境规划署",
    Programme: "环境",
    Subprogramme: "科学政策",
    Title: "改进电子废物的监测和收集",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: " ",
    SpecificResult: "改善用于循证决策的计量与统计促进可持续发展",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.14)&l=zh#page=36"
  },
  {
    ID: 304,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "联合国环境规划署",
    Programme: "环境",
    Subprogramme: "科学政策",
    Title: "加强拉丁美洲和加勒比的科学与政策衔接",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: " ",
    SpecificResult: "改善用于循证决策的计量与统计促进可持续发展",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CL,CO,CR,CU,DM,DO,EC,SV,GD,GT,GY,HT,HN,JM,MX,NI,PA,PY,PE,KN,LC,VC,SR,TT,UY,VE",
    Image: "14UNEP27.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.14)&l=zh#page=37"
  },
  {
    ID: 305,
    BudgetSection: 14,
    Entity: "UNEP",
    EntityFullName: "联合国环境规划署",
    Programme: "环境",
    Subprogramme: "科学政策",
    Title: "政府和机构利用联合国环境规划署的知识、数据、统计和评估为政策制",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: " ",
    SpecificResult: "改善信息传播和使用",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP28.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.14)&l=zh#page=38"
  },
  {
    ID: 306,
    BudgetSection: 15,
    Entity: "UN-Habitat",
    EntityFullName: "联合国人类住区规划署",
    Programme: "人类住区",
    Subprogramme: "住房、土地、基本服务和城市环境",
    Title: "将可持续出行与公交便利型住房结合，以在城市(特别是城市边缘地区) 扩大公平使用安全公平的公共交通的机会",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "非洲会员国",
    SpecificResult: "实现更具有包容性的发展，不让任何一个人掉队；消除贫困和减少不平等；减少对妇女和女童的歧视，加强性别平等。",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "GH,KE,NG,UG",
    Image: "15UN-Habitat1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.15)&l=zh#page=12"
  },
  {
    ID: 307,
    BudgetSection: 15,
    Entity: "UN-Habitat",
    EntityFullName: "联合国人类住区规划署",
    Programme: "人类住区",
    Subprogramme: "住房、土地、基本服务和城市环境",
    Title: "城市和国家承诺为所有人提供适当住房，并解决无家可归和在住房方面遭到排斥的问题",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "难民、少数群体和其他弱势群体",
    SpecificResult: "实现更具有包容性的发展，不让任何一个人掉队；消除贫困和减少不平等；减少对妇女和女童的歧视，加强性别平等。",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CR,KM,CU,MX",
    Image: "15UN-Habitat2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.15)&l=zh#page=13"
  },
  {
    ID: 308,
    BudgetSection: 15,
    Entity: "UN-Habitat",
    EntityFullName: "联合国人类住区规划署",
    Programme: "人类住区",
    Subprogramme: "住房、土地、基本服务和城市环境",
    Title: "土地保有权保障得到加强",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "难民、少数群体和其他弱势群体",
    SpecificResult: "在人权的保护和享受方面取得进展，减少不平等和歧视；进一步融合发展权",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "NP",
    Image: "15UN-Habitat3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.15)&l=zh#page=13"
  },
  {
    ID: 309,
    BudgetSection: 15,
    Entity: "UN-Habitat",
    EntityFullName: "联合国人类住区规划署",
    Programme: "人类住区",
    Subprogramme: "住房、土地、基本服务和城市环境",
    Title: "增加适当住房、土地和基本服务的获取渠道",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "难民、少数群体和其他弱势群体",
    SpecificResult: "实现更具有包容性的发展，不让任何一个人掉队；消除贫困和减少不平等；减少对妇女和女童的歧视，加强性别平等。",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "15UN-Habitat4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.15)&l=zh#page=14"
  },
  {
    ID: 310,
    BudgetSection: 15,
    Entity: "UN-Habitat",
    EntityFullName: "联合国人类住区规划署",
    Programme: "人类住区",
    Subprogramme: "规划、财政政策、本地化和治理",
    Title: "通过规划法改革加强多层级治理，建设有韧性且可持续的城市",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: " ",
    SpecificResult: "加强监管框架和环境治理；加大气候行动力度促进可持续发展",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BW,SL,ZW",
    Image: "15UN-Habitat5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.15)&l=zh#page=17"
  },
  {
    ID: 311,
    BudgetSection: 15,
    Entity: "UN-Habitat",
    EntityFullName: "联合国人类住区规划署",
    Programme: "人类住区",
    Subprogramme: "规划、财政政策、本地化和治理",
    Title: "提升自筹财源系统，以改善地方政府绩效",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: " ",
    SpecificResult: "增进对筹资需求的了解，改进为可持续资本投资筹措资金的政策备选方案，加大可持续项目供资承诺和参与力度",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "15UN-Habitat6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.15)&l=zh#page=18"
  },
  {
    ID: 312,
    BudgetSection: 15,
    Entity: "UN-Habitat",
    EntityFullName: "联合国人类住区规划署",
    Programme: "人类住区",
    Subprogramme: "规划、财政政策、本地化和治理",
    Title: "可持续发展目标本地化通过培育包容性多层级治理、利益攸关方参与、机构能力和为地方解决方案筹措资金，促进了系统变革和区域转型",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: " ",
    SpecificResult: "通过稳健协调结构等途径，利用可持续发展目标之间的相互关联性，加快推进可持续发展目标",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "15UN-Habitat7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.15)&l=zh#page=19"
  },
  {
    ID: 313,
    BudgetSection: 15,
    Entity: "UN-Habitat",
    EntityFullName: "联合国人类住区规划署",
    Programme: "人类住区",
    Subprogramme: "知识、数据、数字化和能力发展",
    Title: "城市专业人员可从公开渠道查阅以多种语言提供的实用知识和指南，以帮助加速实施《新城市议程》和可持续发展目标",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "青年",
    SpecificResult: "改善信息传播和使用",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "15UN-Habitat8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.15)&l=zh#page=22"
  },
  {
    ID: 314,
    BudgetSection: 15,
    Entity: "UN-Habitat",
    EntityFullName: "联合国人类住区规划署",
    Programme: "人类住区",
    Subprogramme: "知识、数据、数字化和能力发展",
    Title: "数字转型促进城市可持续发展",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "加强监管框架和环境治理；加大气候行动力度促进可持续发展",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "15UN-Habitat9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.15)&l=zh#page=23"
  },
  {
    ID: 315,
    BudgetSection: 15,
    Entity: "UN-Habitat",
    EntityFullName: "联合国人类住区规划署",
    Programme: "人类住区",
    Subprogramme: "知识、数据、数字化和能力发展",
    Title: "国家和地方当局增加并改进了关于住房、土地和基本服务的具有政策相关性的分类数",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "难民、少数群体和其他弱势群体",
    SpecificResult: "改善用于循证决策的计量与统计促进可持续发展",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "15UN-Habitat10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.15)&l=zh#page=23"
  },
  {
    ID: 316,
    BudgetSection: 15,
    Entity: "UN-Habitat",
    EntityFullName: "联合国人类住区规划署",
    Programme: "人类住区",
    Subprogramme: "伙伴关系、联盟、倡导和传播",
    Title: "全球利益攸关方论坛推进包容且负责任的城市发展",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "加强合作、增进信息和最佳做法共享，推动在实现可持续发展目标方面取得进展",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "15UN-Habitat11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.15)&l=zh#page=26"
  },
  {
    ID: 317,
    BudgetSection: 15,
    Entity: "UN-Habitat",
    EntityFullName: "联合国人类住区规划署",
    Programme: "人类住区",
    Subprogramme: "伙伴关系、联盟、倡导和传播",
    Title: "利用世界城市论坛，推进关于确保人人获得适当住房、土地和基本服务的全球承诺",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "加强合作、增进信息和最佳做法共享，推动在实现可持续发展目标方面取得进展",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "15UN-Habitat12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.15)&l=zh#page=27"
  },
  {
    ID: 318,
    BudgetSection: 15,
    Entity: "UN-Habitat",
    EntityFullName: "联合国人类住区规划署",
    Programme: "人类住区",
    Subprogramme: "加强气候行动和改善城市环境",
    Title: "国家自主贡献越来越多地包含城市内容",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "气候和环境",
    SpecificResult: "加强监管框架和环境治理；加大气候行动力度促进可持续发展",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "15UN-Habitat13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.15)&l=zh#page=30"
  },
  {
    ID: 319,
    BudgetSection: 15,
    Entity: "UN-Habitat",
    EntityFullName: "联合国人类住区规划署",
    Programme: "人类住区",
    Subprogramme: "加强气候行动和改善城市环境",
    Title: "为提升最脆弱人群的韧性而制定的城市气候行动计划",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "难民、少数群体和其他弱势群体",
    SpecificResult: "包容型、可持续灾后恢复；建设抵御未来灾害的能力",
    SpecificResultOrder: 12,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "15UN-Habitat14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.15)&l=zh#page=31"
  },
  {
    ID: 320,
    BudgetSection: 15,
    Entity: "UN-Habitat",
    EntityFullName: "联合国人类住区规划署",
    Programme: "人类住区",
    Subprogramme: "有效预防和应对城市危机",
    Title: "流离失所者社群可持续地融入索马里城市地区",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "难民、少数群体和其他弱势群体",
    BeneficiaryTwo: " ",
    SpecificResult: "加强对难民权利的保护，改善生活条件，包括卫生和教育，提高响应能力和共担责任",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "SO",
    Image: "15UN-Habitat15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.15)&l=zh#page=32"
  },
  {
    ID: 321,
    BudgetSection: 15,
    Entity: "UN-Habitat",
    EntityFullName: "联合国人类住区规划署",
    Programme: "人类住区",
    Subprogramme: "有效预防和应对城市危机",
    Title: "参与式综合城市规划和包容性发展",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "难民、少数群体和其他弱势群体",
    SpecificResult: "实现更具有包容性的发展，不让任何一个人掉队；消除贫困和减少不平等；减少对妇女和女童的歧视，加强性别平等。",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "SO",
    Image: "15UN-Habitat16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.15)&l=zh#page=33"
  },
  {
    ID: 322,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "联合国毒品和犯罪问题办公室",
    Programme: "国际药物管理、预防犯罪和恐怖主义及刑事司法",
    Subprogramme: "打击跨国有组织犯罪",
    Title: "加强在打击网络犯罪和共享严重犯罪电子证据方面的国际合作",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "药物管制、预防犯罪和打击一切形式和表现的有组织犯罪和国际恐怖主义",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "国际社会",
    SpecificResult: "加强对法治的遵守；加强预防犯罪和刑事司法；减少腐败；预防和打击恐怖主义",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=zh#page=18"
  },
  {
    ID: 323,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "联合国毒品和犯罪问题办公室",
    Programme: "国际药物管理、预防犯罪和恐怖主义及刑事司法",
    Subprogramme: "打击跨国有组织犯罪",
    Title: "改进枪支、零部件和弹药的登记和可追踪性",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "药物管制、预防犯罪和打击一切形式和表现的有组织犯罪和国际恐怖主义",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "国际社会",
    SpecificResult: "加强对毒品、非法货物和人口贩运的管制；减少非法资金流动",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "HN,SN",
    Image: "16UNODC2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=zh#page=19"
  },
  {
    ID: 324,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "联合国毒品和犯罪问题办公室",
    Programme: "国际药物管理、预防犯罪和恐怖主义及刑事司法",
    Subprogramme: "打击跨国有组织犯罪",
    Title: "加强对空中、海上和陆地贩运的侦测",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "药物管制、预防犯罪和打击一切形式和表现的有组织犯罪和国际恐怖主义",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "国际社会",
    SpecificResult: "加强对毒品、非法货物和人口贩运的管制；减少非法资金流动",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=zh#page=20"
  },
  {
    ID: 325,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "联合国毒品和犯罪问题办公室",
    Programme: "国际药物管理、预防犯罪和恐怖主义及刑事司法",
    Subprogramme: "打击跨国有组织犯罪",
    Title: "加强全球打击有组织犯罪的规范、政策和体制对策",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "药物管制、预防犯罪和打击一切形式和表现的有组织犯罪和国际恐怖主义",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "国际社会",
    SpecificResult: "加强对毒品、非法货物和人口贩运的管制；减少非法资金流动",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=zh#page=20"
  },
  {
    ID: 326,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "联合国毒品和犯罪问题办公室",
    Programme: "国际药物管理、预防犯罪和恐怖主义及刑事司法",
    Subprogramme: "以综合和平衡方针应对世界毒品问题",
    Title: "通过加强基于案例的国际合作，提高会员国摧毁从事贩毒的犯罪网络的能力",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "药物管制、预防犯罪和打击一切形式和表现的有组织犯罪和国际恐怖主义",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "国际社会",
    SpecificResult: "加强对毒品、非法货物和人口贩运的管制；减少非法资金流动",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AR,BO,BR,CV,CL,CI,DE,PE",
    Image: "16UNODC5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=zh#page=23"
  },
  {
    ID: 327,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "联合国毒品和犯罪问题办公室",
    Programme: "国际药物管理、预防犯罪和恐怖主义及刑事司法",
    Subprogramme: "以综合和平衡方针应对世界毒品问题",
    Title: "撒哈拉以南非洲会员国在解决世界毒品问题背景下实施更强有力的健康和发展干预措施",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "药物管制、预防犯罪和打击一切形式和表现的有组织犯罪和国际恐怖主义",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "非洲会员国",
    SpecificResult: "实现更具有包容性的发展，不让任何一个人掉队；消除贫困和减少不平等；减少对妇女和女童的歧视，加强性别平等。",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "16UNODC6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=zh#page=24"
  },
  {
    ID: 328,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "联合国毒品和犯罪问题办公室",
    Programme: "国际药物管理、预防犯罪和恐怖主义及刑事司法",
    Subprogramme: "以综合和平衡方针应对世界毒品问题",
    Title: "通过在国家一级实施新的健康和发展举措，弥补全球在提供服务方面的差距",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "药物管制、预防犯罪和打击一切形式和表现的有组织犯罪和国际恐怖主义",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "难民、少数群体和其他弱势群体",
    SpecificResult: "实现更具有包容性的发展，不让任何一个人掉队；消除贫困和减少不平等；减少对妇女和女童的歧视，加强性别平等。",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=zh#page=24"
  },
  {
    ID: 329,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "联合国毒品和犯罪问题办公室",
    Programme: "国际药物管理、预防犯罪和恐怖主义及刑事司法",
    Subprogramme: "以综合和平衡方针应对世界毒品问题",
    Title: "法证实验室人员具备分析和识别合成药物及其制造过程中使用的前体化学品的能力",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "药物管制、预防犯罪和打击一切形式和表现的有组织犯罪和国际恐怖主义",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "国际社会",
    SpecificResult: "加强对毒品、非法货物和人口贩运的管制；减少非法资金流动",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=zh#page=25"
  },
  {
    ID: 330,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "联合国毒品和犯罪问题办公室",
    Programme: "国际药物管理、预防犯罪和恐怖主义及刑事司法",
    Subprogramme: "反腐败",
    Title: "会员国调查、起诉和判决复杂的国际腐败案件",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "药物管制、预防犯罪和打击一切形式和表现的有组织犯罪和国际恐怖主义",
    Beneficiary: "公共行政",
    BeneficiaryTwo: " ",
    SpecificResult: "加强对法治的遵守；加强预防犯罪和刑事司法；减少腐败；预防和打击恐怖主义",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DO,KE,MY,PA,TZ,VN",
    Image: "16UNODC9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=zh#page=28"
  },
  {
    ID: 331,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "联合国毒品和犯罪问题办公室",
    Programme: "国际药物管理、预防犯罪和恐怖主义及刑事司法",
    Subprogramme: "反腐败",
    Title: "各国在反腐败工作中对实益所有权信息的使用得到加强",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "药物管制、预防犯罪和打击一切形式和表现的有组织犯罪和国际恐怖主义",
    Beneficiary: "公共行政",
    BeneficiaryTwo: " ",
    SpecificResult: "加强对法治的遵守；加强预防犯罪和刑事司法；减少腐败；预防和打击恐怖主义",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "GT,HN,PY,PH,VN,ZM",
    Image: "16UNODC10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=zh#page=29"
  },
  {
    ID: 332,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "联合国毒品和犯罪问题办公室",
    Programme: "国际药物管理、预防犯罪和恐怖主义及刑事司法",
    Subprogramme: "反腐败",
    Title: "加强各国在区域层面上的反腐败合作",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "药物管制、预防犯罪和打击一切形式和表现的有组织犯罪和国际恐怖主义",
    Beneficiary: "公共行政",
    BeneficiaryTwo: " ",
    SpecificResult: "加强对法治的遵守；加强预防犯罪和刑事司法；减少腐败；预防和打击恐怖主义",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=zh#page=29"
  },
  {
    ID: 333,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "联合国毒品和犯罪问题办公室",
    Programme: "国际药物管理、预防犯罪和恐怖主义及刑事司法",
    Subprogramme: "反腐败",
    Title: "各国根据《联合国反腐败公约》建立有效的法律和政策框架来解决腐败问题",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "药物管制、预防犯罪和打击一切形式和表现的有组织犯罪和国际恐怖主义",
    Beneficiary: "公共行政",
    BeneficiaryTwo: " ",
    SpecificResult: "加强对法治的遵守；加强预防犯罪和刑事司法；减少腐败；预防和打击恐怖主义",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=zh#page=30"
  },
  {
    ID: 334,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "联合国毒品和犯罪问题办公室",
    Programme: "国际药物管理、预防犯罪和恐怖主义及刑事司法",
    Subprogramme: "预防恐怖主义",
    Title: "加强刑事司法应对措施，打击科特迪瓦的资助恐怖主义行为",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "药物管制、预防犯罪和打击一切形式和表现的有组织犯罪和国际恐怖主义",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "国际社会",
    SpecificResult: "加强对法治的遵守；加强预防犯罪和刑事司法；减少腐败；预防和打击恐怖主义",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CI",
    Image: "16UNODC13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=zh#page=32"
  },
  {
    ID: 335,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "联合国毒品和犯罪问题办公室",
    Programme: "国际药物管理、预防犯罪和恐怖主义及刑事司法",
    Subprogramme: "预防恐怖主义",
    Title: "南部非洲进行体制变革，建立强有力、负责任的刑事司法系统并打击恐怖主义",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "药物管制、预防犯罪和打击一切形式和表现的有组织犯罪和国际恐怖主义",
    Beneficiary: "公共行政",
    BeneficiaryTwo: " ",
    SpecificResult: "加强对法治的遵守；加强预防犯罪和刑事司法；减少腐败；预防和打击恐怖主义",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "MZ",
    Image: "16UNODC14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=zh#page=33"
  },
  {
    ID: 336,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "联合国毒品和犯罪问题办公室",
    Programme: "国际药物管理、预防犯罪和恐怖主义及刑事司法",
    Subprogramme: "预防恐怖主义",
    Title: "女性官员对加强刑事司法系统、打击恐怖主义的贡献增加",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "药物管制、预防犯罪和打击一切形式和表现的有组织犯罪和国际恐怖主义",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "妇女和女童",
    SpecificResult: "加强对法治的遵守；加强预防犯罪和刑事司法；减少腐败；预防和打击恐怖主义",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=zh#page=33"
  },
  {
    ID: 337,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "联合国毒品和犯罪问题办公室",
    Programme: "国际药物管理、预防犯罪和恐怖主义及刑事司法",
    Subprogramme: "预防恐怖主义",
    Title: "各国通过《制止核恐怖主义行为国际公约》更好地准备打击放射性和核恐怖主义",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "药物管制、预防犯罪和打击一切形式和表现的有组织犯罪和国际恐怖主义",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "国际社会",
    SpecificResult: "加强对法治的遵守；加强预防犯罪和刑事司法；减少腐败；预防和打击恐怖主义",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=zh#page=34"
  },
  {
    ID: 338,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "联合国毒品和犯罪问题办公室",
    Programme: "国际药物管理、预防犯罪和恐怖主义及刑事司法",
    Subprogramme: "司法",
    Title: "国家监狱系统更好地遵守国际标准，以促进康复",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "药物管制、预防犯罪和打击一切形式和表现的有组织犯罪和国际恐怖主义",
    Beneficiary: "公共行政",
    BeneficiaryTwo: " ",
    SpecificResult: "加强对法治的遵守；加强预防犯罪和刑事司法；减少腐败；预防和打击恐怖主义",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=zh#page=37"
  },
  {
    ID: 339,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "联合国毒品和犯罪问题办公室",
    Programme: "国际药物管理、预防犯罪和恐怖主义及刑事司法",
    Subprogramme: "司法",
    Title: "充分尊重人权的预防犯罪和刑事司法改革",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "药物管制、预防犯罪和打击一切形式和表现的有组织犯罪和国际恐怖主义",
    Beneficiary: "公共行政",
    BeneficiaryTwo: " ",
    SpecificResult: "加强对法治的遵守；加强预防犯罪和刑事司法；减少腐败；预防和打击恐怖主义",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=zh#page=38"
  },
  {
    ID: 340,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "联合国毒品和犯罪问题办公室",
    Programme: "国际药物管理、预防犯罪和恐怖主义及刑事司法",
    Subprogramme: "司法",
    Title: "增强儿童和青年的权能，防止儿童卷入犯罪和暴力",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "药物管制、预防犯罪和打击一切形式和表现的有组织犯罪和国际恐怖主义",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "青年",
    SpecificResult: "加强对法治的遵守；加强预防犯罪和刑事司法；减少腐败；预防和打击恐怖主义",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=zh#page=39"
  },
  {
    ID: 341,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "联合国毒品和犯罪问题办公室",
    Programme: "国际药物管理、预防犯罪和恐怖主义及刑事司法",
    Subprogramme: "司法",
    Title: "通过机构伙伴关系增强国家对预防犯罪和刑事司法举措的自主权",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "药物管制、预防犯罪和打击一切形式和表现的有组织犯罪和国际恐怖主义",
    Beneficiary: "公共行政",
    BeneficiaryTwo: " ",
    SpecificResult: "加强对法治的遵守；加强预防犯罪和刑事司法；减少腐败；预防和打击恐怖主义",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=zh#page=39"
  },
  {
    ID: 342,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "联合国毒品和犯罪问题办公室",
    Programme: "国际药物管理、预防犯罪和恐怖主义及刑事司法",
    Subprogramme: "研究、趋势分析和法证",
    Title: "提高美洲执法人员和法证人员在犯罪现场调查和检查伪造及欺诈性安全文件方面的能力和专",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "药物管制、预防犯罪和打击一切形式和表现的有组织犯罪和国际恐怖主义",
    Beneficiary: "公共行政",
    BeneficiaryTwo: " ",
    SpecificResult: "加强对毒品、非法货物和人口贩运的管制；减少非法资金流动",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AR,BO,CL,CR,DO,EC,SV,GT,GY,HN,JM,PA,PY,PE,TT,UY",
    Image: "16UNODC21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=zh#page=42"
  },
  {
    ID: 343,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "联合国毒品和犯罪问题办公室",
    Programme: "国际药物管理、预防犯罪和恐怖主义及刑事司法",
    Subprogramme: "研究、趋势分析和法证",
    Title: "会员国的药物检测和毒理学实验室监测绩效，作为质量保证做法的一部分",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "药物管制、预防犯罪和打击一切形式和表现的有组织犯罪和国际恐怖主义",
    Beneficiary: "公共行政",
    BeneficiaryTwo: " ",
    SpecificResult: "加强对毒品、非法货物和人口贩运的管制；减少非法资金流动",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=zh#page=42"
  },
  {
    ID: 344,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "联合国毒品和犯罪问题办公室",
    Programme: "国际药物管理、预防犯罪和恐怖主义及刑事司法",
    Subprogramme: "研究、趋势分析和法证",
    Title: "会员国更容易获得了解和打击人口贩运所需的证据",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "药物管制、预防犯罪和打击一切形式和表现的有组织犯罪和国际恐怖主义",
    Beneficiary: "难民、少数群体和其他弱势群体",
    BeneficiaryTwo: "国际社会",
    SpecificResult: "加强对毒品、非法货物和人口贩运的管制；减少非法资金流动",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=zh#page=43"
  },
  {
    ID: 345,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "联合国毒品和犯罪问题办公室",
    Programme: "国际药物管理、预防犯罪和恐怖主义及刑事司法",
    Subprogramme: "研究、趋势分析和法证",
    Title: "会员国越来越多地将毒罪办的研究用于决策",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "药物管制、预防犯罪和打击一切形式和表现的有组织犯罪和国际恐怖主义",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "加强对毒品、非法货物和人口贩运的管制；减少非法资金流动",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=zh#page=44"
  },
  {
    ID: 346,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "联合国毒品和犯罪问题办公室",
    Programme: "国际药物管理、预防犯罪和恐怖主义及刑事司法",
    Subprogramme: "政策支助",
    Title: "人口贩运受害者通过联合国援助人口贩运活动受害者特别是妇女和儿童自愿信托基金获得以",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "药物管制、预防犯罪和打击一切形式和表现的有组织犯罪和国际恐怖主义",
    Beneficiary: "难民、少数群体和其他弱势群体",
    BeneficiaryTwo: "妇女和女童",
    SpecificResult: "加强对毒品、非法货物和人口贩运的管制；减少非法资金流动",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=zh#page=46"
  },
  {
    ID: 347,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "联合国毒品和犯罪问题办公室",
    Programme: "国际药物管理、预防犯罪和恐怖主义及刑事司法",
    Subprogramme: "政策支助",
    Title: "青年有意义地参与毒品、犯罪和腐败问题的决策进程",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "药物管制、预防犯罪和打击一切形式和表现的有组织犯罪和国际恐怖主义",
    Beneficiary: "青年",
    BeneficiaryTwo: " ",
    SpecificResult: "多边主义得到加强",
    SpecificResultOrder: 2,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=zh#page=47"
  },
  {
    ID: 348,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "联合国毒品和犯罪问题办公室",
    Programme: "国际药物管理、预防犯罪和恐怖主义及刑事司法",
    Subprogramme: "政策支助",
    Title: "在《联合国打击网络犯罪公约》范围内实施公私伙伴关系举措",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "药物管制、预防犯罪和打击一切形式和表现的有组织犯罪和国际恐怖主义",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "私营部门，包括中小微型企业",
    SpecificResult: "加强对法治的遵守；加强预防犯罪和刑事司法；减少腐败；预防和打击恐怖主义",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DO,NG",
    Image: "16UNODC27.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=zh#page=48"
  },
  {
    ID: 349,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "联合国毒品和犯罪问题办公室",
    Programme: "国际药物管理、预防犯罪和恐怖主义及刑事司法",
    Subprogramme: "政策支助",
    Title: "通过有针对性的社交媒体内容，提高公众对毒品、犯罪、腐败和恐怖主义威胁的认识",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "药物管制、预防犯罪和打击一切形式和表现的有组织犯罪和国际恐怖主义",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "改善信息传播和使用",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC28.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=zh#page=48"
  },
  {
    ID: 350,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "联合国毒品和犯罪问题办公室",
    Programme: "国际药物管理、预防犯罪和恐怖主义及刑事司法",
    Subprogramme: "技术合作和外地支助",
    Title: "海地问责制和司法系统效力得到改善",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "药物管制、预防犯罪和打击一切形式和表现的有组织犯罪和国际恐怖主义",
    Beneficiary: "公共行政",
    BeneficiaryTwo: " ",
    SpecificResult: "加强对法治的遵守；加强预防犯罪和刑事司法；减少腐败；预防和打击恐怖主义",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "HT",
    Image: "16UNODC29.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=zh#page=50"
  },
  {
    ID: 351,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "联合国毒品和犯罪问题办公室",
    Programme: "国际药物管理、预防犯罪和恐怖主义及刑事司法",
    Subprogramme: "技术合作和外地支助",
    Title: "通过加强海上安全管理系统应对海上安全挑战",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "药物管制、预防犯罪和打击一切形式和表现的有组织犯罪和国际恐怖主义",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "加强对法治的遵守；加强预防犯罪和刑事司法；减少腐败；预防和打击恐怖主义",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AO,KM,KE,MG,MU,MZ,NA,SC,TZ",
    Image: "16UNODC30.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=zh#page=51"
  },
  {
    ID: 352,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "联合国毒品和犯罪问题办公室",
    Programme: "国际药物管理、预防犯罪和恐怖主义及刑事司法",
    Subprogramme: "技术合作和外地支助",
    Title: "提高资产管理的透明度和效率，以加强预防犯罪和增进公众信任度",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "药物管制、预防犯罪和打击一切形式和表现的有组织犯罪和国际恐怖主义",
    Beneficiary: "公共行政",
    BeneficiaryTwo: " ",
    SpecificResult: "加强对法治的遵守；加强预防犯罪和刑事司法；减少腐败；预防和打击恐怖主义",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "MZ",
    Image: "16UNODC31.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=zh#page=52"
  },
  {
    ID: 353,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "联合国毒品和犯罪问题办公室",
    Programme: "国际药物管理、预防犯罪和恐怖主义及刑事司法",
    Subprogramme: "技术合作和外地支助",
    Title: "预防和处理土著人民传统居住的土地和领土上的有组织犯罪活动",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "药物管制、预防犯罪和打击一切形式和表现的有组织犯罪和国际恐怖主义",
    Beneficiary: "难民、少数群体和其他弱势群体",
    BeneficiaryTwo: " ",
    SpecificResult: "加强对法治的遵守；加强预防犯罪和刑事司法；减少腐败；预防和打击恐怖主义",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BR",
    Image: "16UNODC32.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=zh#page=53"
  },
  {
    ID: 354,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "联合国毒品和犯罪问题办公室",
    Programme: "国际药物管理、预防犯罪和恐怖主义及刑事司法",
    Subprogramme: "向麻醉药品委员会、预防犯罪和刑事司法委员会及联合国预防犯罪和刑事司法大会提供秘书处服务和实质性支助",
    Title: "为第十五届联合国预防犯罪和刑事司法大会进行的筹备工作取得进展；",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "药物管制、预防犯罪和打击一切形式和表现的有组织犯罪和国际恐怖主义",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "多边主义得到加强",
    SpecificResultOrder: 2,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AT,CR,ET,MA,TH",
    Image: "16UNODC33.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=zh#page=55"
  },
  {
    ID: 355,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "联合国毒品和犯罪问题办公室",
    Programme: "国际药物管理、预防犯罪和恐怖主义及刑事司法",
    Subprogramme: "向麻醉药品委员会、预防犯罪和刑事司法委员会及联合国预防犯罪和刑事司法大会提供秘书处服务和实质性支助",
    Title: "加强执行国际预防犯罪和刑事司法政策承诺",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "药物管制、预防犯罪和打击一切形式和表现的有组织犯罪和国际恐怖主义",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "多边主义得到加强",
    SpecificResultOrder: 2,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC34.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=zh#page=56"
  },
  {
    ID: 356,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "联合国毒品和犯罪问题办公室",
    Programme: "国际药物管理、预防犯罪和恐怖主义及刑事司法",
    Subprogramme: "向麻醉药品委员会、预防犯罪和刑事司法委员会及联合国预防犯罪和刑事司法大会提供秘书处服务和实质性支助",
    Title: "通过和执行阿布扎比宣言，从而加速犯罪预防、刑事司法和法治",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "药物管制、预防犯罪和打击一切形式和表现的有组织犯罪和国际恐怖主义",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "多边主义得到加强",
    SpecificResultOrder: 2,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC35.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=zh#page=56"
  },
  {
    ID: 357,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "联合国毒品和犯罪问题办公室",
    Programme: "国际药物管理、预防犯罪和恐怖主义及刑事司法",
    Subprogramme: "向麻醉药品委员会、预防犯罪和刑事司法委员会及联合国预防犯罪和刑事司法大会提供秘书处服务和实质性支助",
    Title: "加速履行国际药物政策承诺，以有效应对和打击世界毒品问题",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "药物管制、预防犯罪和打击一切形式和表现的有组织犯罪和国际恐怖主义",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "多边主义得到加强",
    SpecificResultOrder: 2,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC36.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=zh#page=57"
  },
  {
    ID: 358,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "联合国毒品和犯罪问题办公室",
    Programme: "国际药物管理、预防犯罪和恐怖主义及刑事司法",
    Subprogramme: "向国际麻醉品管制局提供秘书处服务和实质性支助",
    Title: "用于医疗和科研目的的麻醉药品和精神药物合法贸易国际估计和评估体系的有效运作",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "药物管制、预防犯罪和打击一切形式和表现的有组织犯罪和国际恐怖主义",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "加强对毒品、非法货物和人口贩运的管制；减少非法资金流动",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC37.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=zh#page=61"
  },
  {
    ID: 359,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "联合国毒品和犯罪问题办公室",
    Programme: "国际药物管理、预防犯罪和恐怖主义及刑事司法",
    Subprogramme: "向国际麻醉品管制局提供秘书处服务和实质性支助",
    Title: "强效新精神活性物质和非医用合成阿片类药物的贩运减少",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "药物管制、预防犯罪和打击一切形式和表现的有组织犯罪和国际恐怖主义",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "加强对毒品、非法货物和人口贩运的管制；减少非法资金流动",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC38.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=zh#page=61"
  },
  {
    ID: 360,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "联合国毒品和犯罪问题办公室",
    Programme: "国际药物管理、预防犯罪和恐怖主义及刑事司法",
    Subprogramme: "向国际麻醉品管制局提供秘书处服务和实质性支助",
    Title: "加强会员国确保医疗和科学用途国际管制物质充足供应的能力",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "药物管制、预防犯罪和打击一切形式和表现的有组织犯罪和国际恐怖主义",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "加强对毒品、非法货物和人口贩运的管制；减少非法资金流动",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC39.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=zh#page=62"
  },
  {
    ID: 361,
    BudgetSection: 16,
    Entity: "UNODC",
    EntityFullName: "联合国毒品和犯罪问题办公室",
    Programme: "国际药物管理、预防犯罪和恐怖主义及刑事司法",
    Subprogramme: "向国际麻醉品管制局提供秘书处服务和实质性支助",
    Title: "用于非法制造毒品的前体化学品和未列入附表的化学品的供应减少",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "药物管制、预防犯罪和打击一切形式和表现的有组织犯罪和国际恐怖主义",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "加强对毒品、非法货物和人口贩运的管制；减少非法资金流动",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC40.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.16)&l=zh#page=62"
  },
  {
    ID: 362,
    BudgetSection: 17,
    Entity: "UN-Women",
    EntityFullName: "联合国促进性别平等和增强妇女权能署",
    Programme: "妇女署",
    Subprogramme: "政府间支助、协调和战略伙伴关系",
    Title: "为加快落实《北京行动纲要》而确定并推进的优先行动",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "促进人权",
    Beneficiary: "妇女和女童",
    BeneficiaryTwo: " ",
    SpecificResult: "在人权的保护和享受方面取得进展，减少不平等和歧视；进一步融合发展权",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "17UN-Women1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.17)&l=zh#page=8"
  },
  {
    ID: 363,
    BudgetSection: 17,
    Entity: "UN-Women",
    EntityFullName: "联合国促进性别平等和增强妇女权能署",
    Programme: "妇女署",
    Subprogramme: "政府间支助、协调和战略伙伴关系",
    Title: "关于性别平等及增强所有妇女和女童权能的全球规范和标准得到加强",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "促进人权",
    Beneficiary: "妇女和女童",
    BeneficiaryTwo: " ",
    SpecificResult: "在人权的保护和享受方面取得进展，减少不平等和歧视；进一步融合发展权",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "17UN-Women2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.17)&l=zh#page=9"
  },
  {
    ID: 364,
    BudgetSection: 17,
    Entity: "UN-Women",
    EntityFullName: "联合国促进性别平等和增强妇女权能署",
    Programme: "妇女署",
    Subprogramme: "政府间支助、协调和战略伙伴关系",
    Title: "将性别平等观点纳入联合国可持续发展合作框架的主流",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "妇女和女童",
    BeneficiaryTwo: " ",
    SpecificResult: "实现更具有包容性的发展，不让任何一个人掉队；消除贫困和减少不平等；减少对妇女和女童的歧视，加强性别平等。",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "17UN-Women3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.17)&l=zh#page=9"
  },
  {
    ID: 365,
    BudgetSection: 17,
    Entity: "UN-Women",
    EntityFullName: "联合国促进性别平等和增强妇女权能署",
    Programme: "妇女署",
    Subprogramme: "政府间支助、协调和战略伙伴关系",
    Title: "通过联合国全系统性别平等和增强妇女权能行动计划3.0加强性别平等主流化",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "促进人权",
    Beneficiary: "妇女和女童",
    BeneficiaryTwo: " ",
    SpecificResult: "在人权的保护和享受方面取得进展，减少不平等和歧视；进一步融合发展权",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "17UN-Women4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.17)&l=zh#page=10"
  },
  {
    ID: 366,
    BudgetSection: 17,
    Entity: "UN-Women",
    EntityFullName: "联合国促进性别平等和增强妇女权能署",
    Programme: "妇女署",
    Subprogramme: "政策和方案活动",
    Title: "会员国利用时间使用数据为循证政策提供依据，以确认、减少和再分配无偿照护工作",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "妇女和女童",
    BeneficiaryTwo: " ",
    SpecificResult: "改善用于循证决策的计量与统计促进可持续发展",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "17UN-Women5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.17)&l=zh#page=12"
  },
  {
    ID: 367,
    BudgetSection: 17,
    Entity: "UN-Women",
    EntityFullName: "联合国促进性别平等和增强妇女权能署",
    Programme: "妇女署",
    Subprogramme: "政策和方案活动",
    Title: "政府执行财政政策和促进性别平等的预算编制，以促进性别平等",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "妇女和女童",
    BeneficiaryTwo: " ",
    SpecificResult: "实现更具有包容性的发展，不让任何一个人掉队；消除贫困和减少不平等；减少对妇女和女童的歧视，加强性别平等。",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "17UN-Women6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.17)&l=zh#page=13"
  },
  {
    ID: 368,
    BudgetSection: 17,
    Entity: "UN-Women",
    EntityFullName: "联合国促进性别平等和增强妇女权能署",
    Programme: "妇女署",
    Subprogramme: "政策和方案活动",
    Title: "各国政府通过制止暴力侵害妇女和女童行为的国家行动计划",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "促进人权",
    Beneficiary: "妇女和女童",
    BeneficiaryTwo: " ",
    SpecificResult: "实现更具有包容性的发展，不让任何一个人掉队；消除贫困和减少不平等；减少对妇女和女童的歧视，加强性别平等。",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "17UN-Women7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.17)&l=zh#page=14"
  },
  {
    ID: 369,
    BudgetSection: 17,
    Entity: "UN-Women",
    EntityFullName: "联合国促进性别平等和增强妇女权能署",
    Programme: "妇女署",
    Subprogramme: "政策和方案活动",
    Title: "各国政府在改革歧视性法律方面取得进展",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "促进人权",
    Beneficiary: "妇女和女童",
    BeneficiaryTwo: " ",
    SpecificResult: "在人权的保护和享受方面取得进展，减少不平等和歧视；进一步融合发展权",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "17UN-Women8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.17)&l=zh#page=14"
  },
  {
    ID: 370,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "非洲经济委员会",
    Programme: "非洲经济和社会发展",
    Subprogramme: "宏观经济政策、金融和治理",
    Title: "加强小岛屿发展中国家的债务管理和可持续融资战略",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "非洲的发展",
    Beneficiary: "最不发达国家、内陆发展中国家、小岛屿发展中国家和其他发展中国家",
    BeneficiaryTwo: "非洲会员国",
    SpecificResult: "增进对筹资需求的了解，改进为可持续资本投资筹措资金的政策备选方案，加大可持续项目供资承诺和参与力度",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CV,KM",
    Image: "18ECA1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=zh#page=13"
  },
  {
    ID: 371,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "非洲经济委员会",
    Programme: "非洲经济和社会发展",
    Subprogramme: "宏观经济政策、金融和治理",
    Title: "非洲经委会成员采用创新办法调动国内资源和外部私人资本",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "非洲的发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "非洲会员国",
    SpecificResult: "增进对筹资需求的了解，改进为可持续资本投资筹措资金的政策备选方案，加大可持续项目供资承诺和参与力度",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "BW,ET,GN,MR,UG,TZ",
    Image: "18ECA2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=zh#page=13"
  },
  {
    ID: 372,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "非洲经济委员会",
    Programme: "非洲经济和社会发展",
    Subprogramme: "宏观经济政策、金融和治理",
    Title: "加强宏观经济预测和发展规划，以促进包容性和可持续增长",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "非洲的发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "非洲会员国",
    SpecificResult: "改善用于循证决策的计量与统计促进可持续发展",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "BW",
    Image: "18ECA3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=zh#page=14"
  },
  {
    ID: 373,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "非洲经济委员会",
    Programme: "非洲经济和社会发展",
    Subprogramme: "宏观经济政策、金融和治理",
    Title: "改善经济和金融治理，促进结构转型和包容性发展",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "非洲的发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "非洲会员国",
    SpecificResult: "增进对筹资需求的了解，改进为可持续资本投资筹措资金的政策备选方案，加大可持续项目供资承诺和参与力度",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BJ,ET,GN,UG,ZM",
    Image: "18ECA4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=zh#page=14"
  },
  {
    ID: 374,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "非洲经济委员会",
    Programme: "非洲经济和社会发展",
    Subprogramme: "区域一体化和贸易",
    Title: "埃塞俄比亚在非洲大陆自由贸易区下开展贸易的准备工作增强",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "非洲的发展",
    Beneficiary: "私营部门，包括中小微型企业",
    BeneficiaryTwo: "非洲会员国",
    SpecificResult: "利用电子商务和数字经济等方式增强能力和减少壁垒，改善贸易和竞争力",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "ET",
    Image: "18ECA5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=zh#page=17"
  },
  {
    ID: 375,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "非洲经济委员会",
    Programme: "非洲经济和社会发展",
    Subprogramme: "区域一体化和贸易",
    Title: "执行减轻气候变化影响的可持续贸易战略",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "非洲的发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: "非洲会员国",
    SpecificResult: "利用电子商务和数字经济等方式增强能力和减少壁垒，改善贸易和竞争力",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=zh#page=18"
  },
  {
    ID: 376,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "非洲经济委员会",
    Programme: "非洲经济和社会发展",
    Subprogramme: "区域一体化和贸易",
    Title: "非洲经委会成员采取措施，降低区域价值链和经济特区投资的风险",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "非洲的发展",
    Beneficiary: "私营部门，包括中小微型企业",
    BeneficiaryTwo: "非洲会员国",
    SpecificResult: "利用电子商务和数字经济等方式增强能力和减少壁垒，改善贸易和竞争力",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=zh#page=19"
  },
  {
    ID: 377,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "非洲经济委员会",
    Programme: "非洲经济和社会发展",
    Subprogramme: "区域一体化和贸易",
    Title: "私营部门通过非洲大陆自由贸易区参与非洲内部贸易的国家政策和体制环境得到改善",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "非洲的发展",
    Beneficiary: "私营部门，包括中小微型企业",
    BeneficiaryTwo: "非洲会员国",
    SpecificResult: "利用电子商务和数字经济等方式增强能力和减少壁垒，改善贸易和竞争力",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=zh#page=19"
  },
  {
    ID: 378,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "非洲经济委员会",
    Programme: "非洲经济和社会发展",
    Subprogramme: "技术、创新、连通性和基础设施发展",
    Title: "成员国可以获得支持循证决策的税收政策模拟工具，在非洲实现负担得起的互联互通、包容",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "非洲的发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "非洲会员国",
    SpecificResult: "改善用于循证决策的计量与统计促进可持续发展",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=zh#page=22"
  },
  {
    ID: 379,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "非洲经济委员会",
    Programme: "非洲经济和社会发展",
    Subprogramme: "技术、创新、连通性和基础设施发展",
    Title: "非洲经委会成员更多地使用新技术，并通过强有力的监管框架予以加强",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "非洲的发展",
    Beneficiary: "私营部门，包括中小微型企业",
    BeneficiaryTwo: "非洲会员国",
    SpecificResult: "在科学、技术和创新促进可持续发展(包括人工智能)方面取得进展",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=zh#page=23"
  },
  {
    ID: 380,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "非洲经济委员会",
    Programme: "非洲经济和社会发展",
    Subprogramme: "技术、创新、连通性和基础设施发展",
    Title: "非洲经委会成员利用技术和创新管理其运输和能源基础设施",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "非洲的发展",
    Beneficiary: "私营部门，包括中小微型企业",
    BeneficiaryTwo: "非洲会员国",
    SpecificResult: "在科学、技术和创新促进可持续发展(包括人工智能)方面取得进展",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "EG,QG,GH,KE,MG",
    Image: "18ECA11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=zh#page=23"
  },
  {
    ID: 381,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "非洲经济委员会",
    Programme: "非洲经济和社会发展",
    Subprogramme: "技术、创新、连通性和基础设施发展",
    Title: "加强基础设施发展战略和政策",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "非洲的发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "非洲会员国",
    SpecificResult: "通过稳健协调结构等途径，利用可持续发展目标之间的相互关联性，加快推进可持续发展目标",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "SZ,GM",
    Image: "18ECA12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=zh#page=24"
  },
  {
    ID: 382,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "非洲经济委员会",
    Programme: "非洲经济和社会发展",
    Subprogramme: "数据和统计",
    Title: "非洲经委会成员为区域一体化政策编制和使用更好的经济统计数据",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "非洲的发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "非洲会员国",
    SpecificResult: "改善用于循证决策的计量与统计促进可持续发展",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=zh#page=27"
  },
  {
    ID: 383,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "非洲经济委员会",
    Programme: "非洲经济和社会发展",
    Subprogramme: "数据和统计",
    Title: "在建立统计和地理空间信息综合框架方面取得进展",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "非洲的发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "非洲会员国",
    SpecificResult: "改善用于循证决策的计量与统计促进可持续发展",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "ER,GH,NA",
    Image: "18ECA14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=zh#page=28"
  },
  {
    ID: 384,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "非洲经济委员会",
    Programme: "非洲经济和社会发展",
    Subprogramme: "数据和统计",
    Title: "改进民事登记和生命统计系统",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "非洲的发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "非洲会员国",
    SpecificResult: "改善人口、移民、民事登记和人口统计(包括按性别分列的统计)信息",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "BI,KE,NA,TZ",
    Image: "18ECA15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=zh#page=29"
  },
  {
    ID: 385,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "非洲经济委员会",
    Programme: "非洲经济和社会发展",
    Subprogramme: "数据和统计",
    Title: "加强国家统计系统，能够定期制作和政策上使用创新统计产品，进行循证决策",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "非洲的发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "非洲会员国",
    SpecificResult: "改善人口、移民、民事登记和人口统计(包括按性别分列的统计)信息",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=zh#page=29"
  },
  {
    ID: 386,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "非洲经济委员会",
    Programme: "非洲经济和社会发展",
    Subprogramme: "气候变化、粮食安全和自然资源",
    Title: "非洲经委会成员加强实现有气候适应能力的农业价值链的政策和体制框架",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "非洲的发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: "非洲会员国",
    SpecificResult: "可持续资源管理；在可再生能源方面取得进展",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CI,GH,ZM,ZW",
    Image: "18ECA17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=zh#page=34"
  },
  {
    ID: 387,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "非洲经济委员会",
    Programme: "非洲经济和社会发展",
    Subprogramme: "气候变化、粮食安全和自然资源",
    Title: "非洲经委会成员制定和执行可持续利用自然资源的国家和区域政策与合作框架",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "非洲的发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: "非洲会员国",
    SpecificResult: "可持续资源管理；在可再生能源方面取得进展",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=zh#page=35"
  },
  {
    ID: 388,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "非洲经济委员会",
    Programme: "非洲经济和社会发展",
    Subprogramme: "气候变化、粮食安全和自然资源",
    Title: "具有韧性和包容性的农业食品系统",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "非洲的发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: "非洲会员国",
    SpecificResult: "可持续资源管理；在可再生能源方面取得进展",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=zh#page=35"
  },
  {
    ID: 389,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "非洲经济委员会",
    Programme: "非洲经济和社会发展",
    Subprogramme: "气候变化、粮食安全和自然资源",
    Title: "非洲的气候雄心和气候行动得到增强",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "非洲的发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: "非洲会员国",
    SpecificResult: "加强监管框架和环境治理；加大气候行动力度促进可持续发展",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=zh#page=36"
  },
  {
    ID: 390,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "非洲经济委员会",
    Programme: "非洲经济和社会发展",
    Subprogramme: "增强妇女和青年经济权能",
    Title: "加强关于性别平等和增强妇女权能的数据收集、监测和报告",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "非洲的发展",
    Beneficiary: "妇女和女童",
    BeneficiaryTwo: "非洲会员国",
    SpecificResult: "改善人口、移民、民事登记和人口统计(包括按性别分列的统计)信息",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BI,SS,II",
    Image: "18ECA21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=zh#page=40"
  },
  {
    ID: 391,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "非洲经济委员会",
    Programme: "非洲经济和社会发展",
    Subprogramme: "增强妇女和青年经济权能",
    Title: "非洲经委会成员将性别平等视角纳入财政政策",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "非洲的发展",
    Beneficiary: "妇女和女童",
    BeneficiaryTwo: "非洲会员国",
    SpecificResult: "实现更具有包容性的发展，不让任何一个人掉队；消除贫困和减少不平等；减少对妇女和女童的歧视，加强性别平等。",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "ET,KE,RW,UG,TZ",
    Image: "18ECA22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=zh#page=40"
  },
  {
    ID: 392,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "非洲经济委员会",
    Programme: "非洲经济和社会发展",
    Subprogramme: "增强妇女和青年经济权能",
    Title: "非洲经委会成员采取行动，改善妇女金融普惠",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "非洲的发展",
    Beneficiary: "妇女和女童",
    BeneficiaryTwo: "非洲会员国",
    SpecificResult: "实现更具有包容性的发展，不让任何一个人掉队；消除贫困和减少不平等；减少对妇女和女童的歧视，加强性别平等。",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "GM,SL",
    Image: "18ECA23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=zh#page=41"
  },
  {
    ID: 393,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "非洲经济委员会",
    Programme: "非洲经济和社会发展",
    Subprogramme: "增强妇女和青年经济权能",
    Title: "非洲经委会成员利用数字化增强青年企业家权能",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "非洲的发展",
    Beneficiary: "青年",
    BeneficiaryTwo: "非洲会员国",
    SpecificResult: "创业和提高中小微型企业竞争力",
    SpecificResultOrder: 11,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "ZA",
    Image: "18ECA24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=zh#page=42"
  },
  {
    ID: 394,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "非洲经济委员会",
    Programme: "非洲经济和社会发展",
    Subprogramme: "次区域发展活动: 北非次区域活动",
    Title: "非洲经委会成员采取行动增加可持续融资",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "非洲的发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "非洲会员国",
    SpecificResult: "增进对筹资需求的了解，改进为可持续资本投资筹措资金的政策备选方案，加大可持续项目供资承诺和参与力度",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "EG,QG,SL",
    Image: "18ECA25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=zh#page=44"
  },
  {
    ID: 395,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "非洲经济委员会",
    Programme: "非洲经济和社会发展",
    Subprogramme: "次区域发展活动: 北非次区域活动",
    Title: "非洲经委会成员为可持续发展调动资金",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "非洲的发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "非洲会员国",
    SpecificResult: "在科学、技术和创新促进可持续发展(包括人工智能)方面取得进展",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "EG,QG,LY",
    Image: "18ECA26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=zh#page=45"
  },
  {
    ID: 396,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "非洲经济委员会",
    Programme: "非洲经济和社会发展",
    Subprogramme: "次区域发展活动: 北非次区域活动",
    Title: "非洲经委会成员通过提高生产力、多样化和增值，加快包容性可持续增长",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "非洲的发展",
    Beneficiary: "私营部门，包括中小微型企业",
    BeneficiaryTwo: "非洲会员国",
    SpecificResult: "创业和提高中小微型企业竞争力",
    SpecificResultOrder: 11,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "DZ,EG,QG,LY,MR,SD,QQ,TN",
    Image: "18ECA27.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=zh#page=45"
  },
  {
    ID: 397,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "非洲经济委员会",
    Programme: "非洲经济和社会发展",
    Subprogramme: "次区域发展活动: 北非次区域活动",
    Title: "非洲经委会成员采取行动，最大限度地扩大侨民参与，将侨民作为发展筹资的替代来源",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "非洲的发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "非洲会员国",
    SpecificResult: "增进对筹资需求的了解，改进为可持续资本投资筹措资金的政策备选方案，加大可持续项目供资承诺和参与力度",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,EG,QG,LY,MR,SD,QQ,TN",
    Image: "18ECA28.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=zh#page=46"
  },
  {
    ID: 398,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "非洲经济委员会",
    Programme: "非洲经济和社会发展",
    Subprogramme: "次区域发展活动: 西非次区域活动",
    Title: "非洲经委会的西非成员将农业价值链分析纳入规划框架",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "非洲的发展",
    Beneficiary: "私营部门，包括中小微型企业",
    BeneficiaryTwo: "非洲会员国",
    SpecificResult: "通过稳健协调结构等途径，利用可持续发展目标之间的相互关联性，加快推进可持续发展目标",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BJ,BF,CV,CI,GM,GH,GN,GW,LR,ML,MR,NE,NG,SN,SL,TG",
    Image: "18ECA29.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=zh#page=49"
  },
  {
    ID: 399,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "非洲经济委员会",
    Programme: "非洲经济和社会发展",
    Subprogramme: "次区域发展活动: 西非次区域活动",
    Title: "非洲经委会成员评估债务可持续性并制定长期财政战略",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "非洲的发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "非洲会员国",
    SpecificResult: "通过稳健协调结构等途径，利用可持续发展目标之间的相互关联性，加快推进可持续发展目标",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "SL",
    Image: "18ECA30.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=zh#page=50"
  },
  {
    ID: 400,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "非洲经济委员会",
    Programme: "非洲经济和社会发展",
    Subprogramme: "次区域发展活动: 西非次区域活动",
    Title: "加强非洲大陆自由贸易区国家战略的落实",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "非洲的发展",
    Beneficiary: "私营部门，包括中小微型企业",
    BeneficiaryTwo: "非洲会员国",
    SpecificResult: "利用电子商务和数字经济等方式增强能力和减少壁垒，改善贸易和竞争力",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "CV,GH,LR",
    Image: "18ECA31.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=zh#page=50"
  },
  {
    ID: 401,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "非洲经济委员会",
    Programme: "非洲经济和社会发展",
    Subprogramme: "次区域发展活动: 西非次区域活动",
    Title: "加强国家预算编制和监测系统以利用人口红利",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "非洲的发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "非洲会员国",
    SpecificResult: "加强合作、增进信息和最佳做法共享，推动在实现可持续发展目标方面取得进展",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BJ,BF,CV,CI,GM,GH,GN,GW,LR,ML,MR,NE,NG,SN,SL,TG",
    Image: "18ECA32.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=zh#page=51"
  },
  {
    ID: 402,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "非洲经济委员会",
    Programme: "非洲经济和社会发展",
    Subprogramme: "次区域发展活动: 中部非洲次区域活动",
    Title: "圣多美和普林西比编制并核证了其首批旅游卫星账户",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "非洲的发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "非洲会员国",
    SpecificResult: "加强合作、增进信息和最佳做法共享，推动在实现可持续发展目标方面取得进展",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "ST",
    Image: "18ECA33.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=zh#page=54"
  },
  {
    ID: 403,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "非洲经济委员会",
    Programme: "非洲经济和社会发展",
    Subprogramme: "次区域发展活动: 中部非洲次区域活动",
    Title: "非洲经委会成员建立经济特区，促进可持续和包容性经济多样化",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "非洲的发展",
    Beneficiary: "私营部门，包括中小微型企业",
    BeneficiaryTwo: "非洲会员国",
    SpecificResult: "利用电子商务和数字经济等方式增强能力和减少壁垒，改善贸易和竞争力",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "CM,CG,CD,GA",
    Image: "18ECA34.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=zh#page=54"
  },
  {
    ID: 404,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "非洲经济委员会",
    Programme: "非洲经济和社会发展",
    Subprogramme: "次区域发展活动: 中部非洲次区域活动",
    Title: "非洲经委会的中部非洲成员加强自然资产估值和资本化",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "非洲的发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "非洲会员国",
    SpecificResult: "可持续资源管理；在可再生能源方面取得进展",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "CG,ST",
    Image: "18ECA35.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=zh#page=55"
  },
  {
    ID: 405,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "非洲经济委员会",
    Programme: "非洲经济和社会发展",
    Subprogramme: "次区域发展活动: 中部非洲次区域活动",
    Title: "加强贸易便利化体系和机构能力，以加快区域经济一体化",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "非洲的发展",
    Beneficiary: "私营部门，包括中小微型企业",
    BeneficiaryTwo: "非洲会员国",
    SpecificResult: "利用电子商务和数字经济等方式增强能力和减少壁垒，改善贸易和竞争力",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BI,CM,CF,TD,GQ,CD,GA,CG,RW,ST",
    Image: "18ECA36.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=zh#page=55"
  },
  {
    ID: 406,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "非洲经济委员会",
    Programme: "非洲经济和社会发展",
    Subprogramme: "次区域发展活动: 东非次区域活动",
    Title: "索马里启动《2060年百年愿景》，批准《建立非洲大陆自由贸易区协定》",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "非洲的发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "非洲会员国",
    SpecificResult: "利用电子商务和数字经济等方式增强能力和减少壁垒，改善贸易和竞争力",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "SO",
    Image: "18ECA37.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=zh#page=58"
  },
  {
    ID: 407,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "非洲经济委员会",
    Programme: "非洲经济和社会发展",
    Subprogramme: "次区域发展活动: 东非次区域活动",
    Title: "非洲经委会成员和区域组织制定投资促进战略",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "非洲的发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "非洲会员国",
    SpecificResult: "利用电子商务和数字经济等方式增强能力和减少壁垒，改善贸易和竞争力",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "BI,DJ,ER,ET,KE,RW,SC,SO,SS,II,UG,TZ",
    Image: "18ECA38.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=zh#page=59"
  },
  {
    ID: 408,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "非洲经济委员会",
    Programme: "非洲经济和社会发展",
    Subprogramme: "次区域发展活动: 东非次区域活动",
    Title: "非洲经委会成员实施旅游业和蓝色经济区域框架",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "非洲的发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "非洲会员国",
    SpecificResult: "可持续资源管理；在可再生能源方面取得进展",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "BI,DJ,ER,ET,KE,RW,SC,SO,SS,II,UG,TZ",
    Image: "18ECA39.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=zh#page=59"
  },
  {
    ID: 409,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "非洲经济委员会",
    Programme: "非洲经济和社会发展",
    Subprogramme: "次区域发展活动: 东非次区域活动",
    Title: "加强连通性和基础设施，深化区域一体化",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "非洲的发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "非洲会员国",
    SpecificResult: "利用电子商务和数字经济等方式增强能力和减少壁垒，改善贸易和竞争力",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BI,DJ,ER,ET,KE,RW,SC,SO,SS,II,UG,TZ",
    Image: "18ECA40.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=zh#page=60"
  },
  {
    ID: 410,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "非洲经济委员会",
    Programme: "非洲经济和社会发展",
    Subprogramme: "次区域发展活动: 南部非洲次区域活动",
    Title: "通过数字技术加速南共体区域内的贸易和投资",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "非洲的发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "非洲会员国",
    SpecificResult: "在科学、技术和创新促进可持续发展(包括人工智能)方面取得进展",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AO,BW,KM,CD,SZ,LS,MG,MW,MU,MZ,NA,SC,ZA,TZ,ZM,ZW",
    Image: "18ECA41.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=zh#page=63"
  },
  {
    ID: 411,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "非洲经济委员会",
    Programme: "非洲经济和社会发展",
    Subprogramme: "次区域发展活动: 南部非洲次区域活动",
    Title: "加速南部非洲向更可持续的经济过渡",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "非洲的发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: "非洲会员国",
    SpecificResult: "通过稳健协调结构等途径，利用可持续发展目标之间的相互关联性，加快推进可持续发展目标",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AO,BW,KM,SZ,LS,MG,MW,MU,MZ,NA,SC,ZA,ZM,ZW",
    Image: "18ECA42.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=zh#page=64"
  },
  {
    ID: 412,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "非洲经济委员会",
    Programme: "非洲经济和社会发展",
    Subprogramme: "次区域发展活动: 南部非洲次区域活动",
    Title: "通过发展价值链实现南部非洲的包容性工业化",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "非洲的发展",
    Beneficiary: "私营部门，包括中小微型企业",
    BeneficiaryTwo: "非洲会员国",
    SpecificResult: "实现更具有包容性的发展，不让任何一个人掉队；消除贫困和减少不平等；减少对妇女和女童的歧视，加强性别平等。",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AO,BW,KM,SZ,LS,MG,MW,MU,MZ,NA,SC,ZA,ZM,ZW",
    Image: "18ECA43.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=zh#page=64"
  },
  {
    ID: 413,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "非洲经济委员会",
    Programme: "非洲经济和社会发展",
    Subprogramme: "次区域发展活动: 南部非洲次区域活动",
    Title: "加快南部非洲执行《建立非洲大陆自由贸易区协定》及其他贸易协定",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "非洲的发展",
    Beneficiary: "私营部门，包括中小微型企业",
    BeneficiaryTwo: "非洲会员国",
    SpecificResult: "利用电子商务和数字经济等方式增强能力和减少壁垒，改善贸易和竞争力",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AO,BW,KM,SZ,LS,MG,MW,MU,MZ,NA,SC,ZA,ZM,ZW",
    Image: "18ECA44.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=zh#page=65"
  },
  {
    ID: 414,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "非洲经济委员会",
    Programme: "非洲经济和社会发展",
    Subprogramme: "经济发展和规划",
    Title: "非洲经委会成员通过制定国家社会保护战略，使社会保护从碎片化转向综合化",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "非洲的发展",
    Beneficiary: "难民、少数群体和其他弱势群体",
    BeneficiaryTwo: "非洲会员国",
    SpecificResult: "实现更具有包容性的发展，不让任何一个人掉队；消除贫困和减少不平等；减少对妇女和女童的歧视，加强性别平等。",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CM,SN,ZW",
    Image: "18ECA45.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=zh#page=68"
  },
  {
    ID: 415,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "非洲经济委员会",
    Programme: "非洲经济和社会发展",
    Subprogramme: "经济发展和规划",
    Title: "非洲经委会成员培养面向未来的劳动力队伍",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "非洲的发展",
    Beneficiary: "青年",
    BeneficiaryTwo: "非洲会员国",
    SpecificResult: "实现更具有包容性的发展，不让任何一个人掉队；消除贫困和减少不平等；减少对妇女和女童的歧视，加强性别平等。",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA46.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=zh#page=69"
  },
  {
    ID: 416,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "非洲经济委员会",
    Programme: "非洲经济和社会发展",
    Subprogramme: "经济发展和规划",
    Title: "加强本地化的发展规划和发展筹资",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "非洲的发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "非洲会员国",
    SpecificResult: "通过稳健协调结构等途径，利用可持续发展目标之间的相互关联性，加快推进可持续发展目标",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA47.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=zh#page=69"
  },
  {
    ID: 417,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "非洲经济委员会",
    Programme: "非洲经济和社会发展",
    Subprogramme: "经济发展和规划",
    Title: "改善公共行政培训系统，以加强国家发展规划",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "非洲的发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "非洲会员国",
    SpecificResult: "加强合作、增进信息和最佳做法共享，推动在实现可持续发展目标方面取得进展",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DJ",
    Image: "18ECA48.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=zh#page=70"
  },
  {
    ID: 418,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "非洲经济委员会",
    Programme: "非洲经济和社会发展",
    Subprogramme: "贫困、不平等和社会政策",
    Title: "非洲经委会成员确立了非洲在社会发展优先事项上的共同立场",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "非洲的发展",
    Beneficiary: "青年",
    BeneficiaryTwo: "非洲会员国",
    SpecificResult: "加强合作、增进信息和最佳做法共享，推动在实现可持续发展目标方面取得进展",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA49.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=zh#page=72"
  },
  {
    ID: 419,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "非洲经济委员会",
    Programme: "非洲经济和社会发展",
    Subprogramme: "贫困、不平等和社会政策",
    Title: "改善针对最弱势群体的社会保护制度",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "非洲的发展",
    Beneficiary: "难民、少数群体和其他弱势群体",
    BeneficiaryTwo: "非洲会员国",
    SpecificResult: "实现更具有包容性的发展，不让任何一个人掉队；消除贫困和减少不平等；减少对妇女和女童的歧视，加强性别平等。",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "GH,NA,SN,TZ",
    Image: "18ECA50.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=zh#page=73"
  },
  {
    ID: 420,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "非洲经济委员会",
    Programme: "非洲经济和社会发展",
    Subprogramme: "贫困、不平等和社会政策",
    Title: "加强对人口相关框架的国家和区域审查，以促进可持续发展，不让任何一个人掉队",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "非洲的发展",
    Beneficiary: "国际社会",
    BeneficiaryTwo: "非洲会员国",
    SpecificResult: "实现更具有包容性的发展，不让任何一个人掉队；消除贫困和减少不平等；减少对妇女和女童的歧视，加强性别平等。",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA51.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=zh#page=73"
  },
  {
    ID: 421,
    BudgetSection: 18,
    Entity: "ECA",
    EntityFullName: "非洲经济委员会",
    Programme: "非洲经济和社会发展",
    Subprogramme: "贫困、不平等和社会政策",
    Title: "加强循证就业政策，利用非洲人口红利",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "非洲的发展",
    Beneficiary: "青年",
    BeneficiaryTwo: "非洲会员国",
    SpecificResult: "实现更具有包容性的发展，不让任何一个人掉队；消除贫困和减少不平等；减少对妇女和女童的歧视，加强性别平等。",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA52.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=zh#page=74"
  },
  {
    ID: 422,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "亚洲及太平洋经济社会委员会",
    Programme: "亚洲及太平洋经济和社会发展",
    Subprogramme: "宏观经济政策、减贫和发展筹资",
    Title: "亚太国家的优先事项反映在全球发展融资议程中",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "亚洲及太平洋地区会员国",
    BeneficiaryTwo: "公共行政",
    SpecificResult: "增进对筹资需求的了解，改进为可持续资本投资筹措资金的政策备选方案，加大可持续项目供资承诺和参与力度",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=zh#page=16"
  },
  {
    ID: 423,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "亚洲及太平洋经济社会委员会",
    Programme: "亚洲及太平洋经济和社会发展",
    Subprogramme: "宏观经济政策、减贫和发展筹资",
    Title: "改善宏观经济和发展筹资问题的决策",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "亚洲及太平洋地区会员国",
    SpecificResult: "改善用于循证决策的计量与统计促进可持续发展",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "SD,QQ,BT,KH,MV,MN,PK,LK",
    Image: "19ESCAP2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=zh#page=17"
  },
  {
    ID: 424,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "亚洲及太平洋经济社会委员会",
    Programme: "亚洲及太平洋经济和社会发展",
    Subprogramme: "宏观经济政策、减贫和发展筹资",
    Title: "成员国推出新的政策举措和改革，以加快可持续发展筹资",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "亚洲及太平洋地区会员国",
    SpecificResult: "增进对筹资需求的了解，改进为可持续资本投资筹措资金的政策备选方案，加大可持续项目供资承诺和参与力度",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "SD,QQ,BT,KH,LK",
    Image: "19ESCAP3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=zh#page=18"
  },
  {
    ID: 425,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "亚洲及太平洋经济社会委员会",
    Programme: "亚洲及太平洋经济和社会发展",
    Subprogramme: "宏观经济政策、减贫和发展筹资",
    Title: "成员国制定、评估或实施宏观经济政策，以加快实现气候适应型发展的进程",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "亚洲及太平洋地区会员国",
    BeneficiaryTwo: "气候和环境",
    SpecificResult: "包容型、可持续灾后恢复；建设抵御未来灾害的能力",
    SpecificResultOrder: 12,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=zh#page=18"
  },
  {
    ID: 426,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "亚洲及太平洋经济社会委员会",
    Programme: "亚洲及太平洋经济和社会发展",
    Subprogramme: "贸易、投资和创新",
    Title: "各国通过量身定制的分析加强贸易协定谈判",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "亚洲及太平洋地区会员国",
    BeneficiaryTwo: "公共行政",
    SpecificResult: "在科学、技术和创新促进可持续发展(包括人工智能)方面取得进展",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=zh#page=21"
  },
  {
    ID: 427,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "亚洲及太平洋经济社会委员会",
    Programme: "亚洲及太平洋经济和社会发展",
    Subprogramme: "贸易、投资和创新",
    Title: "通过增加数字和可持续贸易便利化措施，使贸易进程更加可持续和高效",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "亚洲及太平洋地区会员国",
    SpecificResult: "利用电子商务和数字经济等方式增强能力和减少壁垒，改善贸易和竞争力",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=zh#page=22"
  },
  {
    ID: 428,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "亚洲及太平洋经济社会委员会",
    Programme: "亚洲及太平洋经济和社会发展",
    Subprogramme: "贸易、投资和创新",
    Title: "投资促进机构承诺通过外国直接投资促进性别平等",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "妇女和女童",
    BeneficiaryTwo: "亚洲及太平洋地区会员国",
    SpecificResult: "实现更具有包容性的发展，不让任何一个人掉队；消除贫困和减少不平等；减少对妇女和女童的歧视，加强性别平等。",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=zh#page=22"
  },
  {
    ID: 429,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "亚洲及太平洋经济社会委员会",
    Programme: "亚洲及太平洋经济和社会发展",
    Subprogramme: "贸易、投资和创新",
    Title: "改善获得技术转让机会和新兴和创新技术知识的机会",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "亚洲及太平洋地区会员国",
    BeneficiaryTwo: " ",
    SpecificResult: "在科学、技术和创新促进可持续发展(包括人工智能)方面取得进展",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=zh#page=23"
  },
  {
    ID: 430,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "亚洲及太平洋经济社会委员会",
    Programme: "亚洲及太平洋经济和社会发展",
    Subprogramme: "运输",
    Title: "成员国越来越多地将包容性交通原则融入其规划和政策制定过程，以建立亚太城市更无障碍、更具社会包容性的交通系统",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "亚洲及太平洋地区会员国",
    BeneficiaryTwo: " ",
    SpecificResult: "实现更具有包容性的发展，不让任何一个人掉队；消除贫困和减少不平等；减少对妇女和女童的歧视，加强性别平等。",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AZ,LA,MN,NP,FJ,KI,PG,SB,TL",
    Image: "19ESCAP9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=zh#page=26"
  },
  {
    ID: 431,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "亚洲及太平洋经济社会委员会",
    Programme: "亚洲及太平洋经济和社会发展",
    Subprogramme: "运输",
    Title: "提升亚洲及太平洋交通运输互联互通和物流网络的效率和韧性",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "国际社会",
    BeneficiaryTwo: "亚洲及太平洋地区会员国",
    SpecificResult: "创业和提高中小微型企业竞争力",
    SpecificResultOrder: 11,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=zh#page=27"
  },
  {
    ID: 432,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "亚洲及太平洋经济社会委员会",
    Programme: "亚洲及太平洋经济和社会发展",
    Subprogramme: "运输",
    Title: "加速向低排放交通运输过渡",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: "亚洲及太平洋地区会员国",
    SpecificResult: "可持续资源管理；在可再生能源方面取得进展",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=zh#page=27"
  },
  {
    ID: 433,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "亚洲及太平洋经济社会委员会",
    Programme: "亚洲及太平洋经济和社会发展",
    Subprogramme: "运输",
    Title: "加强区域合作，以促进可持续、有韧性和有包容性的交通运输发展",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "亚洲及太平洋地区会员国",
    BeneficiaryTwo: " ",
    SpecificResult: "实现更具有包容性的发展，不让任何一个人掉队；消除贫困和减少不平等；减少对妇女和女童的歧视，加强性别平等。",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=zh#page=28"
  },
  {
    ID: 434,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "亚洲及太平洋经济社会委员会",
    Programme: "亚洲及太平洋经济和社会发展",
    Subprogramme: "环境与发展以及减少和管理灾害风险",
    Title: "加速实施气候行动",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: "亚洲及太平洋地区会员国",
    SpecificResult: "加强监管框架和环境治理；加大气候行动力度促进可持续发展",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BT,PG",
    Image: "19ESCAP13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=zh#page=31"
  },
  {
    ID: 435,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "亚洲及太平洋经济社会委员会",
    Programme: "亚洲及太平洋经济和社会发展",
    Subprogramme: "环境与发展以及减少和管理灾害风险",
    Title: "亚洲及太平洋成员国加强合作，推动环境事项上的参与性办法",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "亚洲及太平洋地区会员国",
    SpecificResult: "加强监管框架和环境治理；加大气候行动力度促进可持续发展",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=zh#page=32"
  },
  {
    ID: 436,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "亚洲及太平洋经济社会委员会",
    Programme: "亚洲及太平洋经济和社会发展",
    Subprogramme: "环境与发展以及减少和管理灾害风险",
    Title: "在海洋气候行动方面加强区域合作，包括通过基于生态系统的办法和基于自然的解决",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: "亚洲及太平洋地区会员国",
    SpecificResult: "加强监管框架和环境治理；加大气候行动力度促进可持续发展",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=zh#page=32"
  },
  {
    ID: 437,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "亚洲及太平洋经济社会委员会",
    Programme: "亚洲及太平洋经济和社会发展",
    Subprogramme: "环境与发展以及减少和管理灾害风险",
    Title: "扩大和加强关于城市可持续发展的区域合作、伙伴关系和举措",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "亚洲及太平洋地区会员国",
    SpecificResult: "通过持续沟通，改善合作和伙伴关系，提高一致性、增强合力和减少重叠",
    SpecificResultOrder: 29,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=zh#page=33"
  },
  {
    ID: 438,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "亚洲及太平洋经济社会委员会",
    Programme: "亚洲及太平洋经济和社会发展",
    Subprogramme: "信息和通信技术与空间应用",
    Title: "加强实施全民预警倡议",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "亚洲及太平洋地区会员国",
    SpecificResult: "包容型、可持续灾后恢复；建设抵御未来灾害的能力",
    SpecificResultOrder: 12,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=zh#page=36"
  },
  {
    ID: 439,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "亚洲及太平洋经济社会委员会",
    Programme: "亚洲及太平洋经济和社会发展",
    Subprogramme: "信息和通信技术与空间应用",
    Title: "更多地采用数字驱动的创新，以实现对气候变化的变革性适应",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "亚洲及太平洋地区会员国",
    SpecificResult: "推进技术进步，改善信息质量、可用性、可及性和安全性",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "MN,LA",
    Image: "19ESCAP18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=zh#page=36"
  },
  {
    ID: 440,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "亚洲及太平洋经济社会委员会",
    Programme: "亚洲及太平洋经济和社会发展",
    Subprogramme: "信息和通信技术与空间应用",
    Title: "特殊处境国家扩大地理空间应用，以实现《2030年议程》",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "亚洲及太平洋地区会员国",
    SpecificResult: "在科学、技术和创新促进可持续发展(包括人工智能)方面取得进展",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=zh#page=37"
  },
  {
    ID: 441,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "亚洲及太平洋经济社会委员会",
    Programme: "亚洲及太平洋经济和社会发展",
    Subprogramme: "信息和通信技术与空间应用",
    Title: "加强区域合作，以利用新兴技术特别是人工智能的应用",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "亚洲及太平洋地区会员国",
    BeneficiaryTwo: " ",
    SpecificResult: "在科学、技术和创新促进可持续发展(包括人工智能)方面取得进展",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=zh#page=37"
  },
  {
    ID: 442,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "亚洲及太平洋经济社会委员会",
    Programme: "亚洲及太平洋经济和社会发展",
    Subprogramme: "社会发展",
    Title: "加强关于亚洲及太平洋安全、有序和正常移民的区域对话、参与和联合审查",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "亚洲及太平洋地区会员国",
    BeneficiaryTwo: "难民、少数群体和其他弱势群体",
    SpecificResult: "改善人口、移民、民事登记和人口统计(包括按性别分列的统计)信息",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=zh#page=41"
  },
  {
    ID: 443,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "亚洲及太平洋经济社会委员会",
    Programme: "亚洲及太平洋经济和社会发展",
    Subprogramme: "社会发展",
    Title: "成员国制定关于照护经济估值和投资的政策措施",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "妇女和女童",
    BeneficiaryTwo: "亚洲及太平洋地区会员国",
    SpecificResult: "改善人口、移民、民事登记和人口统计(包括按性别分列的统计)信息",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "LA,TL",
    Image: "19ESCAP22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=zh#page=42"
  },
  {
    ID: 444,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "亚洲及太平洋经济社会委员会",
    Programme: "亚洲及太平洋经济和社会发展",
    Subprogramme: "社会发展",
    Title: "加强各国制定包容性人口老龄化政策的能力",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "难民、少数群体和其他弱势群体",
    BeneficiaryTwo: "亚洲及太平洋地区会员国",
    SpecificResult: "改善人口、移民、民事登记和人口统计(包括按性别分列的统计)信息",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=zh#page=42"
  },
  {
    ID: 445,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "亚洲及太平洋经济社会委员会",
    Programme: "亚洲及太平洋经济和社会发展",
    Subprogramme: "社会发展",
    Title: "成员国确定将气候韧性纳入社会保障政策的国家路径",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "亚洲及太平洋地区会员国",
    BeneficiaryTwo: "气候和环境",
    SpecificResult: "实现更具有包容性的发展，不让任何一个人掉队；消除贫困和减少不平等；减少对妇女和女童的歧视，加强性别平等。",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=zh#page=43"
  },
  {
    ID: 446,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "亚洲及太平洋经济社会委员会",
    Programme: "亚洲及太平洋经济和社会发展",
    Subprogramme: "统计",
    Title: "利用数据推动民事登记方面取得进展",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "亚洲及太平洋地区会员国",
    SpecificResult: "改善人口、移民、民事登记和人口统计(包括按性别分列的统计)信息",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=zh#page=46"
  },
  {
    ID: 447,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "亚洲及太平洋经济社会委员会",
    Programme: "亚洲及太平洋经济和社会发展",
    Subprogramme: "统计",
    Title: "改善亚洲及太平洋各国统计局的数据治理",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "亚洲及太平洋地区会员国",
    SpecificResult: "改善人口、移民、民事登记和人口统计(包括按性别分列的统计)信息",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=zh#page=47"
  },
  {
    ID: 448,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "亚洲及太平洋经济社会委员会",
    Programme: "亚洲及太平洋经济和社会发展",
    Subprogramme: "统计",
    Title: "建立国家可持续发展目标平台，监测亚洲及太平洋在实现《2030年可持续发展议程》",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "国际社会",
    BeneficiaryTwo: "亚洲及太平洋地区会员国",
    SpecificResult: "提高报告可持续发展目标进展情况的能力；提高自愿国别评估数目和质量",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP27.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=zh#page=47"
  },
  {
    ID: 449,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "亚洲及太平洋经济社会委员会",
    Programme: "亚洲及太平洋经济和社会发展",
    Subprogramme: "统计",
    Title: "通过全社会办法加强国家统计系统",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "亚洲及太平洋地区会员国",
    BeneficiaryTwo: "公共行政",
    SpecificResult: "改善用于循证决策的计量与统计促进可持续发展",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP28.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=zh#page=48"
  },
  {
    ID: 450,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "亚洲及太平洋经济社会委员会",
    Programme: "亚洲及太平洋经济和社会发展",
    Subprogramme: "次区域发展活动: 太平洋次区域发展活动",
    Title: "太平洋地区各国政府将生态系统商品和服务的经济估值纳入政策和规划的能力得到加强",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "最不发达国家、内陆发展中国家、小岛屿发展中国家和其他发展中国家",
    BeneficiaryTwo: "气候和环境",
    SpecificResult: "改善用于循证决策的计量与统计促进可持续发展",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CK,FM,FJ,KI,NR,NU,PW,PG,MH,WS,SB,TO,TV,VU",
    Image: "19ESCAP29.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=zh#page=51"
  },
  {
    ID: 451,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "亚洲及太平洋经济社会委员会",
    Programme: "亚洲及太平洋经济和社会发展",
    Subprogramme: "次区域发展活动: 太平洋次区域发展活动",
    Title: "将《安提瓜和巴布达小岛屿发展中国家议程》纳入国家发展战略主流的途径",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "最不发达国家、内陆发展中国家、小岛屿发展中国家和其他发展中国家",
    BeneficiaryTwo: "亚洲及太平洋地区会员国",
    SpecificResult: "通过稳健协调结构等途径，利用可持续发展目标之间的相互关联性，加快推进可持续发展目标",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CK,FM,FJ,KI,NR,NU,PW,PG,MH,WS,SB,TO,TV,VU",
    Image: "19ESCAP30.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=zh#page=51"
  },
  {
    ID: 452,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "亚洲及太平洋经济社会委员会",
    Programme: "亚洲及太平洋经济和社会发展",
    Subprogramme: "次区域发展活动: 太平洋次区域发展活动",
    Title: "编制和使用用于国家、区域和全球报告的核心指标的效力提升",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "最不发达国家、内陆发展中国家、小岛屿发展中国家和其他发展中国家",
    BeneficiaryTwo: "亚洲及太平洋地区会员国",
    SpecificResult: "提高报告可持续发展目标进展情况的能力；提高自愿国别评估数目和质量",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CK,FM,FJ,KI,NR,NU,PW,PG,MH,WS,SB,TO,TV,VU",
    Image: "19ESCAP31.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=zh#page=52"
  },
  {
    ID: 453,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "亚洲及太平洋经济社会委员会",
    Programme: "亚洲及太平洋经济和社会发展",
    Subprogramme: "次区域发展活动: 太平洋次区域发展活动",
    Title: "扩大太平洋地区的声音，推进更有针对性的联合国多维脆弱性指数",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "最不发达国家、内陆发展中国家、小岛屿发展中国家和其他发展中国家",
    BeneficiaryTwo: "亚洲及太平洋地区会员国",
    SpecificResult: "加强合作、增进信息和最佳做法共享，推动在实现可持续发展目标方面取得进展",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CK,FM,FJ,KI,NR,NU,PW,PG,MH,WS,SB,TO,TV,VU",
    Image: "19ESCAP32.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=zh#page=52"
  },
  {
    ID: 454,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "亚洲及太平洋经济社会委员会",
    Programme: "亚洲及太平洋经济和社会发展",
    Subprogramme: "次区域发展活动: 东亚和东北亚次区域发展活动",
    Title: "推动地方气候行动的知识共享得到加强",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: "亚洲及太平洋地区会员国",
    SpecificResult: "提高报告可持续发展目标进展情况的能力；提高自愿国别评估数目和质量",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP33.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=zh#page=55"
  },
  {
    ID: 455,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "亚洲及太平洋经济社会委员会",
    Programme: "亚洲及太平洋经济和社会发展",
    Subprogramme: "次区域发展活动: 东亚和东北亚次区域发展活动",
    Title: "高效管理跨境铁路运输和过境",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "亚洲及太平洋地区会员国",
    SpecificResult: "创业和提高中小微型企业竞争力",
    SpecificResultOrder: 11,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "MN,KR,RU,KU",
    Image: "19ESCAP34.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=zh#page=56"
  },
  {
    ID: 456,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "亚洲及太平洋经济社会委员会",
    Programme: "亚洲及太平洋经济和社会发展",
    Subprogramme: "次区域发展活动: 东亚和东北亚次区域发展活动",
    Title: "东亚和东北亚处理荒漠化和土地退化问题的跨境合作得到加强",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: "亚洲及太平洋地区会员国",
    SpecificResult: "加强监管框架和环境治理；加大气候行动力度促进可持续发展",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CN,HK,TW,KX,MO,KP,JP,MN,KR,RU,KU",
    Image: "19ESCAP35.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=zh#page=56"
  },
  {
    ID: 457,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "亚洲及太平洋经济社会委员会",
    Programme: "亚洲及太平洋经济和社会发展",
    Subprogramme: "次区域发展活动: 东亚和东北亚次区域发展活动",
    Title: "东北亚海洋保护区协作得到加强",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: "亚洲及太平洋地区会员国",
    SpecificResult: "加强监管框架和环境治理；加大气候行动力度促进可持续发展",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CN,HK,TW,KX,MO,KP,JP,MN,KR,RU,KU",
    Image: "19ESCAP36.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=zh#page=57"
  },
  {
    ID: 458,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "亚洲及太平洋经济社会委员会",
    Programme: "亚洲及太平洋经济和社会发展",
    Subprogramme: "次区域发展活动: 北亚和中亚次区域发展活动",
    Title: "北亚和中亚的成员国提出加强贸易的多项建议",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "亚洲及太平洋地区会员国",
    BeneficiaryTwo: "公共行政",
    SpecificResult: "利用电子商务和数字经济等方式增强能力和减少壁垒，改善贸易和竞争力",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AM,AZ,GE,KZ,KG,RU,KU,TJ,TM,UZ",
    Image: "19ESCAP37.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=zh#page=59"
  },
  {
    ID: 459,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "亚洲及太平洋经济社会委员会",
    Programme: "亚洲及太平洋经济和社会发展",
    Subprogramme: "次区域发展活动: 北亚和中亚次区域发展活动",
    Title: "联合国中亚经济体特别方案的合作文书得到加强",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "亚洲及太平洋地区会员国",
    SpecificResult: "创业和提高中小微型企业竞争力",
    SpecificResultOrder: 11,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AM,AZ,GE,KZ,KG,RU,KU,TJ,TM,UZ",
    Image: "19ESCAP38.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=zh#page=60"
  },
  {
    ID: 460,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "亚洲及太平洋经济社会委员会",
    Programme: "亚洲及太平洋经济和社会发展",
    Subprogramme: "次区域发展活动: 北亚和中亚次区域发展活动",
    Title: "成员国推进数字化转型政策",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "私营部门，包括中小微型企业",
    BeneficiaryTwo: "亚洲及太平洋地区会员国",
    SpecificResult: "在科学、技术和创新促进可持续发展(包括人工智能)方面取得进展",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AM,AZ,GE,KZ,KG,RU,KU,TJ,TM,UZ",
    Image: "19ESCAP39.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=zh#page=60"
  },
  {
    ID: 461,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "亚洲及太平洋经济社会委员会",
    Programme: "亚洲及太平洋经济和社会发展",
    Subprogramme: "次区域发展活动: 北亚和中亚次区域发展活动",
    Title: "北亚和中亚在电网现代化及可再生能源并网方面的次区域合作得到加强",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: "亚洲及太平洋地区会员国",
    SpecificResult: "可持续资源管理；在可再生能源方面取得进展",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AM,AZ,GE,KZ,KG,RU,KU,TJ,TM,UZ",
    Image: "19ESCAP40.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=zh#page=61"
  },
  {
    ID: 462,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "亚洲及太平洋经济社会委员会",
    Programme: "亚洲及太平洋经济和社会发展",
    Subprogramme: "次区域发展活动: 南亚和西南亚次区域发展活动",
    Title: "南亚水与气候变化关联的多利益攸关方合作得到加强",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: "亚洲及太平洋地区会员国",
    SpecificResult: "可持续资源管理；在可再生能源方面取得进展",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,SD,QQ,BT,IN,AP,IR,MV,NP,PK,LK,TR",
    Image: "19ESCAP41.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=zh#page=63"
  },
  {
    ID: 463,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "亚洲及太平洋经济社会委员会",
    Programme: "亚洲及太平洋经济和社会发展",
    Subprogramme: "次区域发展活动: 南亚和西南亚次区域发展活动",
    Title: "加快向可持续能源转型",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: "亚洲及太平洋地区会员国",
    SpecificResult: "可持续资源管理；在可再生能源方面取得进展",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,SD,QQ,BT,IN,AP,IR,MV,NP,PK,LK,TR",
    Image: "19ESCAP42.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=zh#page=64"
  },
  {
    ID: 464,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "亚洲及太平洋经济社会委员会",
    Programme: "亚洲及太平洋经济和社会发展",
    Subprogramme: "次区域发展活动: 南亚和西南亚次区域发展活动",
    Title: "缩小南亚和西南亚的数字鸿沟，不让任何人掉队",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "妇女和女童",
    BeneficiaryTwo: "亚洲及太平洋地区会员国",
    SpecificResult: "实现更具有包容性的发展，不让任何一个人掉队；消除贫困和减少不平等；减少对妇女和女童的歧视，加强性别平等。",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,SD,QQ,BT,IN,AP,IR,MV,NP,PK,LK,TR",
    Image: "19ESCAP43.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=zh#page=64"
  },
  {
    ID: 465,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "亚洲及太平洋经济社会委员会",
    Programme: "亚洲及太平洋经济和社会发展",
    Subprogramme: "次区域发展活动: 南亚和西南亚次区域发展活动",
    Title: "加强南亚和西南亚的跨境贸易互联互通，重点关注边境地区的女企业家和初创企业",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "亚洲及太平洋地区会员国",
    BeneficiaryTwo: "妇女和女童",
    SpecificResult: "利用电子商务和数字经济等方式增强能力和减少壁垒，改善贸易和竞争力",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,SD,QQ,BT,IN,AP,IR,MV,NP,PK,LK,TR",
    Image: "19ESCAP44.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=zh#page=65"
  },
  {
    ID: 466,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "亚洲及太平洋经济社会委员会",
    Programme: "亚洲及太平洋经济和社会发展",
    Subprogramme: "次区域发展活动: 东南亚次区域发展活动",
    Title: "多利益攸关方综合参与促进东南亚可持续发展",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "亚洲及太平洋地区会员国",
    BeneficiaryTwo: " ",
    SpecificResult: "实现更具有包容性的发展，不让任何一个人掉队；消除贫困和减少不平等；减少对妇女和女童的歧视，加强性别平等。",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BN,KH,ID,LA,MY,MM,PH,SG,TH,TL,VN",
    Image: "19ESCAP45.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=zh#page=67"
  },
  {
    ID: 467,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "亚洲及太平洋经济社会委员会",
    Programme: "亚洲及太平洋经济和社会发展",
    Subprogramme: "次区域发展活动: 东南亚次区域发展活动",
    Title: "对投资政策和法规进行了调整，以促进实现可持续发展目标",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "亚洲及太平洋地区会员国",
    SpecificResult: "增进对筹资需求的了解，改进为可持续资本投资筹措资金的政策备选方案，加大可持续项目供资承诺和参与力度",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "BN,KH,ID,LA,MY,MM,PH,SG,TH,TL,VN",
    Image: "19ESCAP46.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=zh#page=68"
  },
  {
    ID: 468,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "亚洲及太平洋经济社会委员会",
    Programme: "亚洲及太平洋经济和社会发展",
    Subprogramme: "次区域发展活动: 东南亚次区域发展活动",
    Title: "青年参与实现可持续发展目标",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "青年",
    BeneficiaryTwo: "亚洲及太平洋地区会员国",
    SpecificResult: "实现更具有包容性的发展，不让任何一个人掉队；消除贫困和减少不平等；减少对妇女和女童的歧视，加强性别平等。",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "BN,KH,ID,LA,MY,MM,PH,SG,TH,TL,VN",
    Image: "19ESCAP47.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=zh#page=68"
  },
  {
    ID: 469,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "亚洲及太平洋经济社会委员会",
    Programme: "亚洲及太平洋经济和社会发展",
    Subprogramme: "次区域发展活动: 东南亚次区域发展活动",
    Title: "数字化转型促进可持续发展的区域对话与合作加强",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "亚洲及太平洋地区会员国",
    BeneficiaryTwo: " ",
    SpecificResult: "在科学、技术和创新促进可持续发展(包括人工智能)方面取得进展",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "19ESCAP48.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=zh#page=69"
  },
  {
    ID: 470,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "亚洲及太平洋经济社会委员会",
    Programme: "亚洲及太平洋经济和社会发展",
    Subprogramme: "能源",
    Title: "与可持续能源转型相关的政策得到加强",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: "亚洲及太平洋地区会员国",
    SpecificResult: "可持续资源管理；在可再生能源方面取得进展",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "KH,FJ,FM,TO,VN",
    Image: "19ESCAP49.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=zh#page=72"
  },
  {
    ID: 471,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "亚洲及太平洋经济社会委员会",
    Programme: "亚洲及太平洋经济和社会发展",
    Subprogramme: "能源",
    Title: "各国通过国家降温行动计划",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: "亚洲及太平洋地区会员国",
    SpecificResult: "加强监管框架和环境治理；加大气候行动力度促进可持续发展",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "VN",
    Image: "19ESCAP50.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=zh#page=72"
  },
  {
    ID: 472,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "亚洲及太平洋经济社会委员会",
    Programme: "亚洲及太平洋经济和社会发展",
    Subprogramme: "能源",
    Title: "亚太区域成员国在跨境电力互联互通项目上加强合作",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: "亚洲及太平洋地区会员国",
    SpecificResult: "利用电子商务和数字经济等方式增强能力和减少壁垒，改善贸易和竞争力",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP51.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=zh#page=73"
  },
  {
    ID: 473,
    BudgetSection: 19,
    Entity: "ESCAP",
    EntityFullName: "亚洲及太平洋经济社会委员会",
    Programme: "亚洲及太平洋经济和社会发展",
    Subprogramme: "能源",
    Title: "推动区域电力系统互联互通方面新达成的政府间商定里程碑",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: "亚洲及太平洋地区会员国",
    SpecificResult: "加强监管框架和环境治理；加大气候行动力度促进可持续发展",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP52.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.19)&l=zh#page=74"
  },
  {
    ID: 474,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "欧洲经济委员会",
    Programme: "欧洲经济发展",
    Subprogramme: "环境",
    Title: "成员国采用前瞻性办法制定环境政策建议，以解决差距和新出现的问题",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: "欧洲、中亚和西亚会员国",
    SpecificResult: "在科学、技术和创新促进可持续发展(包括人工智能)方面取得进展",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.20)&l=zh#page=13"
  },
  {
    ID: 475,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "欧洲经济委员会",
    Programme: "欧洲经济发展",
    Subprogramme: "环境",
    Title: "实现污染物数据库现代化，以便根据事实做出反应迅速的决定",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: "欧洲、中亚和西亚会员国",
    SpecificResult: "改善用于循证决策的计量与统计促进可持续发展",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.20)&l=zh#page=14"
  },
  {
    ID: 476,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "欧洲经济委员会",
    Programme: "欧洲经济发展",
    Subprogramme: "环境",
    Title: "加强泛欧环境知识库，促进知情决策",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: "欧洲、中亚和西亚会员国",
    SpecificResult: "改善用于循证决策的计量与统计促进可持续发展",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.20)&l=zh#page=14"
  },
  {
    ID: 477,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "欧洲经济委员会",
    Programme: "欧洲经济发展",
    Subprogramme: "环境",
    Title: "改进空气排放数据的报告",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: "欧洲、中亚和西亚会员国",
    SpecificResult: "加强监管框架和环境治理；加大气候行动力度促进可持续发展",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.20)&l=zh#page=14"
  },
  {
    ID: 478,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "欧洲经济委员会",
    Programme: "欧洲经济发展",
    Subprogramme: "运输",
    Title: "开源软件使《国际公路货运通行证制度下国际货运公约》附件11得以实施",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "欧洲、中亚和西亚会员国",
    SpecificResult: "利用电子商务和数字经济等方式增强能力和减少壁垒，改善贸易和竞争力",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.20)&l=zh#page=18"
  },
  {
    ID: 479,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "欧洲经济委员会",
    Programme: "欧洲经济发展",
    Subprogramme: "运输",
    Title: "更多国家加入核心道路安全公约，作为促进减少全球道路事故伤亡的第一步",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "欧洲、中亚和西亚会员国",
    SpecificResult: "通过稳健协调结构等途径，利用可持续发展目标之间的相互关联性，加快推进可持续发展目标",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.20)&l=zh#page=18"
  },
  {
    ID: 480,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "欧洲经济委员会",
    Programme: "欧洲经济发展",
    Subprogramme: "运输",
    Title: "可持续内陆运输系统的监管框架得到加强",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "欧洲、中亚和西亚会员国",
    SpecificResult: "加强监管框架和环境治理；加大气候行动力度促进可持续发展",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.20)&l=zh#page=19"
  },
  {
    ID: 481,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "欧洲经济委员会",
    Programme: "欧洲经济发展",
    Subprogramme: "运输",
    Title: "内陆运输法律文书数字化加快",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "欧洲、中亚和西亚会员国",
    SpecificResult: "在科学、技术和创新促进可持续发展(包括人工智能)方面取得进展",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.20)&l=zh#page=20"
  },
  {
    ID: 482,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "欧洲经济委员会",
    Programme: "欧洲经济发展",
    Subprogramme: "统计",
    Title: "成员国采用强化的全球统计标准",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "国际社会",
    BeneficiaryTwo: "欧洲、中亚和西亚会员国",
    SpecificResult: "改善用于循证决策的计量与统计促进可持续发展",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.20)&l=zh#page=23"
  },
  {
    ID: 483,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "欧洲经济委员会",
    Programme: "欧洲经济发展",
    Subprogramme: "统计",
    Title: "欧洲经济委员会统计数据库促进改进研究和决策",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "欧洲、中亚和西亚会员国",
    SpecificResult: "改善用于循证决策的计量与统计促进可持续发展",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.20)&l=zh#page=24"
  },
  {
    ID: 484,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "欧洲经济委员会",
    Programme: "欧洲经济发展",
    Subprogramme: "统计",
    Title: "可持续发展目标监测的报告工作得到改进",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "国际社会",
    BeneficiaryTwo: "欧洲、中亚和西亚会员国",
    SpecificResult: "提高报告可持续发展目标进展情况的能力；提高自愿国别评估数目和质量",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.20)&l=zh#page=24"
  },
  {
    ID: 485,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "欧洲经济委员会",
    Programme: "欧洲经济发展",
    Subprogramme: "统计",
    Title: "气候变化相关统计数据的可用性和可及性增强",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: "欧洲、中亚和西亚会员国",
    SpecificResult: "改善用于循证决策的计量与统计促进可持续发展",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.20)&l=zh#page=25"
  },
  {
    ID: 486,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "欧洲经济委员会",
    Programme: "欧洲经济发展",
    Subprogramme: "经济合作和一体化",
    Title: "成员国通过的欧洲经济委员会《变革性创新宪章》",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "欧洲、中亚和西亚会员国",
    SpecificResult: "在科学、技术和创新促进可持续发展(包括人工智能)方面取得进展",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.20)&l=zh#page=27"
  },
  {
    ID: 487,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "欧洲经济委员会",
    Programme: "欧洲经济发展",
    Subprogramme: "经济合作和一体化",
    Title: "更多公私伙伴关系基础设施项目被评估为符合可持续发展目标",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "私营部门，包括中小微型企业",
    BeneficiaryTwo: "欧洲、中亚和西亚会员国",
    SpecificResult: "增进对筹资需求的了解，改进为可持续资本投资筹措资金的政策备选方案，加大可持续项目供资承诺和参与力度",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.20)&l=zh#page=28"
  },
  {
    ID: 488,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "欧洲经济委员会",
    Programme: "欧洲经济发展",
    Subprogramme: "经济合作和一体化",
    Title: "促进可持续发展的创新政策和举措得到了改进",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "私营部门，包括中小微型企业",
    BeneficiaryTwo: "欧洲、中亚和西亚会员国",
    SpecificResult: "在科学、技术和创新促进可持续发展(包括人工智能)方面取得进展",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.20)&l=zh#page=28"
  },
  {
    ID: 489,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "欧洲经济委员会",
    Programme: "欧洲经济发展",
    Subprogramme: "经济合作和一体化",
    Title: "公私伙伴关系符合欧洲经委会关于公私伙伴关系的标准和准则，以支持可持续发展目标",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "私营部门，包括中小微型企业",
    BeneficiaryTwo: "欧洲、中亚和西亚会员国",
    SpecificResult: "增进对筹资需求的了解，改进为可持续资本投资筹措资金的政策备选方案，加大可持续项目供资承诺和参与力度",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.20)&l=zh#page=29"
  },
  {
    ID: 490,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "欧洲经济委员会",
    Programme: "欧洲经济发展",
    Subprogramme: "可持续能源",
    Title: "加强能源互联互通跨境合作",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: "欧洲、中亚和西亚会员国",
    SpecificResult: "加强监管框架和环境治理；加大气候行动力度促进可持续发展",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.20)&l=zh#page=31"
  },
  {
    ID: 491,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "欧洲经济委员会",
    Programme: "欧洲经济发展",
    Subprogramme: "可持续能源",
    Title: "根据联合国资源框架分类进行更可持续、更具韧性的自然资源管理",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: "欧洲、中亚和西亚会员国",
    SpecificResult: "可持续资源管理；在可再生能源方面取得进展",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.20)&l=zh#page=32"
  },
  {
    ID: 492,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "欧洲经济委员会",
    Programme: "欧洲经济发展",
    Subprogramme: "可持续能源",
    Title: "更多地采用电动交通，促进可持续能源转型",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: "欧洲、中亚和西亚会员国",
    SpecificResult: "加强监管框架和环境治理；加大气候行动力度促进可持续发展",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.20)&l=zh#page=33"
  },
  {
    ID: 493,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "欧洲经济委员会",
    Programme: "欧洲经济发展",
    Subprogramme: "可持续能源",
    Title: "减少高排放强度行业的温室气体排放",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: "欧洲、中亚和西亚会员国",
    SpecificResult: "包容型、可持续灾后恢复；建设抵御未来灾害的能力",
    SpecificResultOrder: 12,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.20)&l=zh#page=33"
  },
  {
    ID: 494,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "欧洲经济委员会",
    Programme: "欧洲经济发展",
    Subprogramme: "贸易",
    Title: "通过的性别平等行动计划促进包容性优质贸易基础设施",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "妇女和女童",
    BeneficiaryTwo: "欧洲、中亚和西亚会员国",
    SpecificResult: "实现更具有包容性的发展，不让任何一个人掉队；消除贫困和减少不平等；减少对妇女和女童的歧视，加强性别平等。",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.20)&l=zh#page=36"
  },
  {
    ID: 495,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "欧洲经济委员会",
    Programme: "欧洲经济发展",
    Subprogramme: "贸易",
    Title: "贸易数字化得到了加强",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "欧洲、中亚和西亚会员国",
    SpecificResult: "在科学、技术和创新促进可持续发展(包括人工智能)方面取得进展",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.20)&l=zh#page=36"
  },
  {
    ID: 496,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "欧洲经济委员会",
    Programme: "欧洲经济发展",
    Subprogramme: "贸易",
    Title: "关键部门价值链的透明度和可追溯性得到了提高",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "欧洲、中亚和西亚会员国",
    SpecificResult: "可持续资源管理；在可再生能源方面取得进展",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.20)&l=zh#page=37"
  },
  {
    ID: 497,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "欧洲经济委员会",
    Programme: "欧洲经济发展",
    Subprogramme: "贸易",
    Title: "为减少粮食损失和浪费，农业质量标准得到了修订",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "欧洲、中亚和西亚会员国",
    SpecificResult: "通过稳健协调结构等途径，利用可持续发展目标之间的相互关联性，加快推进可持续发展目标",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.20)&l=zh#page=38"
  },
  {
    ID: 498,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "欧洲经济委员会",
    Programme: "欧洲经济发展",
    Subprogramme: "森林与林业",
    Title: "可持续城市林业解决方案纳入国家规划工作得到加强",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "欧洲、中亚和西亚会员国",
    SpecificResult: "通过稳健协调结构等途径，利用可持续发展目标之间的相互关联性，加快推进可持续发展目标",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.20)&l=zh#page=40"
  },
  {
    ID: 499,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "欧洲经济委员会",
    Programme: "欧洲经济发展",
    Subprogramme: "森林与林业",
    Title: "为森林产品的可持续生产和消费开展有据可依的规划和行动",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: "欧洲、中亚和西亚会员国",
    SpecificResult: "改善用于循证决策的计量与统计促进可持续发展",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.20)&l=zh#page=41"
  },
  {
    ID: 500,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "欧洲经济委员会",
    Programme: "欧洲经济发展",
    Subprogramme: "森林与林业",
    Title: "获得森林和林业数据的机会增加",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "欧洲、中亚和西亚会员国",
    SpecificResult: "改善信息传播和使用",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE27.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.20)&l=zh#page=41"
  },
  {
    ID: 501,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "欧洲经济委员会",
    Programme: "欧洲经济发展",
    Subprogramme: "森林与林业",
    Title: "开展前瞻性规划，打造具有韧性的可持续森林产业",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: "欧洲、中亚和西亚会员国",
    SpecificResult: "可持续资源管理；在可再生能源方面取得进展",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE28.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.20)&l=zh#page=42"
  },
  {
    ID: 502,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "欧洲经济委员会",
    Programme: "欧洲经济发展",
    Subprogramme: "住房、土地管理和人口",
    Title: "会员国承诺推动住房的可负担性与可持续性",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "难民、少数群体和其他弱势群体",
    BeneficiaryTwo: "欧洲、中亚和西亚会员国",
    SpecificResult: "实现更具有包容性的发展，不让任何一个人掉队；消除贫困和减少不平等；减少对妇女和女童的歧视，加强性别平等。",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE29.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.20)&l=zh#page=45"
  },
  {
    ID: 503,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "欧洲经济委员会",
    Programme: "欧洲经济发展",
    Subprogramme: "住房、土地管理和人口",
    Title: "制定对年龄问题更加敏感更加包容的政策，应对个人和人口老龄化带来的机遇和挑战",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "难民、少数群体和其他弱势群体",
    BeneficiaryTwo: "欧洲、中亚和西亚会员国",
    SpecificResult: "实现更具有包容性的发展，不让任何一个人掉队；消除贫困和减少不平等；减少对妇女和女童的歧视，加强性别平等。",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE30.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.20)&l=zh#page=45"
  },
  {
    ID: 504,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "欧洲经济委员会",
    Programme: "欧洲经济发展",
    Subprogramme: "住房、土地管理和人口",
    Title: "地方和地区政府加速可持续发展目标本地化",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "欧洲、中亚和西亚会员国",
    SpecificResult: "通过稳健协调结构等途径，利用可持续发展目标之间的相互关联性，加快推进可持续发展目标",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE31.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.20)&l=zh#page=46"
  },
  {
    ID: 505,
    BudgetSection: 20,
    Entity: "ECE",
    EntityFullName: "欧洲经济委员会",
    Programme: "欧洲经济发展",
    Subprogramme: "住房、土地管理和人口",
    Title: "老龄化问题前瞻性区域政策框架",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "难民、少数群体和其他弱势群体",
    BeneficiaryTwo: "欧洲、中亚和西亚会员国",
    SpecificResult: "实现更具有包容性的发展，不让任何一个人掉队；消除贫困和减少不平等；减少对妇女和女童的歧视，加强性别平等。",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE32.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.20)&l=zh#page=46"
  },
  {
    ID: 506,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "拉丁美洲和加勒比经济委员会",
    Programme: "拉丁美洲和加勒比经济和社会发展",
    Subprogramme: "国际贸易、一体化和基础设施",
    Title: "为拉丁美洲和加勒比循证决策提供信息的区域投入产出表",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "拉丁美洲和加勒比地区会员国",
    SpecificResult: "改善用于循证决策的计量与统计促进可持续发展",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=zh#page=16"
  },
  {
    ID: 507,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "拉丁美洲和加勒比经济委员会",
    Programme: "拉丁美洲和加勒比经济和社会发展",
    Subprogramme: "国际贸易、一体化和基础设施",
    Title: "为加强区域粮食安全而进行的可持续的韧性粮食贸易、运输系统和物流方面的政策协",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "私营部门，包括中小微型企业",
    BeneficiaryTwo: "拉丁美洲和加勒比地区会员国",
    SpecificResult: "可持续资源管理；在可再生能源方面取得进展",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=zh#page=16"
  },
  {
    ID: 508,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "拉丁美洲和加勒比经济委员会",
    Programme: "拉丁美洲和加勒比经济和社会发展",
    Subprogramme: "国际贸易、一体化和基础设施",
    Title: "加强全面和无障碍的有形一体化、基础设施、运输和物流的政策",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "私营部门，包括中小微型企业",
    BeneficiaryTwo: "拉丁美洲和加勒比地区会员国",
    SpecificResult: "利用电子商务和数字经济等方式增强能力和减少壁垒，改善贸易和竞争力",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=zh#page=17"
  },
  {
    ID: 509,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "拉丁美洲和加勒比经济委员会",
    Programme: "拉丁美洲和加勒比经济和社会发展",
    Subprogramme: "国际贸易、一体化和基础设施",
    Title: "成员国通过增加数字化交付服务的对外销售实现出口多元化",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "拉丁美洲和加勒比地区会员国",
    SpecificResult: "利用电子商务和数字经济等方式增强能力和减少壁垒，改善贸易和竞争力",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=zh#page=18"
  },
  {
    ID: 510,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "拉丁美洲和加勒比经济委员会",
    Programme: "拉丁美洲和加勒比经济和社会发展",
    Subprogramme: "生产和创新",
    Title: "在国土生产发展政策中进一步纳入性别平等视角",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "拉丁美洲和加勒比地区会员国",
    SpecificResult: "实现更具有包容性的发展，不让任何一个人掉队；消除贫困和减少不平等；减少对妇女和女童的歧视，加强性别平等。",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "UY",
    Image: "21ECLAC5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=zh#page=21"
  },
  {
    ID: 511,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "拉丁美洲和加勒比经济委员会",
    Programme: "拉丁美洲和加勒比经济和社会发展",
    Subprogramme: "生产和创新",
    Title: "集群举措和其他国土生产联接举措得到增加和加强",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "拉丁美洲和加勒比地区会员国",
    SpecificResult: "在科学、技术和创新促进可持续发展(包括人工智能)方面取得进展",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=zh#page=21"
  },
  {
    ID: 512,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "拉丁美洲和加勒比经济委员会",
    Programme: "拉丁美洲和加勒比经济和社会发展",
    Subprogramme: "生产和创新",
    Title: "推动各关键部门生产力增长的生产发展政策得到增强",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "私营部门，包括中小微型企业",
    BeneficiaryTwo: "拉丁美洲和加勒比地区会员国",
    SpecificResult: "通过稳健协调结构等途径，利用可持续发展目标之间的相互关联性，加快推进可持续发展目标",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=zh#page=22"
  },
  {
    ID: 513,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "拉丁美洲和加勒比经济委员会",
    Programme: "拉丁美洲和加勒比经济和社会发展",
    Subprogramme: "生产和创新",
    Title: "促进生产升级、多元化和结构性变革以促进平等的生产发展政策",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "拉丁美洲和加勒比地区会员国",
    SpecificResult: "通过稳健协调结构等途径，利用可持续发展目标之间的相互关联性，加快推进可持续发展目标",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=zh#page=22"
  },
  {
    ID: 514,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "拉丁美洲和加勒比经济委员会",
    Programme: "拉丁美洲和加勒比经济和社会发展",
    Subprogramme: "宏观经济政策和增长",
    Title: "哥斯达黎加推进社会影响力债券的制定，以加强国内资源调动",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "拉丁美洲和加勒比地区会员国",
    SpecificResult: "增进对筹资需求的了解，改进为可持续资本投资筹措资金的政策备选方案，加大可持续项目供资承诺和参与力度",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CR",
    Image: "21ECLAC9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=zh#page=25"
  },
  {
    ID: 515,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "拉丁美洲和加勒比经济委员会",
    Programme: "拉丁美洲和加勒比经济和社会发展",
    Subprogramme: "宏观经济政策和增长",
    Title: "促进经济增长、投资、财政可持续性和气候韧性的宏观经济和发展筹资政策",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "拉丁美洲和加勒比地区会员国",
    SpecificResult: "增进对筹资需求的了解，改进为可持续资本投资筹措资金的政策备选方案，加大可持续项目供资承诺和参与力度",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=zh#page=26"
  },
  {
    ID: 516,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "拉丁美洲和加勒比经济委员会",
    Programme: "拉丁美洲和加勒比经济和社会发展",
    Subprogramme: "宏观经济政策和增长",
    Title: "支持可持续发展目标的税收支出政策制定得到加强",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "拉丁美洲和加勒比地区会员国",
    SpecificResult: "增进对筹资需求的了解，改进为可持续资本投资筹措资金的政策备选方案，加大可持续项目供资承诺和参与力度",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=zh#page=26"
  },
  {
    ID: 517,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "拉丁美洲和加勒比经济委员会",
    Programme: "拉丁美洲和加勒比经济和社会发展",
    Subprogramme: "宏观经济政策和增长",
    Title: "根据塞维利亚承诺的目标扩大国内公共资源调动",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "拉丁美洲和加勒比地区会员国",
    SpecificResult: "增进对筹资需求的了解，改进为可持续资本投资筹措资金的政策备选方案，加大可持续项目供资承诺和参与力度",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=zh#page=27"
  },
  {
    ID: 518,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "拉丁美洲和加勒比经济委员会",
    Programme: "拉丁美洲和加勒比经济和社会发展",
    Subprogramme: "社会发展与平等",
    Title: "巴拉圭建立住户社会登记制度，协助加强社会保护体系",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "难民、少数群体和其他弱势群体",
    BeneficiaryTwo: "拉丁美洲和加勒比地区会员国",
    SpecificResult: "实现更具有包容性的发展，不让任何一个人掉队；消除贫困和减少不平等；减少对妇女和女童的歧视，加强性别平等。",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "PY",
    Image: "21ECLAC13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=zh#page=30"
  },
  {
    ID: 519,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "拉丁美洲和加勒比经济委员会",
    Programme: "拉丁美洲和加勒比经济和社会发展",
    Subprogramme: "社会发展与平等",
    Title: "扩大社会保护制度，将非正规工人和独立工人纳入其中",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "难民、少数群体和其他弱势群体",
    BeneficiaryTwo: "拉丁美洲和加勒比地区会员国",
    SpecificResult: "实现更具有包容性的发展，不让任何一个人掉队；消除贫困和减少不平等；减少对妇女和女童的歧视，加强性别平等。",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=zh#page=30"
  },
  {
    ID: 520,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "拉丁美洲和加勒比经济委员会",
    Programme: "拉丁美洲和加勒比经济和社会发展",
    Subprogramme: "社会发展与平等",
    Title: "更好的劳动力包容政策，包括气候变化的影响",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: "拉丁美洲和加勒比地区会员国",
    SpecificResult: "实现更具有包容性的发展，不让任何一个人掉队；消除贫困和减少不平等；减少对妇女和女童的歧视，加强性别平等。",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=zh#page=31"
  },
  {
    ID: 521,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "拉丁美洲和加勒比经济委员会",
    Programme: "拉丁美洲和加勒比经济和社会发展",
    Subprogramme: "社会发展与平等",
    Title: "设计旨在减少不平等的跨部门数字包容和转型政策工具",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "难民、少数群体和其他弱势群体",
    BeneficiaryTwo: "拉丁美洲和加勒比地区会员国",
    SpecificResult: "实现更具有包容性的发展，不让任何一个人掉队；消除贫困和减少不平等；减少对妇女和女童的歧视，加强性别平等。",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=zh#page=31"
  },
  {
    ID: 522,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "拉丁美洲和加勒比经济委员会",
    Programme: "拉丁美洲和加勒比经济和社会发展",
    Subprogramme: "性别平等和妇女自主",
    Title: "实现性别高度平等和照护社会行动十年",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "妇女和女童",
    BeneficiaryTwo: "拉丁美洲和加勒比地区会员国",
    SpecificResult: "实现更具有包容性的发展，不让任何一个人掉队；消除贫困和减少不平等；减少对妇女和女童的歧视，加强性别平等。",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=zh#page=33"
  },
  {
    ID: 523,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "拉丁美洲和加勒比经济委员会",
    Programme: "拉丁美洲和加勒比经济和社会发展",
    Subprogramme: "性别平等和妇女自主",
    Title: "在编制关于时间使用和无酬照护工作的性别统计数据方面取得进展",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "妇女和女童",
    BeneficiaryTwo: "拉丁美洲和加勒比地区会员国",
    SpecificResult: "提高报告可持续发展目标进展情况的能力；提高自愿国别评估数目和质量",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=zh#page=34"
  },
  {
    ID: 524,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "拉丁美洲和加勒比经济委员会",
    Programme: "拉丁美洲和加勒比经济和社会发展",
    Subprogramme: "性别平等和妇女自主",
    Title: "将性别视角纳入对外政策和国际合作的主流",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "妇女和女童",
    BeneficiaryTwo: "拉丁美洲和加勒比地区会员国",
    SpecificResult: "改善人口、移民、民事登记和人口统计(包括按性别分列的统计)信息",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=zh#page=34"
  },
  {
    ID: 525,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "拉丁美洲和加勒比经济委员会",
    Programme: "拉丁美洲和加勒比经济和社会发展",
    Subprogramme: "性别平等和妇女自主",
    Title: "各国计算投资于照护政策的影响",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "妇女和女童",
    BeneficiaryTwo: "拉丁美洲和加勒比地区会员国",
    SpecificResult: "增进对筹资需求的了解，改进为可持续资本投资筹措资金的政策备选方案，加大可持续项目供资承诺和参与力度",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=zh#page=35"
  },
  {
    ID: 526,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "拉丁美洲和加勒比经济委员会",
    Programme: "拉丁美洲和加勒比经济和社会发展",
    Subprogramme: "人口与发展",
    Title: "多民族玻利维亚国公布人口和住房普查结果",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "拉丁美洲和加勒比地区会员国",
    SpecificResult: "改善人口、移民、民事登记和人口统计(包括按性别分列的统计)信息",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BO",
    Image: "21ECLAC21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=zh#page=37"
  },
  {
    ID: 527,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "拉丁美洲和加勒比经济委员会",
    Programme: "拉丁美洲和加勒比经济和社会发展",
    Subprogramme: "人口与发展",
    Title: "为公共政策提供参考的人口分析得到加强",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "拉丁美洲和加勒比地区会员国",
    SpecificResult: "改善人口、移民、民事登记和人口统计(包括按性别分列的统计)信息",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=zh#page=38"
  },
  {
    ID: 528,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "拉丁美洲和加勒比经济委员会",
    Programme: "拉丁美洲和加勒比经济和社会发展",
    Subprogramme: "人口与发展",
    Title: "《马德里老龄问题国际行动计划》在国家一级得到执行",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "难民、少数群体和其他弱势群体",
    BeneficiaryTwo: "拉丁美洲和加勒比地区会员国",
    SpecificResult: "实现更具有包容性的发展，不让任何一个人掉队；消除贫困和减少不平等；减少对妇女和女童的歧视，加强性别平等。",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=zh#page=38"
  },
  {
    ID: 529,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "拉丁美洲和加勒比经济委员会",
    Programme: "拉丁美洲和加勒比经济和社会发展",
    Subprogramme: "人口与发展",
    Title: "各国编制自己最新的人口和劳动力估计和预测",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "拉丁美洲和加勒比地区会员国",
    SpecificResult: "提高报告可持续发展目标进展情况的能力；提高自愿国别评估数目和质量",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=zh#page=39"
  },
  {
    ID: 530,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "拉丁美洲和加勒比经济委员会",
    Programme: "拉丁美洲和加勒比经济和社会发展",
    Subprogramme: "可持续发展和人类住区",
    Title: "加强拉丁美洲的环境影响评估系统",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: "拉丁美洲和加勒比地区会员国",
    SpecificResult: "加强监管框架和环境治理；加大气候行动力度促进可持续发展",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=zh#page=42"
  },
  {
    ID: 531,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "拉丁美洲和加勒比经济委员会",
    Programme: "拉丁美洲和加勒比经济和社会发展",
    Subprogramme: "可持续发展和人类住区",
    Title: "制定促进可持续消费和生产模式、包括循环经济的战略，以提高环保绩效",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: "拉丁美洲和加勒比地区会员国",
    SpecificResult: "加强监管框架和环境治理；加大气候行动力度促进可持续发展",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=zh#page=42"
  },
  {
    ID: 532,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "拉丁美洲和加勒比经济委员会",
    Programme: "拉丁美洲和加勒比经济和社会发展",
    Subprogramme: "可持续发展和人类住区",
    Title: "改进气候变化可能影响模拟，为政策制定和投资选择提供信息",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "拉丁美洲和加勒比地区会员国",
    SpecificResult: "推进技术进步，改善信息质量、可用性、可及性和安全性",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC27.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=zh#page=43"
  },
  {
    ID: 533,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "拉丁美洲和加勒比经济委员会",
    Programme: "拉丁美洲和加勒比经济和社会发展",
    Subprogramme: "可持续发展和人类住区",
    Title: "根据执行《埃斯卡苏协定》的共同框架制定国家优先事项",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: "拉丁美洲和加勒比地区会员国",
    SpecificResult: "加强监管框架和环境治理；加大气候行动力度促进可持续发展",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC28.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=zh#page=43"
  },
  {
    ID: 534,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "拉丁美洲和加勒比经济委员会",
    Programme: "拉丁美洲和加勒比经济和社会发展",
    Subprogramme: "自然资源",
    Title: "加强采矿部门的政治对话与区域治理",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: "拉丁美洲和加勒比地区会员国",
    SpecificResult: "可持续资源管理；在可再生能源方面取得进展",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC29.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=zh#page=45"
  },
  {
    ID: 535,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "拉丁美洲和加勒比经济委员会",
    Programme: "拉丁美洲和加勒比经济和社会发展",
    Subprogramme: "自然资源",
    Title: "本区域各国为能源转型提供关键矿物，并提高经济、社会和环境可持续性",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: "拉丁美洲和加勒比地区会员国",
    SpecificResult: "可持续资源管理；在可再生能源方面取得进展",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC30.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=zh#page=46"
  },
  {
    ID: 536,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "拉丁美洲和加勒比经济委员会",
    Programme: "拉丁美洲和加勒比经济和社会发展",
    Subprogramme: "自然资源",
    Title: "促进拉丁美洲和加勒比能源转型的新举措",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: "拉丁美洲和加勒比地区会员国",
    SpecificResult: "可持续资源管理；在可再生能源方面取得进展",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC31.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=zh#page=46"
  },
  {
    ID: 537,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "拉丁美洲和加勒比经济委员会",
    Programme: "拉丁美洲和加勒比经济和社会发展",
    Subprogramme: "自然资源",
    Title: "加强海洋治理和政策，以加强本区域海洋的可持续利用和管理",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: "拉丁美洲和加勒比地区会员国",
    SpecificResult: "加强监管框架和环境治理；加大气候行动力度促进可持续发展",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC32.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=zh#page=47"
  },
  {
    ID: 538,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "拉丁美洲和加勒比经济委员会",
    Programme: "拉丁美洲和加勒比经济和社会发展",
    Subprogramme: "规划和公共管理促进发展",
    Title: "通过《拉丁美洲和加勒比可持续发展规划和公共管理治理区域议程》，以指导长期战略规划",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "拉丁美洲和加勒比地区会员国",
    SpecificResult: "通过稳健协调结构等途径，利用可持续发展目标之间的相互关联性，加快推进可持续发展目标",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC33.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=zh#page=49"
  },
  {
    ID: 539,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "拉丁美洲和加勒比经济委员会",
    Programme: "拉丁美洲和加勒比经济和社会发展",
    Subprogramme: "规划和公共管理促进发展",
    Title: "制定综合发展政策，建设更具韧性的国土，以加快落实《2030年议程》",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "拉丁美洲和加勒比地区会员国",
    SpecificResult: "通过稳健协调结构等途径，利用可持续发展目标之间的相互关联性，加快推进可持续发展目标",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC34.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=zh#page=50"
  },
  {
    ID: 540,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "拉丁美洲和加勒比经济委员会",
    Programme: "拉丁美洲和加勒比经济和社会发展",
    Subprogramme: "规划和公共管理促进发展",
    Title: "提高公共机构的技术、业务、政治和前瞻能力，以在不断变化的环境中管理变革并应",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "拉丁美洲和加勒比地区会员国",
    SpecificResult: "加强合作、增进信息和最佳做法共享，推动在实现可持续发展目标方面取得进展",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC35.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=zh#page=50"
  },
  {
    ID: 541,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "拉丁美洲和加勒比经济委员会",
    Programme: "拉丁美洲和加勒比经济和社会发展",
    Subprogramme: "规划和公共管理促进发展",
    Title: "成员国制定国家和国家以下各级的长期发展计划，整合《拉丁美洲和加勒比可持续发展规划和公共管理治理区域议程》的四个战略领域",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "拉丁美洲和加勒比地区会员国",
    SpecificResult: "通过稳健协调结构等途径，利用可持续发展目标之间的相互关联性，加快推进可持续发展目标",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC36.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=zh#page=51"
  },
  {
    ID: 542,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "拉丁美洲和加勒比经济委员会",
    Programme: "拉丁美洲和加勒比经济和社会发展",
    Subprogramme: "统计",
    Title: "提高数据的准确性，为关于贫困、不平等、就业、教育和生活条件的政策提供信息",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "拉丁美洲和加勒比地区会员国",
    SpecificResult: "改善用于循证决策的计量与统计促进可持续发展",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC37.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=zh#page=53"
  },
  {
    ID: 543,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "拉丁美洲和加勒比经济委员会",
    Programme: "拉丁美洲和加勒比经济和社会发展",
    Subprogramme: "统计",
    Title: "在国家一级加强实施联合国地理空间信息综合框架",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "拉丁美洲和加勒比地区会员国",
    SpecificResult: "改善用于循证决策的计量与统计促进可持续发展",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC38.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=zh#page=54"
  },
  {
    ID: 544,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "拉丁美洲和加勒比经济委员会",
    Programme: "拉丁美洲和加勒比经济和社会发展",
    Subprogramme: "统计",
    Title: "利用行政登记册编制统计数据工作得到加强",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "拉丁美洲和加勒比地区会员国",
    SpecificResult: "改善人口、移民、民事登记和人口统计(包括按性别分列的统计)信息",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC39.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=zh#page=54"
  },
  {
    ID: 545,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "拉丁美洲和加勒比经济委员会",
    Programme: "拉丁美洲和加勒比经济和社会发展",
    Subprogramme: "统计",
    Title: "拉丁美洲和加勒比国家用于衡量经济活动的现代化国家统计系统",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "拉丁美洲和加勒比地区会员国",
    SpecificResult: "改善用于循证决策的计量与统计促进可持续发展",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC40.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=zh#page=55"
  },
  {
    ID: 546,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "拉丁美洲和加勒比经济委员会",
    Programme: "拉丁美洲和加勒比经济和社会发展",
    Subprogramme: "中美洲、古巴、多米尼加共和国、海地和墨西哥的次区域活动",
    Title: "各国加强基于价值链的生产发展",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "拉丁美洲和加勒比地区会员国",
    SpecificResult: "通过稳健协调结构等途径，利用可持续发展目标之间的相互关联性，加快推进可持续发展目标",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CR,CU,DO,SV,GT,HT,HN,MX,NI,PA",
    Image: "21ECLAC41.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=zh#page=57"
  },
  {
    ID: 547,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "拉丁美洲和加勒比经济委员会",
    Programme: "拉丁美洲和加勒比经济和社会发展",
    Subprogramme: "中美洲、古巴、多米尼加共和国、海地和墨西哥的次区域活动",
    Title: "通过解决结构性差距加快落实可持续发展目标",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "拉丁美洲和加勒比地区会员国",
    SpecificResult: "通过稳健协调结构等途径，利用可持续发展目标之间的相互关联性，加快推进可持续发展目标",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CR,CU,DO,SV,GT,HT,HN,MX,NI,PA",
    Image: "21ECLAC42.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=zh#page=58"
  },
  {
    ID: 548,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "拉丁美洲和加勒比经济委员会",
    Programme: "拉丁美洲和加勒比经济和社会发展",
    Subprogramme: "中美洲、古巴、多米尼加共和国、海地和墨西哥的次区域活动",
    Title: "改善前瞻性治理，为次区域政策制定提供信息",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "拉丁美洲和加勒比地区会员国",
    SpecificResult: "加强合作、增进信息和最佳做法共享，推动在实现可持续发展目标方面取得进展",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CR,CU,DO,SV,GT,HT,HN,MX,NI,PA",
    Image: "21ECLAC43.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=zh#page=59"
  },
  {
    ID: 549,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "拉丁美洲和加勒比经济委员会",
    Programme: "拉丁美洲和加勒比经济和社会发展",
    Subprogramme: "中美洲、古巴、多米尼加共和国、海地和墨西哥的次区域活动",
    Title: "改善促进国家以下特定地区和部门生产发展的公共战略",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "拉丁美洲和加勒比地区会员国",
    SpecificResult: "通过稳健协调结构等途径，利用可持续发展目标之间的相互关联性，加快推进可持续发展目标",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CR,CU,DO,SV,GT,HT,HN,MX,NI,PA",
    Image: "21ECLAC44.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=zh#page=59"
  },
  {
    ID: 550,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "拉丁美洲和加勒比经济委员会",
    Programme: "拉丁美洲和加勒比经济和社会发展",
    Subprogramme: "加勒比次区域活动",
    Title: "针对加勒比海的马尾藻管理制定综合自然资源管理办法",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: "拉丁美洲和加勒比地区会员国",
    SpecificResult: "可持续资源管理；在可再生能源方面取得进展",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,BS,BD,BZ,CU,DM,DO,GD,GY,HT,JM,KN,LC,VC,SR,TT",
    Image: "21ECLAC45.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=zh#page=61"
  },
  {
    ID: 551,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "拉丁美洲和加勒比经济委员会",
    Programme: "拉丁美洲和加勒比经济和社会发展",
    Subprogramme: "加勒比次区域活动",
    Title: "加勒比地区的数字包容",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "拉丁美洲和加勒比地区会员国",
    SpecificResult: "在科学、技术和创新促进可持续发展(包括人工智能)方面取得进展",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,BS,BD,BZ,CU,DM,DO,GD,GY,HT,JM,KN,LC,VC,SR,TT",
    Image: "21ECLAC46.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=zh#page=62"
  },
  {
    ID: 552,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "拉丁美洲和加勒比经济委员会",
    Programme: "拉丁美洲和加勒比经济和社会发展",
    Subprogramme: "加勒比次区域活动",
    Title: "将《安提瓜和巴布达小岛屿发展中国家议程》纳入国家发展进程和议程",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "最不发达国家、内陆发展中国家、小岛屿发展中国家和其他发展中国家",
    BeneficiaryTwo: "拉丁美洲和加勒比地区会员国",
    SpecificResult: "通过稳健协调结构等途径，利用可持续发展目标之间的相互关联性，加快推进可持续发展目标",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,BS,BD,BZ,CU,DM,DO,GD,GY,HT,JM,KN,LC,VC,SR,TT",
    Image: "21ECLAC47.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=zh#page=62"
  },
  {
    ID: 553,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "拉丁美洲和加勒比经济委员会",
    Programme: "拉丁美洲和加勒比经济和社会发展",
    Subprogramme: "加勒比次区域活动",
    Title: "通过加强与拉丁美洲经济体的南南合作实现经济多样化",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "拉丁美洲和加勒比地区会员国",
    SpecificResult: "通过持续沟通，改善合作和伙伴关系，提高一致性、增强合力和减少重叠",
    SpecificResultOrder: 29,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,BS,BD,BZ,CU,DM,DO,GD,GY,HT,JM,KN,LC,VC,SR,TT",
    Image: "21ECLAC48.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=zh#page=63"
  },
  {
    ID: 554,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "拉丁美洲和加勒比经济委员会",
    Programme: "拉丁美洲和加勒比经济和社会发展",
    Subprogramme: "支持区域和次区域一体化及合作进程和组织",
    Title: "区域就衡量超越国内生产总值的可持续发展达成共识",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "国际社会",
    BeneficiaryTwo: "拉丁美洲和加勒比地区会员国",
    SpecificResult: "通过持续沟通，改善合作和伙伴关系，提高一致性、增强合力和减少重叠",
    SpecificResultOrder: 29,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC49.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=zh#page=66"
  },
  {
    ID: 555,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "拉丁美洲和加勒比经济委员会",
    Programme: "拉丁美洲和加勒比经济和社会发展",
    Subprogramme: "支持区域和次区域一体化及合作进程和组织",
    Title: "南南和三方合作中的多利益攸关方倡议得到加强",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "国际社会",
    BeneficiaryTwo: "拉丁美洲和加勒比地区会员国",
    SpecificResult: "加强合作、增进信息和最佳做法共享，推动在实现可持续发展目标方面取得进展",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC50.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=zh#page=66"
  },
  {
    ID: 556,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "拉丁美洲和加勒比经济委员会",
    Programme: "拉丁美洲和加勒比经济和社会发展",
    Subprogramme: "支持区域和次区域一体化及合作进程和组织",
    Title: "拉丁美洲和加勒比国家与区域外行为体就南南和三方合作进行互动协作",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "国际社会",
    BeneficiaryTwo: "拉丁美洲和加勒比地区会员国",
    SpecificResult: "加强合作、增进信息和最佳做法共享，推动在实现可持续发展目标方面取得进展",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC51.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=zh#page=67"
  },
  {
    ID: 557,
    BudgetSection: 21,
    Entity: "ECLAC",
    EntityFullName: "拉丁美洲和加勒比经济委员会",
    Programme: "拉丁美洲和加勒比经济和社会发展",
    Subprogramme: "支持区域和次区域一体化及合作进程和组织",
    Title: "根据《塞维利亚承诺》加强南南和三方合作与区域一体化",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "国际社会",
    BeneficiaryTwo: "拉丁美洲和加勒比地区会员国",
    SpecificResult: "增进对筹资需求的了解，改进为可持续资本投资筹措资金的政策备选方案，加大可持续项目供资承诺和参与力度",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC52.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.21)&l=zh#page=67"
  },
  {
    ID: 558,
    BudgetSection: 22,
    Entity: "ESCWA",
    EntityFullName: "西亚经济社会委员会",
    Programme: "西亚经济和社会发展",
    Subprogramme: "气候变化和自然资源可持续性",
    Title: "阿拉伯区域最不发达国家在部署缓解风险的金融和商业模式工具的支持下，向可负担、可靠、",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: "欧洲、中亚和西亚会员国",
    SpecificResult: "加强监管框架和环境治理；加大气候行动力度促进可持续发展",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.22)&l=zh#page=11"
  },
  {
    ID: 559,
    BudgetSection: 22,
    Entity: "ESCWA",
    EntityFullName: "西亚经济社会委员会",
    Programme: "西亚经济和社会发展",
    Subprogramme: "气候变化和自然资源可持续性",
    Title: "向可持续粮食系统过渡",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "私营部门，包括中小微型企业",
    BeneficiaryTwo: "欧洲、中亚和西亚会员国",
    SpecificResult: "加强监管框架和环境治理；加大气候行动力度促进可持续发展",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "22ESCWA2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.22)&l=zh#page=11"
  },
  {
    ID: 560,
    BudgetSection: 22,
    Entity: "ESCWA",
    EntityFullName: "西亚经济社会委员会",
    Programme: "西亚经济和社会发展",
    Subprogramme: "气候变化和自然资源可持续性",
    Title: "成员国确定防治沙尘暴的联合优先行动",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: "欧洲、中亚和西亚会员国",
    SpecificResult: "包容型、可持续灾后恢复；建设抵御未来灾害的能力",
    SpecificResultOrder: 12,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.22)&l=zh#page=12"
  },
  {
    ID: 561,
    BudgetSection: 22,
    Entity: "ESCWA",
    EntityFullName: "西亚经济社会委员会",
    Programme: "西亚经济和社会发展",
    Subprogramme: "气候变化和自然资源可持续性",
    Title: "阿拉伯区域地表水和地下水流域的复原力得到提高",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "气候和环境",
    BeneficiaryTwo: "欧洲、中亚和西亚会员国",
    SpecificResult: "可持续资源管理；在可再生能源方面取得进展",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.22)&l=zh#page=12"
  },
  {
    ID: 562,
    BudgetSection: 22,
    Entity: "ESCWA",
    EntityFullName: "西亚经济社会委员会",
    Programme: "西亚经济和社会发展",
    Subprogramme: "性别公正、人口和包容性发展",
    Title: "把阿拉伯区域的年轻人与就业机会紧密相连",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "青年",
    BeneficiaryTwo: "欧洲、中亚和西亚会员国",
    SpecificResult: "实现更具有包容性的发展，不让任何一个人掉队；消除贫困和减少不平等；减少对妇女和女童的歧视，加强性别平等。",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.22)&l=zh#page=15"
  },
  {
    ID: 563,
    BudgetSection: 22,
    Entity: "ESCWA",
    EntityFullName: "西亚经济社会委员会",
    Programme: "西亚经济和社会发展",
    Subprogramme: "性别公正、人口和包容性发展",
    Title: "成员国采用减少贫困的多层面办法",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "妇女和女童",
    BeneficiaryTwo: "欧洲、中亚和西亚会员国",
    SpecificResult: "提高报告可持续发展目标进展情况的能力；提高自愿国别评估数目和质量",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.22)&l=zh#page=16"
  },
  {
    ID: 564,
    BudgetSection: 22,
    Entity: "ESCWA",
    EntityFullName: "西亚经济社会委员会",
    Programme: "西亚经济和社会发展",
    Subprogramme: "性别公正、人口和包容性发展",
    Title: "成员国利用机器学习预测社会援助方案编制的预算需求",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "妇女和女童",
    BeneficiaryTwo: "欧洲、中亚和西亚会员国",
    SpecificResult: "在科学、技术和创新促进可持续发展(包括人工智能)方面取得进展",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.22)&l=zh#page=16"
  },
  {
    ID: 565,
    BudgetSection: 22,
    Entity: "ESCWA",
    EntityFullName: "西亚经济社会委员会",
    Programme: "西亚经济和社会发展",
    Subprogramme: "性别公正、人口和包容性发展",
    Title: "成员国确定并启动增强残疾人经济权能的优先行动",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "难民、少数群体和其他弱势群体",
    BeneficiaryTwo: "欧洲、中亚和西亚会员国",
    SpecificResult: "实现更具有包容性的发展，不让任何一个人掉队；消除贫困和减少不平等；减少对妇女和女童的歧视，加强性别平等。",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.22)&l=zh#page=17"
  },
  {
    ID: 566,
    BudgetSection: 22,
    Entity: "ESCWA",
    EntityFullName: "西亚经济社会委员会",
    Programme: "西亚经济和社会发展",
    Subprogramme: "共享经济繁荣",
    Title: "约旦和突尼斯制定了宏观财政政策，以加强社会部门筹资和财政可持续性",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "欧洲、中亚和西亚会员国",
    SpecificResult: "增进对筹资需求的了解，改进为可持续资本投资筹措资金的政策备选方案，加大可持续项目供资承诺和参与力度",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.22)&l=zh#page=20"
  },
  {
    ID: 567,
    BudgetSection: 22,
    Entity: "ESCWA",
    EntityFullName: "西亚经济社会委员会",
    Programme: "西亚经济和社会发展",
    Subprogramme: "共享经济繁荣",
    Title: "提高债务可持续性，以增加对可持续发展优先事项的投资",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "欧洲、中亚和西亚会员国",
    SpecificResult: "改善人口、移民、民事登记和人口统计(包括按性别分列的统计)信息",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.22)&l=zh#page=20"
  },
  {
    ID: 568,
    BudgetSection: 22,
    Entity: "ESCWA",
    EntityFullName: "西亚经济社会委员会",
    Programme: "西亚经济和社会发展",
    Subprogramme: "共享经济繁荣",
    Title: "成员国达成区域外双边贸易协定",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "私营部门，包括中小微型企业",
    BeneficiaryTwo: "欧洲、中亚和西亚会员国",
    SpecificResult: "利用电子商务和数字经济等方式增强能力和减少壁垒，改善贸易和竞争力",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.22)&l=zh#page=21"
  },
  {
    ID: 569,
    BudgetSection: 22,
    Entity: "ESCWA",
    EntityFullName: "西亚经济社会委员会",
    Programme: "西亚经济和社会发展",
    Subprogramme: "共享经济繁荣",
    Title: "阿拉伯国家为促进经济多元化进行宏观经济影响评估",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "欧洲、中亚和西亚会员国",
    SpecificResult: "利用电子商务和数字经济等方式增强能力和减少壁垒，改善贸易和竞争力",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.22)&l=zh#page=21"
  },
  {
    ID: 570,
    BudgetSection: 22,
    Entity: "ESCWA",
    EntityFullName: "西亚经济社会委员会",
    Programme: "西亚经济和社会发展",
    Subprogramme: "统计、信息社会和技术",
    Title: "加强阿拉伯区域的国民账户，促进循证决策",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "欧洲、中亚和西亚会员国",
    SpecificResult: "改善用于循证决策的计量与统计促进可持续发展",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.22)&l=zh#page=24"
  },
  {
    ID: 571,
    BudgetSection: 22,
    Entity: "ESCWA",
    EntityFullName: "西亚经济社会委员会",
    Programme: "西亚经济和社会发展",
    Subprogramme: "统计、信息社会和技术",
    Title: "地理统计证据加强阿拉伯区域的决策和发展规划",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "欧洲、中亚和西亚会员国",
    SpecificResult: "改善用于循证决策的计量与统计促进可持续发展",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.22)&l=zh#page=25"
  },
  {
    ID: 572,
    BudgetSection: 22,
    Entity: "ESCWA",
    EntityFullName: "西亚经济社会委员会",
    Programme: "西亚经济和社会发展",
    Subprogramme: "统计、信息社会和技术",
    Title: "阿拉伯成员国(包括最不发达国家)编制对外贸易统计数据",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "最不发达国家、内陆发展中国家、小岛屿发展中国家和其他发展中国家",
    BeneficiaryTwo: "欧洲、中亚和西亚会员国",
    SpecificResult: "改善用于循证决策的计量与统计促进可持续发展",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.22)&l=zh#page=25"
  },
  {
    ID: 573,
    BudgetSection: 22,
    Entity: "ESCWA",
    EntityFullName: "西亚经济社会委员会",
    Programme: "西亚经济和社会发展",
    Subprogramme: "统计、信息社会和技术",
    Title: "政策制定者使用综合区域数据平台进行循证决策",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "欧洲、中亚和西亚会员国",
    SpecificResult: "推进技术进步，改善信息质量、可用性、可及性和安全性",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.22)&l=zh#page=26"
  },
  {
    ID: 574,
    BudgetSection: 22,
    Entity: "ESCWA",
    EntityFullName: "西亚经济社会委员会",
    Programme: "西亚经济和社会发展",
    Subprogramme: "《2030 年议程》和可持续发展目标的协调",
    Title: "成员国就谈判第二次社会发展问题世界首脑会议政治宣言达成共同立场",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "国际社会",
    BeneficiaryTwo: "欧洲、中亚和西亚会员国",
    SpecificResult: "加强合作、增进信息和最佳做法共享，推动在实现可持续发展目标方面取得进展",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.22)&l=zh#page=29"
  },
  {
    ID: 575,
    BudgetSection: 22,
    Entity: "ESCWA",
    EntityFullName: "西亚经济社会委员会",
    Programme: "西亚经济和社会发展",
    Subprogramme: "《2030 年议程》和可持续发展目标的协调",
    Title: "私营部门对区域和国家可持续发展优先事项的投资增加",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "难民、少数群体和其他弱势群体",
    BeneficiaryTwo: "欧洲、中亚和西亚会员国",
    SpecificResult: "增进对筹资需求的了解，改进为可持续资本投资筹措资金的政策备选方案，加大可持续项目供资承诺和参与力度",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.22)&l=zh#page=29"
  },
  {
    ID: 576,
    BudgetSection: 22,
    Entity: "ESCWA",
    EntityFullName: "西亚经济社会委员会",
    Programme: "西亚经济和社会发展",
    Subprogramme: "《2030 年议程》和可持续发展目标的协调",
    Title: "成员国查明并解决与实施《2030年议程》有关的政策差距",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "欧洲、中亚和西亚会员国",
    SpecificResult: "加强合作、增进信息和最佳做法共享，推动在实现可持续发展目标方面取得进展",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.22)&l=zh#page=30"
  },
  {
    ID: 577,
    BudgetSection: 22,
    Entity: "ESCWA",
    EntityFullName: "西亚经济社会委员会",
    Programme: "西亚经济和社会发展",
    Subprogramme: "《2030 年议程》和可持续发展目标的协调",
    Title: "制定区域展望，确定中长期区域发展道路",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "欧洲、中亚和西亚会员国",
    SpecificResult: "通过稳健协调结构等途径，利用可持续发展目标之间的相互关联性，加快推进可持续发展目标",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.22)&l=zh#page=30"
  },
  {
    ID: 578,
    BudgetSection: 22,
    Entity: "ESCWA",
    EntityFullName: "西亚经济社会委员会",
    Programme: "西亚经济和社会发展",
    Subprogramme: "治理和预防冲突",
    Title: "阿曼采用基于证据的地方发展规划",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "欧洲、中亚和西亚会员国",
    SpecificResult: "通过稳健协调结构等途径，利用可持续发展目标之间的相互关联性，加快推进可持续发展目标",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "OM",
    Image: "22ESCWA21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.22)&l=zh#page=33"
  },
  {
    ID: 579,
    BudgetSection: 22,
    Entity: "ESCWA",
    EntityFullName: "西亚经济社会委员会",
    Programme: "西亚经济和社会发展",
    Subprogramme: "治理和预防冲突",
    Title: "公共行政系统现代化，促进有效和透明的公共治理和社会经济发展",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "欧洲、中亚和西亚会员国",
    SpecificResult: "加强体制、法治和预防冲突",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.22)&l=zh#page=33"
  },
  {
    ID: 580,
    BudgetSection: 22,
    Entity: "ESCWA",
    EntityFullName: "西亚经济社会委员会",
    Programme: "西亚经济和社会发展",
    Subprogramme: "治理和预防冲突",
    Title: "成员国制定和实施能够抵御脆弱性和突发冲击的发展政策",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "欧洲、中亚和西亚会员国",
    SpecificResult: "通过稳健协调结构等途径，利用可持续发展目标之间的相互关联性，加快推进可持续发展目标",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.22)&l=zh#page=34"
  },
  {
    ID: 581,
    BudgetSection: 22,
    Entity: "ESCWA",
    EntityFullName: "西亚经济社会委员会",
    Programme: "西亚经济和社会发展",
    Subprogramme: "治理和预防冲突",
    Title: "加强竞争治理，促进市场的透明度和包容度",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "公共行政",
    BeneficiaryTwo: "欧洲、中亚和西亚会员国",
    SpecificResult: "利用电子商务和数字经济等方式增强能力和减少壁垒，改善贸易和竞争力",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.22)&l=zh#page=35"
  },
  {
    ID: 582,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "联合国人权事务高级专员办事处",
    Programme: "人权",
    Subprogramme: "人权主流化、发展权、研究和分析: 人权主流化",
    Title: "将人权规范和标准纳入共同国家分析和联合国可持续发展合作框架",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "促进人权",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "在人权的保护和享受方面取得进展，减少不平等和歧视；进一步融合发展权",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.24)&l=zh#page=15"
  },
  {
    ID: 583,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "联合国人权事务高级专员办事处",
    Programme: "人权",
    Subprogramme: "人权主流化、发展权、研究和分析: 人权主流化",
    Title: "将关于经济、社会及文化权利的国际人权标准纳入国家预算编制",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "促进人权",
    Beneficiary: "公共行政",
    BeneficiaryTwo: " ",
    SpecificResult: "在人权的保护和享受方面取得进展，减少不平等和歧视；进一步融合发展权",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.24)&l=zh#page=16"
  },
  {
    ID: 584,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "联合国人权事务高级专员办事处",
    Programme: "人权",
    Subprogramme: "人权主流化、发展权、研究和分析: 人权主流化",
    Title: "通过经济、社会和文化权利知识中心，在国家政策和实践中进一步促进和保护人权",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "促进人权",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "在人权的保护和享受方面取得进展，减少不平等和歧视；进一步融合发展权",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.24)&l=zh#page=17"
  },
  {
    ID: 585,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "联合国人权事务高级专员办事处",
    Programme: "人权",
    Subprogramme: "人权主流化、发展权、研究和分析: 人权主流化",
    Title: "会员国通过反恐法律并执行各项措施，这些法律和措施符合并在实施时充分尊重《世",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "促进人权",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "在人权的保护和享受方面取得进展，减少不平等和歧视；进一步融合发展权",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.24)&l=zh#page=17"
  },
  {
    ID: 586,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "联合国人权事务高级专员办事处",
    Programme: "人权",
    Subprogramme: "人权主流化、发展权、研究和分析: 发展权",
    Title: "会员国和其他利益攸关方具备在实现可持续发展目标过程中落实发展权的能力",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "促进人权",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "在人权的保护和享受方面取得进展，减少不平等和歧视；进一步融合发展权",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.24)&l=zh#page=19"
  },
  {
    ID: 587,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "联合国人权事务高级专员办事处",
    Programme: "人权",
    Subprogramme: "人权主流化、发展权、研究和分析: 发展权",
    Title: "制定反腐败政策和做法，消除腐败对享受人权的负面影响",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "促进人权",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "在人权的保护和享受方面取得进展，减少不平等和歧视；进一步融合发展权",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.24)&l=zh#page=20"
  },
  {
    ID: 588,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "联合国人权事务高级专员办事处",
    Programme: "人权",
    Subprogramme: "人权主流化、发展权、研究和分析: 发展权",
    Title: "加强促进和保护发展权",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "促进人权",
    Beneficiary: "最不发达国家、内陆发展中国家、小岛屿发展中国家和其他发展中国家",
    BeneficiaryTwo: " ",
    SpecificResult: "在人权的保护和享受方面取得进展，减少不平等和歧视；进一步融合发展权",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.24)&l=zh#page=21"
  },
  {
    ID: 589,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "联合国人权事务高级专员办事处",
    Programme: "人权",
    Subprogramme: "人权主流化、发展权、研究和分析: 发展权",
    Title: "在区域和国家层面推动促进发展权",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "促进人权",
    Beneficiary: "最不发达国家、内陆发展中国家、小岛屿发展中国家和其他发展中国家",
    BeneficiaryTwo: " ",
    SpecificResult: "在人权的保护和享受方面取得进展，减少不平等和歧视；进一步融合发展权",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.24)&l=zh#page=21"
  },
  {
    ID: 590,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "联合国人权事务高级专员办事处",
    Programme: "人权",
    Subprogramme: "人权主流化、发展权、研究和分析: 研究和分析",
    Title: "会员国促进符合国际人权法的毒品相关法律、政策和做法",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "促进人权",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "在人权的保护和享受方面取得进展，减少不平等和歧视；进一步融合发展权",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BR,CO,PK",
    Image: "24UHCHR9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.24)&l=zh#page=23"
  },
  {
    ID: 591,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "联合国人权事务高级专员办事处",
    Programme: "人权",
    Subprogramme: "人权主流化、发展权、研究和分析: 研究和分析",
    Title: "来自土著人民、少数群体和非洲人后裔的青年人权维护者加深对人权的理解",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "促进人权",
    Beneficiary: "难民、少数群体和其他弱势群体",
    BeneficiaryTwo: "青年",
    SpecificResult: "在人权的保护和享受方面取得进展，减少不平等和歧视；进一步融合发展权",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.24)&l=zh#page=24"
  },
  {
    ID: 592,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "联合国人权事务高级专员办事处",
    Programme: "人权",
    Subprogramme: "人权主流化、发展权、研究和分析: 研究和分析",
    Title: "会员国和其他利益攸关方更好地了解数字技术对人权的影响",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "促进人权",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "在人权的保护和享受方面取得进展，减少不平等和歧视；进一步融合发展权",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.24)&l=zh#page=24"
  },
  {
    ID: 593,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "联合国人权事务高级专员办事处",
    Programme: "人权",
    Subprogramme: "人权主流化、发展权、研究和分析: 研究和分析",
    Title: "会员国通过并执行加强平等、不歧视、容忍和享有所有人权的循证反种族主义政策和",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "促进人权",
    Beneficiary: "难民、少数群体和其他弱势群体",
    BeneficiaryTwo: " ",
    SpecificResult: "在人权的保护和享受方面取得进展，减少不平等和歧视；进一步融合发展权",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.24)&l=zh#page=25"
  },
  {
    ID: 594,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "联合国人权事务高级专员办事处",
    Programme: "人权",
    Subprogramme: "支持人权条约机构",
    Title: "条约机构更多地采用议题清单和报告前议题清单",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "促进人权",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "在人权的保护和享受方面取得进展，减少不平等和歧视；进一步融合发展权",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.24)&l=zh#page=27"
  },
  {
    ID: 595,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "联合国人权事务高级专员办事处",
    Programme: "人权",
    Subprogramme: "支持人权条约机构",
    Title: "开展更多国际合作，支持国家执行、报告和后续行动机制",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "促进人权",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "在人权的保护和享受方面取得进展，减少不平等和歧视；进一步融合发展权",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.24)&l=zh#page=28"
  },
  {
    ID: 596,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "联合国人权事务高级专员办事处",
    Programme: "人权",
    Subprogramme: "支持人权条约机构",
    Title: "改善缔约国和利益攸关方获取条约机构的建议以促进执行建议",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "促进人权",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "在人权的保护和享受方面取得进展，减少不平等和歧视；进一步融合发展权",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.24)&l=zh#page=28"
  },
  {
    ID: 597,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "联合国人权事务高级专员办事处",
    Programme: "人权",
    Subprogramme: "支持人权条约机构",
    Title: "获取条约机构工作信息的一站式平台",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "促进人权",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "在人权的保护和享受方面取得进展，减少不平等和歧视；进一步融合发展权",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.24)&l=zh#page=29"
  },
  {
    ID: 598,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "联合国人权事务高级专员办事处",
    Programme: "人权",
    Subprogramme: "咨询服务、技术合作和外地活动",
    Title: "人权理事会授权的调查通过提供对侵犯人权以及违反国际人道法和国际人权法的行为的",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "促进人权",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "在人权的保护和享受方面取得进展，减少不平等和歧视；进一步融合发展权",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.24)&l=zh#page=32"
  },
  {
    ID: 599,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "联合国人权事务高级专员办事处",
    Programme: "人权",
    Subprogramme: "咨询服务、技术合作和外地活动",
    Title: "根据《巴黎原则》加强国家人权机构的效力",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "促进人权",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "在人权的保护和享受方面取得进展，减少不平等和歧视；进一步融合发展权",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.24)&l=zh#page=33"
  },
  {
    ID: 600,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "联合国人权事务高级专员办事处",
    Programme: "人权",
    Subprogramme: "咨询服务、技术合作和外地活动",
    Title: "加强技术合作，支持加勒比共同体会员国努力促进、保护和实现人权",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "促进人权",
    Beneficiary: "拉丁美洲和加勒比地区会员国",
    BeneficiaryTwo: " ",
    SpecificResult: "在人权的保护和享受方面取得进展，减少不平等和歧视；进一步融合发展权",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,BS,BD,BZ,DM,GD,GY,HT,JM,MS,LC,KN,VC,SR,TT,AI,BM,VG,KY,TC",
    Image: "24UHCHR19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.24)&l=zh#page=34"
  },
  {
    ID: 601,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "联合国人权事务高级专员办事处",
    Programme: "人权",
    Subprogramme: "咨询服务、技术合作和外地活动",
    Title: "会员国和其他利益攸关方采取行动处理国家和区域层面的人权状况",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "促进人权",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "在人权的保护和享受方面取得进展，减少不平等和歧视；进一步融合发展权",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.24)&l=zh#page=34"
  },
  {
    ID: 602,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "联合国人权事务高级专员办事处",
    Programme: "人权",
    Subprogramme: "支持人权理事会及其附属机构和机制",
    Title: "特别程序在全球、区域和国家各级的影响力得到增强",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "促进人权",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "在人权的保护和享受方面取得进展，减少不平等和歧视；进一步融合发展权",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.24)&l=zh#page=37"
  },
  {
    ID: 603,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "联合国人权事务高级专员办事处",
    Programme: "人权",
    Subprogramme: "支持人权理事会及其附属机构和机制",
    Title: "加强国家人权机构对普遍定期审议机制的贡献",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "促进人权",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "在人权的保护和享受方面取得进展，减少不平等和歧视；进一步融合发展权",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.24)&l=zh#page=38"
  },
  {
    ID: 604,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "联合国人权事务高级专员办事处",
    Programme: "人权",
    Subprogramme: "支持人权理事会及其附属机构和机制",
    Title: "加强联合国国家工作队与普遍定期审议机制的互动协作",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "促进人权",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "在人权的保护和享受方面取得进展，减少不平等和歧视；进一步融合发展权",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.24)&l=zh#page=39"
  },
  {
    ID: 605,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "联合国人权事务高级专员办事处",
    Programme: "人权",
    Subprogramme: "支持人权理事会及其附属机构和机制",
    Title: "残疾人参与人权理事会工作的无障碍条件改进",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "促进人权",
    Beneficiary: "国际社会",
    BeneficiaryTwo: "难民、少数群体和其他弱势群体",
    SpecificResult: "通过科学、技术和创新提高流程效率",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.24)&l=zh#page=39"
  },
  {
    ID: 606,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "联合国人权事务高级专员办事处",
    Programme: "人权",
    Subprogramme: "受害人权利倡导者办公室",
    Title: "加强全系统执行秘书长关于将受害人的权利和尊严置于预防和应对性剥削和性虐待工作中心的战略",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "促进人权",
    Beneficiary: "难民、少数群体和其他弱势群体",
    BeneficiaryTwo: "妇女和女童",
    SpecificResult: "加大应对力度，打击性剥削和性虐待、性骚扰以及欺诈和腐败；更好地将以受害者为中心的方法纳入主流",
    SpecificResultOrder: 22,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.24)&l=zh#page=102"
  },
  {
    ID: 607,
    BudgetSection: 24,
    Entity: "OHCHR",
    EntityFullName: "联合国人权事务高级专员办事处",
    Programme: "人权",
    Subprogramme: "受害人权利倡导者办公室",
    Title: "通过利用受害人权利干事在维持和平、人道主义和发展方面的各种经验和知识，对受害人的支持得到加强",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "促进人权",
    Beneficiary: "难民、少数群体和其他弱势群体",
    BeneficiaryTwo: "妇女和女童",
    SpecificResult: "加大应对力度，打击性剥削和性虐待、性骚扰以及欺诈和腐败；更好地将以受害者为中心的方法纳入主流",
    SpecificResultOrder: 22,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "ET,HT,ML,UA",
    Image: "24UHCHR26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.24)&l=zh#page=102"
  },
  {
    ID: 608,
    BudgetSection: 25,
    Entity: "UNHCR",
    EntityFullName: "联合国难民事务高级专员公署",
    Programme: "为难民提供国际保护、持久解决办法和援助",
    Subprogramme: "为难民提供国际保护、持久解决办法和援助",
    Title: "难民问题全球论坛认捐推进对难民和收容社区的责任分担和支持",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "有效协调人道主义援助工作和为难民提供支持",
    Beneficiary: "难民、少数群体和其他弱势群体",
    BeneficiaryTwo: " ",
    SpecificResult: "加强对难民权利的保护，改善生活条件，包括卫生和教育，提高响应能力和共担责任",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "25UNHCR1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.25)&l=zh#page=6"
  },
  {
    ID: 609,
    BudgetSection: 25,
    Entity: "UNHCR",
    EntityFullName: "联合国难民事务高级专员公署",
    Programme: "为难民提供国际保护、持久解决办法和援助",
    Subprogramme: "为难民提供国际保护、持久解决办法和援助",
    Title: "国家和地方伙伴在全球难民应对计划中的占比增加",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "有效协调人道主义援助工作和为难民提供支持",
    Beneficiary: "难民、少数群体和其他弱势群体",
    BeneficiaryTwo: " ",
    SpecificResult: "加强对难民权利的保护，改善生活条件，包括卫生和教育，提高响应能力和共担责任",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "25UNHCR2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.25)&l=zh#page=6"
  },
  {
    ID: 610,
    BudgetSection: 25,
    Entity: "UNHCR",
    EntityFullName: "联合国难民事务高级专员公署",
    Programme: "为难民提供国际保护、持久解决办法和援助",
    Subprogramme: "为难民提供国际保护、持久解决办法和援助",
    Title: "难民和寻求庇护者得到更有力的保护并更易获得服务",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "有效协调人道主义援助工作和为难民提供支持",
    Beneficiary: "难民、少数群体和其他弱势群体",
    BeneficiaryTwo: " ",
    SpecificResult: "加强对难民权利的保护，改善生活条件，包括卫生和教育，提高响应能力和共担责任",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "25UNHCR3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.25)&l=zh#page=7"
  },
  {
    ID: 611,
    BudgetSection: 25,
    Entity: "UNHCR",
    EntityFullName: "联合国难民事务高级专员公署",
    Programme: "为难民提供国际保护、持久解决办法和援助",
    Subprogramme: "为难民提供国际保护、持久解决办法和援助",
    Title: "关于无国籍问题的国际公约得到更好的遵守",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "有效协调人道主义援助工作和为难民提供支持",
    Beneficiary: "难民、少数群体和其他弱势群体",
    BeneficiaryTwo: " ",
    SpecificResult: "加强对难民权利的保护，改善生活条件，包括卫生和教育，提高响应能力和共担责任",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "25UNHCR4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.25)&l=zh#page=7"
  },
  {
    ID: 612,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "联合国近东巴勒斯坦难民救济和工程处",
    Programme: "巴勒斯坦难民",
    Subprogramme: "巴勒斯坦难民通过实现国际法规定的权利而得到保护",
    Title: "增加巴勒斯坦残疾难民获取康复支持的机会",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "有效协调人道主义援助工作和为难民提供支持",
    Beneficiary: "难民、少数群体和其他弱势群体",
    BeneficiaryTwo: "难民、少数群体和其他弱势群体",
    SpecificResult: "加强对难民权利的保护，改善生活条件，包括卫生和教育，提高响应能力和共担责任",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.26)&l=zh#page=7"
  },
  {
    ID: 613,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "联合国近东巴勒斯坦难民救济和工程处",
    Programme: "巴勒斯坦难民",
    Subprogramme: "巴勒斯坦难民通过实现国际法规定的权利而得到保护",
    Title: "获得工程处服务的巴勒斯坦难民的安全和尊严得到改善",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "有效协调人道主义援助工作和为难民提供支持",
    Beneficiary: "难民、少数群体和其他弱势群体",
    BeneficiaryTwo: " ",
    SpecificResult: "加强对难民权利的保护，改善生活条件，包括卫生和教育，提高响应能力和共担责任",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.26)&l=zh#page=8"
  },
  {
    ID: 614,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "联合国近东巴勒斯坦难民救济和工程处",
    Programme: "巴勒斯坦难民",
    Subprogramme: "巴勒斯坦难民通过实现国际法规定的权利而得到保护",
    Title: "对巴勒斯坦难民的保护得到加强，使其免遭性别暴力",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "有效协调人道主义援助工作和为难民提供支持",
    Beneficiary: "难民、少数群体和其他弱势群体",
    BeneficiaryTwo: "妇女和女童",
    SpecificResult: "加强对难民权利的保护，改善生活条件，包括卫生和教育，提高响应能力和共担责任",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.26)&l=zh#page=8"
  },
  {
    ID: 615,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "联合国近东巴勒斯坦难民救济和工程处",
    Programme: "巴勒斯坦难民",
    Subprogramme: "巴勒斯坦难民通过实现国际法规定的权利而得到保护",
    Title: "针对弱势巴勒斯坦难民的社会工作干预措施的有效性得到提高",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "有效协调人道主义援助工作和为难民提供支持",
    Beneficiary: "难民、少数群体和其他弱势群体",
    BeneficiaryTwo: " ",
    SpecificResult: "加强对难民权利的保护，改善生活条件，包括卫生和教育，提高响应能力和共担责任",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.26)&l=zh#page=9"
  },
  {
    ID: 616,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "联合国近东巴勒斯坦难民救济和工程处",
    Programme: "巴勒斯坦难民",
    Subprogramme: "巴勒斯坦难民普遍获得优质初级医疗保健，并有针对性地获得二级和三级医疗保健，从而改善健康结果",
    Title: "巴勒斯坦难民中的非传染性疾病控制得到加强",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "有效协调人道主义援助工作和为难民提供支持",
    Beneficiary: "难民、少数群体和其他弱势群体",
    BeneficiaryTwo: " ",
    SpecificResult: "加强对难民权利的保护，改善生活条件，包括卫生和教育，提高响应能力和共担责任",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.26)&l=zh#page=11"
  },
  {
    ID: 617,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "联合国近东巴勒斯坦难民救济和工程处",
    Programme: "巴勒斯坦难民",
    Subprogramme: "巴勒斯坦难民普遍获得优质初级医疗保健，并有针对性地获得二级和三级医疗保健，从而改善健康结果",
    Title: "巴勒斯坦难民获得孕前保健和生殖计划服务的机会得到改善",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "有效协调人道主义援助工作和为难民提供支持",
    Beneficiary: "难民、少数群体和其他弱势群体",
    BeneficiaryTwo: "妇女和女童",
    SpecificResult: "加强对难民权利的保护，改善生活条件，包括卫生和教育，提高响应能力和共担责任",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.26)&l=zh#page=11"
  },
  {
    ID: 618,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "联合国近东巴勒斯坦难民救济和工程处",
    Programme: "巴勒斯坦难民",
    Subprogramme: "巴勒斯坦难民普遍获得优质初级医疗保健，并有针对性地获得二级和三级医疗保健，从而改善健康结果",
    Title: "巴勒斯坦难民社区的传染病得到控制",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "有效协调人道主义援助工作和为难民提供支持",
    Beneficiary: "难民、少数群体和其他弱势群体",
    BeneficiaryTwo: " ",
    SpecificResult: "加强对难民权利的保护，改善生活条件，包括卫生和教育，提高响应能力和共担责任",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.26)&l=zh#page=12"
  },
  {
    ID: 619,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "联合国近东巴勒斯坦难民救济和工程处",
    Programme: "巴勒斯坦难民",
    Subprogramme: "巴勒斯坦难民普遍获得优质初级医疗保健，并有针对性地获得二级和三级医疗保健，从而改善健康结果",
    Title: "有明确需求的巴勒斯坦难民持续获得精神卫生和社会心理支持",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "有效协调人道主义援助工作和为难民提供支持",
    Beneficiary: "难民、少数群体和其他弱势群体",
    BeneficiaryTwo: " ",
    SpecificResult: "加强对难民权利的保护，改善生活条件，包括卫生和教育，提高响应能力和共担责任",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.26)&l=zh#page=13"
  },
  {
    ID: 620,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "联合国近东巴勒斯坦难民救济和工程处",
    Programme: "巴勒斯坦难民",
    Subprogramme: "巴勒斯坦难民获得包容和公平的优质教育",
    Title: "巴勒斯坦难民儿童持续接受小学教育",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "有效协调人道主义援助工作和为难民提供支持",
    Beneficiary: "难民、少数群体和其他弱势群体",
    BeneficiaryTwo: "青年",
    SpecificResult: "加强对难民权利的保护，改善生活条件，包括卫生和教育，提高响应能力和共担责任",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.26)&l=zh#page=14"
  },
  {
    ID: 621,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "联合国近东巴勒斯坦难民救济和工程处",
    Programme: "巴勒斯坦难民",
    Subprogramme: "巴勒斯坦难民获得包容和公平的优质教育",
    Title: "工程处学校学生学习环境的安全性和包容性得到提高",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "有效协调人道主义援助工作和为难民提供支持",
    Beneficiary: "难民、少数群体和其他弱势群体",
    BeneficiaryTwo: "青年",
    SpecificResult: "加强对难民权利的保护，改善生活条件，包括卫生和教育，提高响应能力和共担责任",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.26)&l=zh#page=15"
  },
  {
    ID: 622,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "联合国近东巴勒斯坦难民救济和工程处",
    Programme: "巴勒斯坦难民",
    Subprogramme: "巴勒斯坦难民获得包容和公平的优质教育",
    Title: "巴勒斯坦难民儿童的社会和情感发展得到保护",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "有效协调人道主义援助工作和为难民提供支持",
    Beneficiary: "难民、少数群体和其他弱势群体",
    BeneficiaryTwo: "青年",
    SpecificResult: "加强对难民权利的保护，改善生活条件，包括卫生和教育，提高响应能力和共担责任",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.26)&l=zh#page=16"
  },
  {
    ID: 623,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "联合国近东巴勒斯坦难民救济和工程处",
    Programme: "巴勒斯坦难民",
    Subprogramme: "巴勒斯坦难民获得包容和公平的优质教育",
    Title: "扩大近东救济工程处业务区的混合和适应性学习",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "有效协调人道主义援助工作和为难民提供支持",
    Beneficiary: "难民、少数群体和其他弱势群体",
    BeneficiaryTwo: "青年",
    SpecificResult: "加强对难民权利的保护，改善生活条件，包括卫生和教育，提高响应能力和共担责任",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.26)&l=zh#page=16"
  },
  {
    ID: 624,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "联合国近东巴勒斯坦难民救济和工程处",
    Programme: "巴勒斯坦难民",
    Subprogramme: "巴勒斯坦难民通过技能、企业支持和公平进入劳动力市场，维持并在可行的情况下加强体面工作和创收的机会",
    Title: "通过基础设施和难民营改建工程扩大就业机会",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "有效协调人道主义援助工作和为难民提供支持",
    Beneficiary: "难民、少数群体和其他弱势群体",
    BeneficiaryTwo: " ",
    SpecificResult: "加强对难民权利的保护，改善生活条件，包括卫生和教育，提高响应能力和共担责任",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.26)&l=zh#page=18"
  },
  {
    ID: 625,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "联合国近东巴勒斯坦难民救济和工程处",
    Programme: "巴勒斯坦难民",
    Subprogramme: "巴勒斯坦难民通过技能、企业支持和公平进入劳动力市场，维持并在可行的情况下加强体面工作和创收的机会",
    Title: "创造私营部门就业机会",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "有效协调人道主义援助工作和为难民提供支持",
    Beneficiary: "难民、少数群体和其他弱势群体",
    BeneficiaryTwo: " ",
    SpecificResult: "加强对难民权利的保护，改善生活条件，包括卫生和教育，提高响应能力和共担责任",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.26)&l=zh#page=19"
  },
  {
    ID: 626,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "联合国近东巴勒斯坦难民救济和工程处",
    Programme: "巴勒斯坦难民",
    Subprogramme: "巴勒斯坦难民通过技能、企业支持和公平进入劳动力市场，维持并在可行的情况下加强体面工作和创收的机会",
    Title: "通过职业培训改善青年就业机会",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "有效协调人道主义援助工作和为难民提供支持",
    Beneficiary: "难民、少数群体和其他弱势群体",
    BeneficiaryTwo: "青年",
    SpecificResult: "加强对难民权利的保护，改善生活条件，包括卫生和教育，提高响应能力和共担责任",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.26)&l=zh#page=19"
  },
  {
    ID: 627,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "联合国近东巴勒斯坦难民救济和工程处",
    Programme: "巴勒斯坦难民",
    Subprogramme: "巴勒斯坦难民通过技能、企业支持和公平进入劳动力市场，维持并在可行的情况下加强体面工作和创收的机会",
    Title: "扩大巴勒斯坦难民妇女获得包容性金融服务的机会",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "有效协调人道主义援助工作和为难民提供支持",
    Beneficiary: "难民、少数群体和其他弱势群体",
    BeneficiaryTwo: "妇女和女童",
    SpecificResult: "加强对难民权利的保护，改善生活条件，包括卫生和教育，提高响应能力和共担责任",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.26)&l=zh#page=20"
  },
  {
    ID: 628,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "联合国近东巴勒斯坦难民救济和工程处",
    Programme: "巴勒斯坦难民",
    Subprogramme: "巴勒斯坦难民可以在安全和可持续的难民营环境中使用基本和公共服务基础设施，保护他们的健康和尊严",
    Title: "难民营中巴勒斯坦难民与水和环境卫生相关的健康风险降低",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "有效协调人道主义援助工作和为难民提供支持",
    Beneficiary: "难民、少数群体和其他弱势群体",
    BeneficiaryTwo: " ",
    SpecificResult: "加强对难民权利的保护，改善生活条件，包括卫生和教育，提高响应能力和共担责任",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.26)&l=zh#page=21"
  },
  {
    ID: 629,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "联合国近东巴勒斯坦难民救济和工程处",
    Programme: "巴勒斯坦难民",
    Subprogramme: "巴勒斯坦难民可以在安全和可持续的难民营环境中使用基本和公共服务基础设施，保护他们的健康和尊严",
    Title: "生活在难民营中的巴勒斯坦难民的安全和尊严得到改善",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "有效协调人道主义援助工作和为难民提供支持",
    Beneficiary: "难民、少数群体和其他弱势群体",
    BeneficiaryTwo: " ",
    SpecificResult: "加强对难民权利的保护，改善生活条件，包括卫生和教育，提高响应能力和共担责任",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.26)&l=zh#page=22"
  },
  {
    ID: 630,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "联合国近东巴勒斯坦难民救济和工程处",
    Programme: "巴勒斯坦难民",
    Subprogramme: "巴勒斯坦难民可以在安全和可持续的难民营环境中使用基本和公共服务基础设施，保护他们的健康和尊严",
    Title: "改善巴勒斯坦难民的水质",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "有效协调人道主义援助工作和为难民提供支持",
    Beneficiary: "难民、少数群体和其他弱势群体",
    BeneficiaryTwo: " ",
    SpecificResult: "加强对难民权利的保护，改善生活条件，包括卫生和教育，提高响应能力和共担责任",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.26)&l=zh#page=23"
  },
  {
    ID: 631,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "联合国近东巴勒斯坦难民救济和工程处",
    Programme: "巴勒斯坦难民",
    Subprogramme: "巴勒斯坦难民可以在安全和可持续的难民营环境中使用基本和公共服务基础设施，保护他们的健康和尊严",
    Title: "难民营中巴勒斯坦难民的生活条件得到改善",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "有效协调人道主义援助工作和为难民提供支持",
    Beneficiary: "难民、少数群体和其他弱势群体",
    BeneficiaryTwo: " ",
    SpecificResult: "加强对难民权利的保护，改善生活条件，包括卫生和教育，提高响应能力和共担责任",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.26)&l=zh#page=23"
  },
  {
    ID: 632,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "联合国近东巴勒斯坦难民救济和工程处",
    Programme: "巴勒斯坦难民",
    Subprogramme: "最弱势的巴勒斯坦难民获得效果更好、更有针对性的社会援助 .",
    Title: "弱势巴勒斯坦难民青年的就业机会得到改善",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "有效协调人道主义援助工作和为难民提供支持",
    Beneficiary: "难民、少数群体和其他弱势群体",
    BeneficiaryTwo: "青年",
    SpecificResult: "加强对难民权利的保护，改善生活条件，包括卫生和教育，提高响应能力和共担责任",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.26)&l=zh#page=25"
  },
  {
    ID: 633,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "联合国近东巴勒斯坦难民救济和工程处",
    Programme: "巴勒斯坦难民",
    Subprogramme: "最弱势的巴勒斯坦难民获得效果更好、更有针对性的社会援助 .",
    Title: "确保获得负担得起的医院护理",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "有效协调人道主义援助工作和为难民提供支持",
    Beneficiary: "难民、少数群体和其他弱势群体",
    BeneficiaryTwo: " ",
    SpecificResult: "加强对难民权利的保护，改善生活条件，包括卫生和教育，提高响应能力和共担责任",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.26)&l=zh#page=25"
  },
  {
    ID: 634,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "联合国近东巴勒斯坦难民救济和工程处",
    Programme: "巴勒斯坦难民",
    Subprogramme: "最弱势的巴勒斯坦难民获得效果更好、更有针对性的社会援助 .",
    Title: "向最弱势巴勒斯坦难民提供的社会转移支付得到保障",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "有效协调人道主义援助工作和为难民提供支持",
    Beneficiary: "难民、少数群体和其他弱势群体",
    BeneficiaryTwo: " ",
    SpecificResult: "加强对难民权利的保护，改善生活条件，包括卫生和教育，提高响应能力和共担责任",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.26)&l=zh#page=26"
  },
  {
    ID: 635,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "联合国近东巴勒斯坦难民救济和工程处",
    Programme: "巴勒斯坦难民",
    Subprogramme: "最弱势的巴勒斯坦难民获得效果更好、更有针对性的社会援助 .",
    Title: "接受社会转移支付的家庭的韧性增强",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "有效协调人道主义援助工作和为难民提供支持",
    Beneficiary: "难民、少数群体和其他弱势群体",
    BeneficiaryTwo: " ",
    SpecificResult: "加强对难民权利的保护，改善生活条件，包括卫生和教育，提高响应能力和共担责任",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.26)&l=zh#page=26"
  },
  {
    ID: 636,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "联合国近东巴勒斯坦难民救济和工程处",
    Programme: "巴勒斯坦难民",
    Subprogramme: "巴勒斯坦难民得到准确登记，其身份得到可靠维护",
    Title: "通过大规模数字化保存和保护历史家族记录",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "有效协调人道主义援助工作和为难民提供支持",
    Beneficiary: "难民、少数群体和其他弱势群体",
    BeneficiaryTwo: " ",
    SpecificResult: "加强对难民权利的保护，改善生活条件，包括卫生和教育，提高响应能力和共担责任",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,LU,PS,SY",
    Image: "26UNRWA25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.26)&l=zh#page=28"
  },
  {
    ID: 637,
    BudgetSection: 26,
    Entity: "UNRWA",
    EntityFullName: "联合国近东巴勒斯坦难民救济和工程处",
    Programme: "巴勒斯坦难民",
    Subprogramme: "巴勒斯坦难民得到准确登记，其身份得到可靠维护",
    Title: "已登记的巴勒斯坦难民对其记录和服务的数字访问机会得到改善",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "有效协调人道主义援助工作和为难民提供支持",
    Beneficiary: "难民、少数群体和其他弱势群体",
    BeneficiaryTwo: " ",
    SpecificResult: "加强对难民权利的保护，改善生活条件，包括卫生和教育，提高响应能力和共担责任",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.26)&l=zh#page=29"
  },
  {
    ID: 638,
    BudgetSection: 27,
    Entity: "OCHA",
    EntityFullName: "联合国人道主义事务协调厅",
    Programme: "人道主义援助",
    Subprogramme: "政策和分析",
    Title: "地方推动的协商为人道主义应对优先事项、筹资和备灾行动提供了参考信息",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "有效协调人道主义援助工作和为难民提供支持",
    Beneficiary: "难民、少数群体和其他弱势群体",
    BeneficiaryTwo: " ",
    SpecificResult: "加强人道主义应对措施的一致性、及时性、有效性和覆盖面；显著降低灾害风险",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CO,PH,SO",
    Image: "27OCHA1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.27)&l=zh#page=8"
  },
  {
    ID: 639,
    BudgetSection: 27,
    Entity: "OCHA",
    EntityFullName: "联合国人道主义事务协调厅",
    Programme: "人道主义援助",
    Subprogramme: "政策和分析",
    Title: "社区更多地参与人道主义应急行动，以有效满足其需求",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "有效协调人道主义援助工作和为难民提供支持",
    Beneficiary: "难民、少数群体和其他弱势群体",
    BeneficiaryTwo: " ",
    SpecificResult: "加强人道主义应对措施的一致性、及时性、有效性和覆盖面；显著降低灾害风险",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CO,NE,PH,SS,II,SO",
    Image: "27OCHA2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.27)&l=zh#page=9"
  },
  {
    ID: 640,
    BudgetSection: 27,
    Entity: "OCHA",
    EntityFullName: "联合国人道主义事务协调厅",
    Programme: "人道主义援助",
    Subprogramme: "政策和分析",
    Title: "通过纳入地方观点改进集体学习",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "有效协调人道主义援助工作和为难民提供支持",
    Beneficiary: "难民、少数群体和其他弱势群体",
    BeneficiaryTwo: " ",
    SpecificResult: "加强人道主义应对措施的一致性、及时性、有效性和覆盖面；显著降低灾害风险",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.27)&l=zh#page=9"
  },
  {
    ID: 641,
    BudgetSection: 27,
    Entity: "OCHA",
    EntityFullName: "联合国人道主义事务协调厅",
    Programme: "人道主义援助",
    Subprogramme: "政策和分析",
    Title: "为受影响社区提供更高效、更结构化的人道主义应对措施",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "有效协调人道主义援助工作和为难民提供支持",
    Beneficiary: "难民、少数群体和其他弱势群体",
    BeneficiaryTwo: " ",
    SpecificResult: "加强人道主义应对措施的一致性、及时性、有效性和覆盖面；显著降低灾害风险",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.27)&l=zh#page=10"
  },
  {
    ID: 642,
    BudgetSection: 27,
    Entity: "OCHA",
    EntityFullName: "联合国人道主义事务协调厅",
    Programme: "人道主义援助",
    Subprogramme: "协调人道主义行动和应急反应",
    Title: "在严重资金短缺的情况下帮助有需要的人",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "有效协调人道主义援助工作和为难民提供支持",
    Beneficiary: "难民、少数群体和其他弱势群体",
    BeneficiaryTwo: " ",
    SpecificResult: "加强人道主义应对措施的一致性、及时性、有效性和覆盖面；显著降低灾害风险",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.27)&l=zh#page=12"
  },
  {
    ID: 643,
    BudgetSection: 27,
    Entity: "OCHA",
    EntityFullName: "联合国人道主义事务协调厅",
    Programme: "人道主义援助",
    Subprogramme: "协调人道主义行动和应急反应",
    Title: "地方和国家行为体更多地参与人道主义协调机制",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "有效协调人道主义援助工作和为难民提供支持",
    Beneficiary: "难民、少数群体和其他弱势群体",
    BeneficiaryTwo: " ",
    SpecificResult: "加强人道主义应对措施的一致性、及时性、有效性和覆盖面；显著降低灾害风险",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.27)&l=zh#page=13"
  },
  {
    ID: 644,
    BudgetSection: 27,
    Entity: "OCHA",
    EntityFullName: "联合国人道主义事务协调厅",
    Programme: "人道主义援助",
    Subprogramme: "协调人道主义行动和应急反应",
    Title: "扩大前瞻性做法和早预警早行动系统",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "有效协调人道主义援助工作和为难民提供支持",
    Beneficiary: "难民、少数群体和其他弱势群体",
    BeneficiaryTwo: " ",
    SpecificResult: "加强人道主义应对措施的一致性、及时性、有效性和覆盖面；显著降低灾害风险",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.27)&l=zh#page=13"
  },
  {
    ID: 645,
    BudgetSection: 27,
    Entity: "OCHA",
    EntityFullName: "联合国人道主义事务协调厅",
    Programme: "人道主义援助",
    Subprogramme: "协调人道主义行动和应急反应",
    Title: "加强全系统外交，以捍卫人道主义原则、确保准入和保护平民",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "有效协调人道主义援助工作和为难民提供支持",
    Beneficiary: "难民、少数群体和其他弱势群体",
    BeneficiaryTwo: " ",
    SpecificResult: "加强人道主义应对措施的一致性、及时性、有效性和覆盖面；显著降低灾害风险",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.27)&l=zh#page=14"
  },
  {
    ID: 646,
    BudgetSection: 27,
    Entity: "OCHA",
    EntityFullName: "联合国人道主义事务协调厅",
    Programme: "人道主义援助",
    Subprogramme: "紧急支助事务",
    Title: "通过更新指南加强国际应急行动",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "有效协调人道主义援助工作和为难民提供支持",
    Beneficiary: "国际社会",
    BeneficiaryTwo: "难民、少数群体和其他弱势群体",
    SpecificResult: "加强人道主义应对措施的一致性、及时性、有效性和覆盖面；显著降低灾害风险",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.27)&l=zh#page=16"
  },
  {
    ID: 647,
    BudgetSection: 27,
    Entity: "OCHA",
    EntityFullName: "联合国人道主义事务协调厅",
    Programme: "人道主义援助",
    Subprogramme: "紧急支助事务",
    Title: "在集体人道主义行动中加强与私营部门的伙伴关系",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "有效协调人道主义援助工作和为难民提供支持",
    Beneficiary: "国际社会",
    BeneficiaryTwo: "难民、少数群体和其他弱势群体",
    SpecificResult: "加强人道主义应对措施的一致性、及时性、有效性和覆盖面；显著降低灾害风险",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "SD,QQ,SB",
    Image: "27OCHA10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.27)&l=zh#page=17"
  },
  {
    ID: 648,
    BudgetSection: 27,
    Entity: "OCHA",
    EntityFullName: "联合国人道主义事务协调厅",
    Programme: "人道主义援助",
    Subprogramme: "紧急支助事务",
    Title: "受危机影响的民众在灾害发生后立即得到紧急人道主义援助",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "有效协调人道主义援助工作和为难民提供支持",
    Beneficiary: "难民、少数群体和其他弱势群体",
    BeneficiaryTwo: " ",
    SpecificResult: "加强人道主义应对措施的一致性、及时性、有效性和覆盖面；显著降低灾害风险",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.27)&l=zh#page=17"
  },
  {
    ID: 649,
    BudgetSection: 27,
    Entity: "OCHA",
    EntityFullName: "联合国人道主义事务协调厅",
    Programme: "人道主义援助",
    Subprogramme: "紧急支助事务",
    Title: "城市搜索救援队的全球准备状态得到增强",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "有效协调人道主义援助工作和为难民提供支持",
    Beneficiary: "难民、少数群体和其他弱势群体",
    BeneficiaryTwo: " ",
    SpecificResult: "加强人道主义应对措施的一致性、及时性、有效性和覆盖面；显著降低灾害风险",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.27)&l=zh#page=18"
  },
  {
    ID: 650,
    BudgetSection: 27,
    Entity: "OCHA",
    EntityFullName: "联合国人道主义事务协调厅",
    Programme: "人道主义援助",
    Subprogramme: "人道主义紧急情况信息和倡导",
    Title: "受危机影响者获得人道主义行为体提供的由数据驱动的支持",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "有效协调人道主义援助工作和为难民提供支持",
    Beneficiary: "难民、少数群体和其他弱势群体",
    BeneficiaryTwo: " ",
    SpecificResult: "加强人道主义应对措施的一致性、及时性、有效性和覆盖面；显著降低灾害风险",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.27)&l=zh#page=20"
  },
  {
    ID: 651,
    BudgetSection: 27,
    Entity: "OCHA",
    EntityFullName: "联合国人道主义事务协调厅",
    Programme: "人道主义援助",
    Subprogramme: "人道主义紧急情况信息和倡导",
    Title: "为人道主义应急人员提供可靠的网络和连通服务",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "有效协调人道主义援助工作和为难民提供支持",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "加强人道主义应对措施的一致性、及时性、有效性和覆盖面；显著降低灾害风险",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.27)&l=zh#page=21"
  },
  {
    ID: 652,
    BudgetSection: 27,
    Entity: "OCHA",
    EntityFullName: "联合国人道主义事务协调厅",
    Programme: "人道主义援助",
    Subprogramme: "人道主义紧急情况信息和倡导",
    Title: "获得关键数据和信息的机会增加",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "有效协调人道主义援助工作和为难民提供支持",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "加强人道主义应对措施的一致性、及时性、有效性和覆盖面；显著降低灾害风险",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.27)&l=zh#page=22"
  },
  {
    ID: 653,
    BudgetSection: 27,
    Entity: "OCHA",
    EntityFullName: "联合国人道主义事务协调厅",
    Programme: "人道主义援助",
    Subprogramme: "人道主义紧急情况信息和倡导",
    Title: "公众对人道主义危机的认识得到加强",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "有效协调人道主义援助工作和为难民提供支持",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "改善信息传播和使用",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.27)&l=zh#page=22"
  },
  {
    ID: 654,
    BudgetSection: 27,
    Entity: "UNDRR",
    EntityFullName: "联合国减少灾害风险办公室",
    Programme: "人道主义援助",
    Subprogramme: "联合国减少灾害风险办公室",
    Title: "会员国和利益攸关方审查《仙台框架》的执行进展并提出建议，以加强减少灾害风险工作",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "有效协调人道主义援助工作和为难民提供支持",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "包容型、可持续灾后恢复；建设抵御未来灾害的能力",
    SpecificResultOrder: 12,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.27)&l=zh#page=27"
  },
  {
    ID: 655,
    BudgetSection: 27,
    Entity: "UNDRR",
    EntityFullName: "联合国减少灾害风险办公室",
    Programme: "人道主义援助",
    Subprogramme: "联合国减少灾害风险办公室",
    Title: "加强惠及最脆弱群体的包容性多灾害早期警报系统",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "有效协调人道主义援助工作和为难民提供支持",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "包容型、可持续灾后恢复；建设抵御未来灾害的能力",
    SpecificResultOrder: 12,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.27)&l=zh#page=27"
  },
  {
    ID: 656,
    BudgetSection: 27,
    Entity: "UNDRR",
    EntityFullName: "联合国减少灾害风险办公室",
    Programme: "人道主义援助",
    Subprogramme: "联合国减少灾害风险办公室",
    Title: "制定为减少灾害风险供资的国家战略",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "有效协调人道主义援助工作和为难民提供支持",
    Beneficiary: "公共行政",
    BeneficiaryTwo: " ",
    SpecificResult: "包容型、可持续灾后恢复；建设抵御未来灾害的能力",
    SpecificResultOrder: 12,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.27)&l=zh#page=28"
  },
  {
    ID: 657,
    BudgetSection: 27,
    Entity: "UNDRR",
    EntityFullName: "联合国减少灾害风险办公室",
    Programme: "人道主义援助",
    Subprogramme: "联合国减少灾害风险办公室",
    Title: "各国政府评估、加强其韧性恢复以重建得更好的准备情况并将其制度化",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "有效协调人道主义援助工作和为难民提供支持",
    Beneficiary: "公共行政",
    BeneficiaryTwo: " ",
    SpecificResult: "包容型、可持续灾后恢复；建设抵御未来灾害的能力",
    SpecificResultOrder: 12,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.27)&l=zh#page=29"
  },
  {
    ID: 658,
    BudgetSection: 28,
    Entity: "DGC",
    EntityFullName: "全球传播部",
    Programme: "全球传播",
    Subprogramme: "传播运动和国家业务服务",
    Title: "加强公众对联合国优先议题的参与",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "改善信息传播和使用",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "28DGC1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.28)&l=zh#page=6"
  },
  {
    ID: 659,
    BudgetSection: 28,
    Entity: "DGC",
    EntityFullName: "全球传播部",
    Programme: "全球传播",
    Subprogramme: "传播运动和国家业务服务",
    Title: "落实《2030年可持续发展议程》的行动得到加强",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "通过稳健协调结构等途径，利用可持续发展目标之间的相互关联性，加快推进可持续发展目标",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "28DGC2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.28)&l=zh#page=7"
  },
  {
    ID: 660,
    BudgetSection: 28,
    Entity: "DGC",
    EntityFullName: "全球传播部",
    Programme: "全球传播",
    Subprogramme: "传播运动和国家业务服务",
    Title: "提高公众对可持续发展目标相关关键问题的理解和参与",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "加强合作、增进信息和最佳做法共享，推动在实现可持续发展目标方面取得进展",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "28DGC3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.28)&l=zh#page=8"
  },
  {
    ID: 661,
    BudgetSection: 28,
    Entity: "DGC",
    EntityFullName: "全球传播部",
    Programme: "全球传播",
    Subprogramme: "传播运动和国家业务服务",
    Title: "关于优先议题的宣传材料获取和信息传递渠道增多",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "通过持续沟通，改善合作和伙伴关系，提高一致性、增强合力和减少重叠",
    SpecificResultOrder: 29,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "28DGC4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.28)&l=zh#page=8"
  },
  {
    ID: 662,
    BudgetSection: 28,
    Entity: "DGC",
    EntityFullName: "全球传播部",
    Programme: "全球传播",
    Subprogramme: "新闻服务",
    Title: "联合国新闻报道的公众覆盖范围扩大",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "改善信息传播和使用",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "28DGC5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.28)&l=zh#page=10"
  },
  {
    ID: 663,
    BudgetSection: 28,
    Entity: "DGC",
    EntityFullName: "全球传播部",
    Programme: "全球传播",
    Subprogramme: "新闻服务",
    Title: "通过实况博客工具和形式加深受众的参与度",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "改善信息传播和使用",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "28DGC6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.28)&l=zh#page=11"
  },
  {
    ID: 664,
    BudgetSection: 28,
    Entity: "DGC",
    EntityFullName: "全球传播部",
    Programme: "全球传播",
    Subprogramme: "新闻服务",
    Title: "受众对联合国国际纪念活动的参与和支持增加",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "改善信息传播和使用",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "28DGC7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.28)&l=zh#page=12"
  },
  {
    ID: 665,
    BudgetSection: 28,
    Entity: "DGC",
    EntityFullName: "全球传播部",
    Programme: "全球传播",
    Subprogramme: "新闻服务",
    Title: "加强并及时向全球发布联合国新闻",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "改善信息传播和使用",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "28DGC8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.28)&l=zh#page=12"
  },
  {
    ID: 666,
    BudgetSection: 28,
    Entity: "DGC",
    EntityFullName: "全球传播部",
    Programme: "全球传播",
    Subprogramme: "外联和知识服务",
    Title: "加强全球对联合国工作的支持和行动",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "通过持续沟通，改善合作和伙伴关系，提高一致性、增强合力和减少重叠",
    SpecificResultOrder: 29,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "28DGC9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.28)&l=zh#page=14"
  },
  {
    ID: 667,
    BudgetSection: 28,
    Entity: "DGC",
    EntityFullName: "全球传播部",
    Programme: "全球传播",
    Subprogramme: "外联和知识服务",
    Title: "青年记者有机会接触和了解联合国的工作",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "青年",
    BeneficiaryTwo: "国际社会",
    SpecificResult: "通过持续沟通，改善合作和伙伴关系，提高一致性、增强合力和减少重叠",
    SpecificResultOrder: 29,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "28DGC10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.28)&l=zh#page=15"
  },
  {
    ID: 668,
    BudgetSection: 28,
    Entity: "DGC",
    EntityFullName: "全球传播部",
    Programme: "全球传播",
    Subprogramme: "外联和知识服务",
    Title: "通过高等教育机构推进落实可持续发展目标",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "可持续发展",
    Beneficiary: "青年",
    BeneficiaryTwo: "国际社会",
    SpecificResult: "通过持续沟通，改善合作和伙伴关系，提高一致性、增强合力和减少重叠",
    SpecificResultOrder: 29,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "28DGC11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.28)&l=zh#page=16"
  },
  {
    ID: 669,
    BudgetSection: 28,
    Entity: "DGC",
    EntityFullName: "全球传播部",
    Programme: "全球传播",
    Subprogramme: "外联和知识服务",
    Title: "通过专题导览参观联合国总部的游客人数增加",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "国际社会",
    BeneficiaryTwo: " ",
    SpecificResult: "改善信息传播和使用",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "28DGC12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.28)&l=zh#page=16"
  },
  {
    ID: 670,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "管理战略、政策和合规部",
    Programme: "管理战略、政策和合规部",
    Subprogramme: "企业资源规划系统解决方案、为大会第五委员会及方案和协调委员会提供的服务以及管理咨询服务: 企业资源规划解决方案",
    Title: "利用“团结”系统进行数字化转型，以提高效率并实现有效决策",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "加强组织能力、问责制和响应能力，更有效地执行任务",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=zh#page=9"
  },
  {
    ID: 671,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "管理战略、政策和合规部",
    Programme: "管理战略、政策和合规部",
    Subprogramme: "企业资源规划系统解决方案、为大会第五委员会及方案和协调委员会提供的服务以及管理咨询服务: 企业资源规划解决方案",
    Title: "通过下一代“团结”系统分析工具提供基于数据、具行动导向的见解",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "加强组织能力、问责制和响应能力，更有效地执行任务",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=zh#page=9"
  },
  {
    ID: 672,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "管理战略、政策和合规部",
    Programme: "管理战略、政策和合规部",
    Subprogramme: "企业资源规划系统解决方案、为大会第五委员会及方案和协调委员会提供的服务以及管理咨询服务: 企业资源规划解决方案",
    Title: "通过增强会员国门户网站便利决策",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "通过科学、技术和创新提高流程效率",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=zh#page=9"
  },
  {
    ID: 673,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "管理战略、政策和合规部",
    Programme: "管理战略、政策和合规部",
    Subprogramme: "企业资源规划系统解决方案、为大会第五委员会及方案和协调委员会提供的服务以及管理咨询服务: 企业资源规划解决方案",
    Title: "升级到新一代企业资源规划系统",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "加强组织能力、问责制和响应能力，更有效地执行任务",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=zh#page=10"
  },
  {
    ID: 674,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "管理战略、政策和合规部",
    Programme: "管理战略、政策和合规部",
    Subprogramme: "企业资源规划系统解决方案、为大会第五委员会及方案和协调委员会提供的服务以及管理咨询服务: 为大会第五委员会及方案和协调委员会提供的服务",
    Title: "通过扩充信息和高效报告支持第五委员会的进程",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: "国际社会",
    SpecificResult: "通过科学、技术和创新提高流程效率",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=zh#page=11"
  },
  {
    ID: 675,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "管理战略、政策和合规部",
    Programme: "管理战略、政策和合规部",
    Subprogramme: "企业资源规划系统解决方案、为大会第五委员会及方案和协调委员会提供的服务以及管理咨询服务: 为大会第五委员会及方案和协调委员会提供的服务",
    Title: "第五委员会成员及方案和协调委员会成员对信息(包括会前信息)的获取得到改善",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: "国际社会",
    SpecificResult: "改善信息传播和使用",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=zh#page=12"
  },
  {
    ID: 676,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "管理战略、政策和合规部",
    Programme: "管理战略、政策和合规部",
    Subprogramme: "企业资源规划系统解决方案、为大会第五委员会及方案和协调委员会提供的服务以及管理咨询服务: 为大会第五委员会及方案和协调委员会提供的服务",
    Title: "为与会者简化和精简程序并改善服务",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: "国际社会",
    SpecificResult: "通过科学、技术和创新提高流程效率",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=zh#page=13"
  },
  {
    ID: 677,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "管理战略、政策和合规部",
    Programme: "管理战略、政策和合规部",
    Subprogramme: "企业资源规划系统解决方案、为大会第五委员会及方案和协调委员会提供的服务以及管理咨询服务: 为大会第五委员会及方案和协调委员会提供的服务",
    Title: "加强对选举和任命相关程序的支持",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: "国际社会",
    SpecificResult: "通过科学、技术和创新提高流程效率",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=zh#page=13"
  },
  {
    ID: 678,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "管理战略、政策和合规部",
    Programme: "管理战略、政策和合规部",
    Subprogramme: "企业资源规划系统解决方案、为大会第五委员会及方案和协调委员会提供的服务以及管理咨询服务: 管理咨询事务",
    Title: "及时答复管理当局评价请求",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "加强组织能力、问责制和响应能力，更有效地执行任务",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=zh#page=15"
  },
  {
    ID: 679,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "管理战略、政策和合规部",
    Programme: "管理战略、政策和合规部",
    Subprogramme: "企业资源规划系统解决方案、为大会第五委员会及方案和协调委员会提供的服务以及管理咨询服务: 管理咨询事务",
    Title: "组织复原力管理系统在联合国系统各组织实现制度化",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "加强组织能力、问责制和响应能力，更有效地执行任务",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=zh#page=16"
  },
  {
    ID: 680,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "管理战略、政策和合规部",
    Programme: "管理战略、政策和合规部",
    Subprogramme: "企业资源规划系统解决方案、为大会第五委员会及方案和协调委员会提供的服务以及管理咨询服务: 管理咨询事务",
    Title: "总部合同委员会的建议得到获授权官员的接受",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "加强组织能力、问责制和响应能力，更有效地执行任务",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=zh#page=16"
  },
  {
    ID: 681,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "管理战略、政策和合规部",
    Programme: "管理战略、政策和合规部",
    Subprogramme: "企业资源规划系统解决方案、为大会第五委员会及方案和协调委员会提供的服务以及管理咨询服务: 管理咨询事务",
    Title: "工作人员对本组织正式司法系统的了解有所增强",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "加强内部司法和调解机制，在联合国内部倡导道德行为、增进和谐和改善诉诸司法机会",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=zh#page=17"
  },
  {
    ID: 682,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "管理战略、政策和合规部",
    Programme: "管理战略、政策和合规部",
    Subprogramme: "方案规划、财务和预算: 财务",
    Title: "秘书处各实体决策所需的成本回收汇总信息的可及性得到改善",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "为更好地执行方案，简化手续、提高透明度和加强便利性",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=zh#page=19"
  },
  {
    ID: 683,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "管理战略、政策和合规部",
    Programme: "管理战略、政策和合规部",
    Subprogramme: "方案规划、财务和预算: 财务",
    Title: "改善客户对联合国全球支付系统的体验",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "加强组织能力、问责制和响应能力，更有效地执行任务",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=zh#page=19"
  },
  {
    ID: 684,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "管理战略、政策和合规部",
    Programme: "管理战略、政策和合规部",
    Subprogramme: "方案规划、财务和预算: 财务",
    Title: "执行经核准的公共部门会计准则更新，并对即将施行的变动进行影响分析",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "加强组织能力、问责制和响应能力，更有效地执行任务",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=zh#page=20"
  },
  {
    ID: 685,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "管理战略、政策和合规部",
    Programme: "管理战略、政策和合规部",
    Subprogramme: "方案规划、财务和预算: 财务",
    Title: "通过新制定和更新的政策工具加强财务管理监管框架",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "建立有利的法律和法规框架；减少法律责任风险",
    SpecificResultOrder: 39,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=zh#page=21"
  },
  {
    ID: 686,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "管理战略、政策和合规部",
    Programme: "管理战略、政策和合规部",
    Subprogramme: "方案规划、财务和预算: 外地行动财务",
    Title: "加强财产管理的监督和问责",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "加强组织能力、问责制和响应能力，更有效地执行任务",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=zh#page=23"
  },
  {
    ID: 687,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "管理战略、政策和合规部",
    Programme: "管理战略、政策和合规部",
    Subprogramme: "方案规划、财务和预算: 外地行动财务",
    Title: "为实现设施管理的协同增效和标准化进行协调和交流",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "通过科学、技术和创新提高流程效率",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=zh#page=24"
  },
  {
    ID: 688,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "管理战略、政策和合规部",
    Programme: "管理战略、政策和合规部",
    Subprogramme: "方案规划、财务和预算: 外地行动财务",
    Title: "本组织高质量和具有成本效益的基本建设项目",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "改善切实有效支持联合国业务的基础设施",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=zh#page=24"
  },
  {
    ID: 689,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "管理战略、政策和合规部",
    Programme: "管理战略、政策和合规部",
    Subprogramme: "方案规划、财务和预算: 外地行动财务",
    Title: "提高特别政治任务所需预算资源编制工作的透明度和效率",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "为更好地执行方案，简化手续、提高透明度和加强便利性",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=zh#page=25"
  },
  {
    ID: 690,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "管理战略、政策和合规部",
    Programme: "管理战略、政策和合规部",
    Subprogramme: "方案规划、财务和预算: 方案规划和预算编制",
    Title: "在缩短的期限内圆满完成关于联合国80周年倡议的预算审议",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: "国际社会",
    SpecificResult: "通过科学、技术和创新提高流程效率",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=zh#page=27"
  },
  {
    ID: 691,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "管理战略、政策和合规部",
    Programme: "管理战略、政策和合规部",
    Subprogramme: "方案规划、财务和预算: 方案规划和预算编制",
    Title: "提高所涉方案预算问题进程对会员国的透明度",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "加强组织能力、问责制和响应能力，更有效地执行任务",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=zh#page=28"
  },
  {
    ID: 692,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "管理战略、政策和合规部",
    Programme: "管理战略、政策和合规部",
    Subprogramme: "方案规划、财务和预算: 方案规划和预算编制",
    Title: "预算信息试点提供的预算信息得到加强，以支持会员国的决策",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "改善信息传播和使用",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=zh#page=28"
  },
  {
    ID: 693,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "管理战略、政策和合规部",
    Programme: "管理战略、政策和合规部",
    Subprogramme: "方案规划、财务和预算: 方案规划和预算编制",
    Title: "秘书处各实体的所需预算资源反映出效率的提高",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "加强组织能力、问责制和响应能力，更有效地执行任务",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=zh#page=29"
  },
  {
    ID: 694,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "管理战略、政策和合规部",
    Programme: "管理战略、政策和合规部",
    Subprogramme: "人力资源: 全球战略和政策",
    Title: "工作人员、管理人员和高级领导层应对组织变革",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "加强组织能力、问责制和响应能力，更有效地执行任务",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=zh#page=32"
  },
  {
    ID: 695,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "管理战略、政策和合规部",
    Programme: "管理战略、政策和合规部",
    Subprogramme: "人力资源: 全球战略和政策",
    Title: "在适当幅度制度内无人任职和任职人数不足的会员国减少",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "改善联合国各实体的征聘和人员配置，包括减少性别和地域代表性方面的不平等",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=zh#page=32"
  },
  {
    ID: 696,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "管理战略、政策和合规部",
    Programme: "管理战略、政策和合规部",
    Subprogramme: "人力资源: 全球战略和政策",
    Title: "公平、有效、高效和敏捷的工作人员甄选制度",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "改善联合国各实体的征聘和人员配置，包括减少性别和地域代表性方面的不平等",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC27.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=zh#page=33"
  },
  {
    ID: 697,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "管理战略、政策和合规部",
    Programme: "管理战略、政策和合规部",
    Subprogramme: "人力资源: 全球战略和政策",
    Title: "全面的青年人才方针提升本组织吸引、培养和留用职业早期人才的能力",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: "青年",
    SpecificResult: "改善联合国各实体的征聘和人员配置，包括减少性别和地域代表性方面的不平等",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC28.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=zh#page=34"
  },
  {
    ID: 698,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "管理战略、政策和合规部",
    Programme: "管理战略、政策和合规部",
    Subprogramme: "人力资源: 行政法",
    Title: "扩大行为和纪律事项甄别工具的使用",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "加大应对力度，打击性剥削和性虐待、性骚扰以及欺诈和腐败；更好地将以受害者为中心的方法纳入主流",
    SpecificResultOrder: 22,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC29.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=zh#page=36"
  },
  {
    ID: 699,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "管理战略、政策和合规部",
    Programme: "管理战略、政策和合规部",
    Subprogramme: "人力资源: 行政法",
    Title: "在联合国争议法庭判决的推动下调整秘书处的政策框架和管理做法",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "建立有利的法律和法规框架；减少法律责任风险",
    SpecificResultOrder: 39,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC30.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=zh#page=36"
  },
  {
    ID: 700,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "管理战略、政策和合规部",
    Programme: "管理战略、政策和合规部",
    Subprogramme: "人力资源: 行政法",
    Title: "高级领导层处理行为和纪律事项的决策能力得到加强",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "加强内部司法和调解机制，在联合国内部倡导道德行为、增进和谐和改善诉诸司法机会",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC31.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=zh#page=37"
  },
  {
    ID: 701,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "管理战略、政策和合规部",
    Programme: "管理战略、政策和合规部",
    Subprogramme: "人力资源: 行政法",
    Title: "通过提高纪律案件复核和处置工作的效率和一致性，加强问责制",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "加强内部司法和调解机制，在联合国内部倡导道德行为、增进和谐和改善诉诸司法机会",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC32.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=zh#page=38"
  },
  {
    ID: 702,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "管理战略、政策和合规部",
    Programme: "管理战略、政策和合规部",
    Subprogramme: "业务转型和问责",
    Title: "使用生成式人工智能解决问题以提高效率",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: "国际社会",
    SpecificResult: "推进技术进步，改善信息质量、可用性、可及性和安全性",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC33.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=zh#page=40"
  },
  {
    ID: 703,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "管理战略、政策和合规部",
    Programme: "管理战略、政策和合规部",
    Subprogramme: "业务转型和问责",
    Title: "小型实体更多地利用内部评价为决策提供参考",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "推进技术进步，改善信息质量、可用性、可及性和安全性",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC34.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=zh#page=40"
  },
  {
    ID: 704,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "管理战略、政策和合规部",
    Programme: "管理战略、政策和合规部",
    Subprogramme: "业务转型和问责",
    Title: "通过不断改进管理看板，加强基于数据的决策",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "推进技术进步，改善信息质量、可用性、可及性和安全性",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC35.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=zh#page=41"
  },
  {
    ID: 705,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "管理战略、政策和合规部",
    Programme: "管理战略、政策和合规部",
    Subprogramme: "业务转型和问责",
    Title: "及时执行监督机构的建议",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "加强组织能力、问责制和响应能力，更有效地执行任务",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC36.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=zh#page=41"
  },
  {
    ID: 706,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "管理战略、政策和合规部",
    Programme: "管理战略、政策和合规部",
    Subprogramme: "应对工作场所中的种族主义问题",
    Title: "消除本组织人际、制度和系统性等各种形式的种族主义",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "加强内部司法和调解机制，在联合国内部倡导道德行为、增进和谐和改善诉诸司法机会",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC37.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=zh#page=43"
  },
  {
    ID: 707,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "管理战略、政策和合规部",
    Programme: "管理战略、政策和合规部",
    Subprogramme: "应对工作场所中的种族主义问题",
    Title: "加强问责制以应对工作场所的种族主义指控",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "加强内部司法和调解机制，在联合国内部倡导道德行为、增进和谐和改善诉诸司法机会",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC38.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=zh#page=44"
  },
  {
    ID: 708,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "管理战略、政策和合规部",
    Programme: "管理战略、政策和合规部",
    Subprogramme: "应对工作场所中的种族主义问题",
    Title: "提高多样性方面的机构透明度",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "加强内部司法和调解机制，在联合国内部倡导道德行为、增进和谐和改善诉诸司法机会",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC39.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=zh#page=45"
  },
  {
    ID: 709,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "管理战略、政策和合规部",
    Programme: "管理战略、政策和合规部",
    Subprogramme: "应对工作场所中的种族主义问题",
    Title: "增强消除工作场所种族主义和种族歧视方面的知识",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "改善信息传播和使用",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC40.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29A)&l=zh#page=45"
  },
  {
    ID: 710,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "业务支助部",
    Programme: "业务支助部",
    Subprogramme: "支助业务: 人力资源支助",
    Title: "秘书处各实体在改组和缩编方面获得全面的人力资源业务支助和指导",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "改善联合国各实体的征聘和人员配置，包括减少性别和地域代表性方面的不平等",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29B)&l=zh#page=7"
  },
  {
    ID: 711,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "业务支助部",
    Programme: "业务支助部",
    Subprogramme: "支助业务: 人力资源支助",
    Title: "整个秘书处的绩效管理得到改善",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "加强组织能力、问责制和响应能力，更有效地执行任务",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "",
    Image: "29BDOS2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29B)&l=zh#page=7"
  },
  {
    ID: 712,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "业务支助部",
    Programme: "业务支助部",
    Subprogramme: "支助业务: 人力资源支助",
    Title: "全球秘书处名册的建立和管理得到增强",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "改善联合国各实体的征聘和人员配置，包括减少性别和地域代表性方面的不平等",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "",
    Image: "29BDOS3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29B)&l=zh#page=8"
  },
  {
    ID: 713,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "业务支助部",
    Programme: "业务支助部",
    Subprogramme: "支助业务: 人力资源支助",
    Title: "对免费提供人员的征聘工作得到加强",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "改善联合国各实体的征聘和人员配置，包括减少性别和地域代表性方面的不平等",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29B)&l=zh#page=8"
  },
  {
    ID: 714,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "业务支助部",
    Programme: "业务支助部",
    Subprogramme: "支助业务: 能力发展和业务培训",
    Title: "作人员和其他人员、会员国、求职者和征聘管理人可使用集中式语文和沟通技能中心",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "加强组织能力、问责制和响应能力，更有效地执行任务",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29B)&l=zh#page=10"
  },
  {
    ID: 715,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "业务支助部",
    Programme: "业务支助部",
    Subprogramme: "支助业务: 能力发展和业务培训",
    Title: "UNTold：整个联合国系统的集体学习和创新",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "加强组织能力、问责制和响应能力，更有效地执行任务",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "",
    Image: "29BDOS6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29B)&l=zh#page=11"
  },
  {
    ID: 716,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "业务支助部",
    Programme: "业务支助部",
    Subprogramme: "支助业务: 能力发展和业务培训",
    Title: "创新、数据分析、数字化转型、战略前瞻和行为科学方面的组织能力增强",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "加强组织能力、问责制和响应能力，更有效地执行任务",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "",
    Image: "29BDOS7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29B)&l=zh#page=12"
  },
  {
    ID: 717,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "业务支助部",
    Programme: "业务支助部",
    Subprogramme: "支助业务: 能力发展和业务培训",
    Title: "行政及业务指导的可用性和可及性得到改善",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "为更好地执行方案，简化手续、提高透明度和加强便利性",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29B)&l=zh#page=12"
  },
  {
    ID: 718,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "业务支助部",
    Programme: "业务支助部",
    Subprogramme: "支助业务: 卫生保健管理与职业安全和健康",
    Title: "加强防范，以预防和减轻影响联合国工作人员和其他人员的传染病风险",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "改善切实有效支持联合国业务的基础设施",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29B)&l=zh#page=14"
  },
  {
    ID: 719,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "业务支助部",
    Programme: "业务支助部",
    Subprogramme: "支助业务: 卫生保健管理与职业安全和健康",
    Title: "联合国人员利用预防保健服务改善健康和福祉",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "加强组织能力、问责制和响应能力，更有效地执行任务",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "",
    Image: "29BDOS10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29B)&l=zh#page=15"
  },
  {
    ID: 720,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "业务支助部",
    Programme: "业务支助部",
    Subprogramme: "支助业务: 卫生保健管理与职业安全和健康",
    Title: "患者照护质量提高",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "推进技术进步，改善信息质量、可用性、可及性和安全性",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "",
    Image: "29BDOS11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29B)&l=zh#page=15"
  },
  {
    ID: 721,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "业务支助部",
    Programme: "业务支助部",
    Subprogramme: "支助业务: 卫生保健管理与职业安全和健康",
    Title: "维和人员获得数字化精神卫生支持的机会增加",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "改善维和特派团的业绩、安全和安保，包括根据安全理事会决议进行平稳过渡",
    SpecificResultOrder: 37,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29B)&l=zh#page=16"
  },
  {
    ID: 722,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "业务支助部",
    Programme: "业务支助部",
    Subprogramme: "供应链管理: 综合供应链管理",
    Title: "按照特派团应急计划，安全及时遣返军警人员",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "改善维和特派团的业绩、安全和安保，包括根据安全理事会决议进行平稳过渡",
    SpecificResultOrder: 37,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29B)&l=zh#page=18"
  },
  {
    ID: 723,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "业务支助部",
    Programme: "业务支助部",
    Subprogramme: "供应链管理: 综合供应链管理",
    Title: "多样化参与联合国商业机会",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "妇女和女童",
    BeneficiaryTwo: "难民、少数群体和其他弱势群体",
    SpecificResult: "加强组织能力、问责制和响应能力，更有效地执行任务",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "",
    Image: "29BDOS14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29B)&l=zh#page=19"
  },
  {
    ID: 724,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "业务支助部",
    Programme: "业务支助部",
    Subprogramme: "供应链管理: 综合供应链管理",
    Title: "增加提供随时可用的后勤解决方案",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "为更好地执行方案，简化手续、提高透明度和加强便利性",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "",
    Image: "29BDOS15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29B)&l=zh#page=19"
  },
  {
    ID: 725,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "业务支助部",
    Programme: "业务支助部",
    Subprogramme: "供应链管理: 综合供应链管理",
    Title: "面向人道主义和复杂环境的综合供应链解决方案",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "为更好地执行方案，简化手续、提高透明度和加强便利性",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29B)&l=zh#page=20"
  },
  {
    ID: 726,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "业务支助部",
    Programme: "业务支助部",
    Subprogramme: "供应链管理: 军警能力支助",
    Title: "维和特派团实施应急计划，实现削减费用",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "改善维和特派团的业绩、安全和安保，包括根据安全理事会决议进行平稳过渡",
    SpecificResultOrder: 37,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29B)&l=zh#page=22"
  },
  {
    ID: 727,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "业务支助部",
    Programme: "业务支助部",
    Subprogramme: "供应链管理: 军警能力支助",
    Title: "为会员国提交索偿申请和获取关于各自在和平行动中部署情况的信息提供安全的一站式入口",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "推进技术进步，改善信息质量、可用性、可及性和安全性",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "",
    Image: "29BDOS18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29B)&l=zh#page=23"
  },
  {
    ID: 728,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "业务支助部",
    Programme: "业务支助部",
    Subprogramme: "供应链管理: 军警能力支助",
    Title: "军警人员和特遣队所属装备的政策、程序、标准和定义得到更新",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "为更好地执行方案，简化手续、提高透明度和加强便利性",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "",
    Image: "29BDOS19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29B)&l=zh#page=23"
  },
  {
    ID: 729,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "业务支助部",
    Programme: "业务支助部",
    Subprogramme: "供应链管理: 军警能力支助",
    Title: "加强特遣队所属弹药管理",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "通过科学、技术和创新提高流程效率",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29B)&l=zh#page=24"
  },
  {
    ID: 730,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "业务支助部",
    Programme: "业务支助部",
    Subprogramme: "特别活动",
    Title: "设立联合国海地支助办公室",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "改善切实有效支持联合国业务的基础设施",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "HT",
    Image: "29BDOS21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29B)&l=zh#page=26"
  },
  {
    ID: 731,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "业务支助部",
    Programme: "业务支助部",
    Subprogramme: "特别活动",
    Title: "处于过渡阶段的实体对业务支助职能的全周期管理得到加强",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "改善维和特派团的业绩、安全和安保，包括根据安全理事会决议进行平稳过渡",
    SpecificResultOrder: 37,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "",
    Image: "29BDOS22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29B)&l=zh#page=27"
  },
  {
    ID: 732,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "业务支助部",
    Programme: "业务支助部",
    Subprogramme: "特别活动",
    Title: "通过加强支助和咨询服务，提高服务提供效率，改善服务",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "为更好地执行方案，简化手续、提高透明度和加强便利性",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "CO,PK,ZW",
    Image: "29BDOS23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29B)&l=zh#page=27"
  },
  {
    ID: 733,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "业务支助部",
    Programme: "业务支助部",
    Subprogramme: "特别活动",
    Title: "加强支助伙伴关系安排",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "为更好地执行方案，简化手续、提高透明度和加强便利性",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29B)&l=zh#page=28"
  },
  {
    ID: 734,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "业务支助部",
    Programme: "业务支助部",
    Subprogramme: "行政，纽约",
    Title: "通过薪金功能自动处理租金成本回收",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "通过科学、技术和创新提高流程效率",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29B)&l=zh#page=30"
  },
  {
    ID: 735,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "业务支助部",
    Programme: "业务支助部",
    Subprogramme: "行政，纽约",
    Title: "历史记录数字化保存",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "改善信息传播和使用",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "",
    Image: "29BDOS26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29B)&l=zh#page=31"
  },
  {
    ID: 736,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "业务支助部",
    Programme: "业务支助部",
    Subprogramme: "行政，纽约",
    Title: "办公空间符合本组织的需要",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "改善切实有效支持联合国业务的基础设施",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "",
    Image: "29BDOS27.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29B)&l=zh#page=31"
  },
  {
    ID: 737,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "业务支助部",
    Programme: "业务支助部",
    Subprogramme: "行政，纽约",
    Title: "联合国总部房地和设施对残疾人的无障碍程度提高",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "难民、少数群体和其他弱势群体",
    BeneficiaryTwo: "扶持",
    SpecificResult: "改善切实有效支持联合国业务的基础设施",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS28.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29B)&l=zh#page=32"
  },
  {
    ID: 738,
    BudgetSection: "29C",
    Entity: "OICT",
    EntityFullName: "信息和通信技术厅",
    Programme: "信息和通信技术厅",
    Subprogramme: "战略和技术创新",
    Title: "提高信息和安全技术安全意识以保护秘书处",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "改善信息传播和使用",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29COICT1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29C)&l=zh#page=7"
  },
  {
    ID: 739,
    BudgetSection: "29C",
    Entity: "OICT",
    EntityFullName: "信息和通信技术厅",
    Programme: "信息和通信技术厅",
    Subprogramme: "战略和技术创新",
    Title: "利用生成式人工智能，提高任务交付的实效",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "通过科学、技术和创新提高流程效率",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29COICT2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29C)&l=zh#page=7"
  },
  {
    ID: 740,
    BudgetSection: "29C",
    Entity: "OICT",
    EntityFullName: "信息和通信技术厅",
    Programme: "信息和通信技术厅",
    Subprogramme: "战略和技术创新",
    Title: "合乎道德和负责任地使用人工智能",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "推进技术进步，改善信息质量、可用性、可及性和安全性",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29COICT3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29C)&l=zh#page=8"
  },
  {
    ID: 741,
    BudgetSection: "29C",
    Entity: "OICT",
    EntityFullName: "信息和通信技术厅",
    Programme: "信息和通信技术厅",
    Subprogramme: "战略和技术创新",
    Title: "使秘书处实体能够有效应用信息和通信技术战略，以更好地交付任务",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "加强组织能力、问责制和响应能力，更有效地执行任务",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29COICT4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29C)&l=zh#page=9"
  },
  {
    ID: 742,
    BudgetSection: "29C",
    Entity: "OICT",
    EntityFullName: "信息和通信技术厅",
    Programme: "信息和通信技术厅",
    Subprogramme: "业务支助",
    Title: "由于总部无线上网条件改善，为代表和工作人员提供的连通性更加可靠和稳定",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "改善切实有效支持联合国业务的基础设施",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29COICT5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29C)&l=zh#page=11"
  },
  {
    ID: 743,
    BudgetSection: "29C",
    Entity: "OICT",
    EntityFullName: "信息和通信技术厅",
    Programme: "信息和通信技术厅",
    Subprogramme: "业务支助",
    Title: "加强对支持政府间会议的技术的管理",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "改善切实有效支持联合国业务的基础设施",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29COICT6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29C)&l=zh#page=11"
  },
  {
    ID: 744,
    BudgetSection: "29C",
    Entity: "OICT",
    EntityFullName: "信息和通信技术厅",
    Programme: "信息和通信技术厅",
    Subprogramme: "业务支助",
    Title: "通过云认证实现安全访问，降低风险",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "改善切实有效支持联合国业务的基础设施",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29COICT7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29C)&l=zh#page=12"
  },
  {
    ID: 745,
    BudgetSection: "29C",
    Entity: "OICT",
    EntityFullName: "信息和通信技术厅",
    Programme: "信息和通信技术厅",
    Subprogramme: "业务支助",
    Title: "减少碎片化并加强数据中心基础设施的信息和通信技术韧性、安全和标准化",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "改善切实有效支持联合国业务的基础设施",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29COICT8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29C)&l=zh#page=13"
  },
  {
    ID: 746,
    BudgetSection: "29C",
    Entity: "OICT",
    EntityFullName: "信息和通信技术厅",
    Programme: "信息和通信技术厅",
    Subprogramme: "企业解决方案",
    Title: "通过从纽约主要技术中心迁离来提高网站和应用程序的可用性",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "改善切实有效支持联合国业务的基础设施",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29COICT9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29C)&l=zh#page=15"
  },
  {
    ID: 747,
    BudgetSection: "29C",
    Entity: "OICT",
    EntityFullName: "信息和通信技术厅",
    Programme: "信息和通信技术厅",
    Subprogramme: "企业解决方案",
    Title: "及时为任务交付提供定制的信息技术解决方案",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "在科学、技术和创新促进可持续发展(包括人工智能)方面取得进展",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29COICT10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29C)&l=zh#page=15"
  },
  {
    ID: 748,
    BudgetSection: "29C",
    Entity: "OICT",
    EntityFullName: "信息和通信技术厅",
    Programme: "信息和通信技术厅",
    Subprogramme: "企业解决方案",
    Title: "信息和通信技术解决方案集成人工智能以协助决策",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "通过科学、技术和创新提高流程效率",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29COICT11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29C)&l=zh#page=16"
  },
  {
    ID: 749,
    BudgetSection: "29C",
    Entity: "OICT",
    EntityFullName: "信息和通信技术厅",
    Programme: "信息和通信技术厅",
    Subprogramme: "企业解决方案",
    Title: "加强联合国新闻网站的标准、安全、多种语文使用和无障碍访问",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "改善信息传播和使用",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29COICT12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29C)&l=zh#page=16"
  },
  {
    ID: 750,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "联合国内罗毕办事处",
    Programme: "行政，内罗毕",
    Subprogramme: "方案规划、财务和预算",
    Title: "提高为客户处理会计分录的及时性",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "加强组织能力、问责制和响应能力，更有效地执行任务",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "KE",
    Image: "29DUNON1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29D)&l=zh#page=6"
  },
  {
    ID: 751,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "联合国内罗毕办事处",
    Programme: "行政，内罗毕",
    Subprogramme: "方案规划、财务和预算",
    Title: "联合国内罗毕办事处建筑物、设施和基础设施的资产核算得以改进",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "为更好地执行方案，简化手续、提高透明度和加强便利性",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "KE",
    Image: "29DUNON2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29D)&l=zh#page=7"
  },
  {
    ID: 752,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "联合国内罗毕办事处",
    Programme: "行政，内罗毕",
    Subprogramme: "方案规划、财务和预算",
    Title: "拒绝付款和退回付款的处理更为及时",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "通过科学、技术和创新提高流程效率",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "KE",
    Image: "29DUNON3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29D)&l=zh#page=8"
  },
  {
    ID: 753,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "联合国内罗毕办事处",
    Programme: "行政，内罗毕",
    Subprogramme: "方案规划、财务和预算",
    Title: "提高向捐助方提供财务报告的及时性",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: "国际社会",
    SpecificResult: "为更好地执行方案，简化手续、提高透明度和加强便利性",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "KE",
    Image: "29DUNON4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29D)&l=zh#page=8"
  },
  {
    ID: 754,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "联合国内罗毕办事处",
    Programme: "行政，内罗毕",
    Subprogramme: "人力资源管理",
    Title: "工作人员和其他人员可获得更完善的福祉和心理健康支持",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "改善切实有效支持联合国业务的基础设施",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "KE",
    Image: "29DUNON5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29D)&l=zh#page=10"
  },
  {
    ID: 755,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "联合国内罗毕办事处",
    Programme: "行政，内罗毕",
    Subprogramme: "人力资源管理",
    Title: "工作人员和人员获得新知识和新技能，以提高组织成效",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "改善联合国各实体的征聘和人员配置，包括减少性别和地域代表性方面的不平等",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "KE",
    Image: "29DUNON6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29D)&l=zh#page=11"
  },
  {
    ID: 756,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "联合国内罗毕办事处",
    Programme: "行政，内罗毕",
    Subprogramme: "人力资源管理",
    Title: "更及时地向所有客户提供工作人员福利和应享权利服务",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "加强组织能力、问责制和响应能力，更有效地执行任务",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "KE",
    Image: "29DUNON7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29D)&l=zh#page=12"
  },
  {
    ID: 757,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "联合国内罗毕办事处",
    Programme: "行政，内罗毕",
    Subprogramme: "人力资源管理",
    Title: "客户单位在征聘预筛选流程中的及时性得到提升",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "改善联合国各实体的征聘和人员配置，包括减少性别和地域代表性方面的不平等",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "KE",
    Image: "29DUNON8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29D)&l=zh#page=12"
  },
  {
    ID: 758,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "联合国内罗毕办事处",
    Programme: "行政，内罗毕",
    Subprogramme: "支助事务",
    Title: "联合国驻肯尼亚各实体可使用内罗毕联合国楼群内的活动中心",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "改善切实有效支持联合国业务的基础设施",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "KE",
    Image: "29DUNON9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29D)&l=zh#page=14"
  },
  {
    ID: 759,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "联合国内罗毕办事处",
    Programme: "行政，内罗毕",
    Subprogramme: "支助事务",
    Title: "为代表、工作人员和人员开会和开展协作提供新区域",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "可持续资源管理；在可再生能源方面取得进展",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "KE",
    Image: "29DUNON10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29D)&l=zh#page=15"
  },
  {
    ID: 760,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "联合国内罗毕办事处",
    Programme: "行政，内罗毕",
    Subprogramme: "支助事务",
    Title: "在肯尼亚和该区域的联合国人员得到顺利和高效的东道国服务",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "改善切实有效支持联合国业务的基础设施",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "KE",
    Image: "29DUNON11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29D)&l=zh#page=15"
  },
  {
    ID: 761,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "联合国内罗毕办事处",
    Programme: "行政，内罗毕",
    Subprogramme: "支助事务",
    Title: "改善与内罗毕联合国房地一体化的会议服务设施",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "改善切实有效支持联合国业务的基础设施",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "KE",
    Image: "29DUNON12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29D)&l=zh#page=16"
  },
  {
    ID: 762,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "联合国内罗毕办事处",
    Programme: "行政，内罗毕",
    Subprogramme: "信息和通信技术业务",
    Title: "一个符合联合国全球标准的现代化信息和通信技术平台",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "推进技术进步，改善信息质量、可用性、可及性和安全性",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "KE",
    Image: "29DUNON13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29D)&l=zh#page=18"
  },
  {
    ID: 763,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "联合国内罗毕办事处",
    Programme: "行政，内罗毕",
    Subprogramme: "信息和通信技术业务",
    Title: "联合国信息和通信技术政策和做法的一致性有所改进",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "推进技术进步，改善信息质量、可用性、可及性和安全性",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "KE",
    Image: "29DUNON14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29D)&l=zh#page=18"
  },
  {
    ID: 764,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "联合国内罗毕办事处",
    Programme: "行政，内罗毕",
    Subprogramme: "信息和通信技术业务",
    Title: "通过升级和维护会议技术，使政府间审议工作顺利进行",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "通过科学、技术和创新提高流程效率",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "KE",
    Image: "29DUNON15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29D)&l=zh#page=19"
  },
  {
    ID: 765,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "联合国内罗毕办事处",
    Programme: "行政，内罗毕",
    Subprogramme: "信息和通信技术业务",
    Title: "在单一服务提供商平台下增强网络互操作性",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "改善切实有效支持联合国业务的基础设施",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "KE",
    Image: "29DUNON16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29D)&l=zh#page=20"
  },
  {
    ID: 766,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "联合国日内瓦办事处",
    Programme: "行政，日内瓦",
    Subprogramme: "方案规划、财务和预算",
    Title: "提高向供应商付款的及时性",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "加强组织能力、问责制和响应能力，更有效地执行任务",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CH",
    Image: "29EUNOG1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29E)&l=zh#page=6"
  },
  {
    ID: 767,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "联合国日内瓦办事处",
    Programme: "行政，日内瓦",
    Subprogramme: "方案规划、财务和预算",
    Title: "各实体在迁入或迁出万国宫时可获得专门支持",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "改善切实有效支持联合国业务的基础设施",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CH",
    Image: "29EUNOG2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29E)&l=zh#page=7"
  },
  {
    ID: 768,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "联合国日内瓦办事处",
    Programme: "行政，日内瓦",
    Subprogramme: "方案规划、财务和预算",
    Title: "有韧性和高效率的财务交易流程",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "加强组织能力、问责制和响应能力，更有效地执行任务",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CH",
    Image: "29EUNOG3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29E)&l=zh#page=7"
  },
  {
    ID: 769,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "联合国日内瓦办事处",
    Programme: "行政，日内瓦",
    Subprogramme: "方案规划、财务和预算",
    Title: "客户通过季度报告更清楚地了解服务绩效",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "改善信息传播和使用",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CH",
    Image: "29EUNOG4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29E)&l=zh#page=8"
  },
  {
    ID: 770,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "联合国日内瓦办事处",
    Programme: "行政，日内瓦",
    Subprogramme: "人力资源管理",
    Title: "支持职业过渡和提前离职的工作人员",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "改善联合国各实体的征聘和人员配置，包括减少性别和地域代表性方面的不平等",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CH",
    Image: "29EUNOG5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29E)&l=zh#page=10"
  },
  {
    ID: 771,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "联合国日内瓦办事处",
    Programme: "行政，日内瓦",
    Subprogramme: "人力资源管理",
    Title: "工作人员和外部申请人更好地了解联合国征聘流程，并作出与职业有关的知情决定",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "改善联合国各实体的征聘和人员配置，包括减少性别和地域代表性方面的不平等",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "CH",
    Image: "29EUNOG6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29E)&l=zh#page=10"
  },
  {
    ID: 772,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "联合国日内瓦办事处",
    Programme: "行政，日内瓦",
    Subprogramme: "人力资源管理",
    Title: "扩大青年参与和代际对话",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: "青年",
    SpecificResult: "改善联合国各实体的征聘和人员配置，包括减少性别和地域代表性方面的不平等",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "CH",
    Image: "29EUNOG7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29E)&l=zh#page=11"
  },
  {
    ID: 773,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "联合国日内瓦办事处",
    Programme: "行政，日内瓦",
    Subprogramme: "人力资源管理",
    Title: "通过过渡改善员工队伍支助和组织准备",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "改善联合国各实体的征聘和人员配置，包括减少性别和地域代表性方面的不平等",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CH",
    Image: "29EUNOG8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29E)&l=zh#page=11"
  },
  {
    ID: 774,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "联合国日内瓦办事处",
    Programme: "行政，日内瓦",
    Subprogramme: "支助事务",
    Title: "大会堂视听系统有助于举办大型政府间会议和活动",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: "国际社会",
    SpecificResult: "改善切实有效支持联合国业务的基础设施",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CH",
    Image: "29EUNOG9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29E)&l=zh#page=13"
  },
  {
    ID: 775,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "联合国日内瓦办事处",
    Programme: "行政，日内瓦",
    Subprogramme: "支助事务",
    Title: "活动支助中心，第二阶段：会员国和客户实体使用的视听支助得到改善",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: "国际社会",
    SpecificResult: "改善切实有效支持联合国业务的基础设施",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CH",
    Image: "29EUNOG10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29E)&l=zh#page=14"
  },
  {
    ID: 776,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "联合国日内瓦办事处",
    Programme: "行政，日内瓦",
    Subprogramme: "支助事务",
    Title: "战略遗产计划翻修完成后，客户受益于现代建筑设施",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "改善切实有效支持联合国业务的基础设施",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CH",
    Image: "29EUNOG11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29E)&l=zh#page=15"
  },
  {
    ID: 777,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "联合国日内瓦办事处",
    Programme: "行政，日内瓦",
    Subprogramme: "支助事务",
    Title: "整个万国宫的能源管理得到改善",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: "气候和环境",
    SpecificResult: "可持续资源管理；在可再生能源方面取得进展",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CH",
    Image: "29EUNOG12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29E)&l=zh#page=15"
  },
  {
    ID: 778,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "联合国日内瓦办事处",
    Programme: "行政，日内瓦",
    Subprogramme: "信息和通信技术业务",
    Title: "客户可以更高效地使用固定电话",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "改善切实有效支持联合国业务的基础设施",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CH",
    Image: "29EUNOG13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29E)&l=zh#page=17"
  },
  {
    ID: 779,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "联合国日内瓦办事处",
    Programme: "行政，日内瓦",
    Subprogramme: "信息和通信技术业务",
    Title: "活动支助中心，第一阶段：客户利用单一联络点和在线工具组织文化活动、会外活动和其他活动",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "通过科学、技术和创新提高流程效率",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CH",
    Image: "29EUNOG14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29E)&l=zh#page=17"
  },
  {
    ID: 780,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "联合国日内瓦办事处",
    Programme: "行政，日内瓦",
    Subprogramme: "信息和通信技术业务",
    Title: "通过物联网提高效率和安全性，以改善客户体验",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "通过科学、技术和创新提高流程效率",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CH",
    Image: "29EUNOG15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29E)&l=zh#page=18"
  },
  {
    ID: 781,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "联合国日内瓦办事处",
    Programme: "行政，日内瓦",
    Subprogramme: "信息和通信技术业务",
    Title: "为客户提供更快、更可靠的网络服务",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "通过科学、技术和创新提高流程效率",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CH",
    Image: "29EUNOG16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29E)&l=zh#page=18"
  },
  {
    ID: 782,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "联合国日内瓦办事处",
    Programme: "行政，日内瓦",
    Subprogramme: "图书馆服务",
    Title: "翻修期间为未来世代保护不可替代的历史图书馆藏品",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "改善切实有效支持联合国业务的基础设施",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CH",
    Image: "29EUNOG17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29E)&l=zh#page=20"
  },
  {
    ID: 783,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "联合国日内瓦办事处",
    Programme: "行政，日内瓦",
    Subprogramme: "图书馆服务",
    Title: "增加客户高效和负责任地获取和使用信息资源的工具",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "改善信息传播和使用",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "CH",
    Image: "29EUNOG18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29E)&l=zh#page=21"
  },
  {
    ID: 784,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "联合国日内瓦办事处",
    Programme: "行政，日内瓦",
    Subprogramme: "图书馆服务",
    Title: "增加获取更多联合国知识的机会",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "改善信息传播和使用",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CH",
    Image: "29EUNOG19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29E)&l=zh#page=21"
  },
  {
    ID: 785,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "联合国日内瓦办事处",
    Programme: "行政，日内瓦",
    Subprogramme: "图书馆服务",
    Title: "会员国和其他利益攸关方可长期可持续地查阅联合国档案",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "改善切实有效支持联合国业务的基础设施",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CH",
    Image: "29EUNOG20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29E)&l=zh#page=22"
  },
  {
    ID: 786,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "联合国维也纳办事处",
    Programme: "行政，维也纳",
    Subprogramme: "方案规划、财务和预算",
    Title: "在资金意外中断的情况下维持方案交付",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: "国际社会",
    SpecificResult: "为更好地执行方案，简化手续、提高透明度和加强便利性",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AT",
    Image: "29FUNOV1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29F)&l=zh#page=6"
  },
  {
    ID: 787,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "联合国维也纳办事处",
    Programme: "行政，维也纳",
    Subprogramme: "方案规划、财务和预算",
    Title: "通过实施《公共部门会计准则第47号(收入)》改进财务会计和报告",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "加强组织能力、问责制和响应能力，更有效地执行任务",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AT",
    Image: "29FUNOV2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29F)&l=zh#page=7"
  },
  {
    ID: 788,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "联合国维也纳办事处",
    Programme: "行政，维也纳",
    Subprogramme: "方案规划、财务和预算",
    Title: "外地办事处未解决的财务问题减少",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "加强组织能力、问责制和响应能力，更有效地执行任务",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AT",
    Image: "29FUNOV3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29F)&l=zh#page=7"
  },
  {
    ID: 789,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "联合国维也纳办事处",
    Programme: "行政，维也纳",
    Subprogramme: "方案规划、财务和预算",
    Title: "财务透明度和管理监督得到改善",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "加强组织能力、问责制和响应能力，更有效地执行任务",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AT",
    Image: "29FUNOV4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29F)&l=zh#page=8"
  },
  {
    ID: 790,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "联合国维也纳办事处",
    Programme: "行政，维也纳",
    Subprogramme: "人力资源管理",
    Title: "改进外地项目人员的合同模式",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "改善联合国各实体的征聘和人员配置，包括减少性别和地域代表性方面的不平等",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AT",
    Image: "29FUNOV5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29F)&l=zh#page=9"
  },
  {
    ID: 791,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "联合国维也纳办事处",
    Programme: "行政，维也纳",
    Subprogramme: "人力资源管理",
    Title: "努力让残疾人融入员工队伍",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: "难民、少数群体和其他弱势群体",
    SpecificResult: "改善联合国各实体的征聘和人员配置，包括减少性别和地域代表性方面的不平等",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AT",
    Image: "29FUNOV6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29F)&l=zh#page=10"
  },
  {
    ID: 792,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "联合国维也纳办事处",
    Programme: "行政，维也纳",
    Subprogramme: "人力资源管理",
    Title: "客户知悉并了解所有相关的人力资源政策和动态",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "改善信息传播和使用",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AT",
    Image: "29FUNOV7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29F)&l=zh#page=10"
  },
  {
    ID: 793,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "联合国维也纳办事处",
    Programme: "行政，维也纳",
    Subprogramme: "人力资源管理",
    Title: "提高对在联合国系统活动中防止骚扰、包括性骚扰的行为守则的认识",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "加强内部司法和调解机制，在联合国内部倡导道德行为、增进和谐和改善诉诸司法机会",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AT",
    Image: "29FUNOV8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29F)&l=zh#page=11"
  },
  {
    ID: 794,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "联合国维也纳办事处",
    Programme: "行政，维也纳",
    Subprogramme: "支助事务",
    Title: "财产管理得到加强",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "加强组织能力、问责制和响应能力，更有效地执行任务",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AT",
    Image: "29FUNOV9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29F)&l=zh#page=13"
  },
  {
    ID: 795,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "联合国维也纳办事处",
    Programme: "行政，维也纳",
    Subprogramme: "支助事务",
    Title: "改善对执行伙伴的监测",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "为更好地执行方案，简化手续、提高透明度和加强便利性",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AT",
    Image: "29FUNOV10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29F)&l=zh#page=14"
  },
  {
    ID: 796,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "联合国维也纳办事处",
    Programme: "行政，维也纳",
    Subprogramme: "支助事务",
    Title: "简化登记和分发来往公文的工作流程",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "通过科学、技术和创新提高流程效率",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AT",
    Image: "29FUNOV11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29F)&l=zh#page=14"
  },
  {
    ID: 797,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "联合国维也纳办事处",
    Programme: "行政，维也纳",
    Subprogramme: "支助事务",
    Title: "办公空间利用率提高",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: "难民、少数群体和其他弱势群体",
    SpecificResult: "改善切实有效支持联合国业务的基础设施",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AT",
    Image: "29FUNOV12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29F)&l=zh#page=15"
  },
  {
    ID: 798,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "联合国维也纳办事处",
    Programme: "行政，维也纳",
    Subprogramme: "信息和通信技术业务",
    Title: "通过整合虚拟基础设施和减少对订阅许可证的依赖，加强信息和通信技术业务的可靠性",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "改善切实有效支持联合国业务的基础设施",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AT",
    Image: "29FUNOV13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29F)&l=zh#page=17"
  },
  {
    ID: 799,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "联合国维也纳办事处",
    Programme: "行政，维也纳",
    Subprogramme: "信息和通信技术业务",
    Title: "外地信息安全得到加强",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "推进技术进步，改善信息质量、可用性、可及性和安全性",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AT",
    Image: "29FUNOV14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29F)&l=zh#page=17"
  },
  {
    ID: 800,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "联合国维也纳办事处",
    Programme: "行政，维也纳",
    Subprogramme: "信息和通信技术业务",
    Title: "客户实体进行数字化转型以改进任务交付",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "为更好地执行方案，简化手续、提高透明度和加强便利性",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AT",
    Image: "29FUNOV15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29F)&l=zh#page=18"
  },
  {
    ID: 801,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "联合国维也纳办事处",
    Programme: "行政，维也纳",
    Subprogramme: "信息和通信技术业务",
    Title: "联合国维也纳办事处所有客户部门地点的信息和通信技术安全采取统一做法",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "改善切实有效支持联合国业务的基础设施",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AT",
    Image: "29FUNOV16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.29F)&l=zh#page=18"
  },
  {
    ID: 802,
    BudgetSection: 30,
    Entity: "OIOS",
    EntityFullName: "内部监督事务厅",
    Programme: "内部监督",
    Subprogramme: "内部审计",
    Title: "加强员工时间和考勤问责制",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "加强组织能力、问责制和响应能力，更有效地执行任务",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "30OIOS1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.30)&l=zh#page=6"
  },
  {
    ID: 803,
    BudgetSection: 30,
    Entity: "OIOS",
    EntityFullName: "内部监督事务厅",
    Programme: "内部监督",
    Subprogramme: "内部审计",
    Title: "加强监测系统，以改进绩效管理，从而支持方案交付",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "加强组织能力、问责制和响应能力，更有效地执行任务",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "30OIOS2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.30)&l=zh#page=7"
  },
  {
    ID: 804,
    BudgetSection: 30,
    Entity: "OIOS",
    EntityFullName: "内部监督事务厅",
    Programme: "内部监督",
    Subprogramme: "内部审计",
    Title: "通过加强组织能力，更好地交付联合国任务和方案",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "加强组织能力、问责制和响应能力，更有效地执行任务",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "30OIOS3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.30)&l=zh#page=8"
  },
  {
    ID: 805,
    BudgetSection: 30,
    Entity: "OIOS",
    EntityFullName: "内部监督事务厅",
    Programme: "内部监督",
    Subprogramme: "内部审计",
    Title: "本组织的行政效率得到提高",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "加强组织能力、问责制和响应能力，更有效地执行任务",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "30OIOS4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.30)&l=zh#page=8"
  },
  {
    ID: 806,
    BudgetSection: 30,
    Entity: "OIOS",
    EntityFullName: "内部监督事务厅",
    Programme: "内部监督",
    Subprogramme: "检查和评价",
    Title: "加强秘书处的自我评价能力",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "加强组织能力、问责制和响应能力，更有效地执行任务",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "30OIOS5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.30)&l=zh#page=10"
  },
  {
    ID: 807,
    BudgetSection: 30,
    Entity: "OIOS",
    EntityFullName: "内部监督事务厅",
    Programme: "内部监督",
    Subprogramme: "检查和评价",
    Title: "加强驻地协调员系统",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "加强组织能力、问责制和响应能力，更有效地执行任务",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "30OIOS6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.30)&l=zh#page=11"
  },
  {
    ID: 808,
    BudgetSection: 30,
    Entity: "OIOS",
    EntityFullName: "内部监督事务厅",
    Programme: "内部监督",
    Subprogramme: "检查和评价",
    Title: "加强方案成果",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "加强组织能力、问责制和响应能力，更有效地执行任务",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "30OIOS7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.30)&l=zh#page=11"
  },
  {
    ID: 809,
    BudgetSection: 30,
    Entity: "OIOS",
    EntityFullName: "内部监督事务厅",
    Programme: "内部监督",
    Subprogramme: "检查和评价",
    Title: "通过加强方案规划更好地执行任务",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "加强组织能力、问责制和响应能力，更有效地执行任务",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "30OIOS8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.30)&l=zh#page=12"
  },
  {
    ID: 810,
    BudgetSection: 30,
    Entity: "OIOS",
    EntityFullName: "内部监督事务厅",
    Programme: "内部监督",
    Subprogramme: "调查",
    Title: "本组织保护其资源和追究其人员责任的能力得到加强",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "加大应对力度，打击性剥削和性虐待、性骚扰以及欺诈和腐败；更好地将以受害者为中心的方法纳入主流",
    SpecificResultOrder: 22,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "30OIOS9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.30)&l=zh#page=14"
  },
  {
    ID: 811,
    BudgetSection: 30,
    Entity: "OIOS",
    EntityFullName: "内部监督事务厅",
    Programme: "内部监督",
    Subprogramme: "调查",
    Title: "加强对需要采取以受害者为中心对策的不当行为的调查工作",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "加大应对力度，打击性剥削和性虐待、性骚扰以及欺诈和腐败；更好地将以受害者为中心的方法纳入主流",
    SpecificResultOrder: 22,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "30OIOS10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.30)&l=zh#page=14"
  },
  {
    ID: 812,
    BudgetSection: 30,
    Entity: "OIOS",
    EntityFullName: "内部监督事务厅",
    Programme: "内部监督",
    Subprogramme: "调查",
    Title: "改进对不当行为投诉的处理和及时决策",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "加大应对力度，打击性剥削和性虐待、性骚扰以及欺诈和腐败；更好地将以受害者为中心的方法纳入主流",
    SpecificResultOrder: 22,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "30OIOS11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.30)&l=zh#page=15"
  },
  {
    ID: 813,
    BudgetSection: 30,
    Entity: "OIOS",
    EntityFullName: "内部监督事务厅",
    Programme: "内部监督",
    Subprogramme: "调查",
    Title: "及时调查可能给本组织造成财务损失的案件",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "加大应对力度，打击性剥削和性虐待、性骚扰以及欺诈和腐败；更好地将以受害者为中心的方法纳入主流",
    SpecificResultOrder: 22,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "30OIOS12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.30)&l=zh#page=16"
  },
  {
    ID: 814,
    BudgetSection: 31,
    Entity: "ICSC",
    EntityFullName: "国际公务员制度委员会",
    Programme: "共同出资的行政活动",
    Subprogramme: "国际公务员制度委员会",
    Title: "公平公正的个人过渡津贴模式",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "加强组织能力、问责制和响应能力，更有效地执行任务",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "31JFA1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.31)&l=zh#page=4"
  },
  {
    ID: 815,
    BudgetSection: 31,
    Entity: "ICSC",
    EntityFullName: "国际公务员制度委员会",
    Programme: "共同出资的行政活动",
    Subprogramme: "国际公务员制度委员会",
    Title: "为在极端艰苦地点工作的工作人员提供更大的灵活性",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "加强组织能力、问责制和响应能力，更有效地执行任务",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "31JFA2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.31)&l=zh#page=5"
  },
  {
    ID: 816,
    BudgetSection: 31,
    Entity: "ICSC",
    EntityFullName: "国际公务员制度委员会",
    Programme: "共同出资的行政活动",
    Subprogramme: "国际公务员制度委员会",
    Title: "指导各组织处理新出现问题的订正行为标准",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "加强组织能力、问责制和响应能力，更有效地执行任务",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "31JFA3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.31)&l=zh#page=5"
  },
  {
    ID: 817,
    BudgetSection: 31,
    Entity: "ICSC",
    EntityFullName: "国际公务员制度委员会",
    Programme: "共同出资的行政活动",
    Subprogramme: "国际公务员制度委员会",
    Title: "反映大会批准的目标、标准和参数的整套报酬办法",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "加强组织能力、问责制和响应能力，更有效地执行任务",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "31JFA4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.31)&l=zh#page=6"
  },
  {
    ID: 818,
    BudgetSection: 31,
    Entity: "JIU",
    EntityFullName: "联合检查组",
    Programme: "共同出资的行政活动",
    Subprogramme: "联合检查组",
    Title: "通过使用新的建议跟踪工具，提高对联合检查组建议的响应能力",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "通过科学、技术和创新提高流程效率",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "31JFA5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.31)&l=zh#page=10"
  },
  {
    ID: 819,
    BudgetSection: 31,
    Entity: "JIU",
    EntityFullName: "联合检查组",
    Programme: "共同出资的行政活动",
    Subprogramme: "联合检查组",
    Title: "联合国系统各组织通过执行联合检查组的战略和业务建议，加强了对行政和方案问题的管理",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "加强组织能力、问责制和响应能力，更有效地执行任务",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "31JFA6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.31)&l=zh#page=11"
  },
  {
    ID: 820,
    BudgetSection: 31,
    Entity: "JIU",
    EntityFullName: "联合检查组",
    Programme: "共同出资的行政活动",
    Subprogramme: "联合检查组",
    Title: "联合检查组建议的影响得到加强",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "加强组织能力、问责制和响应能力，更有效地执行任务",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "31JFA7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.31)&l=zh#page=11"
  },
  {
    ID: 821,
    BudgetSection: 31,
    Entity: "JIU",
    EntityFullName: "联合检查组",
    Programme: "共同出资的行政活动",
    Subprogramme: "联合检查组",
    Title: "通过有据可依的监督调查结论，全系统知识库和知情决策得到加强",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "通过科学、技术和创新提高流程效率",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "31JFA8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.31)&l=zh#page=12"
  },
  {
    ID: 822,
    BudgetSection: 31,
    Entity: "CEB",
    EntityFullName: "联合国系统行政首长协调理事会",
    Programme: "共同出资的行政活动",
    Subprogramme: "联合国系统行政首长协调理事会",
    Title: "采取了影响深远的增效举措，集体共同精简联合国系统业务、降低成本并保持影响力",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "通过科学、技术和创新提高流程效率",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "31JFA9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.31)&l=zh#page=15"
  },
  {
    ID: 823,
    BudgetSection: 31,
    Entity: "CEB",
    EntityFullName: "联合国系统行政首长协调理事会",
    Programme: "共同出资的行政活动",
    Subprogramme: "联合国系统行政首长协调理事会",
    Title: "联合国数字身份证，实现联合国各组织之间互操作性的基础构件",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "推进技术进步，改善信息质量、可用性、可及性和安全性",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "31JFA10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.31)&l=zh#page=16"
  },
  {
    ID: 824,
    BudgetSection: 31,
    Entity: "CEB",
    EntityFullName: "联合国系统行政首长协调理事会",
    Programme: "共同出资的行政活动",
    Subprogramme: "联合国系统行政首长协调理事会",
    Title: "联合国系统为加快实现可持续发展目标的进展和执行《未来契约》而开展的活动的一致性得到改善",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "通过稳健协调结构等途径，利用可持续发展目标之间的相互关联性，加快推进可持续发展目标",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "31JFA11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.31)&l=zh#page=16"
  },
  {
    ID: 825,
    BudgetSection: 31,
    Entity: "CEB",
    EntityFullName: "联合国系统行政首长协调理事会",
    Programme: "共同出资的行政活动",
    Subprogramme: "联合国系统行政首长协调理事会",
    Title: "联合国系统协调与一致性促成了高效、持续和有原则的行动",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "为更好地执行方案，简化手续、提高透明度和加强便利性",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "31JFA12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.31)&l=zh#page=17"
  },
  {
    ID: 826,
    BudgetSection: 34,
    Entity: "DSS",
    EntityFullName: "安全和安保部",
    Programme: "安全和安保",
    Subprogramme: "安保和安全服务",
    Title: "为大会第八十届会议所有代表和与会者提供安全和有保障的环境",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: "国际社会",
    SpecificResult: "改善切实有效支持联合国业务的基础设施",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "34DSS1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.34)&l=zh#page=6"
  },
  {
    ID: 827,
    BudgetSection: 34,
    Entity: "DSS",
    EntityFullName: "安全和安保部",
    Programme: "安全和安保",
    Subprogramme: "安保和安全服务",
    Title: "便利代",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "改善切实有效支持联合国业务的基础设施",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "34DSS2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.34)&l=zh#page=7"
  },
  {
    ID: 828,
    BudgetSection: 34,
    Entity: "DSS",
    EntityFullName: "安全和安保部",
    Programme: "安全和安保",
    Subprogramme: "安保和安全服务",
    Title: "改善残疾人的登记、凭证发放和安全设施",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: "难民、少数群体和其他弱势群体",
    SpecificResult: "改善切实有效支持联合国业务的基础设施",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "34DSS3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.34)&l=zh#page=7"
  },
  {
    ID: 829,
    BudgetSection: 34,
    Entity: "DSS",
    EntityFullName: "安全和安保部",
    Programme: "安全和安保",
    Subprogramme: "安保和安全服务",
    Title: "改进安全和安保决策",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "通过科学、技术和创新提高流程效率",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "34DSS4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.34)&l=zh#page=8"
  },
  {
    ID: 830,
    BudgetSection: 34,
    Entity: "DSS",
    EntityFullName: "安全和安保部",
    Programme: "安全和安保",
    Subprogramme: "外地行动",
    Title: "提高行动效率并重点关注高风险地区",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "加强组织能力、问责制和响应能力，更有效地执行任务",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "34DSS5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.34)&l=zh#page=10"
  },
  {
    ID: 831,
    BudgetSection: 34,
    Entity: "DSS",
    EntityFullName: "安全和安保部",
    Programme: "安全和安保",
    Subprogramme: "外地行动",
    Title: "改进对危机的防备和应对",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "加强组织能力、问责制和响应能力，更有效地执行任务",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "34DSS6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.34)&l=zh#page=10"
  },
  {
    ID: 832,
    BudgetSection: 34,
    Entity: "DSS",
    EntityFullName: "安全和安保部",
    Programme: "安全和安保",
    Subprogramme: "外地行动",
    Title: "改进安保决策",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "加强组织能力、问责制和响应能力，更有效地执行任务",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "34DSS7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.34)&l=zh#page=11"
  },
  {
    ID: 833,
    BudgetSection: 34,
    Entity: "DSS",
    EntityFullName: "安全和安保部",
    Programme: "安全和安保",
    Subprogramme: "外地行动",
    Title: "安全和安保方面的风险知情决策",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "加强组织能力、问责制和响应能力，更有效地执行任务",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "34DSS8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.34)&l=zh#page=11"
  },
  {
    ID: 834,
    BudgetSection: 34,
    Entity: "DSS",
    EntityFullName: "安全和安保部",
    Programme: "安全和安保",
    Subprogramme: "专业服务",
    Title: "新的数字系统加强了联合国人员的安全和保障",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "通过科学、技术和创新提高流程效率",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "34DSS9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.34)&l=zh#page=13"
  },
  {
    ID: 835,
    BudgetSection: 34,
    Entity: "DSS",
    EntityFullName: "安全和安保部",
    Programme: "安全和安保",
    Subprogramme: "专业服务",
    Title: "整个联合国安保管理系统连贯一致运作",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "加强组织能力、问责制和响应能力，更有效地执行任务",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "34DSS10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.34)&l=zh#page=14"
  },
  {
    ID: 836,
    BudgetSection: 34,
    Entity: "DSS",
    EntityFullName: "安全和安保部",
    Programme: "安全和安保",
    Subprogramme: "专业服务",
    Title: "加强对联合国高级官员的个人保护服务",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "加强组织能力、问责制和响应能力，更有效地执行任务",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "34DSS11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.34)&l=zh#page=14"
  },
  {
    ID: 837,
    BudgetSection: 34,
    Entity: "DSS",
    EntityFullName: "安全和安保部",
    Programme: "安全和安保",
    Subprogramme: "专业服务",
    Title: "危急事件发生后采取统一的社会心理支持方法",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "推动八个优先事项取得进展",
    Beneficiary: "扶持",
    BeneficiaryTwo: " ",
    SpecificResult: "加强组织能力、问责制和响应能力，更有效地执行任务",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "34DSS12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.34)&l=zh#page=15"
  }
]